/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
/**
 * 상세 정보
 */
export type ErrorInfoDetails = { [key: string]: unknown };

export interface ErrorInfo {
  /** 에러 코드 */
  code: string;
  /** 에러 메시지 */
  message: string;
  /** 상세 정보 */
  details?: ErrorInfoDetails;
}

/**
 * 응답 데이터 (성공 시에만 포함)
 */
export type BaseResponseDtoData = { [key: string]: unknown };

export interface BaseResponseDto {
  /** API 호출 성공 여부 */
  success: boolean;
  /** 응답 데이터 (성공 시에만 포함) */
  data?: BaseResponseDtoData;
  /** 에러 정보 (실패 시에만 포함) */
  error?: ErrorInfo;
  /** 응답 생성 시각 (ISO 8601) */
  timestamp: string;
  /** HTTP 상태 코드 */
  statusCode?: number;
  /** 요청 처리 메시지 */
  message?: string;
}

export interface BuyerDto {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  userType?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  profileImageUrl?: string | null;
  /** @nullable */
  authId?: string | null;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  gender?: string | null;
  /** @nullable */
  birthDate?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  updatedAt?: string | null;
  /** @nullable */
  trustScore?: number | null;
  /**
   * 구매자 신뢰도 퍼센타일 (1, 5, 10, 15, 20, 30, null)
   * @nullable
   */
  trustPercentile?: number | null;
}

export interface SupplierDto {
  id: string;
  /** @nullable */
  userId?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  userType?: string | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  trustBadge?: string | null;
  /** @nullable */
  trustPercentile?: number | null;
  /**
   * 인증 총점 (0-20)
   * @nullable
   */
  certificationTotalScore?: number | null;
  /**
   * 총 참여 점수 (0-20)
   * @nullable
   */
  totalParticipationScore?: number | null;
  /**
   * 계약 건수 점수 (0-20)
   * @nullable
   */
  contractCountScore?: number | null;
  /**
   * 총 금액 점수 (0-20)
   * @nullable
   */
  totalAmountScore?: number | null;
  /**
   * 총 수수료 점수 (0-20)
   * @nullable
   */
  totalCommissionScore?: number | null;
  /**
   * 최근 참여 점수 (0-20)
   * @nullable
   */
  recentParticipationScore?: number | null;
  /** @nullable */
  profileImageUrl?: string | null;
  /** @nullable */
  authId?: string | null;
  /** @nullable */
  lastLoginAt?: string | null;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  businessNumber?: string | null;
  /** @nullable */
  ceoName?: string | null;
  /** @nullable */
  companyPhone?: string | null;
  /** @nullable */
  managerName?: string | null;
  /** @nullable */
  managerPhone?: string | null;
  /** @nullable */
  businessType?: string | null;
  /** @nullable */
  province?: string | null;
  /** @nullable */
  city?: string | null;
  /** @nullable */
  district?: string | null;
  /** @nullable */
  addressDetail?: string | null;
  /** @nullable */
  addressFull?: string | null;
  /** @nullable */
  companySealUrl?: string | null;
  /** @nullable */
  bankName?: string | null;
  /** @nullable */
  bankAccountNumber?: string | null;
  /** @nullable */
  bankAccountHolder?: string | null;
  /** @nullable */
  trustScore?: number | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  updatedAt?: string | null;
}

export interface ChatRoomQuoteRequestDto {
  /** 견적 요청 ID */
  id: string;
  /** 프로젝트명 */
  projectName: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 견적 요청 상태 */
  status: string;
}

/**
 * 채팅방 상태
 */
export type ChatRoomStatus =
  (typeof ChatRoomStatus)[keyof typeof ChatRoomStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatRoomStatus = {
  active: "active",
  contract_active: "contract_active",
  read_only: "read_only",
  inactive: "inactive",
  CLOSED: "CLOSED",
  archived: "archived",
} as const;

export interface ChatRoomLastMessageDto {
  /** 메시지 내용 */
  content: string;
  /** 메시지 타입 */
  type: string;
  /** 발신자 타입 */
  senderType: string;
}

/**
 * 발신자 타입
 */
export type QuoteMessageResponseDtoSenderType =
  (typeof QuoteMessageResponseDtoSenderType)[keyof typeof QuoteMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type QuoteMessageResponseDtoMessageType =
  (typeof QuoteMessageResponseDtoMessageType)[keyof typeof QuoteMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoMessageType = {
  quote: "quote",
} as const;

/**
 * 단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산)
 */
export type QuoteMessageResponseDtoQuoteDataTaxType =
  (typeof QuoteMessageResponseDtoQuoteDataTaxType)[keyof typeof QuoteMessageResponseDtoQuoteDataTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteMessageResponseDtoQuoteDataTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type QuoteMessageResponseDtoQuoteDataItemsItem = {
  /** 항목명 */
  name?: string;
  /** 사양 */
  spec?: string;
  /** 설명 */
  notes?: string;
  /** 수량 */
  quantity?: number;
  /** 단위 */
  unit?: string;
  /** 단가 */
  unitPrice?: number;
  /** 금액 (quantity × unitPrice) */
  amount?: number;
};

export type QuoteMessageResponseDtoQuoteDataSupplier = {
  /** 공급사 사용자 ID */
  id?: string;
  /** 공급사 회사명 */
  companyName?: string;
  /** 사업자 등록번호 */
  businessNumber?: string;
  /** 대표자명 */
  ceoName?: string;
  /** 주소 */
  addressFull?: string;
  /** 업종 */
  businessType?: string;
  /** 전화번호 */
  companyPhone?: string;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 연락처 */
  managerPhone?: string;
  /** 회사 인장 URL */
  companySealUrl?: string;
  /** 신뢰도 배지 */
  trustBadge?: string;
  /** 검증 여부 */
  isVerified?: boolean;
};

export type QuoteMessageResponseDtoQuoteDataBuyer = {
  /** 담당자 이름 */
  name?: string;
  /** 담당자 연락처 */
  phone?: string;
};

export type QuoteMessageResponseDtoQuoteDataAttachmentsItem = {
  /** 파일명 */
  fileName?: string;
  /** 파일 공개 URL */
  url?: string;
  /** 스토리지 경로 (재서명에 사용) */
  filePath?: string;
  /** 파일 크기 (바이트) */
  fileSize?: number;
  /** MIME 타입 */
  contentType?: string;
};

/**
 * 견적서 데이터 (풍부한 정보 포함)
 */
export type QuoteMessageResponseDtoQuoteData = {
  quoteResponseId?: string;
  /** 버전 레코드 ID */
  quoteVersionId?: string;
  versionNumber?: number;
  totalAmount?: number;
  /** 단가 입력 축 — EXCLUSIVE(단가가 공급가액, 부가세 가산) | INCLUSIVE(단가가 부가세 포함가, 총액에서 역산) */
  taxType?: QuoteMessageResponseDtoQuoteDataTaxType;
  /** 공급가액 (부가세 제외) */
  supplyAmount?: number;
  /** 부가세 */
  taxAmount?: number;
  /** 이전 버전 금액 */
  previousAmount?: number;
  /** 버전 생성일 */
  createdAt?: string;
  /** 버전 수정일 */
  updatedAt?: string;
  items?: QuoteMessageResponseDtoQuoteDataItemsItem[];
  supplier?: QuoteMessageResponseDtoQuoteDataSupplier;
  buyer?: QuoteMessageResponseDtoQuoteDataBuyer;
  /** PDF 다운로드 URL (Supabase Storage) */
  pdfUrl?: string;
  /** 견적 설명 */
  description?: string;
  /** 프로젝트명 */
  projectName?: string;
  /** 계약 완료 여부 (FREE plan 다운로드 제한용) */
  isContracted?: boolean;
  /** 계약 ID */
  contractId?: string;
  /** 첨부파일 목록 */
  attachments?: QuoteMessageResponseDtoQuoteDataAttachmentsItem[];
};

export interface QuoteMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: QuoteMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: QuoteMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 견적서 데이터 (풍부한 정보 포함) */
  quoteData?: QuoteMessageResponseDtoQuoteData;
}

export interface ChatRoomResponseDto {
  /** 채팅방 ID */
  id: string;
  /** 견적 요청 ID */
  quoteRequestId: string;
  /** 구매자 ID (Phase 2: user_id → buyer_id) */
  buyerId: string;
  /** 공급자 ID (필수) - 채팅방 생성 시 자동 설정됨 */
  supplierId: string;
  /** 견적 응답 ID (채팅방이 견적 응답과 연결된 경우) */
  quoteResponseId?: string;
  /** 계약 ID (계약 체결 후 설정) */
  contractId?: string;
  /** 구매자 정보 (users + buyers + quote_requests 테이블) */
  userInfo?: BuyerDto;
  /** 공급자 회사 정보 (users + suppliers 테이블) */
  supplierInfo: SupplierDto;
  /** 견적 요청 정보 (JOIN된 데이터) */
  quoteRequest?: ChatRoomQuoteRequestDto;
  /** Supabase Realtime 채널명 (Backend SSoT) */
  channelName: string;
  /** 채팅방 상태 */
  status: ChatRoomStatus;
  /** 마지막 메시지 시간 (ISO 8601 형식) */
  lastMessageAt?: string;
  /** 생성일시 (ISO 8601 형식) */
  createdAt: string;
  /** 수정일시 (ISO 8601 형식) */
  updatedAt: string;
  /** 마지막 메시지 정보 (성능 최적화) */
  lastMessage?: ChatRoomLastMessageDto;
  /**
   * 안읽은 메시지 수 (Watermark 패턴 기반 계산)
   * @minimum 0
   */
  unreadCount?: number;
  /** 마지막으로 읽은 메시지 ID (Watermark - 구매자용) */
  lastReadMessageIdBuyer?: string;
  /** 마지막으로 읽은 메시지 ID (Watermark - 공급자용) */
  lastReadMessageIdSupplier?: string;
  /** 최신 견적 메시지 (Info Panel 표시용) */
  latestQuoteMessage?: QuoteMessageResponseDto;
  /** 익명 사용자 여부 (상대방 정보의 블러 처리 여부 결정) */
  isAnonymous: boolean;
  /** 구독할 Realtime 이벤트 목록 (Broadcast 패턴) */
  events: string[];
}

export interface PaginationMetaDto {
  /** 전체 항목 수 */
  totalCount: number;
  /** 현재 페이지 항목 수 */
  itemCount: number;
  /** 페이지당 항목 수 */
  pageSize: number;
  /** 전체 페이지 수 */
  totalPages: number;
  /** 현재 페이지 */
  currentPage: number;
  /** 다음 페이지 존재 여부 */
  hasNext: boolean;
  /** 이전 페이지 존재 여부 */
  hasPrev: boolean;
  /** 커서 기반 페이징을 위한 다음 커서 */
  nextCursor?: string;
}

export interface PaginatedResponseDto {
  /** 응답 데이터 배열 */
  items: string[];
  /** 페이지네이션 메타 정보 */
  meta: PaginationMetaDto;
}

/**
 * 발신자 타입
 */
export type TextMessageResponseDtoSenderType =
  (typeof TextMessageResponseDtoSenderType)[keyof typeof TextMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type TextMessageResponseDtoMessageType =
  (typeof TextMessageResponseDtoMessageType)[keyof typeof TextMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TextMessageResponseDtoMessageType = {
  text: "text",
} as const;

export interface TextMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: TextMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: TextMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface ChatMessageAttachmentDto {
  /** 첨부파일 ID */
  id: string;
  /** 파일명 */
  fileName: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** 파일 타입 */
  fileType: string;
  /** MIME 타입 */
  contentType: string;
  /** 파일 URL */
  url: string;
  /** 파일 설명 */
  description?: string;
  /** 이미지 파일 여부 */
  isImage: boolean;
  /** 업로드 일시 (ISO 8601 형식) */
  createdAt: string;
  /** 파일 업로드 상태 (pending: 업로드 중, completed: 완료, failed: 실패) */
  uploadStatus: string;
  /** true이면 supplier에게 노출하지 않는 첨부 (buyer 채팅창 전용). 계약서류 자동 발급/SEMO 견적서에서 사용. */
  hiddenFromSupplier?: boolean;
}

/**
 * 발신자 타입
 */
export type AttachmentMessageResponseDtoSenderType =
  (typeof AttachmentMessageResponseDtoSenderType)[keyof typeof AttachmentMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type AttachmentMessageResponseDtoMessageType =
  (typeof AttachmentMessageResponseDtoMessageType)[keyof typeof AttachmentMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AttachmentMessageResponseDtoMessageType = {
  attachment: "attachment",
} as const;

export interface AttachmentMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: AttachmentMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: AttachmentMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 첨부파일 정보 */
  attachment?: ChatMessageAttachmentDto;
}

/**
 * 계약 상태
 */
export type ContractInfoDtoStatus =
  (typeof ContractInfoDtoStatus)[keyof typeof ContractInfoDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoStatus = {
  complete: "complete",
  cancelled: "cancelled",
  pending: "pending",
} as const;

/**
 * 결제 거래의 수단(payment_transactions 축). CMARKET_CARD 는 씨마켓 결제창을 거쳐 공급기업 가맹점으로 승인된 건이다. 계약 시 고른 현금/카드는 이 필드가 아니라 paymentChannel 이다.
 */
export type ContractInfoDtoPaymentMethod =
  (typeof ContractInfoDtoPaymentMethod)[keyof typeof ContractInfoDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
  CMARKET_CARD: "CMARKET_CARD",
} as const;

/**
 * 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
 * @nullable
 */
export type ContractInfoDtoPaymentChannel =
  | (typeof ContractInfoDtoPaymentChannel)[keyof typeof ContractInfoDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. NULL 은 아직 아무 통지도 오지 않은 상태다. 현금 계약에서 카드의 isPaid 와 같은 자리를 맡는다 — 스냅샷이 아니라 매 조회마다 계약에서 읽는다.
 * @nullable
 */
export type ContractInfoDtoTaxInvoiceStatus =
  | (typeof ContractInfoDtoTaxInvoiceStatus)[keyof typeof ContractInfoDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractInfoDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

export type ContractInfoDtoItemsItem = {
  name?: string;
  spec?: string;
  quantity?: number;
  unit?: string;
  unitPrice?: number;
  amount?: number;
};

export interface ContractInfoDto {
  /** 계약 ID */
  contractId: string;
  /** 결제 ID */
  paymentId: string;
  /** Innopay 거래 고유번호 (TID) */
  tid?: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 계약 체결 일시 */
  contractedAt: string;
  /** 계약 상태 */
  status: ContractInfoDtoStatus;
  /** 결제 거래의 수단(payment_transactions 축). CMARKET_CARD 는 씨마켓 결제창을 거쳐 공급기업 가맹점으로 승인된 건이다. 계약 시 고른 현금/카드는 이 필드가 아니라 paymentChannel 이다. */
  paymentMethod?: ContractInfoDtoPaymentMethod;
  /**
   * 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
   * @nullable
   */
  paymentChannel?: ContractInfoDtoPaymentChannel;
  /**
   * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. NULL 은 아직 아무 통지도 오지 않은 상태다. 현금 계약에서 카드의 isPaid 와 같은 자리를 맡는다 — 스냅샷이 아니라 매 조회마다 계약에서 읽는다.
   * @nullable
   */
  taxInvoiceStatus?: ContractInfoDtoTaxInvoiceStatus;
  /** 이 계약의 대금·계산서를 씨마켓에서 정리하는가(계약-먼저 길인가). 세모 안심결제 계약은 false — 대금은 세모가 이미 받았고 씨마켓에 갈 일이 없다. 카드의 「대금 정리」 칸을 그릴지 이 값 하나로 정한다. 지급 수단으로 되짚지 말 것. */
  settlesOnCmarket?: boolean;
  /** 공급자 상호명 */
  supplierCompanyName?: string;
  /** 공급자 대표자명 */
  supplierCeoName?: string;
  /** 공급자 사업자등록번호 */
  supplierBusinessNumber?: string;
  /** 공급자 주소 */
  supplierAddress?: string;
  /** 공급자 연락처 */
  supplierPhone?: string;
  /** 공급자 이메일 */
  supplierEmail?: string;
  /** 구매자 상호명/기관명 */
  buyerAgencyName?: string;
  /** 구매자 담당자명 */
  buyerManagerName?: string;
  /** 구매자 배송지 주소 */
  buyerAddress?: string;
  /** 배송지 주소 (legacy or alternate) */
  deliveryAddress?: string;
  /** [deprecated] 담당자 개인 연락처 — 더는 채우지 않는다(항상 빈 문자열) */
  buyerManagerPhone?: string;
  /** 발주기관 대표번호 (담당자 개인 휴대폰이 아니다) */
  buyerOrganizationPhone?: string;
  /** 구매자 사업자번호 (보조) */
  buyerBusinessNumber?: string;
  /** 대표 상품/서비스명 */
  itemName?: string;
  /** 상세 품목 리스트 (거래명세서용) */
  items?: ContractInfoDtoItemsItem[];
  /** 카드 승인번호 (Innopay) */
  authCode?: string;
  /** 취소 사유 (cancelled 상태일 때) */
  reason?: string;
  /** 결제 방법 스냅샷. true=선결제, false=후불결제. */
  isPrepaid?: boolean;
  /**
   * 결제 완료 시각. NULL 이면 미결제.
   * @nullable
   */
  paidAt?: string | null;
}

/**
 * 발신자 타입
 */
export type ContractMessageResponseDtoSenderType =
  (typeof ContractMessageResponseDtoSenderType)[keyof typeof ContractMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type ContractMessageResponseDtoMessageType =
  (typeof ContractMessageResponseDtoMessageType)[keyof typeof ContractMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractMessageResponseDtoMessageType = {
  contract: "contract",
} as const;

export interface ContractMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: ContractMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: ContractMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 계약 정보 */
  contractInfo: ContractInfoDto;
}

/**
 * 발신자 타입
 */
export type SystemMessageResponseDtoSenderType =
  (typeof SystemMessageResponseDtoSenderType)[keyof typeof SystemMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type SystemMessageResponseDtoMessageType =
  (typeof SystemMessageResponseDtoMessageType)[keyof typeof SystemMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemMessageResponseDtoMessageType = {
  system: "system",
} as const;

export interface SystemMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: SystemMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: SystemMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

/**
 * 결제 상태
 */
export type PaymentPendingDataDtoStatus =
  (typeof PaymentPendingDataDtoStatus)[keyof typeof PaymentPendingDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingDataDtoStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  EXPIRED: "EXPIRED",
} as const;

export interface PaymentPendingDataDto {
  /** 주문번호 (MOID) */
  moid: string;
  /** 결제 대기 금액 */
  amount: number;
  /** 입금 계좌번호 (가상계좌/무통장) */
  bankAccount: string;
  /** 생성 일시 */
  createdAt: string;
  /** 만료 일시 (입금 기한) */
  expiresAt: string;
  /** 거절 일시 */
  rejectedAt?: string;
  /** 거절 사유 */
  rejectionReason?: string;
  /** 결제 상태 */
  status?: PaymentPendingDataDtoStatus;
  /** 승인 일시 */
  approvedAt?: string;
}

/**
 * 발신자 타입
 */
export type PaymentPendingMessageResponseDtoSenderType =
  (typeof PaymentPendingMessageResponseDtoSenderType)[keyof typeof PaymentPendingMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type PaymentPendingMessageResponseDtoMessageType =
  (typeof PaymentPendingMessageResponseDtoMessageType)[keyof typeof PaymentPendingMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentPendingMessageResponseDtoMessageType = {
  payment_pending: "payment_pending",
} as const;

export interface PaymentPendingMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: PaymentPendingMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: PaymentPendingMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 입금 대기 정보 */
  paymentPendingData: PaymentPendingDataDto;
}

/**
 * 취소 요청 주체 (buyer: 발주기관, supplier: 공급사). 승인/반려 버튼은 상대방에게만 노출해야 함. 레거시 메시지는 buyer로 응답됨.
 */
export type CancellationRequestDataDtoRequesterRole =
  (typeof CancellationRequestDataDtoRequesterRole)[keyof typeof CancellationRequestDataDtoRequesterRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestDataDtoRequesterRole = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

/**
 * 결제 수단
 */
export type CancellationRequestDataDtoPaymentMethod =
  (typeof CancellationRequestDataDtoPaymentMethod)[keyof typeof CancellationRequestDataDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestDataDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
} as const;

/**
 * 요청 상태
 */
export type CancellationRequestDataDtoStatus =
  (typeof CancellationRequestDataDtoStatus)[keyof typeof CancellationRequestDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestDataDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface CancellationRequestDataDto {
  /** 환불 ID */
  refundId: string;
  /** 계약 ID */
  contractId: string;
  /** 취소 사유 */
  requestReason: string;
  /** 취소 요청 주체 (buyer: 발주기관, supplier: 공급사). 승인/반려 버튼은 상대방에게만 노출해야 함. 레거시 메시지는 buyer로 응답됨. */
  requesterRole: CancellationRequestDataDtoRequesterRole;
  /** 반려 사유 */
  rejectionReason?: string;
  /** 거래 번호 (환불) */
  tid?: string;
  /** 결제 수단 */
  paymentMethod?: CancellationRequestDataDtoPaymentMethod;
  /** 취소 금액 */
  totalAmount?: number;
  /** 요청 상태 */
  status: CancellationRequestDataDtoStatus;
}

/**
 * 발신자 타입
 */
export type CancellationRequestMessageResponseDtoSenderType =
  (typeof CancellationRequestMessageResponseDtoSenderType)[keyof typeof CancellationRequestMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type CancellationRequestMessageResponseDtoMessageType =
  (typeof CancellationRequestMessageResponseDtoMessageType)[keyof typeof CancellationRequestMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CancellationRequestMessageResponseDtoMessageType = {
  cancellation_request: "cancellation_request",
} as const;

export interface CancellationRequestMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: CancellationRequestMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: CancellationRequestMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 계약 취소 요청 정보 */
  cancellationRequestData: CancellationRequestDataDto;
}

/**
 * 리뷰 상태
 */
export type ReviewSubmittedDataDtoStatus =
  (typeof ReviewSubmittedDataDtoStatus)[keyof typeof ReviewSubmittedDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedDataDtoStatus = {
  submitted: "submitted",
} as const;

export interface ReviewSubmittedDataDto {
  /** 계약 ID */
  contractId: string;
  /** 리뷰 ID */
  reviewId: string;
  /** 리뷰 상태 */
  status: ReviewSubmittedDataDtoStatus;
}

/**
 * 발신자 타입
 */
export type ReviewSubmittedMessageResponseDtoSenderType =
  (typeof ReviewSubmittedMessageResponseDtoSenderType)[keyof typeof ReviewSubmittedMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type ReviewSubmittedMessageResponseDtoMessageType =
  (typeof ReviewSubmittedMessageResponseDtoMessageType)[keyof typeof ReviewSubmittedMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewSubmittedMessageResponseDtoMessageType = {
  review_submitted: "review_submitted",
} as const;

export interface ReviewSubmittedMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: ReviewSubmittedMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: ReviewSubmittedMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 리뷰 작성 완료 정보 */
  reviewSubmittedData: ReviewSubmittedDataDto;
}

export interface ContractDocumentOptionDto {
  /** c-market 서류 코드 */
  paperCode: number;
  /** 서류 이름 */
  name: string;
  /** 운영자 기본값 여부 - 선택 화면에서 미리 체크 */
  isDefault: boolean;
  /** 시스템 자동 생성 가능 여부 (false: 공급사 직접 제출 대상) */
  autoGenerated: boolean;
}

/**
 * auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출
 */
export type ContractDocumentItemDtoKind =
  (typeof ContractDocumentItemDtoKind)[keyof typeof ContractDocumentItemDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractDocumentItemDtoKind = {
  auto: "auto",
  auto_pending_input: "auto_pending_input",
  manual: "manual",
} as const;

/**
 * 대기(pending) vs 완료(completed)
 */
export type ContractDocumentItemDtoStatus =
  (typeof ContractDocumentItemDtoStatus)[keyof typeof ContractDocumentItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractDocumentItemDtoStatus = {
  pending: "pending",
  completed: "completed",
} as const;

/**
 * 다운로드 가능한 파일 URL (완료 시 존재)
 */
export type ContractDocumentItemDtoFileUrl = { [key: string]: unknown };

/**
 * 원본 파일명 (완료 시 존재)
 */
export type ContractDocumentItemDtoFileName = { [key: string]: unknown };

/**
 * 파일 크기 (bytes)
 */
export type ContractDocumentItemDtoFileSize = { [key: string]: unknown };

/**
 * MIME 타입
 */
export type ContractDocumentItemDtoContentType = { [key: string]: unknown };

/**
 * 업로드 시각 (ISO 8601)
 */
export type ContractDocumentItemDtoUploadedAt = { [key: string]: unknown };

export interface ContractDocumentItemDto {
  /** contract_documents.id */
  id: string;
  /** c-market paperCode */
  paperCode: number;
  /** 서류 이름 */
  name: string;
  /** auto: 즉시 자동 생성. auto_pending_input: 자동 생성이지만 supplier 별도 입력값 필요. manual: 직접 제출 */
  kind: ContractDocumentItemDtoKind;
  /** 대기(pending) vs 완료(completed) */
  status: ContractDocumentItemDtoStatus;
  /** 다운로드 가능한 파일 URL (완료 시 존재) */
  fileUrl?: ContractDocumentItemDtoFileUrl;
  /** 원본 파일명 (완료 시 존재) */
  fileName?: ContractDocumentItemDtoFileName;
  /** 파일 크기 (bytes) */
  fileSize?: ContractDocumentItemDtoFileSize;
  /** MIME 타입 */
  contentType?: ContractDocumentItemDtoContentType;
  /** 업로드 시각 (ISO 8601) */
  uploadedAt?: ContractDocumentItemDtoUploadedAt;
}

export type ContractRestrictionConfirmSnapshotDtoAnswersItem =
  (typeof ContractRestrictionConfirmSnapshotDtoAnswersItem)[keyof typeof ContractRestrictionConfirmSnapshotDtoAnswersItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmSnapshotDtoAnswersItem = {
  YES: "YES",
  NO: "NO",
} as const;

/**
 * 발주기관 최종 확인 응답. 전 문항 "NO" 는 null(확인 절차 없음). "예" 포함 상태에서 buyer 미확인이면 null, 확인 후 잠긴다.
 * @nullable
 */
export type ContractRestrictionConfirmSnapshotDtoBuyerConfirmation =
  | (typeof ContractRestrictionConfirmSnapshotDtoBuyerConfirmation)[keyof typeof ContractRestrictionConfirmSnapshotDtoBuyerConfirmation]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmSnapshotDtoBuyerConfirmation = {
  YES: "YES",
  NO: "NO",
} as const;

/**
 * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
 * @nullable
 */
export type ContractRestrictionConfirmSnapshotDtoConfirmedAt = {
  [key: string]: unknown;
} | null;

export interface ContractRestrictionConfirmSnapshotDto {
  /** 8개 문항 응답 원본 */
  answers: ContractRestrictionConfirmSnapshotDtoAnswersItem[];
  /** "예"로 응답한 문항 인덱스(0-based). 비어있으면 경고 없음. */
  flaggedIndexes: number[];
  /** supplier 제출 시각 (ISO 8601) */
  submittedAt: string;
  /**
   * 발주기관 최종 확인 응답. 전 문항 "NO" 는 null(확인 절차 없음). "예" 포함 상태에서 buyer 미확인이면 null, 확인 후 잠긴다.
   * @nullable
   */
  buyerConfirmation: ContractRestrictionConfirmSnapshotDtoBuyerConfirmation;
  /**
   * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
   * @nullable
   */
  confirmedAt: ContractRestrictionConfirmSnapshotDtoConfirmedAt;
}

/**
 * c-market 거래유형 (quote_requests.category_type 매핑)
 */
export type DocumentRequestDataDtoBidType =
  (typeof DocumentRequestDataDtoBidType)[keyof typeof DocumentRequestDataDtoBidType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoBidType = {
  goods: "goods",
  service: "service",
  construction: "construction",
  sale: "sale",
} as const;

/**
 * 요청 상태
 */
export type DocumentRequestDataDtoStatus =
  (typeof DocumentRequestDataDtoStatus)[keyof typeof DocumentRequestDataDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoStatus = {
  pending: "pending",
  requested: "requested",
} as const;

/**
 * 견적요청의 결제 방법 스냅샷 (2026-07-31). 2026-08-04 부터 신규는 전량 postpaid 라 카드 렌더 판단에는 쓰지 않는다(표시·디버깅용). 결제 CTA 는 paymentChannel 이 정한다.
 */
export type DocumentRequestDataDtoPaymentMethod =
  (typeof DocumentRequestDataDtoPaymentMethod)[keyof typeof DocumentRequestDataDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 계약 시 고른 결제 수단 (contracts.payment_channel 실시간 조회). cash → [계산서 발행요청], card → [카드결제하기]. null 이면 카드가 결제 CTA 를 그리지 않는다 — 컬럼 신설(2026-08-04) 이전 레거시 계약이 여기 해당한다.
 * @nullable
 */
export type DocumentRequestDataDtoPaymentChannel =
  | (typeof DocumentRequestDataDtoPaymentChannel)[keyof typeof DocumentRequestDataDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. 현금 계약에서 isPaid 와 같은 자리를 맡는다.
 * @nullable
 */
export type DocumentRequestDataDtoTaxInvoiceStatus =
  | (typeof DocumentRequestDataDtoTaxInvoiceStatus)[keyof typeof DocumentRequestDataDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestDataDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

export interface DocumentRequestDataDto {
  /** 계약 ID */
  contractId: string;
  /** c-market 거래유형 (quote_requests.category_type 매핑) */
  bidType: DocumentRequestDataDtoBidType;
  /** 선택 가능한 계약서류 목록 (pending 카드 렌더용 스냅샷) */
  documents: ContractDocumentOptionDto[];
  /** 요청 상태 */
  status: DocumentRequestDataDtoStatus;
  /** 발급 완료된 c-market 계약서류 코드 */
  issuedPaperCodes: number[];
  /** [계약 서류 관리] 카드 항목 목록. status="requested" 로 전환된 이후에만 채워진다. */
  contractDocuments?: ContractDocumentItemDto[];
  /** 견적요청의 결제 방법 스냅샷 (2026-07-31). 2026-08-04 부터 신규는 전량 postpaid 라 카드 렌더 판단에는 쓰지 않는다(표시·디버깅용). 결제 CTA 는 paymentChannel 이 정한다. */
  paymentMethod?: DocumentRequestDataDtoPaymentMethod;
  /**
   * 계약 시 고른 결제 수단 (contracts.payment_channel 실시간 조회). cash → [계산서 발행요청], card → [카드결제하기]. null 이면 카드가 결제 CTA 를 그리지 않는다 — 컬럼 신설(2026-08-04) 이전 레거시 계약이 여기 해당한다.
   * @nullable
   */
  paymentChannel?: DocumentRequestDataDtoPaymentChannel;
  /** 결제 완료 여부 (contracts.paid_at 유무). CONTRACT 메시지 카드와 같은 판정을 쓴다. */
  isPaid?: boolean;
  /**
   * 씨마켓 계산서 진행 상태 (contracts.tax_invoice_status 실시간 조회). REQUESTED=발행요청됨, ISSUED=발행완료. 현금 계약에서 isPaid 와 같은 자리를 맡는다.
   * @nullable
   */
  taxInvoiceStatus?: DocumentRequestDataDtoTaxInvoiceStatus;
  /** paperCode 135(수의계약체결제한여부확인서) 제출 스냅샷 (2026-08-02). 미제출이면 undefined. */
  restrictionConfirm?: ContractRestrictionConfirmSnapshotDto;
}

/**
 * 발신자 타입
 */
export type DocumentRequestMessageResponseDtoSenderType =
  (typeof DocumentRequestMessageResponseDtoSenderType)[keyof typeof DocumentRequestMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type DocumentRequestMessageResponseDtoMessageType =
  (typeof DocumentRequestMessageResponseDtoMessageType)[keyof typeof DocumentRequestMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DocumentRequestMessageResponseDtoMessageType = {
  document_request: "document_request",
} as const;

export interface DocumentRequestMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: DocumentRequestMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: DocumentRequestMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 계약서류 선택 요청 정보 */
  documentRequestData: DocumentRequestDataDto;
}

/**
 * 발주기관 최종 확인 응답. 미제출이면 null.
 * @nullable
 */
export type ContractRestrictionConfirmDataDtoBuyerConfirmation =
  | (typeof ContractRestrictionConfirmDataDtoBuyerConfirmation)[keyof typeof ContractRestrictionConfirmDataDtoBuyerConfirmation]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmDataDtoBuyerConfirmation = {
  YES: "YES",
  NO: "NO",
} as const;

/**
 * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
 * @nullable
 */
export type ContractRestrictionConfirmDataDtoConfirmedAt = {
  [key: string]: unknown;
} | null;

export interface ContractRestrictionConfirmDataDto {
  /** 계약 ID */
  contractId: string;
  /** 짝이 되는 [계약 서류 관리] 카드 메시지 ID */
  documentRequestMessageId: string;
  /** 8개 문항 응답 원본 */
  answers: string[];
  /** "예"로 응답한 문항 인덱스(0..7) */
  flaggedIndexes: number[];
  /** 공급사 제출 시각 (ISO 8601) */
  submittedAt: string;
  /**
   * 발주기관 최종 확인 응답. 미제출이면 null.
   * @nullable
   */
  buyerConfirmation: ContractRestrictionConfirmDataDtoBuyerConfirmation;
  /**
   * buyer 확인 제출 시각 (ISO 8601). 미제출이면 null.
   * @nullable
   */
  confirmedAt: ContractRestrictionConfirmDataDtoConfirmedAt;
}

/**
 * 발신자 타입
 */
export type ContractRestrictionConfirmMessageResponseDtoSenderType =
  (typeof ContractRestrictionConfirmMessageResponseDtoSenderType)[keyof typeof ContractRestrictionConfirmMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입
 */
export type ContractRestrictionConfirmMessageResponseDtoMessageType =
  (typeof ContractRestrictionConfirmMessageResponseDtoMessageType)[keyof typeof ContractRestrictionConfirmMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmMessageResponseDtoMessageType = {
  contract_restriction_confirm: "contract_restriction_confirm",
} as const;

export interface ContractRestrictionConfirmMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: ContractRestrictionConfirmMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 */
  messageType: ContractRestrictionConfirmMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /** 수의계약 체결 제한 확인 요청 정보 */
  contractRestrictionConfirmData: ContractRestrictionConfirmDataDto;
}

export type ChatMessagesResponseDtoItemsItem =
  | TextMessageResponseDto
  | AttachmentMessageResponseDto
  | QuoteMessageResponseDto
  | ContractMessageResponseDto
  | SystemMessageResponseDto
  | PaymentPendingMessageResponseDto
  | CancellationRequestMessageResponseDto
  | ReviewSubmittedMessageResponseDto
  | DocumentRequestMessageResponseDto
  | ContractRestrictionConfirmMessageResponseDto;

export interface ChatMessagesResponseDto {
  /** 채팅 메시지 목록 */
  items: ChatMessagesResponseDtoItemsItem[];
  /**
   * 다음 커서
   * @nullable
   */
  nextCursor: string | null;
  /** 추가 데이터 여부 */
  hasMore: boolean;
}

/**
 * 발신자 타입
 */
export type BaseChatMessageResponseDtoSenderType =
  (typeof BaseChatMessageResponseDtoSenderType)[keyof typeof BaseChatMessageResponseDtoSenderType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageResponseDtoSenderType = {
  buyer: "buyer",
  supplier: "supplier",
  system: "system",
} as const;

/**
 * 메시지 타입 (Discriminator)
 */
export type BaseChatMessageResponseDtoMessageType =
  (typeof BaseChatMessageResponseDtoMessageType)[keyof typeof BaseChatMessageResponseDtoMessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BaseChatMessageResponseDtoMessageType = {
  text: "text",
  attachment: "attachment",
  quote: "quote",
  contract: "contract",
  system: "system",
  payment_pending: "payment_pending",
  cancellation_request: "cancellation_request",
  review_submitted: "review_submitted",
  document_request: "document_request",
  contract_restriction_confirm: "contract_restriction_confirm",
} as const;

export interface BaseChatMessageResponseDto {
  /** 메시지 ID */
  id: string;
  /** 채팅방 ID */
  roomId: string;
  /** 발신자 ID */
  senderId: string;
  /** 발신자 타입 */
  senderType: BaseChatMessageResponseDtoSenderType;
  /** 발신자 이름 (회사명 또는 사용자명) - Realtime 알림용 */
  senderName?: string;
  /** 메시지 타입 (Discriminator) */
  messageType: BaseChatMessageResponseDtoMessageType;
  /** 메시지 내용 */
  message: string;
  /** 시스템 메시지 여부 */
  isSystemMessage: boolean;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽은 시간 */
  readAt?: string;
  /** 삭제 여부 */
  isDeleted: boolean;
  /** 삭제 시간 */
  deletedAt?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CreateMessageDto {
  /**
   * 메시지 내용 (필수)
   * @maxLength 1000
   */
  content: string;
  /** 답글 대상 메시지 ID */
  replyToId?: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface GeneratedContractDocumentDto {
  paperCode: number;
  name: string;
  fileUrl: string;
}

export interface RequestContractDocumentsDto {
  /** 계약서류 선택 요청 메시지 ID */
  messageId: string;
  /** 발급할 c-market 계약서류 코드 */
  paperCodes: number[];
  /** c-market 멱등성 키. 같은 사용자 동작의 재시도에는 같은 값을 사용 */
  idempotencyKey: string;
}

export type ContractRestrictionConfirmDtoAnswersItem =
  (typeof ContractRestrictionConfirmDtoAnswersItem)[keyof typeof ContractRestrictionConfirmDtoAnswersItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractRestrictionConfirmDtoAnswersItem = {
  YES: "YES",
  NO: "NO",
} as const;

export interface ContractRestrictionConfirmDto {
  /** 8개 문항 응답 ("YES" | "NO"). "YES" 포함 시 발주기관 확인 절차로 진입. */
  answers: ContractRestrictionConfirmDtoAnswersItem[];
}

/**
 * 입사일 (YYYY-MM-DD)
 * @nullable
 */
export type RetireeRosterRowDtoJoinDate = { [key: string]: unknown } | null;

/**
 * 간부·보직자 직급 (예: 3급)
 * @nullable
 */
export type RetireeRosterRowDtoRetireType = { [key: string]: unknown } | null;

/**
 * 근무기간 (개월 단위 숫자 문자열)
 * @nullable
 */
export type RetireeRosterRowDtoServicePeriod = {
  [key: string]: unknown;
} | null;

/**
 * 비고
 * @nullable
 */
export type RetireeRosterRowDtoEtc = { [key: string]: unknown } | null;

export interface RetireeRosterRowDto {
  name: string;
  position: string;
  /**
   * 입사일 (YYYY-MM-DD)
   * @nullable
   */
  joinDate?: RetireeRosterRowDtoJoinDate;
  /**
   * 간부·보직자 직급 (예: 3급)
   * @nullable
   */
  retireType?: RetireeRosterRowDtoRetireType;
  /**
   * 근무기간 (개월 단위 숫자 문자열)
   * @nullable
   */
  servicePeriod?: RetireeRosterRowDtoServicePeriod;
  /**
   * 비고
   * @nullable
   */
  etc?: RetireeRosterRowDtoEtc;
}

export interface RetireeRosterDto {
  rows: RetireeRosterRowDto[];
}

export interface SubmitContractDocumentInputDto {
  /** c-market 멱등성 키 */
  idempotencyKey: string;
  /** paperCode=135 (수의계약체결제한여부확인서) 응답 */
  contractRestrictionConfirm?: ContractRestrictionConfirmDto;
  /** paperCode=164/188/195/222 응답. 해당없음은 rows=[] 로 전달 (c-market spec) */
  retireeRoster?: RetireeRosterDto;
}

/**
 * 발주기관 최종 확인 응답
 */
export type SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation =
  (typeof SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation)[keyof typeof SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation = {
  YES: "YES",
  NO: "NO",
} as const;

export interface SubmitContractDocumentBuyerConfirmationDto {
  /** c-market 멱등성 키 */
  idempotencyKey: string;
  /** 발주기관 최종 확인 응답 */
  buyerConfirmation: SubmitContractDocumentBuyerConfirmationDtoBuyerConfirmation;
}

export interface MarkRoomAsReadDto {
  /** 마지막으로 읽은 메시지 ID (Watermark) */
  lastReadMessageId: string;
}

export interface QuoteResponseItemDto {
  /** 품목명 */
  name: string;
  /**
   * 단가 (원 단위, 부가세 포함)
   * @minimum 1
   * @maximum 10000000000000
   */
  unitPrice: number;
  /**
   * 수량
   * @minimum 1
   * @maximum 1000000000
   */
  quantity: number;
  /** 단위 (예: 세트, EA, 박스) */
  unit: string;
  /**
   * 품목별 총액 (quantity × unitPrice)
   * @minimum 0
   * @maximum 10000000000000
   */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 카탈로그 단가 업데이트 여부 (기존 단가가 있을 때만 참조됨) */
  updateCatalog?: number;
  /** 표준 아이템 ID (items_v2_base.id) */
  itemId?: string;
}

export interface AttachmentMetadataDto {
  /** 파일명 */
  fileName: string;
  /** 파일 공개 URL */
  url: string;
  /** 스토리지 내부 경로. 전달 시 백엔드가 매 조회마다 fresh signed URL을 재발급합니다. */
  filePath?: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** MIME 타입 */
  contentType?: string;
}

/**
 * 단가 입력 축 — EXCLUSIVE(공급가액 단가, 기본) | INCLUSIVE(부가세 포함 단가). INCLUSIVE 면 품목 합계가 총액이고 공급가액은 총액에서 역산한 값이다.
 */
export type CreateQuoteResponseVersionDtoTaxType =
  (typeof CreateQuoteResponseVersionDtoTaxType)[keyof typeof CreateQuoteResponseVersionDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteResponseVersionDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface CreateQuoteResponseVersionDto {
  /** 견적 응답 ID (내부용 - PDF 파일명 생성) */
  id?: string;
  /** 버전 번호 (내부용 - PDF 파일명 생성) */
  versionNumber?: number;
  /**
   * 견적 총액 (원, 부가세 10% 포함)
   * @minimum 0
   * @maximum 100000000000000
   */
  totalAmount: number;
  /**
   * 부가가치세(VAT) 금액 (선택사항)
   * @minimum 0
   * @maximum 10000000000000
   */
  taxAmount?: number;
  /** 단가 입력 축 — EXCLUSIVE(공급가액 단가, 기본) | INCLUSIVE(부가세 포함 단가). INCLUSIVE 면 품목 합계가 총액이고 공급가액은 총액에서 역산한 값이다. */
  taxType?: CreateQuoteResponseVersionDtoTaxType;
  /**
   * 견적 품목 상세 목록 (물품 카테고리일 때 필수, 업체용 - 단가 필수) - 각 품목은 반드시 unit(단위), unitPrice(단가), amount(금액)를 포함해야 합니다. amount = quantity × unitPrice. 총액은 모든 품목의 금액 합계에 10% VAT를 포함한 금액입니다. 제조·용역, 공사, 중고 판매 카테고리에서는 선택사항입니다.
   * @nullable
   */
  items?: QuoteResponseItemDto[] | null;
  /**
   * 버전 생성 사유 (선택사항) - 예: "initial_submission", "buyer_requested_update", "협상 후 금액 조정"
   * @maxLength 500
   */
  description?: string;
  /** 첨부파일 목록 (선택사항, 최대 10개) */
  attachments?: AttachmentMetadataDto[];
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

/**
 * 처리 상태
 */
export type QuoteResponseFlowResultDtoStatus =
  (typeof QuoteResponseFlowResultDtoStatus)[keyof typeof QuoteResponseFlowResultDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteResponseFlowResultDtoStatus = {
  submitted: "submitted",
  processing: "processing",
} as const;

export interface QuoteResponseFlowResultDto {
  /** 생성된 견적 응답 ID */
  quoteResponseId: string;
  /** 버전 번호 (첫 응답은 항상 1) */
  versionNumber: number;
  /** 채팅방 ID */
  chatRoomId: string;
  /** 처리 상태 */
  status: QuoteResponseFlowResultDtoStatus;
  /** 생성 시간 (ISO 8601) */
  createdAt: string;
}

export interface WithdrawQuoteResponseResultDto {
  /** 철회한 견적 응답 ID */
  quoteResponseId: string;
  /** 철회 시각 (ISO 8601) */
  withdrawnAt: string;
  /**
   * 철회 사유 (없으면 null)
   * @nullable
   */
  withdrawalReason: string | null;
}

export interface WithdrawQuoteResponseDto {
  /**
   * 철회 사유 (선택, 500자 이내)
   * @maxLength 500
   */
  reason?: string;
}

export interface RecipientInfoDto {
  /** 담당자 이름 */
  name?: string;
  /** 담당자 연락처 */
  phone?: string;
}

export interface QuoteItemDto {
  /**
   * 품목명 (필수)
   * @maxLength 255
   */
  name: string;
  /**
   * 단가 (부가세 포함, 원 단위)
   * @minimum 0
   */
  unitPrice: number;
  /**
   * 단위 (예: EA, 박스, 세트)
   * @maxLength 10
   */
  unit: string;
  /**
   * 규격 1 (예: A4, 500ml)
   * @maxLength 255
   */
  spec1?: string;
  /**
   * 규격 2 - 재질/타입 (예: 80g, 스테인리스)
   * @maxLength 255
   */
  spec2?: string;
  /**
   * 규격 3 - 패키징 (예: 2500매/박스)
   * @maxLength 255
   */
  spec3?: string;
  /**
   * 수량 (견적응답 전용 - items 테이블에는 없음)
   * @minimum 1
   */
  quantity: number;
  /**
   * 품목별 총액 (단가 x 수량, 견적응답 전용)
   * @minimum 0
   */
  amount: number;
  /**
   * 상품코드 (items 테이블 선택사항)
   * @maxLength 100
   */
  itemCode?: string;
  /**
   * 제조사 (items 테이블 선택사항)
   * @maxLength 100
   */
  manufacturer?: string;
  /**
   * 브랜드 (items 테이블 선택사항)
   * @maxLength 100
   */
  brand?: string;
  /** 시스템 아이템 ID (자동 견적 매칭용) */
  itemId?: string;
}

export interface QuoteAttachmentDto {
  /** 첨부파일 ID (UUID) */
  id?: string;
  /**
   * 파일 이름
   * @maxLength 255
   */
  fileName: string;
  /** 파일 경로 */
  filePath?: string;
  /** 파일 접근 URL */
  url?: string;
  /**
   * 파일 크기 (bytes)
   * @maximum 10485760
   */
  fileSize?: number;
  /** MIME 타입 */
  mimeType?: string;
}

/**
 * 견적 응답 상태
 */
export type QuoteResponseResponseDtoStatus =
  (typeof QuoteResponseResponseDtoStatus)[keyof typeof QuoteResponseResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteResponseResponseDtoStatus = {
  pending: "pending",
  submitted: "submitted",
  withdrawn: "withdrawn",
  expired: "expired",
} as const;

export interface QuoteResponseResponseDto {
  /** 견적 응답 ID (UUID) */
  id: string;
  /** 견적 요청 ID */
  quoteRequestId: string;
  /** 공급자 정보 */
  supplier: SupplierDto;
  /** 공급자 ID */
  supplierId: string;
  /** 수신자 정보 */
  recipientInfo?: RecipientInfoDto;
  /** 견적번호 */
  quoteNumber?: string;
  /** 발행일 (ISO 8601) */
  issueDate?: string;
  /** 견적 설명/비고 */
  description?: string;
  /**
   * 견적 총액 (원, 부가세 제외)
   * @minimum 0
   */
  totalAmount: number;
  /**
   * 공급 금액 (원)
   * @minimum 0
   */
  supplyAmount?: number;
  /**
   * 부가가치세(VAT) 금액 (원)
   * @minimum 0
   */
  vatAmount?: number;
  /** 세금 유형 (VAT, TAX, NONE) */
  taxType?: string;
  /** 견적 품목 상세 목록 */
  items: QuoteItemDto[];
  /** 첨부파일 목록 */
  attachments?: QuoteAttachmentDto[];
  /** 유효기간 (타임스탬프) */
  validUntil?: number;
  /**
   * 배송기간 (일)
   * @minimum 0
   */
  deliveryDays?: number;
  /**
   * 견적 응답 버전 번호
   * @minimum 1
   */
  versionNumber?: number;
  /**
   * PDF 파일 URL
   * @nullable
   */
  pdfUrl?: string | null;
  /** 견적 응답 상태 */
  status: QuoteResponseResponseDtoStatus;
  /** 채팅방 ID (vendor와의 협상 채팅) */
  chatRoomId?: string;
  /** 생성 일시 (ISO 8601) */
  createdAt?: string;
  /** 수정 일시 (ISO 8601) */
  updatedAt?: string;
  /** 익명 여부 (블러 처리 필요) */
  isAnonymous: boolean;
  /** 계약 여부 */
  isContracted: boolean;
  /**
   * 공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨 — 철회된 견적은 계약·결제할 수 없다
   * @nullable
   */
  withdrawnAt?: string | null;
}

export interface PdfUrlResponseDto {
  /** 생성된 PDF의 Public URL */
  pdfUrl: string;
}

export interface PdfGenerationResponseDto {
  /** PDF 파일 공개 URL (Supabase Storage에서 접근 가능) */
  pdfUrl: string;
  /** PDF 파일명 */
  fileName: string;
  /**
   * PDF 파일 크기 (바이트 단위)
   * @minimum 0
   */
  fileSize: number;
  /** PDF 파일 해시 (SHA-256, 파일 검증용) */
  fileHash: string;
}

export interface QuotePdfItemDto {
  /** 품명 (Product name) */
  name: string;
  /** 규격 (Specification) */
  spec?: string;
  /**
   * 수량 (Quantity)
   * @minimum 1
   */
  quantity: number;
  /** 단위 (Unit) */
  unit: string;
  /**
   * 단가 (Unit price)
   * @minimum 0
   */
  unitPrice: number;
  /**
   * 금액 (Total price)
   * @minimum 0
   */
  totalPrice: number;
}

export interface QuotePdfAttachmentDto {
  /** 파일명 (File name) */
  fileName: string;
  /** 파일 URL (File URL) */
  fileUrl: string;
}

/**
 * 카테고리 (제품/서비스)
 */
export type CreateQuotePdfDtoCategoryType =
  (typeof CreateQuotePdfDtoCategoryType)[keyof typeof CreateQuotePdfDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuotePdfDtoCategoryType = {
  product: "product",
  service: "service",
} as const;

export interface CreateQuotePdfDto {
  /** 공급자 회사명 */
  supplierName: string;
  /** 공급자 대표자명 */
  supplierCeoName: string;
  /** 사업자등록번호 */
  supplierRegistrationNumber: string;
  /** 공급자 주소 */
  supplierAddress: string;
  /** 공급자 전화번호 */
  supplierPhone: string;
  /** 공급자 이메일 */
  supplierEmail: string;
  /** 회사 직인 URL (선택) */
  companySealUrl?: string;
  /** 구매자명 (또는 회사명) */
  buyerName: string;
  /** 공고번호 (선택) */
  announcementNumber?: string;
  /** 견적 항목 목록 */
  items: QuotePdfItemDto[];
  /**
   * 공급가액 (부가세 제외)
   * @minimum 0
   */
  subtotal: number;
  /**
   * 부가세 (10%)
   * @minimum 0
   */
  tax: number;
  /**
   * 총 금액 (공급가액 + 부가세)
   * @minimum 0
   */
  totalAmount: number;
  /** 카테고리 (제품/서비스) */
  categoryType: CreateQuotePdfDtoCategoryType;
  /** 설명 (선택) */
  description?: string;
  /** 첨부파일 목록 (선택) */
  attachments?: QuotePdfAttachmentDto[];
}

/**
 * 카테고리 (제품/서비스)
 */
export type CreateContractPdfDtoCategoryType =
  (typeof CreateContractPdfDtoCategoryType)[keyof typeof CreateContractPdfDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContractPdfDtoCategoryType = {
  product: "product",
  service: "service",
} as const;

export interface CreateContractPdfDto {
  /** 공급자 회사명 */
  supplierName: string;
  /** 공급자 대표자명 */
  supplierCeoName: string;
  /** 사업자등록번호 */
  supplierRegistrationNumber: string;
  /** 공급자 주소 */
  supplierAddress: string;
  /** 공급자 전화번호 */
  supplierPhone: string;
  /** 공급자 이메일 */
  supplierEmail: string;
  /** 회사 직인 URL (선택) */
  companySealUrl?: string;
  /** 구매자명 (또는 회사명) */
  buyerName: string;
  /** 공고번호 (선택) */
  announcementNumber?: string;
  /** 견적 항목 목록 */
  items: QuotePdfItemDto[];
  /**
   * 공급가액 (부가세 제외)
   * @minimum 0
   */
  subtotal: number;
  /**
   * 부가세 (10%)
   * @minimum 0
   */
  tax: number;
  /**
   * 총 금액 (공급가액 + 부가세)
   * @minimum 0
   */
  totalAmount: number;
  /** 카테고리 (제품/서비스) */
  categoryType: CreateContractPdfDtoCategoryType;
  /** 설명 (선택) */
  description?: string;
  /** 첨부파일 목록 (선택) */
  attachments?: QuotePdfAttachmentDto[];
  /** 계약번호 */
  contractNumber: string;
  /** 계약일자 (ISO8601) */
  contractDate: string;
  /** 결제 트랜잭션 ID */
  paymentTransactionId: string;
  /** 결제 승인일시 (ISO8601) */
  paymentApprovedAt: string;
}

export interface SystemConfigResponseDto {
  /** PRO 플랜 1개월 무료 체험 활성화 여부 */
  proTrialEnabled: boolean;
  /** 무료 체험 일수 */
  proTrialDays: number;
}

export interface AddressResponseDto {
  /** 주소 ID (UUID) */
  id: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /** 주소 라벨 (회사, 집, 창고 등) */
  label?: string;
  /** 기본 배송지 여부 */
  isDefault: boolean;
  /** 우편번호 (5자리 숫자) */
  postalCode: string;
  /** 시/도 (광역시 또는 도 단위) */
  province: string;
  /** 시/군/구 (기초자치단체) */
  city: string;
  /** 읍/면/동 (선택사항) */
  district?: string;
  /** 도로명 주소 */
  streetAddress: string;
  /** 상세 주소 (건물명, 동/호 등) */
  addressDetail?: string;
  /** 수령인 이름 */
  recipientName?: string;
  /** 수령인 연락처 (휴대폰 또는 일반전화) */
  recipientPhone?: string;
  /** 생성일 (ISO 8601 형식) */
  createdAt?: string;
  /** 수정일 (ISO 8601 형식) */
  updatedAt?: string;
}

/**
 * 사용자 타입 (buyer: 구매자, supplier: 공급자, admin: 관리자)
 */
export type UserInfoDtoUserType =
  (typeof UserInfoDtoUserType)[keyof typeof UserInfoDtoUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserInfoDtoUserType = {
  buyer: "buyer",
  supplier: "supplier",
  admin: "admin",
} as const;

/**
 * 기본 배송지 정보
 * @nullable
 */
export type UserInfoDtoDefaultAddress = AddressResponseDto | null;

export interface UserInfoDto {
  /** 내부 사용자 ID (UUID) */
  id: string;
  /** 사용자가 입력한 ID (username) */
  userId?: string;
  /** Supabase Auth ID */
  authId?: string;
  /** 사용자 연락처 이메일 */
  contactEmail: string;
  /** 사용자 성명 */
  name?: string;
  /** 사용자 전화번호 */
  phone?: string;
  /**
   * 프로필 이미지 URL
   * @nullable
   */
  profileImageUrl?: string | null;
  /** 이메일 인증 여부 */
  emailVerified?: boolean;
  /**
   * NICE 본인인증 완료 날짜 (ISO 8601 형식)
   * @nullable
   */
  niceVerifiedAt?: string | null;
  /** 사용자 타입 (buyer: 구매자, supplier: 공급자, admin: 관리자) */
  userType?: UserInfoDtoUserType;
  /** 마스터 관리자 여부 (관리자 계정일 때만 제공) */
  isMaster?: boolean;
  /** 사용자 생성 날짜 (ISO 8601 형식) */
  createdAt?: string;
  /**
   * 기본 배송지 정보
   * @nullable
   */
  defaultAddress?: UserInfoDtoDefaultAddress;
}

export interface LoginResponseDto {
  user: UserInfoDto;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Access Token 만료 시간 (초) */
  expiresIn: number;
  /** 토큰 타입 */
  tokenType: string;
  message: string;
}

export interface LoginDto {
  /**
   * 사용자 ID 또는 이메일
   * @minLength 3
   */
  userId: string;
  /**
   * 사용자 비밀번호
   * @minLength 6
   */
  password: string;
  /** 로그인 상태 유지 여부 */
  rememberMe?: boolean;
}

export interface SignupResponseDto {
  user: UserInfoDto;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
  message: string;
}

/**
 * 성별 - NICE 인증에서 확인된 성별
 */
export type Gender = (typeof Gender)[keyof typeof Gender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Gender = {
  M: "M",
  F: "F",
  O: "O",
} as const;

export interface NiceDataDto {
  /** NICE CI 해시값 - 중복가입 방지용 고유 식별자 */
  ciHash: string;
  /** NICE DI 해시값 - 서비스별 중복가입 확인용 식별자 */
  diHash: string;
  /**
   * 실명 - NICE 본인인증에서 확인된 이름
   * @maxLength 50
   */
  name: string;
  /**
   * 생년월일 - NICE 인증에서 확인된 8자리 생년월일 (YYYYMMDD)
   * @pattern ^[0-9]{8}$
   */
  birthDate: string;
  /** 성별 - NICE 인증에서 확인된 성별 */
  gender: Gender;
  /**
   * 휴대폰 번호 - NICE 인증에서 확인된 휴대폰 번호 (하이픈 있거나 없음)
   * @pattern ^0(?:[1][0-9]|[2-9]\d?)-?\d{3,4}-?\d{4}$
   */
  phone: string;
}

/**
 * 약관 타입 - terms: 이용약관(필수), privacy: 개인정보처리방침(필수), marketing: 마케팅수신(선택)
 */
export type TermDtoType = (typeof TermDtoType)[keyof typeof TermDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TermDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface TermDto {
  /** 약관 타입 - terms: 이용약관(필수), privacy: 개인정보처리방침(필수), marketing: 마케팅수신(선택) */
  type: TermDtoType;
  /** 약관 동의 여부 - terms와 privacy는 필수(true), marketing은 선택 */
  agreed: boolean;
  /** 약관 버전 */
  version: string;
}

export interface SignupCompleteDto {
  /**
   * 사용자 ID - 로그인용 고유 식별자 (4-50자, 영문/숫자/_/- 만 허용)
   * @minLength 4
   * @maxLength 50
   * @pattern ^[a-zA-Z0-9_-]+$
   */
  userId: string;
  /**
   * 비밀번호 - 8자 이상 64자 이하, 영문 소문자·숫자·특수문자(!$%&*?@) 각 1자 이상
   * @minLength 8
   * @maxLength 64
   * @pattern ^(?=.*[a-z])(?=.*\d)(?=.*[!$%&*?@])[a-zA-Z\d!$%&*?@]+$
   */
  password: string;
  /** NICE 본인인증 데이터 - 인증 완료 후 받은 사용자 정보 */
  niceData: NiceDataDto;
  /** 검증 완료된 NICE 인증 요청 번호 (POST /auth/nice/callback 응답의 requestNo) */
  verificationRequestNo: string;
  /** 약관 동의 목록 - terms와 privacy는 필수 동의, marketing은 선택 동의 */
  terms: TermDto[];
}

export interface RefreshResponseDto {
  /** New Access Token */
  accessToken: string;
  /** New Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
  message: string;
  timestamp: string;
}

export interface RefreshDto {
  /** Refresh Token */
  refreshToken: string;
}

export interface LogoutResponseDto {
  message: string;
  timestamp: string;
}

export interface TermsDefinitionResponseDto {
  id: string;
  type: string;
  version: string;
  title: string;
  content: string;
  isRequired: boolean;
}

export interface ChangePasswordDto {
  /** 현재 비밀번호 */
  currentPassword: string;
  /** 새로운 비밀번호 */
  newPassword: string;
}

export interface VerifyCiHashResponseDto {
  /** 검증 성공 여부 */
  success: boolean;
  /** 비밀번호 재설정용 임시 토큰 (15분 유효) */
  resetToken: string;
}

export interface VerifyCiHashApiResponse {
  /** API 호출 성공 여부 */
  success: boolean;
  /** 작업 성공 메시지 */
  message: string;
  /** CI Hash 검증 응답 데이터 */
  data: VerifyCiHashResponseDto;
  /** 응답 생성 시각 (ISO 8601) */
  timestamp: string;
}

export interface VerifyCiHashDto {
  /** 사용자 ID */
  userId: string;
  /** NICE 본인인증으로 받은 CI Hash */
  ciHash: string;
  /** 이번 재설정에서 한 NICE 본인인증의 요청번호 */
  requestNo: string;
}

export interface ConfirmPasswordResetResponseDto {
  /** 비밀번호 변경 완료 메시지 */
  message: string;
}

export interface ConfirmPasswordResetApiResponse {
  /** API 호출 성공 여부 */
  success: boolean;
  /** 작업 성공 메시지 */
  message: string;
  /** 비밀번호 변경 응답 데이터 */
  data: ConfirmPasswordResetResponseDto;
  /** 응답 생성 시각 (ISO 8601) */
  timestamp: string;
}

export interface ConfirmPasswordResetDto {
  /** CI Hash 검증 시 받은 재설정 토큰 */
  resetToken: string;
  /** 새 비밀번호 (최소 8자) */
  newPassword: string;
}

export interface FindUserIdDto {
  /**
   * 사용자 실명 - 회원가입 시 입력한 이름
   * @maxLength 50
   */
  name: string;
  /**
   * 휴대폰 번호 - 하이픈 있거나 없음
   * @pattern ^0(?:[1][0-9]|[2-9]\\d?)-?\\d{3,4}-?\\d{4}$
   */
  phone: string;
}

export interface FindUserIdResponseDto {
  /** 사용자 존재 여부 - true면 userId 포함, false면 null */
  exists: boolean;
  /**
   * 사용자 비즈니스 ID (user_id) - 영문/숫자/언더스코어 형식 (exists가 false면 null)
   * @nullable
   */
  userId: string | null;
}

export interface CheckUserIdAvailabilityDto {
  /** 사용자 ID */
  userId: string;
}

export interface CheckUserIdAvailabilityResponseDto {
  /** ID 사용 가능 여부 */
  available: boolean;
  /** 상태 메시지 */
  message: string;
}

/**
 * 공급자 정보
 */
export type UserResponseDtoSupplierInfo = { [key: string]: unknown };

export interface UserResponseDto {
  /** 사용자 고유 ID (UUID) */
  id: string;
  /** 사용자가 입력한 ID (username) */
  userId: string;
  /** 사용자 성명 */
  name: string;
  /** 연락처 이메일 */
  contactEmail?: string;
  /** 사용자 전화번호 */
  phone: string;
  /** 생년월일 (YYYY-MM-DD 형식) */
  birthDate?: string;
  /** 성별 (M: 남성, F: 여성) */
  gender?: string;
  /** 통신사 */
  telecom?: string;
  /** 계정 활성 상태 */
  isActive: boolean;
  /** 사용자 유형 */
  userType: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 마지막 로그인 시간 (ISO 8601 형식) */
  lastLoginAt?: string;
  /** 사용자 생성 날짜 (ISO 8601 형식) */
  createdAt: string;
  /** 프로필 수정일 (ISO 8601 형식) */
  updatedAt?: string;
  /** 공급자 정보 */
  supplierInfo?: UserResponseDtoSupplierInfo;
  /** Supabase Auth 사용자 ID (UUID) */
  authId: string;
  /** 탈퇴 신청 일시 (ISO 8601 형식) */
  withdrawalRequestedAt?: string;
  /** NICE 인증 완료 시간 (ISO 8601 형식) */
  niceVerifiedAt?: string;
  /** NICE 응답번호 */
  niceResponseNo?: string;
  /** CI (연계정보) */
  ci?: string;
  /** DI (중복가입확인정보) */
  di?: string;
  /** C마켓 공급자 ID */
  supplierId?: string;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
}

export interface UpdateUserDto {
  /** 새로운 이메일 주소 */
  email?: string;
  /** 프로필 이미지의 공개 URL */
  profileImageUrl?: string;
}

export interface ProfileImageUploadResponseDto {
  /** 업로드된 이미지의 공개 URL */
  imageUrl: string;
  /** 원본 파일명 */
  fileName: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** 파일 MIME 타입 */
  contentType: string;
}

export interface VerificationDateResponseDto {
  /**
   * 본인인증 완료 시간 (ISO 8601)
   * @nullable
   */
  verifiedAt?: string | null;
  /**
   * 본인인증 이후 경과 일수
   * @nullable
   */
  daysAgo?: number | null;
  /** 본인인증 여부 */
  isVerified: boolean;
  /**
   * 인증 상태 메시지
   * @nullable
   */
  displayText?: string | null;
}

export interface UpsertAddressDto {
  /**
   * 주소 라벨
   * @maxLength 50
   */
  label?: string;
  /** 기본 주소 설정 */
  isDefault: boolean;
  /**
   * 우편번호
   * @maxLength 10
   */
  postalCode: string;
  /**
   * 시/도
   * @maxLength 50
   */
  province: string;
  /**
   * 시/군/구
   * @maxLength 50
   */
  city: string;
  /**
   * 읍/면/동 (누락 시 null 저장)
   * @maxLength 50
   * @nullable
   */
  district?: string | null;
  /**
   * 도로명 주소
   * @maxLength 200
   */
  streetAddress: string;
  /**
   * 상세 주소
   * @maxLength 200
   */
  addressDetail?: string;
  /**
   * 수령인 이름
   * @maxLength 50
   */
  recipientName: string;
  /**
   * 수령인 연락처
   * @maxLength 20
   */
  recipientPhone?: string;
  /**
   * 주소 ID (선택사항)
   * @nullable
   */
  id?: string | null;
}

export interface SendVerificationCodeResponseDto {
  /** 마스킹된 이메일 주소 */
  maskedEmail: string;
  /** 코드 만료 시간 (초) */
  expiresIn: number;
}

export interface SendEmailVerificationCodeDto {
  /** 인증받을 이메일 주소 */
  email: string;
  /**
   * 현재 비밀번호 (본인 재확인)
   * @maxLength 64
   */
  currentPassword: string;
}

export interface EmailVerificationResponseDto {
  /** 인증된 이메일 주소 */
  email: string;
  /** 이메일 인증 성공 여부 */
  isVerified: boolean;
  /** 이메일 인증 완료 시간 (ISO 8601) */
  verifiedAt?: string;
}

export interface VerifyEmailCodeDto {
  /** 인증 코드를 받은 이메일 주소 */
  email: string;
  /**
   * 6자리 인증 코드
   * @minLength 6
   * @maxLength 6
   */
  code: string;
}

export interface NotificationSettingsResponseDto {
  /** 설정 ID (UUID) */
  id: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /** 시스템 알람 수신 여부 */
  systemEnabled: boolean;
  /** 프로젝트 알람 수신 여부 */
  projectEnabled: boolean;
  /** 채팅 알람 수신 여부 */
  chatEnabled: boolean;
  /** 결제 알람 수신 여부 */
  paymentEnabled: boolean;
  /** 후기 알람 수신 여부 */
  reviewEnabled: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoTalkEnabled: boolean;
  /** 생성일 (ISO 8601 형식) */
  createdAt: string;
  /** 수정일 (ISO 8601 형식) */
  updatedAt: string;
}

export interface UpdateNotificationSettingsDto {
  /** 시스템 알람 수신 여부 */
  systemEnabled?: boolean;
  /** 프로젝트 알람 수신 여부 */
  projectEnabled?: boolean;
  /** 채팅 알람 수신 여부 */
  chatEnabled?: boolean;
  /** 결제 알람 수신 여부 */
  paymentEnabled?: boolean;
  /** 후기 알람 수신 여부 */
  reviewEnabled?: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoTalkEnabled?: boolean;
}

export interface MarketingConsentResponseDto {
  /** 마케팅 정보 수신 동의 여부 */
  agreed: boolean;
  /**
   * 동의 시점
   * @nullable
   */
  agreedAt?: string | null;
  /**
   * 철회 시점
   * @nullable
   */
  revokedAt?: string | null;
  /**
   * 동의 채널
   * @nullable
   */
  consentChannel?: string | null;
  /**
   * 약관 버전
   * @nullable
   */
  version?: string | null;
}

export interface UpdateMarketingConsentDto {
  /** 마케팅 정보 수신 동의 여부 */
  agreed: boolean;
}

export interface UpdateAutoQuoteDto {
  /** 자동 견적 응답 활성화 여부 */
  enabled: boolean;
}

export interface WithdrawUserDto {
  /**
   * Current password for verification
   * @minLength 6
   */
  password: string;
  /** Reason for withdrawal */
  reason: string;
  /** Detailed reason for withdrawal (optional) */
  detail?: string;
}

export interface ReviewTopTagDto {
  /** 태그 문구 */
  label: string;
  /** 태그 횟수 */
  count: number;
}

export interface ProfileReviewSummaryDto {
  /** 총 리뷰 수 */
  totalReviews: number;
  /** 평균 평점 (1-5) */
  averageRating: number;
  /** 긍정 리뷰 수 (평점 4-5) */
  positiveReviewCount: number;
  /** 부정 리뷰 수 (평점 1-2) */
  negativeReviewCount: number;
  /** 긍정 태그 상위 */
  topTags: ReviewTopTagDto[];
}

/**
 * 발급 기관
 * @nullable
 */
export type SupplierCertificationDtoIssuer = { [key: string]: unknown } | null;

/**
 * 인증 번호
 * @nullable
 */
export type SupplierCertificationDtoCertNumber = {
  [key: string]: unknown;
} | null;

/**
 * 발급일
 * @nullable
 */
export type SupplierCertificationDtoIssuedAt = {
  [key: string]: unknown;
} | null;

/**
 * 만료일
 * @nullable
 */
export type SupplierCertificationDtoExpiresAt = {
  [key: string]: unknown;
} | null;

/**
 * 검증 상태
 */
export type SupplierCertificationDtoStatus =
  (typeof SupplierCertificationDtoStatus)[keyof typeof SupplierCertificationDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierCertificationDtoStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
} as const;

/**
 * 출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가)
 */
export type SupplierCertificationDtoSource =
  (typeof SupplierCertificationDtoSource)[keyof typeof SupplierCertificationDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierCertificationDtoSource = {
  SELF: "SELF",
  CMARKET: "CMARKET",
} as const;

/**
 * 종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)
 * @nullable
 */
export type SupplierCertificationDtoKind = { [key: string]: unknown } | null;

/**
 * 반려 사유
 * @nullable
 */
export type SupplierCertificationDtoRejectionReason = {
  [key: string]: unknown;
} | null;

/**
 * 업로드 파일 URL (본인/어드민만)
 * @nullable
 */
export type SupplierCertificationDtoFileUrl = { [key: string]: unknown } | null;

/**
 * 업로드 파일명
 * @nullable
 */
export type SupplierCertificationDtoFileName = {
  [key: string]: unknown;
} | null;

export interface SupplierCertificationDto {
  /** 인증서 ID */
  id: string;
  /** 인증서 명칭 */
  name: string;
  /**
   * 발급 기관
   * @nullable
   */
  issuer?: SupplierCertificationDtoIssuer;
  /**
   * 인증 번호
   * @nullable
   */
  certNumber?: SupplierCertificationDtoCertNumber;
  /**
   * 발급일
   * @nullable
   */
  issuedAt?: SupplierCertificationDtoIssuedAt;
  /**
   * 만료일
   * @nullable
   */
  expiresAt?: SupplierCertificationDtoExpiresAt;
  /** 검증 상태 */
  status: SupplierCertificationDtoStatus;
  /** 출처 — SELF: 세모에서 직접 업로드, CMARKET: 씨마켓 회원프로필 동기화(세모에서 수정·삭제 불가) */
  source: SupplierCertificationDtoSource;
  /**
   * 종류 (CERTIFICATION/LICENSE/CUSTOM, 씨마켓 동기화분만)
   * @nullable
   */
  kind?: SupplierCertificationDtoKind;
  /**
   * 반려 사유
   * @nullable
   */
  rejectionReason?: SupplierCertificationDtoRejectionReason;
  /**
   * 업로드 파일 URL (본인/어드민만)
   * @nullable
   */
  fileUrl?: SupplierCertificationDtoFileUrl;
  /**
   * 업로드 파일명
   * @nullable
   */
  fileName?: SupplierCertificationDtoFileName;
  /** 등록일시 */
  createdAt: string;
}

export interface ProfileCompletenessDto {
  /** 완성도 (0-100) */
  percent: number;
  /** 비어 있는 항목 키 목록 */
  missing: string[];
}

/**
 * 회사명 (익명이면 null)
 * @nullable
 */
export type MySupplierProfileDtoCompanyName = { [key: string]: unknown } | null;

/**
 * 대표자명 (익명이면 null)
 * @nullable
 */
export type MySupplierProfileDtoCeoName = { [key: string]: unknown } | null;

/**
 * 지역 (시/도 + 시군구, 익명에도 공개)
 * @nullable
 */
export type MySupplierProfileDtoRegion = { [key: string]: unknown } | null;

/**
 * 홈페이지 URL
 * @nullable
 */
export type MySupplierProfileDtoHomepageUrl = { [key: string]: unknown } | null;

/**
 * 회사 로고 URL
 * @nullable
 */
export type MySupplierProfileDtoLogoUrl = { [key: string]: unknown } | null;

/**
 * 홈페이지 랜딩 썸네일 URL (assets 사본)
 * @nullable
 */
export type MySupplierProfileDtoLandingThumbnailUrl = {
  [key: string]: unknown;
} | null;

/**
 * 회사 소개
 * @nullable
 */
export type MySupplierProfileDtoCompanyIntro = {
  [key: string]: unknown;
} | null;

/**
 * 취급 품목 요약
 * @nullable
 */
export type MySupplierProfileDtoProductDescription = {
  [key: string]: unknown;
} | null;

/**
 * 설립일
 * @nullable
 */
export type MySupplierProfileDtoEstablishedAt = {
  [key: string]: unknown;
} | null;

/**
 * 업력 (년차, 설립일 미입력 시 null)
 * @nullable
 */
export type MySupplierProfileDtoYearsInBusiness = {
  [key: string]: unknown;
} | null;

/**
 * 세모 가입일
 * @nullable
 */
export type MySupplierProfileDtoJoinedAt = { [key: string]: unknown } | null;

/**
 * 신뢰도 점수 (0-100)
 * @nullable
 */
export type MySupplierProfileDtoTrustScore = { [key: string]: unknown } | null;

/**
 * 신뢰도 상위 백분위 (1=상위 1%)
 * @nullable
 */
export type MySupplierProfileDtoTrustPercentile = {
  [key: string]: unknown;
} | null;

export interface MySupplierProfileDto {
  /** 공급사 사용자 ID (users.id) */
  supplierId: string;
  /** 신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true) */
  isRevealed: boolean;
  /**
   * 회사명 (익명이면 null)
   * @nullable
   */
  companyName?: MySupplierProfileDtoCompanyName;
  /**
   * 대표자명 (익명이면 null)
   * @nullable
   */
  ceoName?: MySupplierProfileDtoCeoName;
  /**
   * 지역 (시/도 + 시군구, 익명에도 공개)
   * @nullable
   */
  region?: MySupplierProfileDtoRegion;
  /**
   * 홈페이지 URL
   * @nullable
   */
  homepageUrl?: MySupplierProfileDtoHomepageUrl;
  /**
   * 회사 로고 URL
   * @nullable
   */
  logoUrl?: MySupplierProfileDtoLogoUrl;
  /**
   * 홈페이지 랜딩 썸네일 URL (assets 사본)
   * @nullable
   */
  landingThumbnailUrl?: MySupplierProfileDtoLandingThumbnailUrl;
  /**
   * 회사 소개
   * @nullable
   */
  companyIntro?: MySupplierProfileDtoCompanyIntro;
  /**
   * 취급 품목 요약
   * @nullable
   */
  productDescription?: MySupplierProfileDtoProductDescription;
  /**
   * 설립일
   * @nullable
   */
  establishedAt?: MySupplierProfileDtoEstablishedAt;
  /**
   * 업력 (년차, 설립일 미입력 시 null)
   * @nullable
   */
  yearsInBusiness?: MySupplierProfileDtoYearsInBusiness;
  /**
   * 세모 가입일
   * @nullable
   */
  joinedAt?: MySupplierProfileDtoJoinedAt;
  /**
   * 신뢰도 점수 (0-100)
   * @nullable
   */
  trustScore?: MySupplierProfileDtoTrustScore;
  /**
   * 신뢰도 상위 백분위 (1=상위 1%)
   * @nullable
   */
  trustPercentile?: MySupplierProfileDtoTrustPercentile;
  /** 후기 요약 */
  reviewSummary: ProfileReviewSummaryDto;
  /** 검증된 인증서 수 */
  certificationCount: number;
  /** 검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개) */
  certifications: SupplierCertificationDto[];
  /** 프로필 완성도 */
  completeness: ProfileCompletenessDto;
}

export interface UpdateSupplierProfileRequestDto {
  /** 홈페이지 URL (변경 시 랜딩 썸네일 재캡처) */
  homepageUrl?: string;
  /** 설립일 */
  establishedAt?: string;
  /** 회사 소개 */
  companyIntro?: string;
  /** 취급 품목 요약 (255자) */
  productDescription?: string;
}

export interface SupplierLogoUploadResponseDto {
  /** 업로드된 로고 공개 URL */
  logoUrl: string;
}

/**
 * 회사명 (익명이면 null)
 * @nullable
 */
export type SupplierPublicProfileDtoCompanyName = {
  [key: string]: unknown;
} | null;

/**
 * 대표자명 (익명이면 null)
 * @nullable
 */
export type SupplierPublicProfileDtoCeoName = { [key: string]: unknown } | null;

/**
 * 지역 (시/도 + 시군구, 익명에도 공개)
 * @nullable
 */
export type SupplierPublicProfileDtoRegion = { [key: string]: unknown } | null;

/**
 * 홈페이지 URL
 * @nullable
 */
export type SupplierPublicProfileDtoHomepageUrl = {
  [key: string]: unknown;
} | null;

/**
 * 회사 로고 URL
 * @nullable
 */
export type SupplierPublicProfileDtoLogoUrl = { [key: string]: unknown } | null;

/**
 * 홈페이지 랜딩 썸네일 URL (assets 사본)
 * @nullable
 */
export type SupplierPublicProfileDtoLandingThumbnailUrl = {
  [key: string]: unknown;
} | null;

/**
 * 회사 소개
 * @nullable
 */
export type SupplierPublicProfileDtoCompanyIntro = {
  [key: string]: unknown;
} | null;

/**
 * 취급 품목 요약
 * @nullable
 */
export type SupplierPublicProfileDtoProductDescription = {
  [key: string]: unknown;
} | null;

/**
 * 설립일
 * @nullable
 */
export type SupplierPublicProfileDtoEstablishedAt = {
  [key: string]: unknown;
} | null;

/**
 * 업력 (년차, 설립일 미입력 시 null)
 * @nullable
 */
export type SupplierPublicProfileDtoYearsInBusiness = {
  [key: string]: unknown;
} | null;

/**
 * 세모 가입일
 * @nullable
 */
export type SupplierPublicProfileDtoJoinedAt = {
  [key: string]: unknown;
} | null;

/**
 * 신뢰도 점수 (0-100)
 * @nullable
 */
export type SupplierPublicProfileDtoTrustScore = {
  [key: string]: unknown;
} | null;

/**
 * 신뢰도 상위 백분위 (1=상위 1%)
 * @nullable
 */
export type SupplierPublicProfileDtoTrustPercentile = {
  [key: string]: unknown;
} | null;

export interface SupplierPublicProfileDto {
  /** 공급사 사용자 ID (users.id) */
  supplierId: string;
  /** 신원 공개 여부 (계약 체결·PRO 플랜·본인·어드민이면 true) */
  isRevealed: boolean;
  /**
   * 회사명 (익명이면 null)
   * @nullable
   */
  companyName?: SupplierPublicProfileDtoCompanyName;
  /**
   * 대표자명 (익명이면 null)
   * @nullable
   */
  ceoName?: SupplierPublicProfileDtoCeoName;
  /**
   * 지역 (시/도 + 시군구, 익명에도 공개)
   * @nullable
   */
  region?: SupplierPublicProfileDtoRegion;
  /**
   * 홈페이지 URL
   * @nullable
   */
  homepageUrl?: SupplierPublicProfileDtoHomepageUrl;
  /**
   * 회사 로고 URL
   * @nullable
   */
  logoUrl?: SupplierPublicProfileDtoLogoUrl;
  /**
   * 홈페이지 랜딩 썸네일 URL (assets 사본)
   * @nullable
   */
  landingThumbnailUrl?: SupplierPublicProfileDtoLandingThumbnailUrl;
  /**
   * 회사 소개
   * @nullable
   */
  companyIntro?: SupplierPublicProfileDtoCompanyIntro;
  /**
   * 취급 품목 요약
   * @nullable
   */
  productDescription?: SupplierPublicProfileDtoProductDescription;
  /**
   * 설립일
   * @nullable
   */
  establishedAt?: SupplierPublicProfileDtoEstablishedAt;
  /**
   * 업력 (년차, 설립일 미입력 시 null)
   * @nullable
   */
  yearsInBusiness?: SupplierPublicProfileDtoYearsInBusiness;
  /**
   * 세모 가입일
   * @nullable
   */
  joinedAt?: SupplierPublicProfileDtoJoinedAt;
  /**
   * 신뢰도 점수 (0-100)
   * @nullable
   */
  trustScore?: SupplierPublicProfileDtoTrustScore;
  /**
   * 신뢰도 상위 백분위 (1=상위 1%)
   * @nullable
   */
  trustPercentile?: SupplierPublicProfileDtoTrustPercentile;
  /** 후기 요약 */
  reviewSummary: ProfileReviewSummaryDto;
  /** 검증된 인증서 수 */
  certificationCount: number;
  /** 검증된 인증서 목록 (익명이면 빈 배열 — 개수만 공개) */
  certifications: SupplierCertificationDto[];
}

/**
 * 검증 결과
 */
export type VerifySupplierCertificationRequestDtoStatus =
  (typeof VerifySupplierCertificationRequestDtoStatus)[keyof typeof VerifySupplierCertificationRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VerifySupplierCertificationRequestDtoStatus = {
  VERIFIED: "VERIFIED",
  REJECTED: "REJECTED",
} as const;

export interface VerifySupplierCertificationRequestDto {
  /** 검증 결과 */
  status: VerifySupplierCertificationRequestDtoStatus;
  /** 반려 사유 (REJECTED 시) */
  rejectionReason?: string;
}

export interface ContractListSupplierDto {
  /** 공급자 회사명 */
  name: string;
}

/**
 * 견적 요청 상태
 */
export type QuoteRequestInfoDtoStatus =
  (typeof QuoteRequestInfoDtoStatus)[keyof typeof QuoteRequestInfoDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestInfoDtoStatus = {
  TEMP_SAVE: "TEMP_SAVE",
  WAITING_APPROVAL: "WAITING_APPROVAL",
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED",
} as const;

export interface QuoteRequestInfoDto {
  /** 견적 요청 ID */
  id: string;
  /** 견적 요청 번호 (UI 표시용 - SE 제외) */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 견적 요청 상태 */
  status: QuoteRequestInfoDtoStatus;
  /**
   * 마감일 (ISO 8601)
   * @nullable
   */
  deadline: string | null;
  /**
   * 응답 수
   * @minimum 0
   */
  responseCount: number;
}

export interface ContractListBuyerDto {
  /** 구매자명 */
  name?: string;
}

export interface ContractLabelValueDto {
  /** 내부 코드 */
  value: string;
  /** 표시 라벨 */
  label: string;
}

/**
 * 계약 상태
 */
export type ContractListResponseDtoStatus =
  (typeof ContractListResponseDtoStatus)[keyof typeof ContractListResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

/**
 * 정산상태
 */
export type ContractListResponseDtoSettlementStatus =
  (typeof ContractListResponseDtoSettlementStatus)[keyof typeof ContractListResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoSettlementStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

/**
 * 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)
 * @nullable
 */
export type ContractListResponseDtoPaymentMethod =
  | (typeof ContractListResponseDtoPaymentMethod)[keyof typeof ContractListResponseDtoPaymentMethod]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoPaymentMethod = {
  CARD: "CARD",
  BANK_TRANSFER: "BANK_TRANSFER",
} as const;

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.
 * @nullable
 */
export type ContractListResponseDtoPaymentChannel =
  | (typeof ContractListResponseDtoPaymentChannel)[keyof typeof ContractListResponseDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.
 * @nullable
 */
export type ContractListResponseDtoTaxInvoiceStatus =
  | (typeof ContractListResponseDtoTaxInvoiceStatus)[keyof typeof ContractListResponseDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

/**
 * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.
 * @nullable
 */
export type ContractListResponseDtoTaxInvoiceTargetId = {
  [key: string]: unknown;
} | null;

/**
 * 발주자 정보
 * @nullable
 */
export type ContractListResponseDtoBuyer = ContractListBuyerDto | null;

/**
 * 공사 유형 (공사 카테고리인 경우)
 * @nullable
 */
export type ContractListResponseDtoConstructionType =
  ContractLabelValueDto | null;

/**
 * 공사 장소 (공사 카테고리인 경우)
 * @nullable
 */
export type ContractListResponseDtoSpaceType = ContractLabelValueDto | null;

/**
 * 공사 면적 (공사 카테고리인 경우)
 * @nullable
 */
export type ContractListResponseDtoConstructionArea =
  ContractLabelValueDto | null;

/**
 * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
 * @nullable
 */
export type ContractListResponseDtoCancellationRequestedBy =
  | (typeof ContractListResponseDtoCancellationRequestedBy)[keyof typeof ContractListResponseDtoCancellationRequestedBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractListResponseDtoCancellationRequestedBy = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

export interface ContractListResponseDto {
  /** 계약 ID (UUID) */
  id: string;
  /** 계약 번호 (UI 표시용 - SE 제외) */
  contractNumber: string;
  /** 계약 상태 */
  status: ContractListResponseDtoStatus;
  /** 총 금액 */
  totalAmount: number;
  /**
   * 계약서 PDF URL (생성 중이면 null)
   * @nullable
   */
  pdfUrl: string | null;
  /** 공급자 정보 */
  supplier: ContractListSupplierDto;
  /** 견적 요청 정보 (참조용) */
  quoteRequest: QuoteRequestInfoDto;
  /**
   * 이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고(`externalRef`), 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다. 계약 목록에서 [카드결제]/[카드영수증] 을 그리는 재료.
   * @nullable
   */
  quoteResponseVersionId?: string | null;
  /** 정산상태 */
  settlementStatus: ContractListResponseDtoSettlementStatus;
  /**
   * 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)
   * @nullable
   */
  paymentMethod?: ContractListResponseDtoPaymentMethod;
  /**
   * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 위 `paymentMethod` 는 **결제 거래**의 수단(DIRECT/CMARKET_CARD 등)이라 이것과 다른 축이다 — 현금/카드 배지는 반드시 이 필드로 그릴 것.
   * @nullable
   */
  paymentChannel?: ContractListResponseDtoPaymentChannel;
  /**
   * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨.
   * @nullable
   */
  taxInvoiceStatus?: ContractListResponseDtoTaxInvoiceStatus;
  /**
   * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키.
   * @nullable
   */
  taxInvoiceTargetId?: ContractListResponseDtoTaxInvoiceTargetId;
  /**
   * 발주자 정보
   * @nullable
   */
  buyer?: ContractListResponseDtoBuyer;
  /**
   * 공사 유형 (공사 카테고리인 경우)
   * @nullable
   */
  constructionType?: ContractListResponseDtoConstructionType;
  /**
   * 공사 장소 (공사 카테고리인 경우)
   * @nullable
   */
  spaceType?: ContractListResponseDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리인 경우)
   * @nullable
   */
  constructionArea?: ContractListResponseDtoConstructionArea;
  /**
   * 계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * 계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)
   * @nullable
   */
  cancellationRequestedAt?: string | null;
  /**
   * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
   * @nullable
   */
  cancellationRequestedBy?: ContractListResponseDtoCancellationRequestedBy;
  /**
   * 계약 취소 일시 (status=CANCELED일 때만 존재)
   * @nullable
   */
  canceledAt?: string | null;
  /** 계약 생성 일시 (ISO 8601) */
  createdAt: string;
}

export interface ContractSupplierDto {
  /** 공급자 ID */
  id: string;
  /** 공급자 회사명 */
  name: string;
  /** 대표자명 */
  ceoName: string;
  /** 사업자등록번호 */
  businessNumber: string;
  /** 회사 주소 */
  address?: string;
  /** 회사 전화번호 */
  phone?: string;
  /** 공급자 이메일 */
  email?: string;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 전화번호 */
  managerPhone?: string;
  /** 회사 직인 URL */
  companySealUrl?: string;
  /** 은행명 */
  bankName?: string;
  /** 계좌번호 */
  bankAccountNumber?: string;
  /** 예금주 */
  bankAccountHolder?: string;
}

export interface ContractBuyerDto {
  /** 구매자명 */
  name?: string;
  /** 발주기관명 */
  company?: string;
  /** 발주기관 대표자 */
  representativeName?: string;
  /** 발주기관 사업자등록번호 */
  businessNumber?: string;
  /** 발주기관 주소 */
  address?: string;
  /** 구매자 전화번호 */
  phone?: string;
  /** 구매자 이메일 */
  email?: string;
}

/**
 * 계약 상태
 */
export type ContractResponseDtoStatus =
  (typeof ContractResponseDtoStatus)[keyof typeof ContractResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

/**
 * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
 * @nullable
 */
export type ContractResponseDtoCancellationRequestedBy =
  | (typeof ContractResponseDtoCancellationRequestedBy)[keyof typeof ContractResponseDtoCancellationRequestedBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoCancellationRequestedBy = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

/**
 * 카테고리 유형
 */
export type ContractResponseDtoCategoryType =
  (typeof ContractResponseDtoCategoryType)[keyof typeof ContractResponseDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER)
 */
export type ContractResponseDtoPaymentMethod =
  (typeof ContractResponseDtoPaymentMethod)[keyof typeof ContractResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoPaymentMethod = {
  CARD: "CARD",
  BANK_TRANSFER: "BANK_TRANSFER",
} as const;

/**
 * 정산상태
 */
export type ContractResponseDtoSettlementStatus =
  (typeof ContractResponseDtoSettlementStatus)[keyof typeof ContractResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoSettlementStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

/**
 * 발주자 정보
 * @nullable
 */
export type ContractResponseDtoBuyer = ContractBuyerDto | null;

/**
 * 배송지 정보
 * @nullable
 */
export type ContractResponseDtoDeliveryAddress = AddressResponseDto | null;

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
 * @nullable
 */
export type ContractResponseDtoPaymentChannel =
  | (typeof ContractResponseDtoPaymentChannel)[keyof typeof ContractResponseDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

/**
 * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.
 * @nullable
 */
export type ContractResponseDtoTaxInvoiceStatus =
  | (typeof ContractResponseDtoTaxInvoiceStatus)[keyof typeof ContractResponseDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractResponseDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

/**
 * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).
 * @nullable
 */
export type ContractResponseDtoTaxInvoiceTargetId = {
  [key: string]: unknown;
} | null;

export interface ContractResponseDto {
  /** 계약 ID */
  id: string;
  /** 결제 거래 ID */
  paymentTransactionId: string;
  /** 계약번호 */
  contractNumber: string;
  /** 총 금액 */
  totalAmount: number;
  /** 세금 (선택사항) */
  taxAmount?: number;
  /** 계약 상태 */
  status: ContractResponseDtoStatus;
  /**
   * 계약서 PDF URL
   * @nullable
   */
  pdfUrl: string | null;
  /** 계약서 PDF 생성 일시 (ISO 8601) */
  pdfGeneratedAt: string;
  /** 계약 항목 */
  items: QuoteItemDto[];
  /** 공급자 정보 */
  supplier: ContractSupplierDto;
  /** 견적 설명/비고 */
  description?: string;
  /** 계약 생성 일시 (ISO 8601) */
  createdAt: string;
  /** 계약 수정 일시 (ISO 8601) */
  updatedAt: string;
  /**
   * 계약 취소 일시 (status=CANCELED일 때만 존재)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * 계약 취소 사유 (발주기관이 취소 요청 시 입력한 값. 취소 요청 접수 시점부터 세팅되며, 취소 확정 후에도 원본이 유지됨)
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * 계약 취소 요청 일시 (환불 승인 대기 상태일 때부터 존재)
   * @nullable
   */
  cancellationRequestedAt?: string | null;
  /**
   * 계약 취소 요청 주체 (buyer: 발주기관 요청, supplier: 공급사 요청). 취소 요청이 없거나 반려된 경우 null.
   * @nullable
   */
  cancellationRequestedBy?: ContractResponseDtoCancellationRequestedBy;
  /**
   * 구매확정 일시 (status=COMPLETED일 때만 존재)
   * @nullable
   */
  completedAt?: string | null;
  /** 프로젝트명 (거래명) */
  projectName?: string;
  /** 카테고리 유형 */
  categoryType?: ContractResponseDtoCategoryType;
  /** 견적 요청 ID */
  quoteRequestId?: string;
  /** 견적 응답 버전 ID (2026-07-31). 계약 카드의 [결제하기] 가 씨마켓 결제창을 발행할 때 이 값을 필요로 한다. */
  quoteResponseVersionId?: string;
  /** 채팅방 ID (채팅 시작용) */
  chatRoomId?: string;
  /** 채팅 메시지 ID */
  chatMessageId?: string;
  /** 리뷰 ID (작성된 리뷰가 있는 경우) */
  reviewId?: string;
  /** 결제방식 (결제 수단 유형: CARD, BANK_TRANSFER) */
  paymentMethod?: ContractResponseDtoPaymentMethod;
  /** 정산상태 */
  settlementStatus: ContractResponseDtoSettlementStatus;
  /**
   * 환불 상태 (REQUESTED, APPROVED, REJECTED, PROCESSING, COMPLETED, FAILED)
   * @nullable
   */
  refundStatus?: string | null;
  /**
   * 환불 반려 사유 (refundStatus=REJECTED일 때만 존재)
   * @nullable
   */
  rejectionReason?: string | null;
  /**
   * 발주자 정보
   * @nullable
   */
  buyer?: ContractResponseDtoBuyer;
  /**
   * 배송지 정보
   * @nullable
   */
  deliveryAddress?: ContractResponseDtoDeliveryAddress;
  /** 결제 방법 (계약 시점 스냅샷). true=선결제(prepaid, 계약 체결과 결제 동시), false=후불결제(postpaid, 결제 없이 계약 체결 후 별도 결제). */
  isPrepaid: boolean;
  /**
   * 결제 완료 시각. NULL 이면 미결제(postpaid 만 가능). prepaid 는 created_at 과 동일.
   * @nullable
   */
  paidAt?: string | null;
  /**
   * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
   * @nullable
   */
  paymentChannel?: ContractResponseDtoPaymentChannel;
  /**
   * 씨마켓 세금계산서 상태. NULL 은 아직 발행요청 전. REQUESTED=발주기관이 요청함, ISSUED=공급기업이 발행함, CANCELLED=발행취소됨. 발행 자체는 씨마켓 나의 계약 관리에서 일어난다.
   * @nullable
   */
  taxInvoiceStatus?: ContractResponseDtoTaxInvoiceStatus;
  /**
   * 씨마켓 세금계산서 축 id(`SI…`). 씨마켓 계산서 화면으로 넘길 때의 키다. NULL 이면 씨마켓에 발행 대상이 없는 계약(미연동 계정이거나 등록 실패).
   * @nullable
   */
  taxInvoiceTargetId?: ContractResponseDtoTaxInvoiceTargetId;
}

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 미전달 시 미상(NULL)으로 저장된다.
 */
export type CreateContractRequestDtoPaymentChannel =
  (typeof CreateContractRequestDtoPaymentChannel)[keyof typeof CreateContractRequestDtoPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContractRequestDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

export interface CreateContractRequestDto {
  /** 결제 거래 ID (MOID). 직접 결제 시 생략 가능. */
  paymentTransactionId?: string;
  /** 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /** 총 금액 */
  totalAmount: number;
  /** 세금 (선택사항) */
  taxAmount?: number;
  /** 계약 항목 */
  items: QuoteItemDto[];
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
  /** 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. 미전달 시 미상(NULL)으로 저장된다. */
  paymentChannel?: CreateContractRequestDtoPaymentChannel;
}

export interface ContractCardPaymentStatusResponseDto {
  /** 씨마켓 카드결제 가맹 가입 안내를 띄워야 하는가. 씨마켓 결제창으로 받아야 하는 카드 계약인데 공급사가 아직 가맹이 아닐 때만 true. 세모 안심결제 계약·현금 계약·판정할 수 없는 경우는 false. */
  cmarketCardSignupRequired: boolean;
}

export interface CompleteContractRequestDto {
  /** 좋은 점 태그 (최대 6개) */
  positiveAspects: string[];
  /** 아쉬운 점 태그 (최대 4개) */
  negativeAspects?: string[];
  /**
   * 상세 후기 (최소 10자)
   * @minLength 10
   */
  detailedReview: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface CancelContractRequestDto {
  /**
   * 계약 취소 사유 (canonical). reason 또는 refund_reason 중 최소 하나는 필수.
   * @minLength 1
   */
  reason?: string;
  /**
   * [Deprecated] 취소 사유의 구버전 필드명. reason 필드로 마이그레이션 예정. reason이 없을 때만 fallback으로 사용됨.
   * @deprecated
   * @minLength 1
   */
  refund_reason?: string;
  /** 환불 받을 은행명 (현금 결제 & 발주기관 요청 시에만 유효) */
  refund_bank?: string;
  /** 환불 받을 계좌번호 (현금 결제 시 필수) */
  refund_account_number?: string;
  /** 환불 계좌 예금주 (현금 결제 시 필수) */
  refund_account_holder?: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface CreateQuoteRequestItemDto {
  /** 품목명 */
  name: string;
  /**
   * 수량
   * @minimum 1
   */
  quantity: number;
  /** 단위 (예: 세트, EA, 박스) */
  unit: string;
  /**
   * 금액 (원 단위, 예상 금액 또는 0)
   * @minimum 0
   */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 품목 ID (items_v2_base.id) - 자동완성 선택 시에만 제공 */
  itemId?: string;
}

export interface LabelValuePair {
  /** English code identifier */
  value: string;
  /** Korean UI label for display */
  label: string;
}

/**
 * Construction type code
 */
export type ConstructionTypeLabelValueValue =
  (typeof ConstructionTypeLabelValueValue)[keyof typeof ConstructionTypeLabelValueValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionTypeLabelValueValue = {
  facility_maintenance: "facility_maintenance",
  interior_architecture: "interior_architecture",
  waterproofing_plaster_painting: "waterproofing_plaster_painting",
  mechanical_equipment: "mechanical_equipment",
  metal_structure_window: "metal_structure_window",
  paving: "paving",
  electrical: "electrical",
  scaffolding_demolition: "scaffolding_demolition",
  asbestos_removal: "asbestos_removal",
  rebar_concrete: "rebar_concrete",
  fire_safety: "fire_safety",
  landscaping: "landscaping",
  roofing_assembly: "roofing_assembly",
  elevator: "elevator",
  gas_facility: "gas_facility",
  hvac: "hvac",
  telecommunications: "telecommunications",
  cctv: "cctv",
  "365_corner": "365_corner",
  civil_construction: "civil_construction",
  building_construction: "building_construction",
  specialized_construction: "specialized_construction",
  water_sewage: "water_sewage",
  stone_work: "stone_work",
  earthwork: "earthwork",
  grouting: "grouting",
  dredging: "dredging",
  outdoor_signage: "outdoor_signage",
  other: "other",
} as const;

export interface ConstructionTypeLabelValue {
  /** Construction type code */
  value: ConstructionTypeLabelValueValue;
  /** Korean label for display */
  label: string;
}

/**
 * Space type code
 */
export type SpaceTypeLabelValueValue =
  (typeof SpaceTypeLabelValueValue)[keyof typeof SpaceTypeLabelValueValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SpaceTypeLabelValueValue = {
  office: "office",
  retail: "retail",
  factory: "factory",
  warehouse: "warehouse",
} as const;

export interface SpaceTypeLabelValue {
  /** Space type code */
  value: SpaceTypeLabelValueValue;
  /** Korean label for display */
  label: string;
}

/**
 * Construction area code
 */
export type ConstructionAreaLabelValueValue =
  (typeof ConstructionAreaLabelValueValue)[keyof typeof ConstructionAreaLabelValueValue];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionAreaLabelValueValue = {
  NUMBER_30: "30",
  NUMBER_50: "50",
  NUMBER_100: "100",
  NUMBER_200: "200",
} as const;

export interface ConstructionAreaLabelValue {
  /** Construction area code */
  value: ConstructionAreaLabelValueValue;
  /** Korean label for display */
  label: string;
}

/**
 * 카테고리 타입
 */
export type CreateQuoteRequestDtoCategoryType =
  (typeof CreateQuoteRequestDtoCategoryType)[keyof typeof CreateQuoteRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type CreateQuoteRequestDtoBudgetType =
  | (typeof CreateQuoteRequestDtoBudgetType)[keyof typeof CreateQuoteRequestDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type CreateQuoteRequestDtoPaymentMethod =
  (typeof CreateQuoteRequestDtoPaymentMethod)[keyof typeof CreateQuoteRequestDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type CreateQuoteRequestDtoPreferredPaymentChannel =
  (typeof CreateQuoteRequestDtoPreferredPaymentChannel)[keyof typeof CreateQuoteRequestDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type CreateQuoteRequestDtoDueDateValue =
  | (typeof CreateQuoteRequestDtoDueDateValue)[keyof typeof CreateQuoteRequestDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateQuoteRequestDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateQuoteRequestDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateQuoteRequestDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type CreateQuoteRequestDtoConstructionArea =
  ConstructionAreaLabelValue | null;

export interface CreateQuoteRequestDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType: CreateQuoteRequestDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact: string;
  /**
   * 담당자명
   * @maxLength 100
   */
  managerName: string;
  /** 주소 ID (addresses 테이블 외래키) */
  addressId: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: CreateQuoteRequestDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: CreateQuoteRequestDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: CreateQuoteRequestDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: CreateQuoteRequestDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: CreateQuoteRequestDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: CreateQuoteRequestDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: CreateQuoteRequestDtoConstructionArea;
}

export interface QuoteRequestSimpleAddressDto {
  /** 시/도 */
  province: string;
  /** 시/군/구 */
  city: string;
  /**
   * 읍/면/동
   * @nullable
   */
  district?: string | null;
  /**
   * 배송지 이름 (예: 회사) (작성자 본인만)
   * @nullable
   */
  label?: string | null;
  /**
   * 우편번호 (작성자 본인만)
   * @nullable
   */
  postalCode?: string | null;
  /**
   * 기본주소 (작성자 본인만)
   * @nullable
   */
  addressLine1?: string | null;
  /**
   * 상세주소 (작성자 본인만)
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * 수령인 (작성자 본인만)
   * @nullable
   */
  recipientName?: string | null;
}

/**
 * 상태
 */
export type QuoteRequestListItemDtoStatus =
  (typeof QuoteRequestListItemDtoStatus)[keyof typeof QuoteRequestListItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type QuoteRequestListItemDtoCategoryType =
  (typeof QuoteRequestListItemDtoCategoryType)[keyof typeof QuoteRequestListItemDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 지역 정보
 * @nullable
 */
export type QuoteRequestListItemDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type QuoteRequestListItemDtoBudgetType =
  | (typeof QuoteRequestListItemDtoBudgetType)[keyof typeof QuoteRequestListItemDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type QuoteRequestListItemDtoPaymentMethod =
  (typeof QuoteRequestListItemDtoPaymentMethod)[keyof typeof QuoteRequestListItemDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type QuoteRequestListItemDtoPreferredPaymentChannel =
  | (typeof QuoteRequestListItemDtoPreferredPaymentChannel)[keyof typeof QuoteRequestListItemDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type QuoteRequestListItemDtoDueDateValue =
  | (typeof QuoteRequestListItemDtoDueDateValue)[keyof typeof QuoteRequestListItemDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestListItemDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 유형
 * @nullable
 */
export type QuoteRequestListItemDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 유형
 * @nullable
 */
export type QuoteRequestListItemDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적
 * @nullable
 */
export type QuoteRequestListItemDtoConstructionArea =
  ConstructionAreaLabelValue | null;

export interface QuoteRequestListItemDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /** 상태 */
  status: QuoteRequestListItemDtoStatus;
  /** 카테고리 타입 */
  categoryType: QuoteRequestListItemDtoCategoryType;
  /** 마감일 */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /** 사용자 ID (UUID) */
  userId: string;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 주소 ID
   * @nullable
   */
  addressId?: string | null;
  /**
   * 지역 정보
   * @nullable
   */
  address?: QuoteRequestListItemDtoAddress;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: QuoteRequestListItemDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: QuoteRequestListItemDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: QuoteRequestListItemDtoPreferredPaymentChannel;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: QuoteRequestListItemDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 공사 유형
   * @nullable
   */
  constructionType?: QuoteRequestListItemDtoConstructionType;
  /**
   * 공간 유형
   * @nullable
   */
  spaceType?: QuoteRequestListItemDtoSpaceType;
  /**
   * 공사 면적
   * @nullable
   */
  constructionArea?: QuoteRequestListItemDtoConstructionArea;
  /** 받은 견적 응답 개수 */
  responseCount: number;
  /**
   * 현재 판매자의 응답 여부
   * @nullable
   */
  hasResponded?: boolean | null;
  /** 판매자가 작성한 견적 응답 ID */
  quoteResponseId?: string;
  /** 자동 견적 가능 여부 (공급자 전용) */
  canAutoQuote?: boolean;
  /**
   * 현재 판매자 본인의 비취소 계약 존재 여부 (공급자 전용). 견적요청 단위 status=CONTRACT_IN_PROGRESS 와 달리 타사 계약에는 켜지지 않는다. null=판정 불가(발주기관 조회 등).
   * @nullable
   */
  hasMyContract?: boolean | null;
}

export interface QuoteResponseSummaryDto {
  /** 견적 응답 ID */
  id: string;
  /** 공급자명 */
  supplierName: string;
  /** 공급자 ID (세모 내부 UUID) */
  supplierId: string;
  /**
   * 씨마켓 공급사 회원 ID. 익명화 대상이거나 씨마켓 회원이 아니면 null
   * @nullable
   */
  supplierMemberId: string | null;
  /** 견적 금액 */
  totalAmount: number;
  /** 공급자 신뢰 점수 */
  trustScore: number;
  /**
   * 공급자 신뢰 백분위
   * @nullable
   */
  trustPercentile?: number | null;
  /**
   * 채팅방 ID
   * @nullable
   */
  chatRoomId: string | null;
  /** 익명 여부 (블러 처리 필요) */
  isAnonymous: boolean;
  /** 계약 여부 (채팅방 기준) */
  isContracted: boolean;
  /**
   * 공급사가 견적을 철회한 시각 (ISO 8601). null 이면 철회 안 됨
   * @nullable
   */
  withdrawnAt?: string | null;
  /** 공급사 첨부. URL 은 1시간 서명. 익명화 대상이면 빈 배열 */
  attachments: AttachmentMetadataDto[];
  /** 생성일 */
  createdAt: string;
}

/**
 * 계약 상태
 */
export type QuoteRequestContractSummaryDtoStatus =
  (typeof QuoteRequestContractSummaryDtoStatus)[keyof typeof QuoteRequestContractSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestContractSummaryDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

/**
 * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
 * @nullable
 */
export type QuoteRequestContractSummaryDtoPaymentChannel =
  | (typeof QuoteRequestContractSummaryDtoPaymentChannel)[keyof typeof QuoteRequestContractSummaryDtoPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestContractSummaryDtoPaymentChannel = {
  cash: "cash",
  card: "card",
} as const;

export interface QuoteRequestContractSummaryDto {
  /** 계약 ID (UUID) */
  id: string;
  /** 계약 번호 (UI 표시용) */
  contractNumber: string;
  /** 계약 상태 */
  status: QuoteRequestContractSummaryDtoStatus;
  /** 계약 취소 여부 */
  isCanceled: boolean;
  /**
   * 계약 취소 요청 일시 (ISO 8601)
   * @nullable
   */
  cancellationRequestedAt?: string | null;
  /**
   * 계약 취소 완료 일시 (ISO 8601)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * 계약 취소 사유
   * @nullable
   */
  cancellationReason?: string | null;
  /** 계약 공급사 ID (UUID) */
  supplierId: string;
  /**
   * 계약 공급사 상호. 씨마켓 «계약 업체» 칸이 그리는 값 — 참여 업체 목록과 짝맞추지 않아도 되도록 여기서 함께 내려보낸다.
   * @nullable
   */
  supplierName?: string | null;
  /**
   * 이 계약이 선 견적 응답 **버전** id. 씨마켓이 이 계약의 결제창을 되짚는 유일한 키다 — 결제창 발행 시 이 값을 멱등키로 보냈고, 씨마켓은 그 값으로 계약 ↔ 결제창을 1:1 로 묶어 두었다.
   * @nullable
   */
  quoteResponseVersionId?: string | null;
  /**
   * 발주기관이 계약 체결 시 고른 대금 지급 수단. cash=계산서 발행요청 경로, card=씨마켓 결제창 경로. NULL 은 채널 개념 이전의 레거시 계약(미상)이라 화면에서 임의로 접지 말 것.
   * @nullable
   */
  paymentChannel?: QuoteRequestContractSummaryDtoPaymentChannel;
  /** 계약 생성 일시 (ISO 8601) */
  createdAt: string;
}

export interface QuoteRequestItemResponseDto {
  /** 품목명 */
  name: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit: string;
  /** 금액 */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 품목 ID */
  itemId?: string;
  /** 매칭된 표준 품목명 */
  itemName?: string;
  /** 매칭된 표준 품목 코드 */
  itemCodeMatch?: string;
  /** 매칭된 표준 품목 단가 */
  itemPrice?: number;
  /** 매칭된 표준 품목 이미지 URL */
  itemImageUrl?: string;
  /** 매칭된 표준 품목 규격 요약 */
  itemSpec?: string;
}

/**
 * 상태
 */
export type ProductQuoteRequestDetailDtoStatus =
  (typeof ProductQuoteRequestDetailDtoStatus)[keyof typeof ProductQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type ProductQuoteRequestDetailDtoCategoryType =
  (typeof ProductQuoteRequestDetailDtoCategoryType)[keyof typeof ProductQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoCategoryType = {
  product: "product",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type ProductQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type ProductQuoteRequestDetailDtoBudgetType =
  | (typeof ProductQuoteRequestDetailDtoBudgetType)[keyof typeof ProductQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type ProductQuoteRequestDetailDtoPaymentMethod =
  (typeof ProductQuoteRequestDetailDtoPaymentMethod)[keyof typeof ProductQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type ProductQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof ProductQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof ProductQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type ProductQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof ProductQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof ProductQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type ProductQuoteRequestDetailDtoDueDateValue =
  | (typeof ProductQuoteRequestDetailDtoDueDateValue)[keyof typeof ProductQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

export interface ProductQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: ProductQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: ProductQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: ProductQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: ProductQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: ProductQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: ProductQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일 */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: ProductQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: ProductQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /** 물품 목록 */
  items: QuoteRequestItemResponseDto[];
  /**
   * 추가 조건
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
}

/**
 * 상태
 */
export type ConstructionQuoteRequestDetailDtoStatus =
  (typeof ConstructionQuoteRequestDetailDtoStatus)[keyof typeof ConstructionQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type ConstructionQuoteRequestDetailDtoCategoryType =
  (typeof ConstructionQuoteRequestDetailDtoCategoryType)[keyof typeof ConstructionQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoCategoryType = {
  construction: "construction",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoBudgetType =
  | (typeof ConstructionQuoteRequestDetailDtoBudgetType)[keyof typeof ConstructionQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type ConstructionQuoteRequestDetailDtoPaymentMethod =
  (typeof ConstructionQuoteRequestDetailDtoPaymentMethod)[keyof typeof ConstructionQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof ConstructionQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof ConstructionQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type ConstructionQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof ConstructionQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof ConstructionQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type ConstructionQuoteRequestDetailDtoDueDateValue =
  | (typeof ConstructionQuoteRequestDetailDtoDueDateValue)[keyof typeof ConstructionQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConstructionQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

export interface ConstructionQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: ConstructionQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: ConstructionQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: ConstructionQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: ConstructionQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: ConstructionQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: ConstructionQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일 */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: ConstructionQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: ConstructionQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /** 공사 유형 */
  constructionType: ConstructionTypeLabelValue;
  /** 공간 유형 */
  spaceType: SpaceTypeLabelValue;
  /** 공사 면적 */
  constructionArea: ConstructionAreaLabelValue;
}

/**
 * 상태
 */
export type ManufacturingQuoteRequestDetailDtoStatus =
  (typeof ManufacturingQuoteRequestDetailDtoStatus)[keyof typeof ManufacturingQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type ManufacturingQuoteRequestDetailDtoCategoryType =
  (typeof ManufacturingQuoteRequestDetailDtoCategoryType)[keyof typeof ManufacturingQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoCategoryType = {
  manufacturing: "manufacturing",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoBudgetType =
  | (typeof ManufacturingQuoteRequestDetailDtoBudgetType)[keyof typeof ManufacturingQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type ManufacturingQuoteRequestDetailDtoPaymentMethod =
  (typeof ManufacturingQuoteRequestDetailDtoPaymentMethod)[keyof typeof ManufacturingQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type ManufacturingQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof ManufacturingQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof ManufacturingQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type ManufacturingQuoteRequestDetailDtoDueDateValue =
  | (typeof ManufacturingQuoteRequestDetailDtoDueDateValue)[keyof typeof ManufacturingQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ManufacturingQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

export interface ManufacturingQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: ManufacturingQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: ManufacturingQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: ManufacturingQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: ManufacturingQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: ManufacturingQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: ManufacturingQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일 */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: ManufacturingQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: ManufacturingQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
}

/**
 * 상태
 */
export type UsedQuoteRequestDetailDtoStatus =
  (typeof UsedQuoteRequestDetailDtoStatus)[keyof typeof UsedQuoteRequestDetailDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

/**
 * 카테고리 타입
 */
export type UsedQuoteRequestDetailDtoCategoryType =
  (typeof UsedQuoteRequestDetailDtoCategoryType)[keyof typeof UsedQuoteRequestDetailDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoCategoryType = {
  used: "used",
} as const;

/**
 * 주소 정보
 * @nullable
 */
export type UsedQuoteRequestDetailDtoAddress =
  QuoteRequestSimpleAddressDto | null;

/**
 * 예산 타입
 * @nullable
 */
export type UsedQuoteRequestDetailDtoBudgetType =
  | (typeof UsedQuoteRequestDetailDtoBudgetType)[keyof typeof UsedQuoteRequestDetailDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type UsedQuoteRequestDetailDtoPaymentMethod =
  (typeof UsedQuoteRequestDetailDtoPaymentMethod)[keyof typeof UsedQuoteRequestDetailDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
 * @nullable
 */
export type UsedQuoteRequestDetailDtoPreferredPaymentChannel =
  | (typeof UsedQuoteRequestDetailDtoPreferredPaymentChannel)[keyof typeof UsedQuoteRequestDetailDtoPreferredPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 스마트 견적 생성 상태
 */
export type UsedQuoteRequestDetailDtoAutoQuoteStatus =
  (typeof UsedQuoteRequestDetailDtoAutoQuoteStatus)[keyof typeof UsedQuoteRequestDetailDtoAutoQuoteStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoAutoQuoteStatus = {
  none: "none",
  pending: "pending",
  processing: "processing",
  completed: "completed",
  failed: "failed",
} as const;

/**
 * 배송일 (구체적/협의가능)
 * @nullable
 */
export type UsedQuoteRequestDetailDtoDueDateValue =
  | (typeof UsedQuoteRequestDetailDtoDueDateValue)[keyof typeof UsedQuoteRequestDetailDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsedQuoteRequestDetailDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

export interface UsedQuoteRequestDetailDto {
  /** 견적 요청 ID (UUID) */
  id: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 프로젝트명 */
  projectName: string;
  /** 사용자 ID (작성자) */
  userId: string;
  /** 현재 인증 사용자가 이 견적 요청의 등록자인지 여부 (클라이언트 소유권 판단용) */
  isOwner?: boolean;
  /** 상태 */
  status: UsedQuoteRequestDetailDtoStatus;
  /** 카테고리 타입 */
  categoryType: UsedQuoteRequestDetailDtoCategoryType;
  /**
   * 담당자명
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 연락처
   * @nullable
   */
  managerContact?: string | null;
  /**
   * 발주기관 이름 (공개 공고에서만. 비공개 공고는 본인·어드민 외 null. 기관명이 없는 구매자는 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 발주기관 대표번호 (담당자 개인 휴대폰이 아니다. 공개 공고에서만, 비공개는 본인·어드민 외 null)
   * @nullable
   */
  organizationPhone?: string | null;
  /** 주소 ID */
  addressId: string;
  /**
   * 주소 정보
   * @nullable
   */
  address?: UsedQuoteRequestDetailDtoAddress;
  /**
   * 설명
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: UsedQuoteRequestDetailDtoBudgetType;
  /**
   * 예산 금액
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod: UsedQuoteRequestDetailDtoPaymentMethod;
  /** 결제 방법 (boolean form). true=선결제, false=후불결제. */
  isPrepaid: boolean;
  /**
   * 공고 결제방법. card/cash/undecided. null 은 기능 신설(2026-08-19) 이전 공고이며, 발주기관이 고른 적이 없다는 뜻이다 — 「미결정」 배지를 그리지 말 것. paymentMethod(선결제/후불)와 다른 축이다.
   * @nullable
   */
  preferredPaymentChannel: UsedQuoteRequestDetailDtoPreferredPaymentChannel;
  /**
   * 동일 지역만
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감일 */
  deadline: string;
  /**
   * 생성일 (ISO 8601)
   * @nullable
   */
  createdAt?: string | null;
  /**
   * 수정일 (ISO 8601)
   * @nullable
   */
  updatedAt?: string | null;
  /**
   * 승인 일시 (ISO 8601)
   * @nullable
   */
  approvedAt?: string | null;
  /**
   * 마감 일시 (ISO 8601)
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason?: string | null;
  /**
   * 보류 일시 (ISO 8601)
   * @nullable
   */
  onHoldAt?: string | null;
  /**
   * 첨부파일 목록
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /** 견적 응답 수 */
  responseCount: number;
  /** 견적 응답 목록 */
  responses: QuoteResponseSummaryDto[];
  /** 자동 견적 발송 여부 */
  willGenerateAutoQuotes: boolean;
  /** 스마트 견적 생성 상태 */
  autoQuoteStatus: UsedQuoteRequestDetailDtoAutoQuoteStatus;
  /** 현재 사용자에게 노출 가능한 연결 계약 목록 (external 상세에서 제공) */
  contracts: QuoteRequestContractSummaryDto[];
  /**
   * 배송일 (구체적/협의가능)
   * @nullable
   */
  dueDateValue?: UsedQuoteRequestDetailDtoDueDateValue;
  /**
   * 희망 배송일 (ISO 8601)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 추가 요청사항
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
}

export interface CheckAutoQuoteItemDto {
  /** 항목명 */
  name: string;
  /** 마스터 품목 ID (Autocomplete 선택 시) */
  itemId?: string;
}

export interface CheckAutoQuoteRequestDto {
  /** 체크할 항목 목록 */
  items: CheckAutoQuoteItemDto[];
}

export interface SuggestedBundleDto {
  /** 번들에 포함된 품목명 목록 */
  itemNames: string[];
  /** 이 조합을 처리 가능한 업체 수 */
  supplierCount: number;
  /** 전체 품목 대비 커버리지 (0~1) */
  coverage: number;
}

/**
 * 매칭 상태
 */
export type ItemAnalysisDtoStatus =
  (typeof ItemAnalysisDtoStatus)[keyof typeof ItemAnalysisDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemAnalysisDtoStatus = {
  matched: "matched",
  bundle_conflict: "bundle_conflict",
  no_supplier: "no_supplier",
} as const;

export interface ItemAnalysisDto {
  /** 품목명 */
  name: string;
  /** 마스터 품목 ID */
  itemId?: string;
  /** 매칭 상태 */
  status: ItemAnalysisDtoStatus;
  /** 이 품목을 취급하는 총 업체 수 */
  supplierCount: number;
}

export interface CheckAutoQuoteResponseDto {
  /** 전체 품목 자동 견적 가능 여부 */
  canAutoQuote: boolean;
  /** 전체 품목 매칭 시 업체 수 (canAutoQuote가 true일 때만 의미 있음) */
  supplierCount: number;
  /** 즉시 견적 가능한 최적의 품목 조합 추천 목록 */
  suggestedBundles?: SuggestedBundleDto[];
  /** 품목별 상세 분석 결과 */
  itemAnalysis?: ItemAnalysisDto[];
  /** 자동 견적이 불가능하게 만드는 품목명 목록 (하위 호환성 유지) */
  unmatchedItemNames?: string[];
}

/**
 * 카테고리 타입
 */
export type UpdateQuoteRequestDtoCategoryType =
  (typeof UpdateQuoteRequestDtoCategoryType)[keyof typeof UpdateQuoteRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type UpdateQuoteRequestDtoBudgetType =
  | (typeof UpdateQuoteRequestDtoBudgetType)[keyof typeof UpdateQuoteRequestDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type UpdateQuoteRequestDtoPaymentMethod =
  (typeof UpdateQuoteRequestDtoPaymentMethod)[keyof typeof UpdateQuoteRequestDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type UpdateQuoteRequestDtoPreferredPaymentChannel =
  (typeof UpdateQuoteRequestDtoPreferredPaymentChannel)[keyof typeof UpdateQuoteRequestDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type UpdateQuoteRequestDtoDueDateValue =
  | (typeof UpdateQuoteRequestDtoDueDateValue)[keyof typeof UpdateQuoteRequestDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateQuoteRequestDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateQuoteRequestDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateQuoteRequestDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateQuoteRequestDtoConstructionArea =
  ConstructionAreaLabelValue | null;

export interface UpdateQuoteRequestDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType?: UpdateQuoteRequestDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact?: string;
  /**
   * 담당자명
   * @maxLength 100
   */
  managerName?: string;
  /** 주소 ID (addresses 테이블 외래키) */
  addressId?: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: UpdateQuoteRequestDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: UpdateQuoteRequestDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: UpdateQuoteRequestDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: UpdateQuoteRequestDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: UpdateQuoteRequestDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: UpdateQuoteRequestDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: UpdateQuoteRequestDtoConstructionArea;
}

export interface CloseQuoteRequestDto {
  /** 마감 사유 */
  closeReason?: string;
}

/**
 * 만기가 가장 가까운 잔액
 * @nullable
 */
export type AdminPointBalanceRowDtoExpiringSoon = {
  [key: string]: unknown;
} | null;

export interface AdminPointBalanceRowDto {
  /** 씨마켓 회원/사번 */
  memberNo: string;
  total: number;
  /**
   * 만기가 가장 가까운 잔액
   * @nullable
   */
  expiringSoon: AdminPointBalanceRowDtoExpiringSoon;
}

export interface AdminPointBalanceListDto {
  members: AdminPointBalanceRowDto[];
}

export type StorefrontPointEntryDtoType =
  (typeof StorefrontPointEntryDtoType)[keyof typeof StorefrontPointEntryDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontPointEntryDtoType = {
  CHARGE: "CHARGE",
  SPEND: "SPEND",
  REFUND: "REFUND",
  DEDUCT: "DEDUCT",
  EXPIRE: "EXPIRE",
} as const;

/**
 * @nullable
 */
export type StorefrontPointEntryDtoOrderNo = { [key: string]: unknown } | null;

/**
 * 충전 로트의 사용기한 / 만료가 닫은 로트의 기한
 * @nullable
 */
export type StorefrontPointEntryDtoExpiresAt = {
  [key: string]: unknown;
} | null;

/**
 * @nullable
 */
export type StorefrontPointEntryDtoReason = { [key: string]: unknown } | null;

/**
 * 관리자 행위의 주체
 * @nullable
 */
export type StorefrontPointEntryDtoActor = { [key: string]: unknown } | null;

export interface StorefrontPointEntryDto {
  id: string;
  type: StorefrontPointEntryDtoType;
  /** 부호 있는 변동량(충전·환불 +, 사용·차감·만료 -) */
  amount: number;
  balanceAfter: number;
  /** @nullable */
  orderNo: StorefrontPointEntryDtoOrderNo;
  /**
   * 충전 로트의 사용기한 / 만료가 닫은 로트의 기한
   * @nullable
   */
  expiresAt: StorefrontPointEntryDtoExpiresAt;
  /** @nullable */
  reason: StorefrontPointEntryDtoReason;
  /**
   * 관리자 행위의 주체
   * @nullable
   */
  actor: StorefrontPointEntryDtoActor;
  createdAt: string;
}

export interface AdminPointLedgerDto {
  entries: StorefrontPointEntryDto[];
}

export interface StorefrontPointExpiringDto {
  /** 만기가 가장 가까운 잔액 */
  amount: number;
  expiresAt: string;
}

/**
 * @nullable
 */
export type StorefrontPointSummaryDtoExpiringSoon =
  StorefrontPointExpiringDto | null;

export interface StorefrontPointSummaryDto {
  /** 사용 가능 포인트(살아 있는 로트의 합) */
  total: number;
  /** @nullable */
  expiringSoon: StorefrontPointSummaryDtoExpiringSoon;
}

export interface AdminPointMutationResultDto {
  /** 처리 후 잔액 */
  balance: StorefrontPointSummaryDto;
}

/**
 * 이 충전분(로트)의 사용기한. 비우면 무기한.
 * @nullable
 */
export type AdminPointChargeDtoExpiresAt = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type AdminPointChargeDtoReason = { [key: string]: unknown } | null;

export interface AdminPointChargeDto {
  memberNo: string;
  /** 충전 포인트(양수 정수) */
  amount: number;
  /**
   * 이 충전분(로트)의 사용기한. 비우면 무기한.
   * @nullable
   */
  expiresAt?: AdminPointChargeDtoExpiresAt;
  /** @nullable */
  reason?: AdminPointChargeDtoReason;
}

export interface AdminPointDeductDto {
  memberNo: string;
  /** 차감 포인트(양수 정수) */
  amount: number;
  /** 사유 — 관리자 차감은 사유 없이 성립하지 않는다 */
  reason: string;
}

export interface AdminStorefrontDto {
  id: string;
  slug: string;
  name: string;
  /** @nullable */
  description?: string | null;
  isActive: boolean;
  /** true=부가세 포함가로 표시, false=공급가액으로 표시 */
  includeVat: boolean;
  /** 연결된 활성 업체 수 */
  supplierCount: number;
  /** 노출 중인 상품 수 */
  offeringCount: number;
  createdAt: string;
}

export interface CreateStorefrontDto {
  /** 피드 경로에 쓰이는 식별자(생성 후 불변) */
  slug: string;
  name: string;
  description?: string;
}

export interface SuccessResultDto {
  success: boolean;
}

export interface UpdateStorefrontDto {
  /** true=부가세 포함가로 표시, false=공급가액으로 표시 */
  includeVat?: boolean;
  name?: string;
  description?: string;
  isActive?: boolean;
}

export interface StorefrontSupplierDto {
  id: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  /** 이 업체가 취급하는 품목 수 */
  handledItemCount: number;
  /** 이 쇼핑몰에 노출 중인 수 */
  offeringCount: number;
  isActive: boolean;
}

export interface LinkSupplierDto {
  /** 공급사 ID (suppliers.id) */
  supplierId: string;
}

export interface UnlinkSupplierResultDto {
  /** 연결 해제로 노출이 중지된 상품 수 */
  deactivatedOfferings: number;
}

export interface CandidateItemDto {
  itemId: string;
  name: string;
  /** @nullable */
  categoryName?: string | null;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  unit?: string | null;
  /** 이 공급사의 일반 공급가(참고용) */
  basePrice: number;
  /** 이 업체 이름으로 이미 담겨 있는가 */
  isOffered: boolean;
  /** 같은 품목을 이미 내고 있는 **다른** 업체 수. 2기부터 한 품목을 여러 곳이 낼 수 있고, 손님은 익명 단가 리스트에서 최저가를 고른다 — 담는다고 남의 줄이 밀려나지 않는다 */
  competitorCount: number;
}

export interface CandidateListResponseDto {
  items: CandidateItemDto[];
  /** 검색 조건에 맞는 전체 건수 */
  total: number;
}

export interface AdminOfferingDto {
  id: string;
  itemId: string;
  itemName: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  /**
   * 공급사가 이 몰용으로 입력한 단가. null 이면 아직 안 넣어 노출되지 않는다
   * @nullable
   */
  supplierPrice?: number | null;
  /**
   * 이 공급사의 일반 공급가(참고용, 비교에만 쓴다)
   * @nullable
   */
  basePrice?: number | null;
  /** 공급사가 단가를 넣어 실제 노출 중인지 */
  isListed: boolean;
  isActive: boolean;
}

export interface AddOfferingsResultDto {
  /** 새로 담긴 건수 */
  created: number;
  /** 다른 업체에서 교체된 건수 */
  replaced: number;
}

export interface OfferingInputDto {
  /** 품목 ID (items_v2_base.id) */
  itemId: string;
  /** 이 품목을 파는 공급사 */
  supplierId: string;
}

export interface CreateOfferingsDto {
  /**
   * 한 번에 여러 건을 담는다(최대 500건)
   * @maxItems 500
   */
  items: OfferingInputDto[];
}

export interface UpdateOfferingDto {
  /** 공급사 교체 */
  supplierId?: string;
  isActive?: boolean;
  /**
   * 몰 판매가(원). null 이면 단가를 지운다 — 그 줄은 노출에서 빠진다
   * @nullable
   */
  supplierPrice?: number | null;
}

export interface AdminOrderInspectionDto {
  /** 검수 세션 상태 — `OPEN` · `COMPLETED` · `CANCELED`. */
  status: string;
  /**
   * 검수 담당자가 여는 촬영·대조 링크
   * @nullable
   */
  verificationUrl: string | null;
  /**
   * 완료된 검수의 보고서 주소
   * @nullable
   */
  reportUrl: string | null;
  /**
   * 라벨이 일치한 건수
   * @nullable
   */
  matchedCount: number | null;
  /**
   * 대조하지 못한 건수. 남아 있어도 검수는 완료될 수 있다.
   * @nullable
   */
  unmatchedCount: number | null;
  /**
   * 검수 완료 시각(ISO 8601)
   * @nullable
   */
  completedAt: string | null;
}

export interface AdminOrderContractDto {
  /** 계약 id */
  id: string;
  /** 계약번호 */
  contractNumber: string;
  /** 이 계약의 공급사 id */
  supplierId: string;
  /**
   * 계산서 보류 사유. 값이 있으면 **그 계약의 계산서 발행이 막혀 있다**. null 이면 열려 있다.
   * @nullable
   */
  taxInvoiceHoldReason: string | null;
}

/**
 * 검수 세션. null 이면 대조할 품목이 없어 검수를 열지 않은 주문이다(= 계산서 게이트도 없다).
 * @nullable
 */
export type AdminStorefrontOrderDtoInspection = AdminOrderInspectionDto | null;

export interface AdminStorefrontOrderDto {
  /** 주문 id */
  id: string;
  /** 주문번호 */
  orderNo: string;
  /** 주문 상태 — `PLACED` · `QUOTING` · `QUOTE_CLOSED` · `SENT_TO_ERP` · `CONTRACTED` · `SHIPPING` · `DELIVERED` · `INSPECTED` · `SETTLED` · `CANCELED`. */
  status: string;
  /**
   * 주문한 사람의 사번
   * @nullable
   */
  employeeNo: string | null;
  /** 공급가액 합계 */
  totalSupply: number;
  /** 부가세 합계 */
  totalVat: number;
  /**
   * ERP 가 회신한 구매요구번호
   * @nullable
   */
  erpRequisitionNo: string | null;
  /**
   * 이 주문으로 올라간 견적 공고 id. 아직 안 올렸으면 null.
   * @nullable
   */
  quoteRequestId: string | null;
  /** 주문 시각(ISO 8601) */
  createdAt: string;
  /**
   * 취소 시각(ISO 8601). 취소되지 않았으면 null.
   * @nullable
   */
  canceledAt: string | null;
  /**
   * 검수 세션. null 이면 대조할 품목이 없어 검수를 열지 않은 주문이다(= 계산서 게이트도 없다).
   * @nullable
   */
  inspection: AdminStorefrontOrderDtoInspection;
  /** 이 주문에 걸린 계약들 */
  contracts: AdminOrderContractDto[];
}

export interface AdminStorefrontOrderListDto {
  orders: AdminStorefrontOrderDto[];
  /** 필터 조건에 맞는 전체 건수 */
  total: number;
}

export interface ForceReleaseInspectionResultDto {
  /** 보류가 풀린 계약 수. 0 이면 아직 계약이 서지 않은 주문이다. */
  releasedContracts: number;
}

export interface ForceReleaseInspectionDto {
  /**
   * 강제 해제 사유. 계약 행에 그대로 남아 「왜 검수 없이 계산서가 나갔나」에 답한다.
   * @minLength 5
   */
  reason: string;
}

export interface ForceOrderActionResultDto {
  /** 처리 후 주문 상태. */
  status: string;
}

export interface ForceOrderActionDto {
  /**
   * 강제 처리 사유. 송장·확정 버튼 없이 상태를 옮긴 근거로 로그에 남는다.
   * @minLength 5
   */
  reason: string;
}

export interface BulkOfferResultDto {
  dryRun: boolean;
  /** 조건에 맞는 공급사 품목 수 */
  candidates: number;
  /** 새로 담길(담긴) 수 */
  willCreate: number;
  /** 실제로 만들어진 수(dryRun 이면 0) */
  created: number;
  /** 이미 담겨 노출 대상인 수 */
  alreadyActive: number;
  /** 이미 담겼지만 비활성인 수 — 일괄 활성화로 되살릴 수 있다 */
  alreadyInactive: number;
  /** 제외 목록에 걸려 건너뛴 수 */
  excluded: number;
  /**
   * 되돌리기의 단위
   * @nullable
   */
  batchId?: string | null;
}

/**
 * linked 면 승인과 동시에 공급사 단가로 노출된다. manual 이면 공급사가 몰 단가를 적어야 노출된다
 */
export type BulkOfferDtoPriceSource =
  (typeof BulkOfferDtoPriceSource)[keyof typeof BulkOfferDtoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkOfferDtoPriceSource = {
  manual: "manual",
  linked: "linked",
} as const;

export interface BulkOfferDto {
  /** 어느 업체의 품목을 담을지 */
  supplierId: string;
  /** 품명 부분일치. 비우면 전 품목 */
  q?: string;
  /** 카테고리 한정. 대분류를 주면 그 아래 소분류까지 전부 대상 */
  categoryIds?: string[];
  /** 공급가 하한(원) */
  priceMin?: number;
  /** 공급가 상한(원) */
  priceMax?: number;
  /** linked 면 승인과 동시에 공급사 단가로 노출된다. manual 이면 공급사가 몰 단가를 적어야 노출된다 */
  priceSource?: BulkOfferDtoPriceSource;
  /** linked 일 때 얹을 가산율(만분율). 0 이면 공급사 단가 그대로 */
  markupBp?: number;
  /** true 면 건수만 계산하고 아무것도 만들지 않는다 */
  dryRun?: boolean;
}

export interface BulkActiveResultDto {
  dryRun: boolean;
  willChange: number;
  changed: number;
  /** @nullable */
  batchId?: string | null;
}

export interface BulkActiveDto {
  /** 업체 한정. 비우면 이 몰의 전 상품 */
  supplierId?: string;
  /** true=노출 재개, false=노출 중지 */
  isActive: boolean;
  itemIds?: string[];
  dryRun?: boolean;
}

export interface BulkPriceSampleDto {
  name: string;
  /** @nullable */
  oldPrice?: number | null;
  /** @nullable */
  newPrice?: number | null;
  /** 변동 배수. 1 에서 멀수록 확인이 필요하다 */
  ratio: number;
}

export type BulkPriceResultDtoMode =
  (typeof BulkPriceResultDtoMode)[keyof typeof BulkPriceResultDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkPriceResultDtoMode = {
  copy_base: "copy_base",
  link: "link",
  unlink: "unlink",
  clear: "clear",
} as const;

export interface BulkPriceResultDto {
  dryRun: boolean;
  mode: BulkPriceResultDtoMode;
  /** 조건에 걸린 줄 수 */
  targets: number;
  /** 값이 바뀔(바뀐) 줄 수 */
  willChange: number;
  /** 실제로 바뀐 줄 수(dryRun 이면 0) */
  changed: number;
  /** 조건에 안 맞아 건너뛴 줄 수 */
  skipped: number;
  /** 공급사 단가가 없어 복사할 값이 없는 줄 수 */
  noBasePrice: number;
  /** 변동폭이 큰 순 최대 20건. 2만 건에서 오타를 찾는 유일한 창 */
  samples: BulkPriceSampleDto[];
  /** @nullable */
  batchId?: string | null;
}

/**
 * copy_base=내 단가 복사 / link=내 단가에 연동(이후 자동 추종) / unlink=지금 값으로 굳히기 / clear=몰 단가 지우기
 */
export type BulkPriceDtoMode =
  (typeof BulkPriceDtoMode)[keyof typeof BulkPriceDtoMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BulkPriceDtoMode = {
  copy_base: "copy_base",
  link: "link",
  unlink: "unlink",
  clear: "clear",
} as const;

export interface BulkPriceDto {
  /** copy_base=내 단가 복사 / link=내 단가에 연동(이후 자동 추종) / unlink=지금 값으로 굳히기 / clear=몰 단가 지우기 */
  mode: BulkPriceDtoMode;
  /** 가산율(만분율) */
  markupBp?: number;
  /** 이미 값이 있는 줄도 덮어쓸지. 기본은 빈 칸만 채운다 */
  overwrite?: boolean;
  /** 지정하면 그 품목만. 비우면 이 몰의 내 전 품목 */
  itemIds?: string[];
  dryRun?: boolean;
}

export type BatchDtoAction =
  (typeof BatchDtoAction)[keyof typeof BatchDtoAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchDtoAction = {
  bulk_offer: "bulk_offer",
  bulk_price: "bulk_price",
  bulk_active: "bulk_active",
  rule_apply: "rule_apply",
} as const;

/**
 * @nullable
 */
export type BatchDtoParams = { [key: string]: unknown } | null;

/**
 * @nullable
 */
export type BatchDtoResult = { [key: string]: unknown } | null;

export interface BatchDto {
  id: string;
  action: BatchDtoAction;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  supplierName?: string | null;
  /** 바뀐 줄 수 */
  affected: number;
  /** @nullable */
  params?: BatchDtoParams;
  /** @nullable */
  result?: BatchDtoResult;
  /** @nullable */
  undoneAt?: string | null;
  /** @nullable */
  undoneCount?: number | null;
  createdAt: string;
  /** 되돌릴 수 있는 작업인지 */
  canUndo: boolean;
}

export interface BatchListResponseDto {
  items: BatchDto[];
  total: number;
}

export interface UndoBatchResultDto {
  batchId: string;
  /** 되돌린 줄 수 */
  undone: number;
  /** 그 뒤에 공급사가 손대서 그대로 둔 줄 수 */
  skipped: number;
}

export type RuleDtoScope = (typeof RuleDtoScope)[keyof typeof RuleDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleDtoScope = {
  all: "all",
  category: "category",
} as const;

export type RuleDtoAutoPriceSource =
  (typeof RuleDtoAutoPriceSource)[keyof typeof RuleDtoAutoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RuleDtoAutoPriceSource = {
  none: "none",
  linked: "linked",
} as const;

export interface RuleDto {
  id: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  scope: RuleDtoScope;
  /** @nullable */
  categoryIds?: string[] | null;
  /** @nullable */
  q?: string | null;
  /** @nullable */
  priceMin?: number | null;
  /** @nullable */
  priceMax?: number | null;
  autoPriceSource: RuleDtoAutoPriceSource;
  autoMarkupBp: number;
  isActive: boolean;
  /** @nullable */
  lastAppliedAt?: string | null;
  /** @nullable */
  lastAppliedCount?: number | null;
  createdAt: string;
}

export type CreateRuleDtoScope =
  (typeof CreateRuleDtoScope)[keyof typeof CreateRuleDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRuleDtoScope = {
  all: "all",
  category: "category",
} as const;

/**
 * linked 면 규칙이 넣은 품목이 공급사 단가로 곧바로 노출된다
 */
export type CreateRuleDtoAutoPriceSource =
  (typeof CreateRuleDtoAutoPriceSource)[keyof typeof CreateRuleDtoAutoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateRuleDtoAutoPriceSource = {
  none: "none",
  linked: "linked",
} as const;

export interface CreateRuleDto {
  supplierId: string;
  scope?: CreateRuleDtoScope;
  categoryIds?: string[];
  q?: string;
  priceMin?: number;
  priceMax?: number;
  /** linked 면 규칙이 넣은 품목이 공급사 단가로 곧바로 노출된다 */
  autoPriceSource?: CreateRuleDtoAutoPriceSource;
  autoMarkupBp?: number;
}

export type UpdateRuleDtoScope =
  (typeof UpdateRuleDtoScope)[keyof typeof UpdateRuleDtoScope];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRuleDtoScope = {
  all: "all",
  category: "category",
} as const;

export type UpdateRuleDtoAutoPriceSource =
  (typeof UpdateRuleDtoAutoPriceSource)[keyof typeof UpdateRuleDtoAutoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateRuleDtoAutoPriceSource = {
  none: "none",
  linked: "linked",
} as const;

export interface UpdateRuleDto {
  isActive?: boolean;
  scope?: UpdateRuleDtoScope;
  categoryIds?: string[];
  q?: string;
  autoPriceSource?: UpdateRuleDtoAutoPriceSource;
  autoMarkupBp?: number;
}

export interface ApplyRulesResultDto {
  /** 적용한 규칙 수 */
  rules: number;
  /** 새로 담긴 품목 수 */
  created: number;
}

export interface ExclusionDto {
  id: string;
  itemId: string;
  /** @nullable */
  itemName?: string | null;
  /** @nullable */
  supplierId?: string | null;
  /** @nullable */
  reason?: string | null;
  createdAt: string;
}

export interface CreateExclusionDto {
  itemId: string;
  /** 비우면 이 몰 전체에서 제외(어느 업체가 내든 안 담긴다) */
  supplierId?: string;
  reason?: string;
}

export type OfferingRequestDtoStatus =
  (typeof OfferingRequestDtoStatus)[keyof typeof OfferingRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OfferingRequestDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface OfferingRequestDto {
  id: string;
  storefrontId: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  itemId: string;
  /** @nullable */
  itemName?: string | null;
  /** @nullable */
  basePrice?: number | null;
  /** @nullable */
  note?: string | null;
  status: OfferingRequestDtoStatus;
  /** @nullable */
  decisionNote?: string | null;
  createdAt: string;
}

export interface RequestListResponseDto {
  items: OfferingRequestDto[];
  total: number;
}

export type DecideRequestDtoStatus =
  (typeof DecideRequestDtoStatus)[keyof typeof DecideRequestDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecideRequestDtoStatus = {
  approved: "approved",
  rejected: "rejected",
} as const;

/**
 * 승인할 때 만들 줄의 가격 출처
 */
export type DecideRequestDtoPriceSource =
  (typeof DecideRequestDtoPriceSource)[keyof typeof DecideRequestDtoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DecideRequestDtoPriceSource = {
  manual: "manual",
  linked: "linked",
} as const;

export interface DecideRequestDto {
  status: DecideRequestDtoStatus;
  /** 승인할 때 만들 줄의 가격 출처 */
  priceSource?: DecideRequestDtoPriceSource;
  decisionNote?: string;
}

export interface SupplierPriceAxisStatusDto {
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  /** 활성 단가 수 */
  priceCount: number;
  /** 그중 부가세 포함가로 라벨된 수 */
  inclusiveCount: number;
  /** 과세/면세를 모르는 품목 수 */
  unknownTaxCategoryCount: number;
  /**
   * 축을 확인한 시각. 비어 있으면 몰이 이 업체 단가를 환산하지 않는다
   * @nullable
   */
  verifiedAt?: string | null;
  /** @nullable */
  note?: string | null;
}

/**
 * 면세·영세면 공급가액과 총액이 같다
 * @nullable
 */
export type PriceAxisSampleDtoTaxCategory =
  | (typeof PriceAxisSampleDtoTaxCategory)[keyof typeof PriceAxisSampleDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAxisSampleDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface PriceAxisSampleDto {
  name: string;
  /** 지금 저장돼 있는 값(안 바뀐다) */
  basePrice: number;
  /** 정정 후 이 단가가 뜻하게 되는 공급가액 */
  supplyPrice: number;
  /** 정정 후 부가세까지 더한 총액 */
  totalPrice: number;
  /**
   * 면세·영세면 공급가액과 총액이 같다
   * @nullable
   */
  taxCategory?: PriceAxisSampleDtoTaxCategory;
}

export type SetSupplierPriceAxisResultDtoTaxType =
  (typeof SetSupplierPriceAxisResultDtoTaxType)[keyof typeof SetSupplierPriceAxisResultDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSupplierPriceAxisResultDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SetSupplierPriceAxisResultDto {
  dryRun: boolean;
  taxType: SetSupplierPriceAxisResultDtoTaxType;
  /** 이 업체의 활성 단가 수 */
  targets: number;
  /** 축이 바뀔(바뀐) 행 수 */
  willChange: number;
  /** 실제로 바뀐 행 수(dryRun 이면 0) */
  changed: number;
  /** 과세/면세를 모르는 품목 수. 이 품목들은 도장을 찍어도 환산하지 않는다 — 면세를 과세로 단정하면 가격이 조용히 9% 떨어진다 */
  unknownTaxCategory: number;
  /** 면세·영세 품목 수(축과 무관하게 값이 그대로다) */
  vatFree: number;
  /** 고가 순 최대 20건 */
  samples: PriceAxisSampleDto[];
  /** @nullable */
  batchId?: string | null;
}

/**
 * EXCLUSIVE=이 업체 단가는 공급가액 / INCLUSIVE=부가세 포함가. 값은 그대로 두고 축만 바꾼다
 */
export type SetSupplierPriceAxisDtoTaxType =
  (typeof SetSupplierPriceAxisDtoTaxType)[keyof typeof SetSupplierPriceAxisDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetSupplierPriceAxisDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SetSupplierPriceAxisDto {
  /** EXCLUSIVE=이 업체 단가는 공급가액 / INCLUSIVE=부가세 포함가. 값은 그대로 두고 축만 바꾼다 */
  taxType: SetSupplierPriceAxisDtoTaxType;
  /** 일부 품목만 정정할 때. 비우면 이 업체의 활성 단가 전부 */
  itemIds?: string[];
  /** 축이 사실과 맞는지 확인했다는 도장. 이걸 찍어야 몰이 이 업체 단가를 환산한다. 일부 품목만 정정할 때는 찍히지 않는다 — 나머지 미확인분까지 환산 대상이 되기 때문이다 */
  markVerified?: boolean;
  /** 무엇으로 확인했는지(원본 파일 헤더·업체 회신·세금계산서 대조 등). 나중에 «왜 이렇게 정했나» 에 답하는 유일한 근거다 */
  note?: string;
  dryRun?: boolean;
}

export type SetTaxCategoryResultDtoTaxCategory =
  (typeof SetTaxCategoryResultDtoTaxCategory)[keyof typeof SetTaxCategoryResultDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetTaxCategoryResultDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface SetTaxCategoryResultDto {
  dryRun: boolean;
  taxCategory: SetTaxCategoryResultDtoTaxCategory;
  targets: number;
  willChange: number;
  changed: number;
}

/**
 * TAXABLE=과세 / EXEMPT=면세 / ZERO_RATED=영세율
 */
export type SetTaxCategoryDtoTaxCategory =
  (typeof SetTaxCategoryDtoTaxCategory)[keyof typeof SetTaxCategoryDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SetTaxCategoryDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface SetTaxCategoryDto {
  /** TAXABLE=과세 / EXEMPT=면세 / ZERO_RATED=영세율 */
  taxCategory: SetTaxCategoryDtoTaxCategory;
  itemIds?: string[];
  /** 이 업체가 취급하는 품목 전부를 대상으로 할 때 */
  supplierId?: string;
  /** 비어 있는 것만 채운다. 품목은 업체 사이에 공유되므로, 이미 지정된 값을 덮으면 남이 확인해 둔 사실까지 지워진다 */
  onlyUnset?: boolean;
  dryRun?: boolean;
}

export type PriceAxisBatchDtoTaxType =
  (typeof PriceAxisBatchDtoTaxType)[keyof typeof PriceAxisBatchDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAxisBatchDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type PriceAxisBatchDtoPreviousTaxType =
  (typeof PriceAxisBatchDtoPreviousTaxType)[keyof typeof PriceAxisBatchDtoPreviousTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceAxisBatchDtoPreviousTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface PriceAxisBatchDto {
  id: string;
  supplierId: string;
  /** @nullable */
  supplierName?: string | null;
  taxType: PriceAxisBatchDtoTaxType;
  previousTaxType: PriceAxisBatchDtoPreviousTaxType;
  affected: number;
  /** 이 정정으로 «확인됨» 도장이 찍혔는지 */
  markedVerified: boolean;
  /** @nullable */
  note?: string | null;
  /** @nullable */
  undoneAt?: string | null;
  /** @nullable */
  undoneCount?: number | null;
  createdAt: string;
}

export interface UndoPriceAxisResultDto {
  batchId: string;
  undone: number;
}

export interface RecalculateTrustScoresResponseDto {
  /** 업데이트 성공한 공급업체 수 */
  updated_count: number;
  /** 업데이트 실패한 공급업체 수 */
  failed_count: number;
  /** 작업 소요 시간 (밀리초) */
  duration_ms: number;
}

/**
 * 백분위 구간 (1, 5, 10, 15, 20, 30, null)
 * @nullable
 */
export type SupplierTrustScoreDtoPercentile =
  | (typeof SupplierTrustScoreDtoPercentile)[keyof typeof SupplierTrustScoreDtoPercentile]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierTrustScoreDtoPercentile = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

export interface SupplierTrustScoreDto {
  /**
   * 총점 (6개 컴포넌트 합산, 0-100)
   * @minimum 0
   * @maximum 100
   */
  total: number;
  /**
   * 인증 총점 (0-20)
   * @minimum 0
   * @maximum 20
   */
  certificationTotalScore: number;
  /**
   * 총 참여 점수 (0-10)
   * @minimum 0
   * @maximum 10
   */
  totalParticipationScore: number;
  /**
   * 계약 건수 점수 (0-20)
   * @minimum 0
   * @maximum 20
   */
  contractCountScore: number;
  /**
   * 총 금액 점수 (0-20)
   * @minimum 0
   * @maximum 20
   */
  totalAmountScore: number;
  /**
   * 총 수수료 점수 (0-20)
   * @minimum 0
   * @maximum 20
   */
  totalCommissionScore: number;
  /**
   * 최근 참여 점수 (0-10)
   * @minimum 0
   * @maximum 10
   */
  recentParticipationScore: number;
  /**
   * 백분위 구간 (1, 5, 10, 15, 20, 30, null)
   * @nullable
   */
  percentile: SupplierTrustScoreDtoPercentile;
  /**
   * 신뢰 점수 업데이트 시각
   * @nullable
   */
  updatedAt: string | null;
}

/**
 * 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입
 */
export type SupplierWithTrustScoreDtoSource =
  (typeof SupplierWithTrustScoreDtoSource)[keyof typeof SupplierWithTrustScoreDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierWithTrustScoreDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface SupplierWithTrustScoreDto {
  /** Supplier ID (UUID) */
  id: string;
  /**
   * User ID (로그인 ID)
   * @nullable
   */
  userId: string | null;
  /**
   * 이름
   * @nullable
   */
  name: string | null;
  /**
   * 연락용 이메일
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 전화번호
   * @nullable
   */
  phone: string | null;
  /** 회사명 */
  companyName: string;
  /** 사업자 등록번호 */
  businessNumber: string;
  /** CEO 이름 */
  ceoName: string;
  /**
   * 회사 직인 이미지 URL
   * @nullable
   */
  companySealUrl: string | null;
  /** 회사 전화번호 */
  companyPhone: string;
  /** 담당자 이름 (suppliers.manager_name — users.name 은 상호다) */
  managerName: string;
  /** 담당자 연락처 (suppliers.manager_phone) */
  managerPhone: string;
  /**
   * 외부 Supplier ID (C-Market ID)
   * @nullable
   */
  externalSupplierId: string | null;
  /** 활성 상태 */
  isActive: boolean;
  /** 자동 견적 활성화 여부 */
  autoQuoteEnabled: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
  /**
   * 마지막 로그인 일시
   * @nullable
   */
  lastLoginAt: string | null;
  /**
   * 생성 일시
   * @nullable
   */
  createdAt: string | null;
  /**
   * 마지막 업데이트 일시
   * @nullable
   */
  updatedAt: string | null;
  /** 신뢰 점수 정보 (6개 개별 점수 + 총점 + 백분위) */
  trustScore: SupplierTrustScoreDto;
  /** 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입 */
  source: SupplierWithTrustScoreDtoSource;
}

export interface EmbedJoinResponseDto {
  /** Embed URL (OTT는 URL fragment #token=... 에 포함) */
  embedUrl: string;
}

export interface UpdateSupplierKakaoNotificationDto {
  /** 알림톡 수신 여부 — true 면 발송, false 면 미발송 */
  enabled: boolean;
}

export interface UpdateSupplierActiveDto {
  /** 활성 여부 — false 면 로그인·세션 발급이 모두 막힌다(정지) */
  isActive: boolean;
}

/**
 * 성별 (M/F)
 * @nullable
 */
export type BuyerWithTrustScoreDtoGender =
  | (typeof BuyerWithTrustScoreDtoGender)[keyof typeof BuyerWithTrustScoreDtoGender]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerWithTrustScoreDtoGender = {
  M: "M",
  F: "F",
} as const;

/**
 * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
 * @nullable
 */
export type BuyerWithTrustScoreDtoTrustPercentile =
  | (typeof BuyerWithTrustScoreDtoTrustPercentile)[keyof typeof BuyerWithTrustScoreDtoTrustPercentile]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerWithTrustScoreDtoTrustPercentile = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

/**
 * 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입
 */
export type BuyerWithTrustScoreDtoSource =
  (typeof BuyerWithTrustScoreDtoSource)[keyof typeof BuyerWithTrustScoreDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerWithTrustScoreDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface BuyerWithTrustScoreDto {
  /** 구매자 ID */
  id: string;
  /**
   * 사용자 ID (users.id)
   * @nullable
   */
  userId: string | null;
  /**
   * 연락용 이메일
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 휴대폰 번호
   * @nullable
   */
  phone: string | null;
  /**
   * 이름
   * @nullable
   */
  name: string | null;
  /**
   * 성별 (M/F)
   * @nullable
   */
  gender: BuyerWithTrustScoreDtoGender;
  /**
   * 생년월일 (YYYY-MM-DD)
   * @nullable
   */
  birthDate: string | null;
  /**
   * 신뢰 점수 (0-100)
   * @nullable
   */
  trustScore: number | null;
  /**
   * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
   * @nullable
   */
  trustPercentile: BuyerWithTrustScoreDtoTrustPercentile;
  /** 활성 상태 */
  isActive: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
  /**
   * 마지막 로그인 일시
   * @nullable
   */
  lastLoginAt: string | null;
  /** 생성 날짜 */
  createdAt: string;
  /** 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입 */
  source: BuyerWithTrustScoreDtoSource;
  /**
   * 씨마켓 발주기관명 (자체가입은 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 씨마켓 회원 ID (자체가입은 null)
   * @nullable
   */
  externalBuyerId?: string | null;
}

export interface PaymentCardDto {
  /** 카드 고유 식별자 (UUID) */
  id: string;
  /** 마스킹된 카드번호 (PCI-DSS 준수) */
  maskedCardNumber: string;
  /** 카드사 코드 (01: 비씨, 02: 국민, 06: 신한 등) */
  cardCode?: string;
  /** 주 결제수단 여부 */
  isPrimary: boolean;
  /** 카드 등록일시 */
  registeredAt: string;
}

/**
 * Subscription plan type
 */
export type SubscriptionResponseDtoPlanType =
  (typeof SubscriptionResponseDtoPlanType)[keyof typeof SubscriptionResponseDtoPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

/**
 * Billing cycle
 */
export type SubscriptionResponseDtoBillingCycle =
  (typeof SubscriptionResponseDtoBillingCycle)[keyof typeof SubscriptionResponseDtoBillingCycle];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoBillingCycle = {
  MONTHLY: "MONTHLY",
} as const;

/**
 * Subscription status
 */
export type SubscriptionResponseDtoStatus =
  (typeof SubscriptionResponseDtoStatus)[keyof typeof SubscriptionResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoStatus = {
  ACTIVE: "ACTIVE",
  CANCELED: "CANCELED",
  FAILED: "FAILED",
} as const;

/**
 * Pending plan type (for scheduled plan changes)
 * @nullable
 */
export type SubscriptionResponseDtoPendingPlanType =
  | (typeof SubscriptionResponseDtoPendingPlanType)[keyof typeof SubscriptionResponseDtoPendingPlanType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionResponseDtoPendingPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface SubscriptionResponseDto {
  /** Subscription ID */
  id: string;
  /** Buyer ID */
  buyerId: string;
  /** Subscription plan type */
  planType: SubscriptionResponseDtoPlanType;
  /** Monthly subscription amount in KRW */
  amount: number;
  /** Billing cycle */
  billingCycle: SubscriptionResponseDtoBillingCycle;
  /** Next payment date (YYYY-MM-DD) */
  nextPaymentDate: string;
  /** Subscription status */
  status: SubscriptionResponseDtoStatus;
  /** Created at timestamp */
  createdAt: string;
  /** Last updated at timestamp */
  updatedAt: string;
  /**
   * Canceled at timestamp (if canceled)
   * @nullable
   */
  canceledAt?: string | null;
  /**
   * Cancellation reason (if provided)
   * @nullable
   */
  cancellationReason?: string | null;
  /**
   * Pending plan type (for scheduled plan changes)
   * @nullable
   */
  pendingPlanType?: SubscriptionResponseDtoPendingPlanType;
  /**
   * Scheduled plan change date (YYYY-MM-DD)
   * @nullable
   */
  scheduledPlanChangeAt?: string | null;
  /** Whether the subscription is currently under a promotion */
  isPromotional: boolean;
  /** Whether the subscription is a free trial (e.g. signup bonus) */
  isTrial: boolean;
  /**
   * Applied promotion code (if any)
   * @nullable
   */
  promotionCode?: string | null;
  /** Whether this is a permanent subscription (no expiry, nextPaymentDate >= 2090) */
  isPermanent: boolean;
}

export interface TermsAgreementResponseDto {
  /** Terms type (terms, privacy, marketing) */
  type: string;
  /** Whether user agreed */
  agreed: boolean;
  /** Terms version */
  version: string;
  /** Date of agreement */
  agreedAt: string;
  /**
   * Date of revocation (if applicable)
   * @nullable
   */
  revokedAt?: string | null;
  /**
   * Channel through which consent was given
   * @nullable
   */
  consentChannel?: string | null;
  /**
   * IP address at time of agreement
   * @nullable
   */
  ipAddress?: string | null;
  /**
   * User agent at time of agreement
   * @nullable
   */
  userAgent?: string | null;
}

/**
 * 성별 (M/F)
 * @nullable
 */
export type BuyerDetailDtoGender =
  | (typeof BuyerDetailDtoGender)[keyof typeof BuyerDetailDtoGender]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerDetailDtoGender = {
  M: "M",
  F: "F",
} as const;

/**
 * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
 * @nullable
 */
export type BuyerDetailDtoTrustPercentile =
  | (typeof BuyerDetailDtoTrustPercentile)[keyof typeof BuyerDetailDtoTrustPercentile]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerDetailDtoTrustPercentile = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

/**
 * 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입
 */
export type BuyerDetailDtoSource =
  (typeof BuyerDetailDtoSource)[keyof typeof BuyerDetailDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BuyerDetailDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface BuyerDetailDto {
  /** 구매자 ID */
  id: string;
  /**
   * 사용자 ID (users.id)
   * @nullable
   */
  userId: string | null;
  /**
   * 연락용 이메일
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 휴대폰 번호
   * @nullable
   */
  phone: string | null;
  /**
   * 이름
   * @nullable
   */
  name: string | null;
  /**
   * 성별 (M/F)
   * @nullable
   */
  gender: BuyerDetailDtoGender;
  /**
   * 생년월일 (YYYY-MM-DD)
   * @nullable
   */
  birthDate: string | null;
  /**
   * 신뢰 점수 (0-100)
   * @nullable
   */
  trustScore: number | null;
  /**
   * 신뢰 백분위 (1, 5, 10, 15, 20, 30, null = 하위 70%)
   * @nullable
   */
  trustPercentile: BuyerDetailDtoTrustPercentile;
  /** 활성 상태 */
  isActive: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled: boolean;
  /**
   * 마지막 로그인 일시
   * @nullable
   */
  lastLoginAt: string | null;
  /** 생성 날짜 */
  createdAt: string;
  /** 가입 경로 — direct: 세모 직접 가입 / cmarket: 외부 파트너(C-Market) 자동 가입 */
  source: BuyerDetailDtoSource;
  /**
   * 씨마켓 발주기관명 (자체가입은 null)
   * @nullable
   */
  organizationName?: string | null;
  /**
   * 씨마켓 회원 ID (자체가입은 null)
   * @nullable
   */
  externalBuyerId?: string | null;
  /** Registered addresses */
  addresses: AddressResponseDto[];
  /** Payment cards */
  cards: PaymentCardDto[];
  /** Subscription plans */
  subscriptions: SubscriptionResponseDto[];
  /** Terms and agreements history */
  termsAgreements: TermsAgreementResponseDto[];
  /**
   * Withdrawal reason (if withdrawn)
   * @nullable
   */
  withdrawalReason?: string | null;
}

export interface BuyerLoginLockStatusDto {
  /** 지금 잠겨 있는가 */
  locked: boolean;
  /** 마지막 성공 뒤 연속 실패 횟수(풀린 잠금은 0) */
  failedCount: number;
  /**
   * 잠금이 풀리는 시각(ISO). 잠겨 있지 않으면 null
   * @nullable
   */
  lockedUntil: string | null;
  /**
   * 잠금이 풀리기까지 남은 분(올림). 잠겨 있지 않으면 null
   * @nullable
   */
  remainingMinutes: number | null;
  /** 잠금까지 허용하는 연속 실패 횟수 */
  maxFailedAttempts: number;
  /** 잠그는 시간(분) */
  lockMinutes: number;
}

export interface RefundDetailedResponseDto {
  /** 환불 ID */
  id: string;
  /** 결제 트랜잭션 ID */
  paymentTransactionId: string;
  /** 환불 상태 */
  status: string;
  /** 환불 상태 설명 */
  statusDescription: string;
  /** 환불 금액 */
  refundAmount: number;
  /** 환불 사유 */
  refundReason: string;
  /** 환불 요청 일시 */
  requestedAt: string;
  /** 환불 요청자 ID */
  requestedBy?: string;
  /** 환불 승인 일시 */
  approvedAt?: string;
  /** 환불 승인자 ID */
  approvedBy?: string;
  /** 승인 메모 */
  approvalNote?: string;
  /** 환불 거부 일시 */
  rejectedAt?: string;
  /** 환불 거부자 ID */
  rejectedBy?: string;
  /** 거부 사유 */
  rejectionReason?: string;
  /** 환불 완료 일시 */
  completedAt?: string;
  /** 환불 실패 일시 */
  failedAt?: string;
  /** 에러 코드 */
  errorCode?: string;
  /** 에러 메시지 */
  errorMessage?: string;
  /** 환불 은행 */
  refundBank?: string;
  /** 환불 계좌번호 */
  refundAccountNumber?: string;
  /** 환불 예금주 */
  refundAccountHolder?: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

/**
 * 결제 상태
 */
export type PaymentTransactionResponseDtoStatus =
  (typeof PaymentTransactionResponseDtoStatus)[keyof typeof PaymentTransactionResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionResponseDtoStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
} as const;

/**
 * 결제 수단 (CARD | CASH | DIRECT)
 */
export type PaymentTransactionResponseDtoPaymentMethod =
  (typeof PaymentTransactionResponseDtoPaymentMethod)[keyof typeof PaymentTransactionResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionResponseDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
} as const;

export interface PaymentTransactionResponseDto {
  /** 결제 트랜잭션 ID (MOID - Merchant Order ID) */
  id: string;
  /** 견적 응답 버전 ID (UUID) */
  quoteResponseVersionId: string;
  /**
   * 결제 카드 ID (UUID)
   * @nullable
   */
  paymentCardId: string | null;
  /** 결제 상태 */
  status: PaymentTransactionResponseDtoStatus;
  /**
   * PG 거래 번호 (Innopay 거래 ID)
   * @nullable
   */
  tid: string | null;
  /**
   * 결제 승인 시각 (ISO 8601)
   * @nullable
   */
  approvedAt: string | null;
  /**
   * 에러 코드 (Innopay API 에러 코드)
   * @nullable
   */
  errorCode: string | null;
  /**
   * 에러 메시지 (Innopay API 에러 메시지)
   * @nullable
   */
  errorMessage: string | null;
  /** 생성 시각 (ISO 8601) */
  createdAt: string;
  /** 수정 시각 (ISO 8601) */
  updatedAt: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /**
   * 환불 ID (UUID)
   * @nullable
   */
  refundId: string | null;
  /** 결제 수단 (CARD | CASH | DIRECT) */
  paymentMethod: PaymentTransactionResponseDtoPaymentMethod;
  /**
   * 결제 만료 시각 (ISO 8601)
   * @nullable
   */
  expiresAt: string | null;
  /**
   * 결제 취소 시각 (ISO 8601)
   * @nullable
   */
  canceledAt: string | null;
}

export interface PendingCashPaymentDto {
  /** 결제 거래 번호 (MOID) */
  id: string;
  /** 사용자 ID (UUID) */
  userId: string;
  /** 사용자명 */
  userName: string;
  /** 사용자 이메일 */
  userEmail: string;
  /** 결제 금액 */
  amount: number;
  /** 세금 */
  taxAmount: number;
  /**
   * 프로젝트명 (nullable)
   * @nullable
   */
  projectName: string | null;
  /** 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /** 생성 시간 */
  createdAt: string;
  /** 만료 시간 (생성 시간으로부터 15분) */
  expiresAt: string;
  /**
   * 반려 시간 (null이면 아직 반려되지 않음)
   * @nullable
   */
  rejectedAt: string | null;
  /**
   * 반려 사유 (null이면 아직 반려되지 않음)
   * @nullable
   */
  rejectionReason: string | null;
}

export interface AdminCashPaymentDto {
  /** MOID */
  id: string;
  /** User ID */
  userId: string;
  /** User Name */
  userName: string;
  /** User Email */
  userEmail: string;
  /**
   * User Contact Email
   * @nullable
   */
  contactEmail: string | null;
  /** Payment Amount */
  amount: number;
  /** Tax Amount */
  taxAmount: number;
  /**
   * Project Name
   * @nullable
   */
  projectName: string | null;
  /** Quote Response Version ID */
  quoteResponseVersionId: string;
  /** Created At */
  createdAt: string;
  /** Expires At */
  expiresAt: string;
  /** Payment Status */
  status: string;
  /**
   * Approved At
   * @nullable
   */
  approvedAt: string | null;
  /**
   * Rejected At
   * @nullable
   */
  rejectedAt: string | null;
  /**
   * Canceled At
   * @nullable
   */
  canceledAt: string | null;
  /**
   * Rejection Reason
   * @nullable
   */
  rejectionReason: string | null;
}

export interface RejectPaymentDto {
  /** 반려 사유 */
  reason: string;
}

export interface AdminBulkUploadResultDto {
  /** 성공한 행 개수 */
  successCount: number;
  /** 실패한 행 개수 */
  errorCount: number;
  /** 에러 상세 메시지 목록 */
  errors: string[];
  /** 성공한 항목 이름 목록 */
  successItems?: string[];
}

export interface CategoryTreeNodeDto {
  /** 카테고리 ID (UUID) */
  id: string;
  /** 카테고리 이름 */
  name: string;
  /**
   * 카테고리 레벨
   * @minimum 1
   * @maximum 4
   */
  level: number;
  /**
   * 표시 순서
   * @minimum 0
   */
  displayOrder: number;
  /**
   * 아이콘 이름
   * @nullable
   */
  icon?: string | null;
  /**
   * 카테고리 설명
   * @nullable
   */
  description?: string | null;
  /** 활성 상태 */
  isActive: boolean;
  /** 자식 카테고리 목록 (재귀적) */
  children: CategoryTreeNodeDto[];
  /**
   * 하위 상품 개수
   * @minimum 0
   */
  productCount?: number;
}

export interface AdminCategoryItemDto {
  /**
   * CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)
   * @nullable
   */
  casNo?: string | null;
  /**
   * 국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null
   * @nullable
   */
  keNo?: string | null;
  /**
   * UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null
   * @nullable
   */
  unNo?: string | null;
  /**
   * EC 번호 (EU EINECS/ELINCS)
   * @nullable
   */
  enNo?: string | null;
  /**
   * KOSHA 기준 국문 표준 물질명
   * @nullable
   */
  chemNameKor?: string | null;
  /** 품목 ID (items_v2_base.id - UUID) */
  id: string;
  /** 상품명 */
  name: string;
  /**
   * 카테고리 ID (items_v2_categories.id - UUID)
   * @nullable
   */
  categoryId: string | null;
  /** 카테고리 경로 (표시용) */
  categoryPath: string;
  /** 기준 가격 (정가) */
  price: number;
  /**
   * 최저가 거래 단가
   * @nullable
   */
  lowestPrice: number | null;
  /**
   * 최저가 거래 날짜
   * @nullable
   */
  lowestPriceDate: string | null;
  /**
   * 최저가 거래 공급자명
   * @nullable
   */
  lowestPriceSupplierName: string | null;
  /** 카테고리 레벨 (0-3) */
  level: number;
  /**
   * 부모 카테고리 UUID
   * @nullable
   */
  parentId: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand: string | null;
  /**
   * 상품코드
   * @nullable
   */
  code: string | null;
  /** 단위 */
  unit: string;
  /**
   * 이미지 URL
   * @nullable
   */
  imageUrl: string | null;
  /**
   * 규격1
   * @nullable
   */
  spec1: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3: string | null;
  /** 취급 공급자 수 */
  supplierCount: number;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CategoryResponseDto {
  /** 카테고리 ID (UUID) */
  id: string;
  /** 카테고리 이름 */
  name: string;
  /**
   * 부모 카테고리 ID (null이면 최상위)
   * @nullable
   */
  parentId?: string | null;
  /**
   * 카테고리 레벨 (1-4)
   * @minimum 1
   * @maximum 4
   */
  level: number;
  /**
   * 표시 순서
   * @minimum 0
   */
  displayOrder: number;
  /**
   * 아이콘 이름
   * @nullable
   */
  icon?: string | null;
  /**
   * 카테고리 설명
   * @nullable
   */
  description?: string | null;
  /** 활성 상태 */
  isActive: boolean;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CreateCategoryDto {
  /**
   * 카테고리 이름
   * @minLength 1
   * @maxLength 100
   */
  name: string;
  /**
   * 부모 카테고리 ID (null이면 최상위)
   * @nullable
   */
  parentId?: string | null;
  /**
   * 카테고리 레벨 (1-4)
   * @minimum 1
   * @maximum 4
   */
  level: number;
  /**
   * 표시 순서 (0 이상)
   * @minimum 0
   */
  displayOrder?: number;
  /** 아이콘 */
  icon?: string;
  /** 카테고리 설명 */
  description?: string;
}

export interface UpdateCategoryDto {
  /**
   * 카테고리 이름
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * 표시 순서 (0 이상)
   * @minimum 0
   */
  displayOrder?: number;
  /**
   * 아이콘
   * @nullable
   */
  icon?: string | null;
  /**
   * 카테고리 설명
   * @nullable
   */
  description?: string | null;
  /** 활성 상태 (true=활성, false=비활성) */
  isActive?: boolean;
}

export interface ReorderCategoryDto {
  /**
   * 새로운 표시 순서 (0 이상)
   * @minimum 0
   */
  newOrder: number;
}

export interface DuplicateItemCandidateDto {
  /** 유사한 항목들을 묶는 그룹 ID (기준 물품의 ID) */
  groupId: string;
  /** 물품 ID */
  itemId: string;
  /** 물품명 */
  name: string;
  /**
   * 브랜드
   * @nullable
   */
  brand?: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 상품 코드(모델명)
   * @nullable
   */
  code?: string | null;
  /**
   * 최저가 거래단가
   * @nullable
   */
  price?: number | null;
  /** 공급사 수 */
  supplierCount: number;
  /** 기준 물품과의 유사도 점수 (0.0 ~ 1.0) */
  similarityScore: number;
  /**
   * 규격1
   * @nullable
   */
  spec1?: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2?: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3?: string | null;
  /** 그룹의 최고 유사도. 목록 정렬과 구간(밴드) 판정이 모두 이 값을 쓴다. */
  groupMaxScore: number;
}

export interface DuplicateCandidateBandDto {
  /** 구간 하한 (포함) */
  bandMin: number;
  /**
   * 구간 상한 (미포함). null 이면 상한 없음 — 완전 일치(1.0)를 담는 구간이다.
   * @nullable
   */
  bandMax: number | null;
  /** 이 구간에 속하는 그룹 수 */
  groupCount: number;
}

export interface DuplicateRecalculationStatusDto {
  /** 진행 중인 작업 존재 여부 */
  isProcessing: boolean;
}

/**
 * 상태 (기존, 추가, 충돌)
 */
export type MergePreviewSupplierDtoStatus =
  (typeof MergePreviewSupplierDtoStatus)[keyof typeof MergePreviewSupplierDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MergePreviewSupplierDtoStatus = {
  EXISTING: "EXISTING",
  ADDED: "ADDED",
  CONFLICT: "CONFLICT",
} as const;

export interface MergePreviewSupplierDto {
  /** 공급사 ID (UUID 또는 문자열) */
  supplierId: string;
  /** 공급사명 */
  supplierName: string;
  /** 상태 (기존, 추가, 충돌) */
  status: MergePreviewSupplierDtoStatus;
  /** 최종 예상 단가 */
  finalPrice: number;
  /** 충돌 시 보여줄 참고용 단가 (마스터 단가 등) */
  originalPrice?: number;
}

export interface MergePreviewResponseDto {
  /** 마스터 물품의 기존 공급자 수 */
  beforeCount: number;
  /** 병합 후 예상되는 순수 총 공급자 수 */
  afterCount: number;
  /** 마스터 물품과 이미 겹치는 공급사들의 ID 목록 (UUID 또는 문자열 ID) */
  overlappingSupplierIds: string[];
  /** 최종 예상 공급사 목록 */
  expectedSuppliers: MergePreviewSupplierDto[];
}

export interface MergeItemsDto {
  /** 대표(마스터) 물품 ID (이 물품으로 거래 이력 등이 모두 이관됩니다) */
  masterItemId: string;
  /** 병합되어 비활성화될 중복 물품 ID 목록 */
  duplicateItemIds: string[];
}

export interface MergeItemsResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 대표 물품 ID */
  masterItemId: string;
  /** 병합된 물품 개수 */
  mergedCount: number;
}

export interface AdminProductImageUploadResponseDto {
  /** 업로드된 이미지의 공개 URL (items.image_url 에 저장할 값) */
  imageUrl: string;
  /** 버킷 내 저장 경로 */
  filePath: string;
  /** 업로드한 원본 파일명 */
  fileName: string;
  /** 파일 크기 (bytes) */
  fileSize: number;
  /** 확장자에서 정규화한 Content-Type */
  mimeType: string;
}

export interface CreateProductResponseDto {
  /** 상품 ID */
  id: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 상품 코드 */
  code?: string;
  /** 단위 */
  unit: string;
  /** 가격 */
  price?: number;
  /** 이미지 URL */
  imageUrl?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 등록 Admin ID */
  createdByAdminId: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface CreateAdminProductDto {
  /** 상품명 (필수) */
  name: string;
  /** 제조사 (선택) */
  manufacturer?: string;
  /** 브랜드 (선택) */
  brand?: string;
  /** 품목코드 (선택) */
  code?: string;
  /** 단위 (필수) */
  unit: string;
  /** 정가 (필수) */
  price: number;
  /** 이미지 URL (선택) */
  imageUrl?: string;
  /** 카테고리 ID (필수, UUID) */
  categoryId: string;
  /** 규격1 (선택) */
  spec1?: string;
  /** 규격2 (선택) */
  spec2?: string;
  /** 규격3 (선택) */
  spec3?: string;
}

/**
 * 상태
 */
export type SupplierItemRequestSummaryDtoStatus =
  (typeof SupplierItemRequestSummaryDtoStatus)[keyof typeof SupplierItemRequestSummaryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemRequestSummaryDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface SupplierItemRequestSummaryDto {
  /** 요청 ID */
  id: string;
  /** Supplier ID (UUID) */
  supplierId: string;
  /** 업체명 (상호) */
  companyName?: string;
  /** 업체 코드 (Supplier ID) */
  supplierCode?: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 카테고리명 */
  categoryName?: string;
  /** 요청 사유 */
  requestReason?: string;
  /** 상태 */
  status: SupplierItemRequestSummaryDtoStatus;
  /** Admin 거부 사유 */
  adminComment?: string;
  /** 생성 일시 */
  createdAt?: string;
  /**
   * 수정 일시
   * @nullable
   */
  updatedAt: string | null;
}

/**
 * 추가 카테고리 IDs
 */
export type SupplierItemRequestDetailResponseDtoAdditionalCategoryIds = {
  [key: string]: unknown;
};

/**
 * 상태
 */
export type SupplierItemRequestDetailResponseDtoStatus =
  (typeof SupplierItemRequestDetailResponseDtoStatus)[keyof typeof SupplierItemRequestDetailResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemRequestDetailResponseDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface SupplierItemRequestDetailResponseDto {
  /** 요청 ID */
  id: string;
  /** Supplier ID */
  supplierId: string;
  /** 업체명 (상호) */
  companyName?: string;
  /** 업체 코드 (Supplier ID) */
  supplierCode?: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 카테고리명 */
  categoryName?: string;
  /** 추가 카테고리 IDs */
  additionalCategoryIds?: SupplierItemRequestDetailResponseDtoAdditionalCategoryIds;
  /** 요청 사유 */
  requestReason?: string;
  /** 상태 */
  status: SupplierItemRequestDetailResponseDtoStatus;
  /** Admin 거부 사유 */
  adminComment?: string;
  /** 승인한 Admin ID */
  approvedByAdminId?: string;
  /** 승인 시 생성된 물품 ID */
  approvedItemId?: string;
  /** 생성 일시 */
  createdAt?: string;
  /**
   * 수정 일시
   * @nullable
   */
  updatedAt: string | null;
}

export interface ApprovalResultResponseDto {
  /** 요청 상태 */
  status: string;
  /** 요청 ID */
  requestId: string;
  /** 생성된 물품 ID */
  approvedItemId: string;
}

export interface ApproveSupplierItemRequestDto {
  /** 카테고리 ID (승인 시 지정/변경 가능) */
  categoryId?: string;
  /** 상품명 (승인 시 변경 가능) */
  name?: string;
  /** 단위 (승인 시 변경 가능) */
  unit?: string;
  /** 제조사 (승인 시 변경 가능) */
  manufacturer?: string;
  /** 브랜드 (승인 시 변경 가능) */
  brand?: string;
  /** 규격 1 (승인 시 변경 가능) */
  spec1?: string;
  /** 규격 2 (승인 시 변경 가능) */
  spec2?: string;
  /** 규격 3 (승인 시 변경 가능) */
  spec3?: string;
  /** 관리자 코멘트 (승인/반려 시) */
  adminComment?: string;
}

export interface RejectionResultResponseDto {
  /** 요청 상태 */
  status: string;
  /** 요청 ID */
  requestId: string;
  /** 거부 사유 */
  comment: string;
}

export interface RejectSupplierItemRequestDto {
  /** 거부 사유 */
  comment: string;
}

export interface UpdateProductResponseDto {
  /** 상품 ID */
  id: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 상품 코드 */
  code?: string;
  /** 단위 */
  unit: string;
  /** 가격 */
  price?: number;
  /** 이미지 URL */
  imageUrl?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface UpdateAdminProductDto {
  /** 상품명 (선택) */
  name?: string;
  /** 제조사 (선택) */
  manufacturer?: string;
  /** 브랜드 (선택) */
  brand?: string;
  /** 품목코드 (선택) */
  code?: string;
  /** 단위 (선택) */
  unit?: string;
  /** 정가 (선택) */
  price?: number;
  /** 이미지 URL (선택) */
  imageUrl?: string;
  /** 카테고리 ID (선택, UUID) */
  categoryId?: string;
  /** 규격1 (선택) */
  spec1?: string;
  /** 규격2 (선택) */
  spec2?: string;
  /** 규격3 (선택) */
  spec3?: string;
}

export interface GetProductResponseDto {
  /** 상품 ID */
  id: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 상품 코드 */
  code?: string;
  /** 단위 */
  unit: string;
  /** 가격 */
  price?: number;
  /** 이미지 URL */
  imageUrl?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 등록 Admin ID */
  createdByAdminId: string;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
}

export interface PriceHistoryPointDto {
  /** 날짜 (YYYY-MM-DD or YYYY-MM) */
  date: string;
  /** 가격 */
  price: number;
}

/**
 * 최근 거래가의 부가세 축. INCLUSIVE 면 부가세 포함가라, 공급가액 단가와 나란히 놓고 그냥 비교하면 안 된다(10% 만큼 싸 보인다).
 */
export type VendorStatsResponseDtoTaxType =
  (typeof VendorStatsResponseDtoTaxType)[keyof typeof VendorStatsResponseDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorStatsResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface VendorStatsResponseDto {
  /** 공급사 ID */
  id: string;
  /** 공급사명 (업체명_상호) */
  name: string;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 휴대폰 */
  managerPhone?: string;
  /** 최근 거래가 */
  price: number;
  /** 최근 거래가의 부가세 축. INCLUSIVE 면 부가세 포함가라, 공급가액 단가와 나란히 놓고 그냥 비교하면 안 된다(10% 만큼 싸 보인다). */
  taxType: VendorStatsResponseDtoTaxType;
  /** 최근 거래일 (ISO) */
  updatedAt: string;
  /** 최저가 여부 */
  isLowest: boolean;
  /** 가격 변동 추이 */
  history: PriceHistoryPointDto[];
}

export interface DeleteProductResponseDto {
  /** 삭제된 상품 ID */
  id: string;
}

export interface MsdsCatalogSyncStartedDto {
  /** 처리 안내 메시지 */
  message: string;
}

export interface MsdsCatalogStatusDto {
  /** 적재된 화학물질 수 (CAS 기준) */
  total: number;
  /** KE 번호를 가진 화학물질 수 */
  withKeNo: number;
  /**
   * 최종 적재 시각 (한 번도 적재하지 않았으면 null)
   * @nullable
   */
  lastSyncedAt: string | null;
}

/**
 * 사용자 유형
 */
export type AdminInfoDtoUserType =
  (typeof AdminInfoDtoUserType)[keyof typeof AdminInfoDtoUserType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminInfoDtoUserType = {
  admin: "admin",
} as const;

export interface AdminInfoDto {
  /** 관리자 ID (UUID) */
  id: string;
  /** 사용자 ID */
  userId: string;
  /** 관리자 이름 */
  name?: string;
  /** 사용자 유형 */
  userType: AdminInfoDtoUserType;
  /** 계정 활성화 여부 */
  isActive: boolean;
  /** 생성 시간 */
  createdAt: string;
}

export interface AdminSignupResponseDto {
  /** 성공 메시지 */
  message: string;
  /** 회원가입된 관리자 정보 */
  admin: AdminInfoDto;
  /** 액세스 토큰 (JWT) */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
}

export interface AdminSignupDto {
  /**
   * 관리자 사용자 ID
   * @minLength 3
   */
  userId: string;
  /**
   * 관리자 비밀번호
   * @minLength 6
   */
  password: string;
  /** 가입 인증 키 */
  secretKey: string;
}

export interface AdminLoginResponseDto {
  /** 성공 메시지 */
  message: string;
  /** 로그인한 관리자 정보 */
  admin: AdminInfoDto;
  /** 액세스 토큰 (JWT) */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** Expires In (seconds) */
  expiresIn: number;
  /** Token Type */
  tokenType: string;
}

export interface AdminLoginDto {
  /**
   * 관리자 사용자 ID
   * @minLength 3
   */
  userId: string;
  /**
   * 관리자 비밀번호
   * @minLength 6
   */
  password: string;
  /** 로그인 상태 유지 */
  rememberMe?: boolean;
}

/**
 * 신뢰등급
 */
export type PriceBandListItemDtoGrade =
  (typeof PriceBandListItemDtoGrade)[keyof typeof PriceBandListItemDtoGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceBandListItemDtoGrade = {
  A: "A",
  B: "B",
  C: "C",
} as const;

export interface PriceBandListItemDto {
  /** SKU ID (12자리 안정 해시) */
  skuId: string;
  /** 대표 품명 */
  itemName: string;
  /**
   * 규격
   * @nullable
   */
  itemSpec: string | null;
  /** 신뢰등급 */
  grade: PriceBandListItemDtoGrade;
  /** 총 관측수 */
  skuN: number;
  /** 고유 공급사 수 */
  skuSuppliers: number;
  /**
   * 가격추세 라벨 — 급등|상승|보합|하락|급락, null 이면 trendBasis 로 사유 확인
   * @nullable
   */
  trendLabel: string | null;
  /**
   * 최근/이전 6개월 등락률(%)
   * @nullable
   */
  trendPct?: number | null;
  /**
   * trendLabel=null 일 때 사유 — 'no_recent_data'|'insufficient_history'
   * @nullable
   */
  trendBasis: string | null;
  /**
   * 수량 10배 증가 시 할인율(%), 항상 0~68.4
   * @nullable
   */
  qtyDiscountPct: number | null;
}

export interface PriceBandTierDto {
  /** 티어 순번 (0~11) */
  tierIdx: number;
  /** 티어 라벨 (예: "2-3", "1000+") */
  tier: string;
  /** 티어 하한 수량 */
  tierLo: number;
  /**
   * 티어 상한 수량 (null=상한 없음, 마지막 티어)
   * @nullable
   */
  tierHi: number | null;
  /** 실측 없음(β 보간 추정치) 여부 */
  isEstimated: boolean;
  /** 실측 관측수 (추정 셀은 0) */
  n: number;
  /** 낙찰 관측수 */
  nWon: number;
  /** 고유 공급사 수 */
  suppliers: number;
  /**
   * 가중 25백분위가 (추정 셀은 null)
   * @nullable
   */
  p25: number | null;
  /**
   * 가중 중앙값 (실측 또는 β 보간)
   * @nullable
   */
  p50: number | null;
  /**
   * 가중 75백분위가 (추정 셀은 null)
   * @nullable
   */
  p75: number | null;
  /** @nullable */
  priceMin: number | null;
  /** @nullable */
  priceMax: number | null;
  /**
   * 낙찰가 가중중앙값 (낙찰 관측 3건 이상일 때만)
   * @nullable
   */
  wonP50: number | null;
  /** @nullable */
  latestQuote: string | null;
  /**
   * 보간에 실제 쓰인 β (beta_sku 와 동일, 하위호환용)
   * @nullable
   */
  betaUsed: number | null;
  /**
   * SKU 자체 실측 기울기(또는 전역 β 폴백)
   * @nullable
   */
  betaSku: number | null;
  /**
   * 'sku'|'global'
   * @nullable
   */
  slopeSource: string | null;
}

export interface PriceBandTrendPointDto {
  /** 연월 (YYYY-MM) */
  ym: string;
  /** 그 달 관측수 */
  n: number;
  /**
   * SKU 중앙수량 기준 β 수량보정 중앙값
   * @nullable
   */
  p50Adj: number | null;
  /**
   * n>=3 일 때만 존재
   * @nullable
   */
  p25Adj: number | null;
  /**
   * n>=3 일 때만 존재
   * @nullable
   */
  p75Adj: number | null;
  /**
   * 수량보정 안 한 원본 중앙값
   * @nullable
   */
  p50Raw: number | null;
}

export interface PriceBandRawPointDto {
  /** 이 관측이 속한 티어 순번 */
  tierIdx: number;
  /** 실제 거래 수량 */
  qty: number;
  /**
   * 실제 단가
   * @nullable
   */
  price: number | null;
  /** 낙찰 관측 여부 */
  won: boolean;
}

export interface PriceBandSupplierTrendPointDto {
  /** 연월 (YYYY-MM) */
  ym: string;
  /** 그 달 이 공급사의 응찰 건수 */
  n: number;
  /** 그 달 이 공급사의 낙찰 건수 */
  nWon: number;
  /**
   * SKU 중앙수량 기준 β 수량보정 중앙 단가
   * @nullable
   */
  p50Adj: number | null;
  /**
   * 수량보정 안 한 원본 중앙 단가
   * @nullable
   */
  p50Raw: number | null;
  /**
   * 그 달 응찰 건의 중앙 수량 (보정 근거 확인용)
   * @nullable
   */
  qtyMedian: number | null;
}

export interface PriceBandSupplierSeriesDto {
  /** 공급사 ID */
  supplierId: string;
  /**
   * 상호
   * @nullable
   */
  supplierName: string | null;
  /** 이 SKU 에 대한 총 응찰 건수 */
  totalN: number;
  /** 이 SKU 에 대한 총 낙찰 건수 */
  totalWon: number;
  /** 첫 응찰 연월 (YYYY-MM) */
  firstYm: string;
  /** 마지막 응찰 연월 (YYYY-MM) */
  lastYm: string;
  /** 월별 시계열 (오름차순) */
  points: PriceBandSupplierTrendPointDto[];
}

export type PriceBandDetailDtoGrade =
  (typeof PriceBandDetailDtoGrade)[keyof typeof PriceBandDetailDtoGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PriceBandDetailDtoGrade = {
  A: "A",
  B: "B",
  C: "C",
} as const;

export interface PriceBandDetailDto {
  skuId: string;
  skuKey: string;
  itemName: string;
  /** @nullable */
  itemSpec: string | null;
  /** @nullable */
  catName: string | null;
  grade: PriceBandDetailDtoGrade;
  skuN: number;
  skuNWon: number;
  skuSuppliers: number;
  /** @nullable */
  skuFirstQuote: string | null;
  /** @nullable */
  skuLastQuote: string | null;
  /**
   * 전체 관측 가중중앙값(최신성 가중, 티어 무관)
   * @nullable
   */
  skuP50All: number | null;
  /** @nullable */
  skuQtyMedian: number | null;
  /** @nullable */
  qtyDiscountPct: number | null;
  /** @nullable */
  trendLabel: string | null;
  /** @nullable */
  trendPct: number | null;
  /** @nullable */
  trendMonthsTotal: number | null;
  /** @nullable */
  trendBasis: string | null;
  /**
   * 전역 β (폴백/리포팅용 대표값)
   * @nullable
   */
  betaGlobal: number | null;
  /** 이 데이터의 배치 기준일 (compute.py --asof) */
  asof: string;
  /** 12개 수량티어 */
  tiers: PriceBandTierDto[];
  /** 월별 시간추이 */
  trend: PriceBandTrendPointDto[];
  /** 원시 관측치(최대 500개, 차트 산점도 전용) */
  points: PriceBandRawPointDto[];
  /** 공급사별 월간 가격 추이. 총 응찰 건수 내림차순. 배치에서 SKU당 상위 10곳만 적재하므로 꼬리 공급사는 빠져 있다 */
  supplierTrend: PriceBandSupplierSeriesDto[];
}

export interface AdminAddressDto {
  /** 주소 ID */
  id: string;
  /** 수령인명 */
  recipientName?: string;
  /** 연락처 */
  phone?: string;
  /** 우편번호 */
  postalCode?: string;
  /** 시/도 */
  province?: string;
  /** 시/군/구 */
  city?: string;
  /** 읍/면/동 */
  district?: string;
  /** 기본 주소 (도로명) */
  addressLine1?: string;
  /** 상세 주소 */
  addressLine2?: string;
}

export interface AdminUserSummaryDto {
  /** 사용자 ID */
  id: string;
  /** 사용자명 */
  name: string;
  /** 연락처 이메일 */
  contactEmail: string;
  /** 연락처 */
  phone: string;
  /** 회사명 */
  companyName?: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 신뢰도 백분위 */
  trustPercentile?: number;
}

export interface AdminProjectParticipantDto {
  /** 공급사 ID */
  supplierId: string;
  /** 업체명 (없으면 사용자 이름) */
  companyName: string;
  /**
   * 최신 견적 금액(원). 아직 견적을 내지 않았으면 null
   * @nullable
   */
  totalAmount?: number | null;
}

export interface AdminProjectItemDto {
  /** 품목명 */
  name: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit: string;
  /** 금액 */
  amount: number;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 품목 코드 */
  itemCode?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 품목 ID */
  itemId?: string;
  /** 매칭된 표준 품목명 */
  itemName?: string;
  /** 매칭된 표준 품목 코드 */
  itemCodeMatch?: string;
  /** 매칭된 표준 품목 단가 */
  itemPrice?: number;
  /** 매칭된 표준 품목 이미지 URL */
  itemImageUrl?: string;
  /** 매칭된 표준 품목 규격 요약 */
  itemSpec?: string;
  /** 이 줄로 이미 견적을 낸 업체명 목록. 비어 있지 않으면 매칭을 바꿀 수 없다(서버도 409 로 막는다) — 매칭을 바꾸면 이미 나간 견적이 무엇에 대한 금액인지 알 수 없게 되기 때문이다. */
  quotedSupplierNames?: string[];
}

export interface AdminProjectNoteDto {
  /** 메모 ID */
  id: string;
  /** 메모 내용 */
  body: string;
  /**
   * 작성 관리자 users.id. 계정이 삭제되면 null 이 되고 본문은 남는다. 삭제 버튼 노출 판단에 쓴다(자기 메모만 지울 수 있다).
   * @nullable
   */
  authorId?: string | null;
  /** 작성자 표시명. 이름이 없으면 이메일, 둘 다 없으면 "알 수 없음" */
  authorName: string;
  /** 작성 시각 (ISO 8601) */
  createdAt: string;
}

/**
 * 가입 경로. `cmarket` 이면 씨마켓을 통해 들어온 공고다(`users.source`).
 */
export type AdminProjectBuyerDtoSource =
  (typeof AdminProjectBuyerDtoSource)[keyof typeof AdminProjectBuyerDtoSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectBuyerDtoSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export interface AdminProjectBuyerDto {
  /**
   * 발주기관명(`buyers.organization_name`). 세모 직가입 개인 구매자는 값이 없다.
   * @nullable
   */
  organizationName?: string | null;
  /** 계정 이름(`users.name`). 씨마켓 연동 건에서는 기관명이 아니라 담당자 직함이다 — 기관명 아래 보조 정보로만 쓴다. */
  accountName: string;
  /**
   * 씨마켓 회원 아이디(`buyers.external_buyer_id`). 씨마켓 연동 건에만 값이 있다.
   * @nullable
   */
  externalBuyerId?: string | null;
  /** 가입 경로. `cmarket` 이면 씨마켓을 통해 들어온 공고다(`users.source`). */
  source: AdminProjectBuyerDtoSource;
  /**
   * 실무 담당자명(`buyers.manager_name`)
   * @nullable
   */
  managerName?: string | null;
  /**
   * 담당자 부서/직위 — 툴팁에서 계정 이름의 정체를 설명한다.
   * @nullable
   */
  managerTitle?: string | null;
  /** 연락처 이메일 */
  contactEmail: string;
  /**
   * 연락처
   * @nullable
   */
  phone?: string | null;
}

export interface AdminProjectContractLinkDto {
  /** 계약 ID */
  id: string;
  /**
   * 계약번호
   * @nullable
   */
  contractNumber?: string | null;
  /** 계약 상태 DB 원값 */
  status: string;
  /**
   * 계약 금액(원)
   * @nullable
   */
  totalAmount?: number | null;
  /**
   * 계약 체결일
   * @nullable
   */
  createdAt?: string | null;
}

export interface AdminProjectMatchSummaryDto {
  /** 물품 줄 수. 0 이면 물품 목록이 없는 공고다. */
  totalItems: number;
  /** 표준 물품에 매칭된 줄 수 */
  matchedItems: number;
  /** 자동견적이 실제로 나갈 수 있는 줄 수 — 매칭됐고 취급 공급사가 1곳 이상인 줄. matchedItems 보다 작으면 매칭을 더 해도 견적이 늘지 않는다. */
  quotableItems: number;
}

/**
 * 상태. 계약 이력이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)이고, 있으면 조회 전용 파생값으로 덮어써 실려 나간다 — 취소되지 않은 계약이 있으면 `CONTRACT_IN_PROGRESS`(계약 진행), 남은 것이 전부 취소분이면 `CONTRACT_CANCELED`(계약 취소). 파생값은 DB 에 저장되지 않는다. 화면은 `ON_HOLD`·`CLOSED` 를 모두 "시간 마감" 한 칸으로 그린다.
 */
export type AdminProjectDtoStatus =
  (typeof AdminProjectDtoStatus)[keyof typeof AdminProjectDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
  CONTRACT_CANCELED: "CONTRACT_CANCELED",
} as const;

/**
 * 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)
 */
export type AdminProjectDtoTransactionModel =
  (typeof AdminProjectDtoTransactionModel)[keyof typeof AdminProjectDtoTransactionModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoTransactionModel = {
  brokerage: "brokerage",
  agency: "agency",
} as const;

/**
 * 카테고리 타입
 */
export type AdminProjectDtoCategoryType =
  (typeof AdminProjectDtoCategoryType)[keyof typeof AdminProjectDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 마감 주체. `BUYER`(발주기관이 직접 [마감하기]) · `ADMIN`(관리자 대행 마감) · `DEADLINE`(마감일이 지나 스케줄러가 내림). 아직 진행중이면 null. 이 컬럼이 생기기 전에 마감된 건은 `BUYER` 로 읽는다 — 그때는 관리자에게 마감 수단 자체가 없었다.
 * @nullable
 */
export type AdminProjectDtoClosedBy =
  | (typeof AdminProjectDtoClosedBy)[keyof typeof AdminProjectDtoClosedBy]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectDtoClosedBy = {
  BUYER: "BUYER",
  ADMIN: "ADMIN",
  DEADLINE: "DEADLINE",
} as const;

/**
 * 가장 최근 메모. 목록의 마우스 오버 미리보기에 쓴다 — 메모가 있는지 알려면 상세로 들어가야 하는 동선을 없앤다. 메모가 없으면 null.
 * @nullable
 */
export type AdminProjectDtoLatestNote = AdminProjectNoteDto | null;

export interface AdminProjectDto {
  /** 프로젝트 ID */
  id: string;
  /** 프로젝트명 */
  projectName: string;
  /** 견적 요청 번호 */
  requestNumber: string;
  /** 상태. 계약 이력이 없으면 DB 원값(`IN_PROGRESS`·`ON_HOLD`·`CLOSED`)이고, 있으면 조회 전용 파생값으로 덮어써 실려 나간다 — 취소되지 않은 계약이 있으면 `CONTRACT_IN_PROGRESS`(계약 진행), 남은 것이 전부 취소분이면 `CONTRACT_CANCELED`(계약 취소). 파생값은 DB 에 저장되지 않는다. 화면은 `ON_HOLD`·`CLOSED` 를 모두 "시간 마감" 한 칸으로 그린다. */
  status: AdminProjectDtoStatus;
  /** 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다) */
  transactionModel: AdminProjectDtoTransactionModel;
  /** 취소되지 않은 계약 수. 계약 이력이 없거나 전부 취소됐으면 0. 2 이상이면 화면은 상태 대신 "계약 N건" 만 보여준다 — 여러 계약의 상태를 하나로 접으면 그게 어느 계약 얘기인지 알 수 없어지기 때문이다. */
  activeContractCount: number;
  /** 구매자 ID */
  userId: string;
  /** 생성일 */
  createdAt: string;
  /** 수정일 */
  updatedAt: string;
  /** 설명 */
  description?: string;
  /** 주소 정보 */
  address: AdminAddressDto;
  /** 구매자 정보 */
  user: AdminUserSummaryDto;
  /** 담당자명 */
  managerName?: string;
  /** 담당자 연락처 */
  managerContact: string;
  /** 카테고리 타입 */
  categoryType: AdminProjectDtoCategoryType;
  /** 마감 사유 */
  closeReason?: string;
  /**
   * 마감 시각 (ISO 8601). 마감 전이면 null. 마감일이 지나 스케줄러가 내린 건은 누른 사람이 없으므로 이 값도 비어 있다 — 그때의 기준 시각은 `deadline` 이다.
   * @nullable
   */
  closedAt?: string | null;
  /**
   * 마감 주체. `BUYER`(발주기관이 직접 [마감하기]) · `ADMIN`(관리자 대행 마감) · `DEADLINE`(마감일이 지나 스케줄러가 내림). 아직 진행중이면 null. 이 컬럼이 생기기 전에 마감된 건은 `BUYER` 로 읽는다 — 그때는 관리자에게 마감 수단 자체가 없었다.
   * @nullable
   */
  closedBy?: AdminProjectDtoClosedBy;
  /**
   * 마감을 누른 사람 이름. 주체가 `ADMIN` 일 때 «관리자 · 홍길동» 으로 쓴다. 이름을 되찾을 수 없는 예전 건은 null 이며, 그때는 주체 라벨만 보여준다.
   * @nullable
   */
  closedByName?: string | null;
  /** 마감일 */
  deadline: string;
  /** 참여 업체 수. 이 공고에 열린 채팅방 개수이며 상세 화면의 "참여 업체" 와 같은 정의다. */
  participantCount: number;
  /** 참여 업체 요약(업체명·견적금액). 목록에서 마우스 오버로 "누가 얼마에" 를 보여준다. */
  participants: AdminProjectParticipantDto[];
  /**
   * 동일 지역만 허용 여부. true 이면 발주자 시/도 + 인접 2개 시/도 (총 3개 지역) 공급사만 참여 가능.
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /** 물품 목록 */
  items?: AdminProjectItemDto[];
  /** 첨부파일 목록 */
  attachments?: AttachmentMetadataDto[];
  /**
   * 삭제 시각. 값이 있으면 "삭제됨" 상태이며 일반 목록·발주기관·공급사 화면에서 보이지 않는다. 데이터는 지워지지 않는다.
   * @nullable
   */
  deletedAt?: string | null;
  /**
   * 삭제한 관리자 이름
   * @nullable
   */
  deletedByName?: string | null;
  /** 이 공고에 달린 운영 메모 개수. 목록에서 어느 공고에 인수인계 맥락이 있는지 한눈에 보여주기 위한 것이라, 0 이면 아이콘 자체를 그리지 않는다. */
  noteCount: number;
  /**
   * 가장 최근 메모. 목록의 마우스 오버 미리보기에 쓴다 — 메모가 있는지 알려면 상세로 들어가야 하는 동선을 없앤다. 메모가 없으면 null.
   * @nullable
   */
  latestNote?: AdminProjectDtoLatestNote;
  /** 발주기관 신원. 목록의 「발주기관」 칸은 `user.name` 이 아니라 이 값을 쓴다. */
  buyer: AdminProjectBuyerDto;
  /** 이 공고에 걸린 계약들. 취소분도 포함한다 — 목록에서 계약서로 바로 넘어가기 위한 것이라 "엎어진 계약을 확인하는" 동선도 같은 자리에서 처리한다. 계약이 없으면 빈 배열. */
  contracts: AdminProjectContractLinkDto[];
  /** 물품 매칭 요약(전체/매칭/발송가능 줄 수). */
  matchSummary: AdminProjectMatchSummaryDto;
  /**
   * 자동견적 진행 상태(`none`·`pending`·`processing`·`completed`·`failed`). `failed` 는 사람이 보지 않으면 드러나지 않아 목록에 표시한다.
   * @nullable
   */
  autoQuoteStatus?: string | null;
  /**
   * 예산 금액(원)
   * @nullable
   */
  budgetAmount?: number | null;
  /**
   * 공개 공고 여부. false 면 지정한 공급사만 본다 — 참여가 적은 이유가 된다.
   * @nullable
   */
  isPublic?: boolean | null;
}

/**
 * 견적 상태
 */
export type AdminQuoteDtoStatus =
  (typeof AdminQuoteDtoStatus)[keyof typeof AdminQuoteDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteDtoStatus = {
  pending: "pending",
  submitted: "submitted",
  withdrawn: "withdrawn",
  expired: "expired",
} as const;

export interface AdminQuoteDto {
  /** 견적 ID */
  id: string;
  /** 견적 금액 */
  totalAmount?: number;
  /** 견적 상태 */
  status?: AdminQuoteDtoStatus;
}

/**
 * 참여 노출 상태. visible=정상, hidden=마스터에만 흐리게
 */
export type AdminChatRoomDtoParticipationState =
  (typeof AdminChatRoomDtoParticipationState)[keyof typeof AdminChatRoomDtoParticipationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChatRoomDtoParticipationState = {
  visible: "visible",
  hidden: "hidden",
} as const;

export interface AdminChatRoomDto {
  /** 채팅방 ID */
  id: string;
  /** 견적 요청 ID */
  quote_request_id: string;
  /** 공급자 정보 */
  supplier: AdminUserSummaryDto;
  /** 구매자 정보 */
  buyer: AdminUserSummaryDto;
  /** 마지막 메시지 시간 */
  last_message_at?: string;
  /** 연관된 견적 정보 */
  quote?: AdminQuoteDto;
  /** 상태 */
  status?: string;
  /** 참여 노출 상태. visible=정상, hidden=마스터에만 흐리게 */
  participationState: AdminChatRoomDtoParticipationState;
  /** 계약이 체결된 참여인지. true 면 숨기기도 삭제도 막힌다. */
  hasContracted: boolean;
  /**
   * 감춘 시각 (ISO 8601). 정상 상태면 null.
   * @nullable
   */
  hiddenAt?: string | null;
}

export interface AdminProjectDetailResponseDto {
  project: AdminProjectDto;
  chatRooms: AdminChatRoomDto[];
}

export interface AdminMatchItemResponseDto {
  /** 성공 여부 */
  success: boolean;
}

export interface AdminMatchItemDto {
  /** 표준 물품 UUID (items_v2_base.id) */
  baseItemId: string;
  /** 이 줄로 이미 견적을 낸 업체가 있는데도 물품을 바꾸겠다는 확인. 마스터 화면이 어긋날 견적을 보여주고 체크를 받은 뒤에 true 로 보낸다. 확인 없이 바꾸려 하면 409 로 되돌아온다. */
  confirmRematch?: boolean;
}

export interface AdminRegisterAndMatchItemResultDto {
  /** 생성된 표준 물품 UUID (items_v2_base.id) */
  itemId: string;
  /**
   * 자동 채번된 물품코드
   * @nullable
   */
  productCode: string | null;
  /** 등록된 물품명 */
  name: string;
}

export interface AdminRegisterAndMatchItemResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 등록 결과 */
  result: AdminRegisterAndMatchItemResultDto;
}

export interface AdminRegisterAndMatchItemDto {
  /** 상품명 (필수) */
  name: string;
  /** 제조사 (선택) */
  manufacturer?: string;
  /** 브랜드 (선택) */
  brand?: string;
  /** 품목코드 (선택) */
  code?: string;
  /** 단위 (필수) */
  unit: string;
  /** 정가 (필수) */
  price: number;
  /** 이미지 URL (선택) */
  imageUrl?: string;
  /** 카테고리 ID (필수, UUID) */
  categoryId: string;
  /** 규격1 (선택) */
  spec1?: string;
  /** 규격2 (선택) */
  spec2?: string;
  /** 규격3 (선택) */
  spec3?: string;
  /** 이 줄로 이미 견적을 낸 업체가 있는데도 물품을 바꾸겠다는 확인. 마스터 화면이 어긋날 견적을 보여주고 체크를 받은 뒤에 true 로 보낸다. 확인 없이 바꾸려 하면 409 로 되돌아온다. */
  confirmRematch?: boolean;
}

/**
 * 단가의 부가세 축. INCLUSIVE 면 부가세 포함가라 그대로 등재된다(가산하지 않는다)
 */
export type AdminQuotedPriceCandidateDtoTaxType =
  (typeof AdminQuotedPriceCandidateDtoTaxType)[keyof typeof AdminQuotedPriceCandidateDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuotedPriceCandidateDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

/**
 * 카탈로그 단가의 부가세 축
 * @nullable
 */
export type AdminQuotedPriceCandidateDtoCatalogTaxType =
  | (typeof AdminQuotedPriceCandidateDtoCatalogTaxType)[keyof typeof AdminQuotedPriceCandidateDtoCatalogTaxType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuotedPriceCandidateDtoCatalogTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface AdminQuotedPriceCandidateDto {
  /** 공급사 ID (users.id) */
  supplierId: string;
  /** 공급사명 */
  supplierName: string;
  /**
   * 그 줄에 제시한 단가. 견적서에 값이 없으면 null
   * @nullable
   */
  unitPrice: number | null;
  /** 단가의 부가세 축. INCLUSIVE 면 부가세 포함가라 그대로 등재된다(가산하지 않는다) */
  taxType: AdminQuotedPriceCandidateDtoTaxType;
  /**
   * 견적 제출 시각
   * @nullable
   */
  submittedAt: string | null;
  /** 이 공급사의 단가가 이미 카탈로그에 있는가. true 면 연결 버튼을 막는다 — 공급사가 스스로 관리하는 단가를 관리자가 덮지 않는다. */
  linked: boolean;
  /**
   * 카탈로그에 이미 있는 단가
   * @nullable
   */
  catalogPrice: number | null;
  /**
   * 카탈로그 단가의 부가세 축
   * @nullable
   */
  catalogTaxType: AdminQuotedPriceCandidateDtoCatalogTaxType;
}

export interface AdminQuotedPriceLineDto {
  /** 공고 줄 인덱스 */
  itemIndex: number;
  /** 공고 줄 이름 */
  itemName: string;
  /**
   * 매칭된 표준 물품 ID. null 이면 아직 매칭 전이라 연결할 대상이 없다
   * @nullable
   */
  itemId: string | null;
  /** 이 줄에 견적을 낸 업체들 */
  candidates: AdminQuotedPriceCandidateDto[];
}

/**
 * 그 단가의 부가세 축
 */
export type AdminLinkQuotedPriceResponseDtoTaxType =
  (typeof AdminLinkQuotedPriceResponseDtoTaxType)[keyof typeof AdminLinkQuotedPriceResponseDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminLinkQuotedPriceResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface AdminLinkQuotedPriceResponseDto {
  /** 요청 성공 여부 */
  success: boolean;
  /** 이번에 새로 등재했는가. false 면 이미 단가가 있어 그대로 두었다는 뜻이다 */
  created: boolean;
  /** 등재된 표준 물품 ID */
  itemId: string;
  /** 공급사 ID */
  supplierId: string;
  /** 카탈로그에 남은 단가 */
  price: number;
  /** 그 단가의 부가세 축 */
  taxType: AdminLinkQuotedPriceResponseDtoTaxType;
}

export interface AdminExtendDeadlineResultDto {
  /** 견적 요청 ID */
  id: string;
  /** 연장된 마감일시 (ISO 8601) */
  deadline: string;
  /** 연장 후 상태. 마감일이 지나 ON_HOLD 로 내려가 있던 공고는 IN_PROGRESS 로 되살아납니다. */
  status: string;
}

export interface AdminExtendDeadlineResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 연장 결과 */
  result: AdminExtendDeadlineResultDto;
}

export interface AdminExtendDeadlineDto {
  /** 새 마감일시 (ISO 8601). 현재 시각과 기존 마감일시보다 뒤여야 하며, 한 번에 30일까지 연장할 수 있습니다. */
  deadline: string;
}

export interface AdminCloseProjectResultDto {
  /** 견적 요청 ID */
  id: string;
  /** 마감 후 상태 */
  status: string;
  /**
   * 마감 시각 (ISO 8601)
   * @nullable
   */
  closedAt: string | null;
  /**
   * 마감 사유
   * @nullable
   */
  closeReason: string | null;
}

export interface AdminCloseProjectResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 마감 결과 */
  result: AdminCloseProjectResultDto;
}

export interface AdminCloseProjectDto {
  /**
   * 마감 사유. 목록의 상태 위에 그대로 뜹니다.
   * @minLength 2
   * @maxLength 200
   */
  reason: string;
}

export interface AdminAgencyQuoteSubmissionResponseDto {
  /** 생성된 엔씨하이 견적 id */
  quoteResponseId: string;
  /** 생성된 견적 버전 id */
  versionId: string;
  /** 매입 대상이 된 공급사 상호 */
  sourceSupplierName: string;
  /** 그 공급사의 견적 총액 */
  sourceTotalAmount: number;
  /** 발주기관에게 제시되는 구매대행 총액 */
  saleTotalAmount: number;
  /** 중개 대비 발주기관 절감액 */
  buyerSavingAmount: number;
}

/**
 * 전환된 거래 모델
 */
export type AdminTransactionModelResponseDtoTransactionModel =
  (typeof AdminTransactionModelResponseDtoTransactionModel)[keyof typeof AdminTransactionModelResponseDtoTransactionModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTransactionModelResponseDtoTransactionModel = {
  brokerage: "brokerage",
  agency: "agency",
} as const;

export interface AdminTransactionModelResponseDto {
  /** 공고 ID */
  projectId: string;
  /** 전환된 거래 모델 */
  transactionModel: AdminTransactionModelResponseDtoTransactionModel;
  /** 전환 시점의 참여업체 수 */
  participantCount: number;
}

/**
 * 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다)
 */
export type AdminSetTransactionModelDtoTransactionModel =
  (typeof AdminSetTransactionModelDtoTransactionModel)[keyof typeof AdminSetTransactionModelDtoTransactionModel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSetTransactionModelDtoTransactionModel = {
  brokerage: "brokerage",
  agency: "agency",
} as const;

export interface AdminSetTransactionModelDto {
  /** 거래 모델. brokerage=중개(발주기관↔공급사 직접), agency=구매대행(엔씨하이가 사서 판다) */
  transactionModel: AdminSetTransactionModelDtoTransactionModel;
}

export interface AutoQuoteFailedSupplierDto {
  /** 공급자 ID */
  supplierId: string;
  /** 공급자명 */
  supplierName: string;
  /** 에러 메시지 */
  error: string;
}

export interface AutoQuoteTriggerResultDto {
  /** 견적 요청 ID */
  quoteRequestId: string;
  /** 적격 공급자 총 수 */
  totalEligibleSuppliers: number;
  /** 발송 성공 수 */
  successCount: number;
  /** 발송 실패 수 */
  failureCount: number;
  /** 이미 응답한 공급자 수 */
  alreadyRespondedCount: number;
  /** 실패한 공급자 목록 */
  failedSuppliers: AutoQuoteFailedSupplierDto[];
}

export interface AdminTriggerAutoQuotesResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 상세 결과 */
  result: AutoQuoteTriggerResultDto;
}

export interface AdminSimilarSupplierDto {
  /** 공급사 사용자 ID (알림톡 수신자) */
  supplierId: string;
  /** 업체명 */
  companyName: string;
  /** 이 업체를 뽑은 근거가 된 유사 품목명 */
  basisItemName: string;
  /** 근거가 된 공고 줄 이름 */
  requestItemName: string;
  /**
   * 근거 품목의 가장 최근 거래일
   * @nullable
   */
  lastTransactionDate?: string | null;
  /**
   * 알림톡을 받을 수 없는 이유(연락처 없음·수신 거부). null 이면 발송 가능하다.
   * @nullable
   */
  unreachableReason?: string | null;
}

export interface AdminSimilarSuppliersResponseDto {
  candidates: AdminSimilarSupplierDto[];
  /** 이미 이 공고에 참여 중이라 후보에서 제외한 업체 수(채팅방이 열렸거나 견적을 낸 곳). */
  excludedParticipantCount: number;
}

export interface AdminNotifySimilarSuppliersSummaryDto {
  /** 알림톡을 보낸 곳 */
  sent: number;
  /** 연락처가 없거나 카카오 알림을 꺼 둬서 보내지 못한 곳 */
  skipped: number;
  /** 발송 중 오류가 난 곳 */
  failed: number;
  /** 요청에는 있었지만 이미 참여 중이거나 공급사가 아니어서 제외한 ID 수 */
  ignored?: number;
}

export interface AdminNotifySimilarSuppliersResultDto {
  /** 성공 여부 */
  success: boolean;
  /** 발송 결과 */
  result: AdminNotifySimilarSuppliersSummaryDto;
}

export interface AdminNotifySimilarSuppliersDto {
  /** 안내를 보낼 공급사 사용자 ID 목록. 후보 조회 결과에서 마스터가 고른 것만 담는다. */
  supplierIds: string[];
}

export interface AdminProjectNoteListResponseDto {
  /** 최신순 메모 목록 */
  notes: AdminProjectNoteDto[];
}

export interface AdminProjectNoteResponseDto {
  /** 성공 여부 */
  success: boolean;
  /** 작성된 메모 */
  result: AdminProjectNoteDto;
}

export interface CreateAdminProjectNoteDto {
  /**
   * 메모 내용
   * @maxLength 2000
   */
  body: string;
}

/**
 * 바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게)
 */
export type AdminParticipationVisibilityResponseDtoState =
  (typeof AdminParticipationVisibilityResponseDtoState)[keyof typeof AdminParticipationVisibilityResponseDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminParticipationVisibilityResponseDtoState = {
  visible: "visible",
  hidden: "hidden",
} as const;

/**
 * 바뀌기 전 상태. 이미 같은 상태였으면 생략된다.
 */
export type AdminParticipationVisibilityResponseDtoPreviousState =
  (typeof AdminParticipationVisibilityResponseDtoPreviousState)[keyof typeof AdminParticipationVisibilityResponseDtoPreviousState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminParticipationVisibilityResponseDtoPreviousState = {
  visible: "visible",
  hidden: "hidden",
} as const;

export interface AdminParticipationVisibilityResponseDto {
  /** 대상 참여의 채팅방 ID */
  chatRoomId: string;
  /** 바뀐 뒤 상태. visible=정상, hidden=숨김(마스터에만 흐리게) */
  state: AdminParticipationVisibilityResponseDtoState;
  /** 바뀌기 전 상태. 이미 같은 상태였으면 생략된다. */
  previousState?: AdminParticipationVisibilityResponseDtoPreviousState;
  /** 실제로 상태가 바뀌었는지. false 면 이미 그 상태였다는 뜻이다. */
  changed: boolean;
  /** 함께 표시된 견적 행 수. 견적을 내지 않고 방만 열린 참여는 0 이다. */
  quoteResponses: number;
}

export interface AdminParticipationDeletionResponseDto {
  /** 지운 참여의 채팅방 ID */
  chatRoomId: string;
  /** 이 참여가 속했던 공고 ID */
  quoteRequestId: string;
  /** 이 참여의 공급사 users.id */
  supplierId: string;
  /** 함께 사라진 견적 수 */
  quoteResponses: number;
  /** 함께 사라진 견적서 버전 수 */
  quoteVersions: number;
  /** 함께 사라진 대화 메시지 수. 되돌릴 수 없다. */
  chatMessages: number;
  /** 함께 사라진 대화방 수 */
  chatRooms: number;
}

/**
 * 변경할 정산 상태
 */
export type BatchUpdateSettlementStatusDtoStatus =
  (typeof BatchUpdateSettlementStatusDtoStatus)[keyof typeof BatchUpdateSettlementStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BatchUpdateSettlementStatusDtoStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface BatchUpdateSettlementStatusDto {
  /** 변경할 계약 ID 목록 */
  contractIds: string[];
  /** 변경할 정산 상태 */
  status: BatchUpdateSettlementStatusDtoStatus;
}

/**
 * 결제 수단
 */
export type AdminSettlementResponseDtoPaymentMethod =
  (typeof AdminSettlementResponseDtoPaymentMethod)[keyof typeof AdminSettlementResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSettlementResponseDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
} as const;

/**
 * 정산 상태
 */
export type AdminSettlementResponseDtoSettlementStatus =
  (typeof AdminSettlementResponseDtoSettlementStatus)[keyof typeof AdminSettlementResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSettlementResponseDtoSettlementStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface AdminSettlementResponseDto {
  /** 계약 ID */
  id: string;
  /** 계약 상세 정보 */
  contract?: ContractResponseDto;
  /** 계약 번호 */
  contractNumber: string;
  /** 계약 생성 일시 */
  contractDate: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 플랫폼 수수료 */
  commissionAmount: number;
  /**
   * 계약 건별로 직접 지정한 수수료 정액(원). null 이면 전역 요율로 계산한 값이다.
   * @nullable
   */
  commissionOverrideAmount?: number | null;
  /** 정산 예정 금액 (총액 - 수수료) */
  settlementAmount: number;
  /** 결제 수단 */
  paymentMethod: AdminSettlementResponseDtoPaymentMethod;
  /** 정산 상태 */
  settlementStatus: AdminSettlementResponseDtoSettlementStatus;
  /**
   * 정산 예정일 (구매확정일 + 15일)
   * @nullable
   */
  settlementExpectedDate?: string | null;
  /**
   * 구매확정 일시
   * @nullable
   */
  completedAt?: string | null;
  /**
   * 정산 지급 완료 일시
   * @nullable
   */
  settledAt?: string | null;
  /** 구매자(발주)명 */
  clientName: string;
  /** 공급자(수주)명 */
  supplierName: string;
  /** 공급자 사업자번호 */
  supplierBusinessNumber?: string;
  /** 비고 */
  note?: string;
}

export interface SettlementStatsResponseDto {
  /** 미수 수수료 합계 — 계약이 서서 청구됐으나 아직 받지 못한 수수료 */
  unpaidCommission: number;
  /** 누적 수납 수수료 — 업체에서 실제로 받은 수수료 */
  collectedCommission: number;
  /** 미수 건수 */
  unpaidCount: number;
  /** (레거시·대금 축) 정산 예정 총액. 직거래 전환으로 세모가 지급할 대금이 없어 화면에서 쓰지 않는다. */
  totalPendingAmount: number;
  /** (레거시·대금 축) 정산 완료 총액 */
  totalCompletedAmount: number;
  /** (레거시) 대기 건수 — `unpaidCount` 와 같은 값이다 */
  pendingCount: number;
  /** 수수료 청구액 합계 — 건별 10원 절사 후 합산이라 목록 표의 수수료 합과 정의가 같다. */
  totalCommission: number;
  /** 안심결제 매출 총액 */
  safePaymentRevenue: number;
  /** 직접결제 유통 총액 (GMV) */
  directPaymentGMV: number;
  /** 계약금액 합계 — 현재 필터에 해당하는 계약의 총액 합 */
  totalContractAmount: number;
}

export interface MonthlyBillingLineItemDto {
  /** 거래일자 (KST) */
  txDate: string;
  /** 그 날의 계약 건수 */
  txCount: number;
  /** 그 날의 계약금액 합계 */
  contractAmount: number;
  /** 그 날의 수수료 합계 (건별 10원 절사 후 합산, 부가세 포함) */
  commission: number;
  /** 공급가액 */
  supplyAmount: number;
  /** 세액 */
  taxAmount: number;
}

export interface MonthlyCommissionInvoiceDto {
  /** 공급기업 ID */
  supplierId: string;
  /** 공급기업 상호 */
  companyName: string;
  /** 사업자등록번호 */
  businessNumber: string;
  /** 대표자명 */
  ceoName: string;
  /** 사업장 주소 */
  addressFull: string;
  /** 업태 */
  businessType: string;
  /** 종목 */
  businessItem: string;
  /** 계산서 수신 이메일 (계산서 전용 → 담당자 → 계정 순) */
  email: string;
  /** 청구월 거래 건수 */
  txCount: number;
  /** 청구월 거래일자 수 */
  txDateCount: number;
  /** 계약금액 합계 */
  contractAmount: number;
  /** 수수료 청구액 (부가세 포함) */
  commission: number;
  /** 공급가액 */
  supplyAmount: number;
  /** 세액 */
  taxAmount: number;
  /** 거래일자별 명세 (오름차순) */
  lineItems: MonthlyBillingLineItemDto[];
  /** 계산서 품목칸을 거래일자별로 채울 수 있는지. 거래일자가 4개를 넘으면 false 가 되고 월합계 1줄로 접힌다. */
  itemizedByDate: boolean;
  /** 이 기업의 청구월 계약 중 이미 계산서가 발행된 건수 */
  issuedCount: number;
  /**
   * 마지막 발행 일시
   * @nullable
   */
  lastIssuedAt?: string | null;
}

export interface MonthlyBillingSummaryDto {
  /** 청구 대상 기업 수 */
  supplierCount: number;
  /** 거래 건수 합계 */
  txCount: number;
  /** 계약금액 합계 */
  contractAmount: number;
  /** 수수료 청구액 합계 */
  commission: number;
}

export interface MonthlyBillingResponseDto {
  /** 청구월 'YYYY-MM' */
  month: string;
  /** 기업별 청구서 */
  invoices: MonthlyCommissionInvoiceDto[];
  /** 조회 조건 합계 */
  summary: MonthlyBillingSummaryDto;
}

/**
 * 변경할 정산 상태
 */
export type UpdateSettlementStatusDtoStatus =
  (typeof UpdateSettlementStatusDtoStatus)[keyof typeof UpdateSettlementStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateSettlementStatusDtoStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface UpdateSettlementStatusDto {
  /** 변경할 정산 상태 */
  status: UpdateSettlementStatusDtoStatus;
}

export interface AdminContractResponseDto {
  /** 계약 ID */
  id: string;
  /** 계약 상세 정보 (전체 DTO) */
  contract?: ContractResponseDto;
  /** 계약 번호 */
  contractNumber: string;
  /** 계약 생성 일시 */
  createdAt: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 계약 상태 */
  status: string;
  /** 프로젝트명 */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType?: string;
  /** 구매자(발주)명 */
  buyerName: string;
  /** 공급자(수주)명 */
  supplierName: string;
  /**
   * PDF URL
   * @nullable
   */
  pdfUrl?: string | null;
  /** 채팅방 ID */
  chatRoomId?: string;
  /**
   * 씨마켓 회원 아이디 (씨마켓 연동 발주기관만)
   * @nullable
   */
  buyerExternalId?: string | null;
  /**
   * 씨마켓 기관명 (씨마켓 연동 발주기관만)
   * @nullable
   */
  buyerOrganizationName?: string | null;
  /**
   * 결제 방식 — 'prepaid'(선불, 엔씨하이 수취) | 'postpaid'(후불, 공급사 직접 수취)
   * @nullable
   */
  paymentMethod?: string | null;
  /**
   * 결제 수단 (카드/무통장 등). 후불은 결제 거래 자체가 없어 null
   * @nullable
   */
  paymentChannel?: string | null;
  /**
   * 엔씨하이(주) 입금 확인 일시. null 이면 아직 입금 전
   * @nullable
   */
  paidAt?: string | null;
  /**
   * 검수(구매확정) 완료 일시. null 이면 검수 전
   * @nullable
   */
  completedAt?: string | null;
  /**
   * 정산 상태 — WAITING | DEFERRED | COMPLETED
   * @nullable
   */
  settlementStatus?: string | null;
  /**
   * 공급사 대금 지급 일시. null 이면 아직 안 나감
   * @nullable
   */
  settledAt?: string | null;
  /**
   * 정산 예정일
   * @nullable
   */
  settlementExpectedAt?: string | null;
}

export interface RegenerateContractPdfResponseDto {
  /** 계약서 재생성 작업이 대기줄에 실렸는지 */
  enqueued: boolean;
  /** 품목을 바꿨는지 */
  itemsUpdated: boolean;
}

export interface AdminContractItemDto {
  /** 품명 */
  name: string;
  /** 수량 */
  quantity: number;
  /** 단위 */
  unit: string;
  /** 금액(공급가액) */
  amount: number;
  /** 단가 */
  unitPrice?: number;
  /** 규격1 */
  spec1?: string;
  /** 규격2 */
  spec2?: string;
  /** 규격3 */
  spec3?: string;
}

export interface RegenerateContractPdfDto {
  /** 교정한 계약 품목 전체. 주면 계약의 품목을 이 목록으로 바꾼 뒤 계약서를 다시 만든다. 생략하면 지금 계약 내용 그대로 다시 만들기만 한다. */
  items?: AdminContractItemDto[];
}

export interface UpdateContractCommissionDto {
  /**
   * 이 계약에만 적용할 수수료 정액(원). null 이면 override 를 해제하고 전역 요율 계산으로 되돌린다. 저장 시 10원 미만은 절사된다.
   * @minimum 0
   * @nullable
   */
  commissionOverrideAmount: number | null;
}

export interface PlatformFeePolicyResponseDto {
  /** 전역 수수료율(%) */
  feeRate: number;
  /**
   * 마지막 변경 시각(ISO)
   * @nullable
   */
  updatedAt: string | null;
}

export interface UpdatePlatformFeePolicyDto {
  /**
   * 전역 수수료율(%). 0 이면 수수료 면제. 변경해도 기존 계약은 재계산하지 않는다.
   * @minimum 0
   * @maximum 100
   */
  feeRate: number;
}

/**
 * 현재 수치
 */
export type DashboardMetricDtoValue = { [key: string]: unknown };

export interface DashboardMetricDto {
  /** 현재 수치 */
  value: DashboardMetricDtoValue;
  /** 지난달 대비 변화량 (절대값 또는 퍼센트) */
  change: number;
  /** 변화 설명 (예: '+180 (지난달 대비)') */
  description: string;
}

export interface ChartDataPointDto {
  /** X축 라벨 (예: '1월') */
  name: string;
  /** 프로젝트 수 */
  projects: number;
  /** 계약 완료 수 */
  contracts: number;
}

export interface RecentActivityDto {
  /** 활동 ID */
  id: string;
  /** 아이콘 식별자 */
  icon: string;
  /** 활동 제목 */
  title: string;
  /** 활동 상세 설명 */
  description: string;
  /** 몇 분 전인지 */
  minutesAgo: number;
}

export interface AdminDashboardResponseDto {
  /** 총 회원수 지표 */
  totalUsers: DashboardMetricDto;
  /** 진행중 프로젝트 지표 */
  activeProjects: DashboardMetricDto;
  /** 계약 완료 지표 */
  completedContracts: DashboardMetricDto;
  /** 총 거래액 지표 */
  totalRevenue: DashboardMetricDto;
  /** 총 수수료 수익 지표 */
  totalCommission: DashboardMetricDto;
  /** 안심결제 매출 지표 */
  safePaymentRevenue: DashboardMetricDto;
  /** 직접결제 유통액 지표 */
  directPaymentGMV: DashboardMetricDto;
  /** 차트 데이터 */
  chartData: ChartDataPointDto[];
  /** 최근 활동 목록 */
  recentActivities: RecentActivityDto[];
}

/**
 * 약관 타입
 */
export type AdminTermsResponseDtoType =
  (typeof AdminTermsResponseDtoType)[keyof typeof AdminTermsResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTermsResponseDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface AdminTermsResponseDto {
  /** 약관 ID (UUID) */
  id: string;
  /** 약관 타입 */
  type: AdminTermsResponseDtoType;
  /** 버전 */
  version: string;
  /** 약관 제목 */
  title: string;
  /** 약관 내용 */
  content: string;
  /** 필수 여부 */
  isRequired: boolean;
  /** 활성(공개) 여부 */
  isActive: boolean;
  /** 게시일 */
  publishedAt: string;
  /** 생성일 */
  createdAt: string;
  /** 수정일 */
  updatedAt: string;
}

/**
 * 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의)
 */
export type CreateTermsDtoType =
  (typeof CreateTermsDtoType)[keyof typeof CreateTermsDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateTermsDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface CreateTermsDto {
  /** 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의) */
  type: CreateTermsDtoType;
  /** 약관 버전 (Semantic Versioning 권장) */
  version: string;
  /** 약관 제목 */
  title: string;
  /** 약관 내용 (HTML 또는 Markdown) */
  content: string;
  /** 필수 동의 여부 */
  isRequired: boolean;
  /** 공개(활성) 여부. true일 경우 해당 타입의 기존 활성 약관은 비활성화됩니다. */
  isActive: boolean;
}

/**
 * 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의)
 */
export type UpdateTermsDtoType =
  (typeof UpdateTermsDtoType)[keyof typeof UpdateTermsDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateTermsDtoType = {
  terms: "terms",
  privacy: "privacy",
  marketing: "marketing",
} as const;

export interface UpdateTermsDto {
  /** 약관 제목 */
  title?: string;
  /** 약관 내용 */
  content?: string;
  /** 필수 동의 여부 */
  isRequired?: boolean;
  /** 약관 타입 (terms: 이용약관, privacy: 개인정보처리방침, marketing: 마케팅수신동의) */
  type?: UpdateTermsDtoType;
  /** 공개(활성) 여부. true로 변경 시 해당 타입의 다른 약관은 비활성화됩니다. */
  isActive?: boolean;
}

/**
 * Target Plan Type
 */
export type PromotionCodeDtoTargetPlanType =
  (typeof PromotionCodeDtoTargetPlanType)[keyof typeof PromotionCodeDtoTargetPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PromotionCodeDtoTargetPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface PromotionCodeDto {
  /** Promotion ID */
  id: string;
  /** Promotion Code */
  code: string;
  /** Description */
  description?: string;
  /** Target Plan Type */
  targetPlanType: PromotionCodeDtoTargetPlanType;
  /** Duration in days */
  durationDays: number;
  /** Max uses total */
  maxUsesPerCode?: number;
  /** Current usage count */
  currentUses: number;
  /** Max uses per user */
  maxUsesPerUser: number;
  /** Valid from date */
  validFrom?: string;
  /** Valid until date */
  validUntil?: string;
  /** Is Active status */
  isActive: boolean;
  /** Created At */
  createdAt: string;
}

/**
 * Target Plan
 */
export type CreatePromotionDtoTargetPlanType =
  (typeof CreatePromotionDtoTargetPlanType)[keyof typeof CreatePromotionDtoTargetPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePromotionDtoTargetPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface CreatePromotionDto {
  /** Promotion Code (e.g. SEMO_LAUNCH_2026) */
  code: string;
  /** Description */
  description: string;
  /** Target Plan */
  targetPlanType: CreatePromotionDtoTargetPlanType;
  /** Duration in days */
  durationDays: number;
  /** Max uses total (null for infinite) */
  maxUsesPerCode?: number;
  /** Max uses per user */
  maxUsesPerUser: number;
  /** Valid from date */
  validFrom?: string;
  /** Valid until date */
  validUntil?: string;
}

export interface PromotionRedemptionDto {
  /** Redemption ID */
  id: string;
  /** Promotion Code ID */
  promotionCodeId: string;
  /** User ID */
  userId: string;
  /** User Name */
  userName?: string;
  /** User Phone */
  userPhone?: string;
  /** User Login ID */
  userLoginId?: string;
  /** Redeemed At */
  redeemedAt: string;
}

export interface UpdatePromotionDto {
  /** Is Active */
  isActive?: boolean;
  /** Increase max uses (add to current) */
  maxUsesPerCode?: number;
  /** Valid until date */
  validUntil?: string;
}

export interface AdminAgencyPartyDto {
  /** 구매대행을 쓸 수 있는 상태인가 */
  enabled: boolean;
  /**
   * 씨마켓 회원 ID
   * @nullable
   */
  cmarketMemberId: string | null;
  /**
   * 상호
   * @nullable
   */
  displayName: string | null;
  /**
   * 매입축 계정 id
   * @nullable
   */
  buyerUserId: string | null;
  /**
   * 판매축 계정 id
   * @nullable
   */
  supplierUserId: string | null;
  /**
   * 마지막 변경 시각
   * @nullable
   */
  updatedAt: string | null;
  /**
   * 못 쓰는 상태면 그 이유
   * @nullable
   */
  unavailableReason: string | null;
}

export interface AdminSetAgencyPartyDto {
  /** 엔씨하이의 씨마켓 회원 ID. 이 값으로 판매축(공급사)·매입축(발주기관) 계정을 함께 찾는다. */
  cmarketMemberId: string;
}

export type AdminPayoutDtoKind =
  (typeof AdminPayoutDtoKind)[keyof typeof AdminPayoutDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPayoutDtoKind = {
  payment: "payment",
  offset: "offset",
} as const;

export type AdminPayoutDtoStatus =
  (typeof AdminPayoutDtoStatus)[keyof typeof AdminPayoutDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPayoutDtoStatus = {
  scheduled: "scheduled",
  on_hold: "on_hold",
  paid: "paid",
  failed: "failed",
  canceled: "canceled",
} as const;

export interface AdminPayoutDto {
  id: string;
  purchaseContractId: string;
  /** 매입계약 번호 */
  contractNumber: string;
  supplierId: string;
  /** 공급기업 상호 */
  supplierName: string;
  kind: AdminPayoutDtoKind;
  /** 금액(부가세 포함). 방향은 kind 가 정한다. */
  amount: number;
  /** 매입계약 총액 */
  purchaseTotalAmount: number;
  status: AdminPayoutDtoStatus;
  /**
   * 지급 완료 시각
   * @nullable
   */
  paidAt: string | null;
  /**
   * 보류 사유
   * @nullable
   */
  holdReason: string | null;
  /**
   * 이체 결과 식별자
   * @nullable
   */
  transferRef: string | null;
  createdAt: string;
}

export interface AdminPayoutBalanceDto {
  contractAmount: number;
  /** 이미 나간 돈 — Σ(지급) − Σ(상계) */
  paidAmount: number;
  /** 아직 더 나갈 수 있는 돈 */
  remainingAmount: number;
}

export interface AdminMarkPayoutPaidDto {
  /** 이체 결과 식별자(은행 거래번호 등). 대사에 쓴다. */
  transferRef?: string;
}

export interface AdminHoldPayoutDto {
  /** 보류 사유 */
  reason: string;
}

export interface UploadedFileDto {
  /** 업로드된 파일의 공개 URL */
  url: string;
  /** 스토리지 경로 (재서명에 사용) */
  filePath: string;
  /** 원본 파일명 */
  fileName: string;
  /** 파일 크기 (바이트) */
  fileSize: number;
  /** MIME 타입 */
  mimeType?: string;
}

export interface TemporaryFileUploadResponseDto {
  /** 업로드된 파일들의 정보 배열 */
  attachments: UploadedFileDto[];
  /** 업로드 시각 (ISO 8601 형식) */
  uploadedAt: string;
  /** 만료 시각 (ISO 8601 형식) */
  expiresAt: string;
}

/**
 * 토큰 전달 방식
 */
export type AuthSupplierResponseDtoTokenType =
  (typeof AuthSupplierResponseDtoTokenType)[keyof typeof AuthSupplierResponseDtoTokenType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthSupplierResponseDtoTokenType = {
  bearer: "bearer",
  cookie: "cookie",
} as const;

export interface AuthSupplierResponseDto {
  /** 공급자 사용자 ID (UUID) */
  supplierId: string;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** 토큰 만료 시간 (초) */
  expiresIn: number;
  /** 토큰 전달 방식 */
  tokenType: AuthSupplierResponseDtoTokenType;
  /** 신규 가입 여부 (true: 신규 가입, false: 기존 회원) */
  isNewUser?: boolean;
}

/**
 * 종류
 */
export type ExternalSupplierCertificationDtoKind =
  (typeof ExternalSupplierCertificationDtoKind)[keyof typeof ExternalSupplierCertificationDtoKind];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalSupplierCertificationDtoKind = {
  CERTIFICATION: "CERTIFICATION",
  LICENSE: "LICENSE",
  CUSTOM: "CUSTOM",
} as const;

/**
 * 만료일 (YYYY-MM-DD)
 * @nullable
 */
export type ExternalSupplierCertificationDtoExpiresAt = {
  [key: string]: unknown;
} | null;

export interface ExternalSupplierCertificationDto {
  /**
   * 씨마켓 쪽 안정 키 (예: ins:0101 / license:L12 / custom:<uuid>). 재동기화 upsert 기준.
   * @maxLength 120
   */
  sourceKey: string;
  /**
   * 인증서/면허 명칭
   * @maxLength 200
   */
  name: string;
  /** 종류 */
  kind: ExternalSupplierCertificationDtoKind;
  /**
   * 만료일 (YYYY-MM-DD)
   * @nullable
   */
  expiresAt?: ExternalSupplierCertificationDtoExpiresAt;
  /** 씨마켓 마스터 승인 여부(masterCheckYn=Y). true 면 세모 프로필에 "검증됨" 으로 노출. */
  verified: boolean;
}

/**
 * 회사 홈페이지 URL (b2b_member.homepage)
 * @maxLength 500
 * @nullable
 */
export type SupplierInfoDtoHomepageUrl = { [key: string]: unknown } | null;

/**
 * 회사 소개 (b2b_member.gita)
 * @maxLength 4000
 * @nullable
 */
export type SupplierInfoDtoCompanyIntro = { [key: string]: unknown } | null;

/**
 * 개업연월일 (b2b_member.beginday, YYYY-MM-DD)
 * @nullable
 */
export type SupplierInfoDtoEstablishedAt = { [key: string]: unknown } | null;

export interface SupplierInfoDto {
  /** C-Market 공급업체 로그인 ID */
  supplierId: string;
  /**
   * 회사명 (company_name)
   * @maxLength 100
   */
  companyName: string;
  /**
   * 사업자등록번호 (business_number)
   * @pattern ^\d{3}-\d{2}-\d{5}$
   */
  businessNumber: string;
  /**
   * 대표자명 (ceo_name)
   * @maxLength 100
   */
  ceoName: string;
  /**
   * 회사 주소 (address_full)
   * @maxLength 255
   */
  addressFull: string;
  /**
   * 우편번호 (zip_code)
   * @maxLength 10
   * @nullable
   */
  zipCode: string | null;
  /**
   * 업태/종목 (business_type)
   * @maxLength 100
   * @nullable
   */
  businessType: string | null;
  /**
   * 취급품목 (product_description)
   * @maxLength 255
   * @nullable
   */
  productDescription: string | null;
  /**
   * 회사 전화번호 (company_phone)
   * @maxLength 20
   */
  companyPhone: string;
  /**
   * 담당자명 (manager_name)
   * @maxLength 100
   */
  managerName: string;
  /**
   * 담당자 이메일 (contact_email)
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 담당자 부서 (manager_department)
   * @maxLength 100
   * @nullable
   */
  managerDepartment: string | null;
  /**
   * 담당자 직위 (manager_position)
   * @maxLength 100
   * @nullable
   */
  managerPosition: string | null;
  /**
   * 회사 팩스 (company_fax)
   * @maxLength 20
   * @nullable
   */
  companyFax: string | null;
  /**
   * 담당자 휴대폰 (manager_phone)
   * @maxLength 20
   */
  managerPhone: string;
  /**
   * 은행명 (bank_name)
   * @maxLength 50
   * @nullable
   */
  bankName: string | null;
  /**
   * 계좌번호 (bank_account_number)
   * @maxLength 50
   * @nullable
   */
  bankAccountNumber: string | null;
  /**
   * 예금주 (bank_account_holder)
   * @maxLength 100
   * @nullable
   */
  bankAccountHolder: string | null;
  /**
   * 직인 이미지 URL (company_seal_url)
   * @maxLength 2048
   * @nullable
   */
  companySealUrl: string | null;
  /**
   * 세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.
   * @nullable
   */
  taxEmail?: string | null;
  /**
   * 종사업장번호 (business_license_number)
   * @maxLength 10
   * @nullable
   */
  businessLicenseNumber?: string | null;
  /**
   * 종사업장번호 사용 여부. null 은 "정보 없음" 으로 미사용(false)과 구분한다.
   * @nullable
   */
  businessLicenseNumberUsed?: boolean | null;
  /**
   * 종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.
   * @maxLength 100
   * @nullable
   */
  businessItem?: string | null;
  /**
   * 기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressMain?: string | null;
  /**
   * 상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 우편번호 유형 (zip_type)
   * @maxLength 50
   * @nullable
   */
  zipType?: string | null;
  /**
   * 은행 코드 (bank_code). 은행명 문자열만으로는 이체 자동화가 안 된다.
   * @maxLength 10
   * @nullable
   */
  bankCode?: string | null;
  /**
   * 예금주 실명확인 완료 여부 (bank_account_verified). null 은 "확인 정보 없음" 으로 미확인(false)과 구분한다.
   * @nullable
   */
  bankAccountVerified?: boolean | null;
  /**
   * 파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다.
   * @nullable
   */
  isActive?: boolean | null;
  /**
   * 회사 홈페이지 URL (b2b_member.homepage)
   * @maxLength 500
   * @nullable
   */
  homepageUrl?: SupplierInfoDtoHomepageUrl;
  /**
   * 회사 소개 (b2b_member.gita)
   * @maxLength 4000
   * @nullable
   */
  companyIntro?: SupplierInfoDtoCompanyIntro;
  /**
   * 개업연월일 (b2b_member.beginday, YYYY-MM-DD)
   * @nullable
   */
  establishedAt?: SupplierInfoDtoEstablishedAt;
  /**
   * 씨마켓 회원프로필의 기업 인증서·면허 목록. 보내면 세모의 CMARKET 출처 인증서를 이 목록으로 통째 동기화한다(없어진 항목은 삭제). 보내지 않으면(null) 인증서는 건드리지 않는다.
   * @nullable
   */
  certifications?: ExternalSupplierCertificationDto[] | null;
}

export interface AuthSupplierRequestDto {
  /** 공급자 정보 (C-Market 공급업체 데이터) */
  supplierInfo: SupplierInfoDto;
}

export interface UpdateSupplierMeDto {
  /** 자동 견적 발송 여부 */
  autoQuoteEnabled?: boolean;
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled?: boolean;
}

/**
 * 토큰 전달 방식
 */
export type AuthBuyerResponseDtoTokenType =
  (typeof AuthBuyerResponseDtoTokenType)[keyof typeof AuthBuyerResponseDtoTokenType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthBuyerResponseDtoTokenType = {
  bearer: "bearer",
  cookie: "cookie",
} as const;

export interface AuthBuyerResponseDto {
  /** 구매사 사용자 ID (UUID) */
  buyerId: string;
  /** Access Token */
  accessToken: string;
  /** Refresh Token */
  refreshToken: string;
  /** 토큰 만료 시간 (초) */
  expiresIn: number;
  /** 토큰 전달 방식 */
  tokenType: AuthBuyerResponseDtoTokenType;
  /** 신규 가입 여부 (true: 신규 가입, false: 기존 회원) */
  isNewUser?: boolean;
}

export interface BuyerInfoDto {
  /** 외부 시스템 발주기관 고유 ID */
  externalBuyerId: string;
  /**
   * 발주기관/구매사 회사명 (organization_name)
   * @maxLength 255
   */
  organizationName: string;
  /**
   * 사업자등록번호 (business_number)
   * @pattern ^\d{3}-\d{2}-\d{5}$
   */
  businessNumber: string;
  /**
   * 대표자명 (ceo_name)
   * @maxLength 100
   */
  ceoName: string;
  /**
   * 주소 (address_full)
   * @maxLength 255
   */
  addressFull: string;
  /**
   * 우편번호 (zip_code)
   * @maxLength 20
   * @nullable
   */
  zipCode: string | null;
  /**
   * 업태/종목 (business_type)
   * @maxLength 100
   * @nullable
   */
  businessType: string | null;
  /**
   * 회사 전화번호 (organization_phone)
   * @maxLength 20
   */
  organizationPhone: string;
  /**
   * 회사 팩스 (organization_fax)
   * @maxLength 20
   * @nullable
   */
  organizationFax: string | null;
  /**
   * 담당자명 (manager_name)
   * @maxLength 100
   */
  managerName: string;
  /**
   * 담당자 휴대폰 (manager_phone). 없으면 계정 연락처는 organizationPhone(대표전화)으로 폴백한다.
   * @maxLength 20
   * @nullable
   */
  managerPhone?: string | null;
  /**
   * 담당자 부서 (manager_department)
   * @maxLength 100
   * @nullable
   */
  managerDepartment: string | null;
  /**
   * 담당자 직위 (manager_position)
   * @maxLength 100
   * @nullable
   */
  managerPosition: string | null;
  /**
   * 담당자 이메일 (contact_email)
   * @nullable
   */
  contactEmail: string | null;
  /**
   * 세금계산서 전용 이메일 (tax_email). 담당자 이메일과 다른 칸이며, 계산서는 이쪽으로 발송한다.
   * @nullable
   */
  taxEmail?: string | null;
  /**
   * 종사업장번호 (business_license_number)
   * @maxLength 10
   * @nullable
   */
  businessLicenseNumber?: string | null;
  /**
   * 종사업장번호 사용 여부 (business_license_number_used). null 은 "정보 없음" 으로 미사용(false)과 구분한다.
   * @nullable
   */
  businessLicenseNumberUsed?: boolean | null;
  /**
   * 종목 (business_item). businessType 은 업태다 — 종전처럼 합쳐 보내지 말고 나눠서 보낸다.
   * @maxLength 100
   * @nullable
   */
  businessItem?: string | null;
  /**
   * 기본주소 원본 (address_main). 주면 addressFull 파싱 대신 이 값을 그대로 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressMain?: string | null;
  /**
   * 상세주소 원본 (address_detail). 주면 파싱 결과 대신 이 값을 저장한다.
   * @maxLength 255
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 우편번호 유형 (zip_type)
   * @maxLength 50
   * @nullable
   */
  zipType?: string | null;
  /**
   * 파트너가 판정한 활성 여부 (users.is_active). false 면 세모에서도 비활성 처리한다. 보내지 않으면(null) 종전처럼 활성으로 본다 — 미전송 파트너가 회원을 통째로 잠그는 사고를 막는다.
   * @nullable
   */
  isActive?: boolean | null;
}

export interface AuthBuyerRequestDto {
  /** 발주기관 정보 (외부 파트너 시스템에서 전달하는 구매사 데이터) */
  buyerInfo: BuyerInfoDto;
}

export interface UpdateBuyerMeDto {
  /** 카카오 알림톡 수신 여부 */
  kakaoNotificationEnabled?: boolean;
}

/**
 * 공급자 정보 (토큰이 유효한 경우에만 반환)
 * @nullable
 */
export type EmbedTokenVerifyResponseDtoSupplierInfo = SupplierInfoDto | null;

/**
 * 인증된 사용자 역할
 * @nullable
 */
export type EmbedTokenVerifyResponseDtoUserType =
  | (typeof EmbedTokenVerifyResponseDtoUserType)[keyof typeof EmbedTokenVerifyResponseDtoUserType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmbedTokenVerifyResponseDtoUserType = {
  supplier: "supplier",
  buyer: "buyer",
} as const;

/**
 * 발주기관 정보 (buyer 토큰일 때만 반환)
 * @nullable
 */
export type EmbedTokenVerifyResponseDtoBuyerInfo = BuyerInfoDto | null;

export interface EmbedTokenVerifyResponseDto {
  /** JWT 토큰의 유효성 여부 */
  isValid: boolean;
  /**
   * 토큰에 포함된 공급자 사용자 ID (public.users.id, 유효하지 않으면 null)
   * @nullable
   */
  userId?: string | null;
  /** Access Token */
  accessToken?: string;
  /**
   * Refresh Token (deprecated — 기본적으로 반환되지 않으며, EMBED_RETURN_REFRESH_TOKEN=true일 때만 임시로 반환됩니다)
   * @deprecated
   */
  refreshToken?: string;
  /**
   * C-Market 공급업체 외부 ID (suppliers.supplier_id, 유효하지 않으면 null)
   * @nullable
   */
  supplierId?: string | null;
  /**
   * 토큰이 유효하지 않은 경우 오류 메시지
   * @nullable
   */
  message?: string | null;
  /**
   * 공급자 정보 (토큰이 유효한 경우에만 반환)
   * @nullable
   */
  supplierInfo?: EmbedTokenVerifyResponseDtoSupplierInfo;
  /**
   * 인증된 사용자 역할
   * @nullable
   */
  userType?: EmbedTokenVerifyResponseDtoUserType;
  /**
   * 외부 파트너 발주기관 ID (buyers.external_buyer_id)
   * @nullable
   */
  buyerId?: string | null;
  /**
   * 발주기관 정보 (buyer 토큰일 때만 반환)
   * @nullable
   */
  buyerInfo?: EmbedTokenVerifyResponseDtoBuyerInfo;
}

export interface EmbedTokenVerifyRequestDto {
  /** JWT 토큰 */
  token: string;
}

export interface GenerateAlimTalkLinksResponseDto {
  /** 이 단가로 제출 링크 (Auto Quote) */
  autoQuoteLink: string;
  /** 단가 수정 후 제출 링크 (Custom Quote) */
  customQuoteLink: string;
}

export interface GenerateAlimTalkLinksRequestDto {
  /** 견적 요청 ID (UUID) */
  quoteRequestId: string;
  /** Base URL (생략 시 서버 환경변수 사용) */
  origin?: string;
}

/**
 * Embed 인터페이스 타입
 */
export type EmbedType = (typeof EmbedType)[keyof typeof EmbedType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EmbedType = {
  "quote-response": "quote-response",
  "quote-detail": "quote-detail",
  chat: "chat",
  dashboard: "dashboard",
  "dashboard-my-projects": "dashboard-my-projects",
  "dashboard-chat-list": "dashboard-chat-list",
  "dashboard-settlements": "dashboard-settlements",
  "dashboard-contracts": "dashboard-contracts",
  "dashboard-products": "dashboard-products",
  "dashboard-shipments": "dashboard-shipments",
  "buyer-quote-request-new": "buyer-quote-request-new",
  "buyer-dashboard": "buyer-dashboard",
  "buyer-chat-list": "buyer-chat-list",
} as const;

export interface EmbedJoinRequestDto {
  /** Embed 인터페이스 타입 */
  type: EmbedType;
  /** 임베드 대상 리소스 ID (dashboard 제외 필수) */
  targetId?: string;
  /** Embed base URL (개발용, EMBED_BASE_URL 환경변수가 없을 때만 사용) */
  origin?: string;
}

export interface SupplierCategoryItemDto {
  /**
   * CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)
   * @nullable
   */
  casNo?: string | null;
  /**
   * 국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null
   * @nullable
   */
  keNo?: string | null;
  /**
   * UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null
   * @nullable
   */
  unNo?: string | null;
  /**
   * EC 번호 (EU EINECS/ELINCS)
   * @nullable
   */
  enNo?: string | null;
  /**
   * KOSHA 기준 국문 표준 물질명
   * @nullable
   */
  chemNameKor?: string | null;
  /** 품목 ID (items_v2_base.id - UUID) */
  id: string;
  /** 상품명 */
  name: string;
  /**
   * 카테고리 ID (items_v2_categories.id - UUID)
   * @nullable
   */
  categoryId: string | null;
  /** 카테고리 경로 (표시용) */
  categoryPath: string;
  /** 기준 가격 (정가) */
  price: number;
  /**
   * 최저가 거래 단가
   * @nullable
   */
  lowestPrice: number | null;
  /**
   * 최저가 거래 날짜
   * @nullable
   */
  lowestPriceDate: string | null;
  /**
   * 최저가 거래 공급자명
   * @nullable
   */
  lowestPriceSupplierName: string | null;
  /** 카테고리 레벨 (0-3) */
  level: number;
  /**
   * 부모 카테고리 UUID
   * @nullable
   */
  parentId: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand: string | null;
  /**
   * 상품코드
   * @nullable
   */
  code: string | null;
  /** 단위 */
  unit: string;
  /**
   * 이미지 URL
   * @nullable
   */
  imageUrl: string | null;
  /**
   * 규격1
   * @nullable
   */
  spec1: string | null;
  /**
   * 규격2
   * @nullable
   */
  spec2: string | null;
  /**
   * 규격3
   * @nullable
   */
  spec3: string | null;
  /** 취급 공급자 수 */
  supplierCount: number;
  /** 생성 일시 */
  createdAt: string;
  /** 수정 일시 */
  updatedAt: string;
  /**
   * 나의 공급가 (items_v2_transactions.거래단가)
   * @nullable
   */
  myPrice: number | null;
  /** 판매 상태 (items_v2_transactions.status) */
  isSelling: boolean;
  /**
   * 단가 레코드 ID (items_v2_transactions.id)
   * @nullable
   */
  priceEntryId: string | null;
}

/**
 * 판매 상태
 */
export type SupplierPriceResponseDtoStatus =
  (typeof SupplierPriceResponseDtoStatus)[keyof typeof SupplierPriceResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceResponseDtoStatus = {
  active: "active",
  inactive: "inactive",
} as const;

/**
 * 단가의 부가세 축. EXCLUSIVE=공급가액(부가세 별도), INCLUSIVE=부가세 포함가
 */
export type SupplierPriceResponseDtoTaxType =
  (typeof SupplierPriceResponseDtoTaxType)[keyof typeof SupplierPriceResponseDtoTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierPriceResponseDtoTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export interface SupplierPriceResponseDto {
  /** 단가 ID */
  id: string;
  /** 물품 ID */
  itemId: string;
  /** 판매 단가 (₩) */
  price: number;
  /** 공급자 ID */
  supplierId: string;
  /** 판매 상태 */
  status: SupplierPriceResponseDtoStatus;
  /** 단가의 부가세 축. EXCLUSIVE=공급가액(부가세 별도), INCLUSIVE=부가세 포함가 */
  taxType: SupplierPriceResponseDtoTaxType;
  /** 마지막 수정 일시 */
  updatedAt: string;
}

export interface UpdateSupplierItemSettingsDto {
  /**
   * 나의 공급가 (₩, 원 단위 정수, 0 ~ 999,999,999)
   * @minimum 0
   * @maximum 999999999
   */
  price?: number;
  /** 판매 상태 */
  isSelling?: boolean;
}

/**
 * 추가 카테고리 IDs
 */
export type SupplierItemRequestResponseDtoAdditionalCategoryIds = {
  [key: string]: unknown;
};

/**
 * 상태
 */
export type SupplierItemRequestResponseDtoStatus =
  (typeof SupplierItemRequestResponseDtoStatus)[keyof typeof SupplierItemRequestResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierItemRequestResponseDtoStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export interface SupplierItemRequestResponseDto {
  /** 요청 ID */
  id: string;
  /** Supplier ID */
  supplierId: string;
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /**
   * 단위
   * @nullable
   */
  unit: string | null;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 추가 카테고리 IDs */
  additionalCategoryIds?: SupplierItemRequestResponseDtoAdditionalCategoryIds;
  /** 요청 사유 */
  requestReason?: string;
  /** 상태 */
  status: SupplierItemRequestResponseDtoStatus;
  /** Admin 거부 사유 */
  adminComment?: string;
  /** 승인한 Admin ID */
  approvedByAdminId?: string;
  /** 승인 시 생성된 물품 ID */
  approvedItemId?: string;
  /** 생성 일시 */
  createdAt: string;
  /**
   * 수정 일시
   * @nullable
   */
  updatedAt: string | null;
}

/**
 * 추가 카테고리 IDs
 */
export type CreateSupplierItemRequestDtoAdditionalCategoryIds = {
  [key: string]: unknown;
};

export interface CreateSupplierItemRequestDto {
  /** 상품명 */
  name: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 단위 */
  unit?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 카테고리 ID */
  categoryId?: string;
  /** 추가 카테고리 IDs */
  additionalCategoryIds?: CreateSupplierItemRequestDtoAdditionalCategoryIds;
  /** 요청 사유 */
  requestReason?: string;
}

export interface ItemV2AutocompleteResponseDto {
  /**
   * CAS 등록번호 — 상품명에서 추출한 값. 시약이 아니면 null (KOSHA 매칭 여부와 무관하게 채워진다)
   * @nullable
   */
  casNo?: string | null;
  /**
   * 국내 기존화학물질 고유번호 (KE 번호). KOSHA 미등록이거나 미부여면 null
   * @nullable
   */
  keNo?: string | null;
  /**
   * UN 번호 (국제 위험물 운송번호). 위험물이 아니면 null
   * @nullable
   */
  unNo?: string | null;
  /**
   * EC 번호 (EU EINECS/ELINCS)
   * @nullable
   */
  enNo?: string | null;
  /**
   * KOSHA 기준 국문 표준 물질명
   * @nullable
   */
  chemNameKor?: string | null;
  /** 품목 ID (items_v2_base.id - UUID) */
  id: string;
  /** 상품명 */
  name: string;
  /**
   * 카테고리 ID (items_v2_categories.id - UUID, FK to normalized category table)
   * @nullable
   */
  categoryId: string | null;
  /** 카테고리 경로 (표시용) */
  categoryPath: string;
  /** 기준 가격 (정가) */
  price: number;
  /**
   * 최저가 거래 단가
   * @nullable
   */
  lowestPrice: number | null;
  /**
   * 최저가 거래 날짜
   * @nullable
   */
  lowestPriceDate: string | null;
  /**
   * 공급사별 단가 (supplierId 파라미터 제공 시에만 반환)
   * @nullable
   */
  supplierPrice?: number | null;
  /**
   * 공급사별 최근 거래 일자
   * @nullable
   */
  supplierLastTransactionDate?: string | null;
  /** 단위 */
  unit?: string;
  /** 제조사 */
  manufacturer?: string;
  /** 브랜드 */
  brand?: string;
  /** 규격 1 */
  spec1?: string;
  /** 규격 2 */
  spec2?: string;
  /** 규격 3 */
  spec3?: string;
  /** 이 품목을 취급하는 공급사 수 (활성 거래이력 기준, 탈퇴/정지 계정 제외). 모든 환경에서 반환된다. */
  supplierCount?: number;
  /** 이 품목을 취급하는 공급사 중 자동견적(auto_quote_enabled)을 켠 공급사 수. supplierCount 의 부분집합이며, 자동견적을 켠 곳이 없으면 0. 집계 시점은 검색 색인 동기화 주기(매일 새벽)를 따른다. */
  autoQuoteSupplierCount?: number;
  /** 자동 견적 가능 여부 (supplierCount > 0, 즉 취급 공급사가 1곳 이상인지). 자동견적을 켠 공급사가 있는지는 autoQuoteSupplierCount 로 판단할 것. */
  canAutoQuote?: boolean;
}

export type ItemV2SortBy = (typeof ItemV2SortBy)[keyof typeof ItemV2SortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemV2SortBy = {
  name: "name",
  supplierCount: "supplierCount",
  autoQuoteSupplierCount: "autoQuoteSupplierCount",
} as const;

export type ItemV2CatalogEpoch =
  (typeof ItemV2CatalogEpoch)[keyof typeof ItemV2CatalogEpoch];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemV2CatalogEpoch = {
  legacy: "legacy",
  v2: "v2",
} as const;

/**
 * 품목의 과세 상태. EXEMPT·ZERO_RATED 는 부가세가 0이라 총액이 표시가와 같다. null 이면 미확인이며, 그 경우 총액은 과세로 보고 계산하는 편이 안전하다
 * @nullable
 */
export type StorefrontItemResponseDtoTaxCategory =
  | (typeof StorefrontItemResponseDtoTaxCategory)[keyof typeof StorefrontItemResponseDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontItemResponseDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface StorefrontItemResponseDto {
  /** 품목 ID (items_v2_base.id) */
  itemId: string;
  /** 상품명 */
  name: string;
  /** 판매가(원). 마스터가 정한 가격 규칙이 적용된 값 */
  price: number;
  /**
   * 카테고리 ID
   * @nullable
   */
  categoryId?: string | null;
  /**
   * 카테고리명
   * @nullable
   */
  categoryName?: string | null;
  /**
   * 대분류(카테고리 계층 최상위) 이름. categoryName 은 말단 소분류라 개수가 많다(현재 253개). 목록 상단 카테고리 묶음에는 이 값을 쓴다(현재 20개). 계층이 3단을 넘으면 null.
   * @nullable
   */
  rootCategoryName?: string | null;
  /**
   * 제조사
   * @nullable
   */
  manufacturer?: string | null;
  /**
   * 브랜드
   * @nullable
   */
  brand?: string | null;
  /**
   * 단위
   * @nullable
   */
  unit?: string | null;
  /**
   * 규격 1
   * @nullable
   */
  spec1?: string | null;
  /**
   * 규격 2
   * @nullable
   */
  spec2?: string | null;
  /**
   * 규격 3
   * @nullable
   */
  spec3?: string | null;
  /**
   * 이미지 URL
   * @nullable
   */
  imageUrl?: string | null;
  /** 이 품목을 대는 공급사 수(익명). 2 이상이면 단가 리스트가 있고 price 는 그중 최저가다 */
  offerCount: number;
  /**
   * 가장 비싼 오퍼. 손님에게 «최대 N원 절약» 을 보여 줄 때 쓴다
   * @nullable
   */
  maxPrice?: number | null;
  /**
   * 표시가의 부가세 축(EXCLUSIVE=공급가액 / INCLUSIVE=부가세 포함). null 이면 미지정
   * @nullable
   */
  taxType?: string | null;
  /**
   * 품목의 과세 상태. EXEMPT·ZERO_RATED 는 부가세가 0이라 총액이 표시가와 같다. null 이면 미확인이며, 그 경우 총액은 과세로 보고 계산하는 편이 안전하다
   * @nullable
   */
  taxCategory?: StorefrontItemResponseDtoTaxCategory;
}

export interface StorefrontItemListResponseDto {
  items: StorefrontItemResponseDto[];
  total: number;
  limit: number;
  offset: number;
}

export interface StorefrontCategoryChildDto {
  /** @nullable */
  categoryId?: string | null;
  /** @nullable */
  categoryName?: string | null;
  /** 이 소분류에 노출 중인 상품 수 */
  itemCount: number;
}

export interface StorefrontCategoryGroupDto {
  /** @nullable */
  rootCategoryId?: string | null;
  /**
   * 대분류 이름. 계층이 3단을 넘으면 null 이라 «기타» 로 묶인다
   * @nullable
   */
  rootCategoryName?: string | null;
  /** 이 대분류에 노출 중인 상품 수 */
  itemCount: number;
  children: StorefrontCategoryChildDto[];
}

export interface StorefrontCategoryListResponseDto {
  groups: StorefrontCategoryGroupDto[];
  /** 노출 중인 상품 총 수 */
  total: number;
}

/**
 * @nullable
 */
export type StorefrontOfferResponseDtoTaxCategory =
  | (typeof StorefrontOfferResponseDtoTaxCategory)[keyof typeof StorefrontOfferResponseDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOfferResponseDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface StorefrontOfferResponseDto {
  /** 이 오퍼의 식별자. 주문할 때 이 값을 지정한다 */
  offerId: string;
  /** 판매가(원) */
  price: number;
  /** 가격 순위. 1 이 최저가 */
  priceRank: number;
  /** @nullable */
  taxType?: string | null;
  /** @nullable */
  taxCategory?: StorefrontOfferResponseDtoTaxCategory;
}

export interface StorefrontOfferListResponseDto {
  offers: StorefrontOfferResponseDto[];
  /** 오퍼 수 */
  total: number;
  /** 최저가 */
  minPrice: number;
  /** 최고가 */
  maxPrice: number;
}

export interface StorefrontPointBalanceDto {
  balance: StorefrontPointSummaryDto;
  /** 원장 이력(최신순, 최대 100건) */
  entries: StorefrontPointEntryDto[];
}

export type StorefrontOrderItemDtoPriceTaxType =
  (typeof StorefrontOrderItemDtoPriceTaxType)[keyof typeof StorefrontOrderItemDtoPriceTaxType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderItemDtoPriceTaxType = {
  EXCLUSIVE: "EXCLUSIVE",
  INCLUSIVE: "INCLUSIVE",
} as const;

export type StorefrontOrderItemDtoTaxCategory =
  (typeof StorefrontOrderItemDtoTaxCategory)[keyof typeof StorefrontOrderItemDtoTaxCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderItemDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

export interface StorefrontOrderItemDto {
  seq: number;
  itemId: string;
  /** @nullable */
  offeringId?: string | null;
  name: string;
  /** @nullable */
  spec?: string | null;
  /** @nullable */
  unit?: string | null;
  quantity: number;
  /** 주문 시점 판매가 스냅샷 */
  salePrice: number;
  priceTaxType: StorefrontOrderItemDtoPriceTaxType;
  taxCategory: StorefrontOrderItemDtoTaxCategory;
}

export interface ShipmentItemDto {
  itemId: string;
  name: string;
  quantity: number;
}

export type ShipmentDtoStatus =
  (typeof ShipmentDtoStatus)[keyof typeof ShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

export interface ShipmentDto {
  id: string;
  /** @nullable */
  courierCode?: string | null;
  /** @nullable */
  courierName?: string | null;
  /** @nullable */
  trackingNo?: string | null;
  status: ShipmentDtoStatus;
  /** @nullable */
  shippedAt?: string | null;
  /** @nullable */
  deliveredAt?: string | null;
  /** @nullable */
  note?: string | null;
  createdAt: string;
  items: ShipmentItemDto[];
}

export type StorefrontOrderDtoStatus =
  (typeof StorefrontOrderDtoStatus)[keyof typeof StorefrontOrderDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StorefrontOrderDtoStatus = {
  PLACED: "PLACED",
  QUOTING: "QUOTING",
  QUOTE_CLOSED: "QUOTE_CLOSED",
  SENT_TO_ERP: "SENT_TO_ERP",
  CONTRACTED: "CONTRACTED",
  SHIPPING: "SHIPPING",
  DELIVERED: "DELIVERED",
  INSPECTED: "INSPECTED",
  SETTLED: "SETTLED",
  CANCELED: "CANCELED",
} as const;

export interface StorefrontOrderDto {
  /** 구매번호 */
  orderNo: string;
  status: StorefrontOrderDtoStatus;
  /** @nullable */
  employeeNo?: string | null;
  shipToName: string;
  shipToZip: string;
  shipToAddress: string;
  /** @nullable */
  shipToTel?: string | null;
  /** 공급가액 합계 */
  totalSupply: number;
  /** 부가세 합계 */
  totalVat: number;
  /** 발주기관이 내는 금액 */
  totalPayable: number;
  /**
   * KCL ERP 가 채번한 구매요구번호. 이 값이 들어오면 계약이 선다.
   * @nullable
   */
  erpRequisitionNo?: string | null;
  /** @nullable */
  erpSentAt?: string | null;
  /** @nullable */
  erpRequisitionedAt?: string | null;
  /** @nullable */
  canceledAt?: string | null;
  createdAt: string;
  items: StorefrontOrderItemDto[];
  shipments?: ShipmentDto[];
}

export interface StorefrontOrderShipToDto {
  name: string;
  zip: string;
  address: string;
  tel?: string;
  /** 기관 사업장 코드. ERP 가 코드를 쓰면 이 값으로 넘어간다. */
  siteCode?: string;
}

export interface StorefrontOrderLineDto {
  /** 품목 id */
  itemId: string;
  /** 고른 오퍼 id. 한 품목을 여러 공급사가 대는 몰에서 필요하다. 없으면 대표(최저가) 오퍼로 확정한다. */
  offeringId?: string;
  quantity: number;
}

export interface CreateStorefrontOrderDto {
  /** 주문자 사원번호. ERP 가 주문자를 특정하는 유일한 키다. */
  employeeNo?: string;
  shipTo: StorefrontOrderShipToDto;
  items: StorefrontOrderLineDto[];
  /** 몰이 만든 주문 키. 같은 키로 다시 보내면 새 주문 대신 **먼저 만든 주문**이 돌아온다. 네트워크가 끊겨 재시도할 때 같은 물건을 두 번 사는 것을 막는 자리다. */
  clientOrderKey?: string;
}

export interface StorefrontOrderListDto {
  orders: StorefrontOrderDto[];
  total: number;
  limit: number;
  offset: number;
}

export interface RequisitionedStorefrontOrderDto {
  /** KCL ERP 가 채번한 구매요구번호 */
  requisitionNo: string;
  /** 구매요구가 만들어진 시각. 씨마켓이 못 받은 경우가 있어 선택이며, 없으면 수신 시각으로 둔다. */
  requisitionedAt?: string;
}

export type InspectionDtoStatus =
  (typeof InspectionDtoStatus)[keyof typeof InspectionDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InspectionDtoStatus = {
  OPEN: "OPEN",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

export interface InspectionDto {
  status: InspectionDtoStatus;
  /**
   * 담당자가 라벨을 촬영할 팝업 주소
   * @nullable
   */
  verificationUrl?: string | null;
  /** 대조 대상 줄 수 */
  targetCount: number;
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  reportUrl?: string | null;
  /** @nullable */
  matchedCount?: number | null;
  /** @nullable */
  unmatchedCount?: number | null;
  createdAt: string;
}

export interface CompleteInspectionDto {
  /** 검수확인서 PDF 주소 */
  reportUrl?: string;
  /** 대조가 일치한 줄 수 */
  matchedCount?: number;
  /** 불일치 줄 수. **남아 있어도 완료로 처리한다** — 게이트는 «마쳤는가» 만 본다. */
  unmatchedCount?: number;
}

export interface CancelStorefrontOrderDto {
  /** 취소 사유 */
  reason?: string;
}

export interface CourierDto {
  code: string;
  name: string;
}

export interface SupplierShipmentTargetShipToDto {
  name: string;
  zip: string;
  address: string;
  /** @nullable */
  tel?: string | null;
}

export interface SupplierShipmentTargetItemDto {
  id: string;
  name: string;
  /** @nullable */
  spec?: string | null;
  /** @nullable */
  unit?: string | null;
  /** 주문 수량 */
  quantity: number;
  /** 이미 송장에 실린 수량(취소 제외) */
  shippedQuantity: number;
}

export interface SupplierShipmentTargetDto {
  orderNo: string;
  /** 주문 상태 */
  orderStatus: string;
  orderedAt: string;
  shipTo: SupplierShipmentTargetShipToDto;
  /** 내 몫 품목 중 **아직 남은 것만**. 다 보낸 줄은 오지 않는다. */
  items: SupplierShipmentTargetItemDto[];
}

export interface QuoteRequestMallOrderDto {
  /** 몰 주문번호 */
  orderNo: string;
  /** 주문 상태 — `PLACED` · `QUOTING` · `QUOTE_CLOSED` · `SENT_TO_ERP` · `CONTRACTED` · `SHIPPING` · `DELIVERED` · `INSPECTED` · `SETTLED` · `CANCELED`. */
  status: string;
  /**
   * ERP 가 회신한 구매요구번호. 아직이면 null.
   * @nullable
   */
  erpRequisitionNo: string | null;
  /** 이 주문에 걸린 송장. 아직 없으면 빈 배열이다. */
  shipments: ShipmentDto[];
}

export interface ShipmentLineDto {
  /** 주문 품목 id(`storefront_order_items.id`) */
  itemId: string;
  /** 이 송장에 실은 수량 */
  quantity: number;
}

/**
 * 등록 시점 상태. 기본 `SHIPPED`(출고).
 */
export type RegisterShipmentDtoStatus =
  (typeof RegisterShipmentDtoStatus)[keyof typeof RegisterShipmentDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegisterShipmentDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

export interface RegisterShipmentDto {
  /** 택배사 코드. 목록은 `GET …/couriers`. 직접 배송이면 `DIRECT`. */
  courierCode?: string;
  /** 송장번호 */
  trackingNo?: string;
  /** 등록 시점 상태. 기본 `SHIPPED`(출고). */
  status?: RegisterShipmentDtoStatus;
  /** 메모(분할 출고 사유 등) */
  note?: string;
  /** 이 송장에 실은 품목 */
  items: ShipmentLineDto[];
}

export type UpdateShipmentStatusDtoStatus =
  (typeof UpdateShipmentStatusDtoStatus)[keyof typeof UpdateShipmentStatusDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateShipmentStatusDtoStatus = {
  READY: "READY",
  SHIPPED: "SHIPPED",
  IN_TRANSIT: "IN_TRANSIT",
  DELIVERED: "DELIVERED",
  CANCELED: "CANCELED",
} as const;

export interface UpdateShipmentStatusDto {
  status: UpdateShipmentStatusDtoStatus;
}

export interface MyStorefrontDto {
  storefrontId: string;
  slug: string;
  name: string;
  /** 이 쇼핑몰에 허용된 내 품목 수 */
  allowedItemCount: number;
  /** 그중 단가를 입력해 실제 노출 중인 수 */
  pricedItemCount: number;
  /** 이 몰의 표시가 축. false 면 공급가액(부가세 별도)으로 표시된다 — 입력 칸의 라벨이 이 값을 따라간다 */
  includeVat: boolean;
}

export interface MyStorefrontPriceDto {
  storefrontId: string;
  itemId: string;
  /**
   * 내가 이 쇼핑몰용으로 적은 단가. null 이면 아직 안 적었다
   * @nullable
   */
  price?: number | null;
}

export interface SetStorefrontPriceResultDto {
  storefrontId: string;
  itemId: string;
  price: number;
  /** 이 값으로 쇼핑몰에 노출되는지 */
  isListed: boolean;
}

export interface SetStorefrontPriceDto {
  /** 이 쇼핑몰에서 팔 단가(수수료 포함가) */
  price: number;
}

/**
 * linked 면 내 단가가 바뀔 때 몰가도 따라간다
 */
export type MyStorefrontOfferingDtoPriceSource =
  (typeof MyStorefrontOfferingDtoPriceSource)[keyof typeof MyStorefrontOfferingDtoPriceSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyStorefrontOfferingDtoPriceSource = {
  manual: "manual",
  linked: "linked",
} as const;

/**
 * 품목의 과세 상태. 면세·영세는 부가세가 붙지 않는다
 * @nullable
 */
export type MyStorefrontOfferingDtoTaxCategory =
  | (typeof MyStorefrontOfferingDtoTaxCategory)[keyof typeof MyStorefrontOfferingDtoTaxCategory]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyStorefrontOfferingDtoTaxCategory = {
  TAXABLE: "TAXABLE",
  EXEMPT: "EXEMPT",
  ZERO_RATED: "ZERO_RATED",
} as const;

/**
 * 노출 중 / 단가 미입력 / 노출 중지
 */
export type MyStorefrontOfferingDtoState =
  (typeof MyStorefrontOfferingDtoState)[keyof typeof MyStorefrontOfferingDtoState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyStorefrontOfferingDtoState = {
  listed: "listed",
  unpriced: "unpriced",
  inactive: "inactive",
} as const;

export interface MyStorefrontOfferingDto {
  offeringId: string;
  itemId: string;
  name: string;
  /** @nullable */
  manufacturer?: string | null;
  /** @nullable */
  spec1?: string | null;
  /** @nullable */
  unit?: string | null;
  /** @nullable */
  categoryName?: string | null;
  /** @nullable */
  imageUrl?: string | null;
  /**
   * 내 일반 공급가(참고용)
   * @nullable
   */
  basePrice?: number | null;
  /**
   * 내가 이 몰용으로 적어 넣은 값. 연동 중이면 비어 있다
   * @nullable
   */
  enteredPrice?: number | null;
  /**
   * 실제 노출가. 연동이면 내 단가에서 계산된다
   * @nullable
   */
  price?: number | null;
  /** linked 면 내 단가가 바뀔 때 몰가도 따라간다 */
  priceSource: MyStorefrontOfferingDtoPriceSource;
  /** 연동 가산율(만분율) */
  priceMarkupBp: number;
  /**
   * 내가 적어 넣은 값의 부가세 축(기록용)
   * @nullable
   */
  taxType?: string | null;
  /**
   * 품목의 과세 상태. 면세·영세는 부가세가 붙지 않는다
   * @nullable
   */
  taxCategory?: MyStorefrontOfferingDtoTaxCategory;
  /** 노출 중 / 단가 미입력 / 노출 중지 */
  state: MyStorefrontOfferingDtoState;
  isActive: boolean;
}

export interface MyStorefrontCountsDto {
  /** 허용된 전체 */
  all: number;
  /** 노출 중 */
  listed: number;
  /** 단가 미입력 */
  unpriced: number;
  /** 노출 중지 */
  inactive: number;
}

export interface MyStorefrontOfferingListDto {
  items: MyStorefrontOfferingDto[];
  total: number;
  /** 상태별 건수 — 화면 상단 퍼널에 쓴다 */
  counts: MyStorefrontCountsDto;
}

export interface CreateOfferingRequestResultDto {
  /** false 면 같은 요청이 이미 대기 중이라 새로 만들지 않았다 */
  created: boolean;
}

export interface CreateOfferingRequestDto {
  /** 이 몰에 올리고 싶은 품목 */
  itemId: string;
  /** 마스터에게 남길 한마디 */
  note?: string;
}

export interface CreateAddressDto {
  /**
   * 주소 라벨
   * @maxLength 50
   */
  label?: string;
  /** 기본 주소 설정 */
  isDefault: boolean;
  /**
   * 우편번호
   * @maxLength 10
   */
  postalCode: string;
  /**
   * 시/도
   * @maxLength 50
   */
  province: string;
  /**
   * 시/군/구
   * @maxLength 50
   */
  city: string;
  /**
   * 읍/면/동 (누락 시 null 저장)
   * @maxLength 50
   * @nullable
   */
  district?: string | null;
  /**
   * 도로명 주소
   * @maxLength 200
   */
  streetAddress: string;
  /**
   * 상세 주소
   * @maxLength 200
   */
  addressDetail?: string;
  /**
   * 수령인 이름
   * @maxLength 50
   */
  recipientName: string;
  /**
   * 수령인 연락처
   * @maxLength 20
   */
  recipientPhone?: string;
}

/**
 * 카테고리 타입
 */
export type CreateExternalQuoteRequestWithAddressDtoCategoryType =
  (typeof CreateExternalQuoteRequestWithAddressDtoCategoryType)[keyof typeof CreateExternalQuoteRequestWithAddressDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoBudgetType =
  | (typeof CreateExternalQuoteRequestWithAddressDtoBudgetType)[keyof typeof CreateExternalQuoteRequestWithAddressDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type CreateExternalQuoteRequestWithAddressDtoPaymentMethod =
  (typeof CreateExternalQuoteRequestWithAddressDtoPaymentMethod)[keyof typeof CreateExternalQuoteRequestWithAddressDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel =
  (typeof CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel)[keyof typeof CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoDueDateValue =
  | (typeof CreateExternalQuoteRequestWithAddressDtoDueDateValue)[keyof typeof CreateExternalQuoteRequestWithAddressDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateExternalQuoteRequestWithAddressDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoSpaceType =
  SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type CreateExternalQuoteRequestWithAddressDtoConstructionArea =
  ConstructionAreaLabelValue | null;

export interface CreateExternalQuoteRequestWithAddressDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType: CreateExternalQuoteRequestWithAddressDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact: string;
  /**
   * 담당자명
   * @maxLength 100
   */
  managerName: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: CreateExternalQuoteRequestWithAddressDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: CreateExternalQuoteRequestWithAddressDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: CreateExternalQuoteRequestWithAddressDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: CreateExternalQuoteRequestWithAddressDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: CreateExternalQuoteRequestWithAddressDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: CreateExternalQuoteRequestWithAddressDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: CreateExternalQuoteRequestWithAddressDtoConstructionArea;
  /** 신규/재사용할 주소 정보 (addresses 테이블에 upsert) */
  address: CreateAddressDto;
  /** 결제 방법. true=선결제, false=후불결제. 미전달 시 SEMO default(선결제). */
  isPrepaid?: boolean;
}

/**
 * 변경 전 값
 * @nullable
 */
export type QuoteRequestFieldChangeDtoBefore = {
  [key: string]: unknown;
} | null;

/**
 * 변경 후 값
 * @nullable
 */
export type QuoteRequestFieldChangeDtoAfter = { [key: string]: unknown } | null;

export interface QuoteRequestFieldChangeDto {
  /** 영속 컬럼명 */
  field: string;
  /** 사람이 읽는 필드 이름 */
  label: string;
  /**
   * 변경 전 값
   * @nullable
   */
  before?: QuoteRequestFieldChangeDtoBefore;
  /**
   * 변경 후 값
   * @nullable
   */
  after?: QuoteRequestFieldChangeDtoAfter;
}

export interface QuoteRequestModificationDto {
  /** 수정 시각 (ISO 8601, UTC) */
  modifiedAt: string;
  /** 무엇이 바뀌었는지 한 줄 요약 */
  summary: string;
  /**
   * 수정 주체(발주기관 사용자 ID). 알 수 없으면 null
   * @nullable
   */
  modifiedBy?: string | null;
  /** 필드별 변경 내역 */
  changes: QuoteRequestFieldChangeDto[];
}

export interface QuoteRequestContractDocumentDto {
  /** 서류 코드 */
  paperCode: number;
  /** 서류명 */
  name: string;
  /** 서류 종류. `auto` 는 견적서 등에서 자동 생성돼 이미 파일이 있고, `auto_pending_input` 은 공급사가 값을 채우면 생성되며, `manual` 은 공급사가 파일을 직접 올린다. */
  kind: string;
  /** 진행 상태 — `pending`(제출 전) · `completed`(제출됨). */
  status: string;
  /**
   * 제출된 파일 주소. 아직 제출 전이면 null 이다.
   * @nullable
   */
  fileUrl: string | null;
  /**
   * 제출된 파일명
   * @nullable
   */
  fileName: string | null;
  /**
   * 제출 시각(ISO 8601)
   * @nullable
   */
  uploadedAt: string | null;
}

export interface QuoteRequestContractDocumentGroupDto {
  /** 계약 id */
  contractId: string;
  /** 계약번호 */
  contractNumber: string;
  /** 이 계약의 공급사 id */
  supplierId: string;
  /**
   * 공급사 상호
   * @nullable
   */
  supplierName: string | null;
  /** 아직 제출되지 않은 서류 수. 0 이면 다 냈다. */
  pendingCount: number;
  /** 이 계약에 걸린 서류 목록 */
  documents: QuoteRequestContractDocumentDto[];
}

/**
 * 카테고리 타입
 */
export type UpdateExternalQuoteRequestDtoCategoryType =
  (typeof UpdateExternalQuoteRequestDtoCategoryType)[keyof typeof UpdateExternalQuoteRequestDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 예산 타입
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoBudgetType =
  | (typeof UpdateExternalQuoteRequestDtoBudgetType)[keyof typeof UpdateExternalQuoteRequestDtoBudgetType]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoBudgetType = {
  public: "public",
  no_budget: "no_budget",
} as const;

/**
 * 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불)
 */
export type UpdateExternalQuoteRequestDtoPaymentMethod =
  (typeof UpdateExternalQuoteRequestDtoPaymentMethod)[keyof typeof UpdateExternalQuoteRequestDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoPaymentMethod = {
  prepaid: "prepaid",
  postpaid: "postpaid",
} as const;

/**
 * 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다.
 */
export type UpdateExternalQuoteRequestDtoPreferredPaymentChannel =
  (typeof UpdateExternalQuoteRequestDtoPreferredPaymentChannel)[keyof typeof UpdateExternalQuoteRequestDtoPreferredPaymentChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoPreferredPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

/**
 * 배송일 값 (사용자 입력값)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoDueDateValue =
  | (typeof UpdateExternalQuoteRequestDtoDueDateValue)[keyof typeof UpdateExternalQuoteRequestDtoDueDateValue]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalQuoteRequestDtoDueDateValue = {
  구체적: "구체적",
  협의가능: "협의가능",
} as const;

/**
 * 공사 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoConstructionType =
  ConstructionTypeLabelValue | null;

/**
 * 공간 타입 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoSpaceType = SpaceTypeLabelValue | null;

/**
 * 공사 면적 (공사 카테고리 전용)
 * @nullable
 */
export type UpdateExternalQuoteRequestDtoConstructionArea =
  ConstructionAreaLabelValue | null;

export interface UpdateExternalQuoteRequestDto {
  /** 프로젝트명 (물품 구매(product) 카테고리는 선택 — 미입력 시 물품 목록으로 자동 생성, 그 외 카테고리는 필수) */
  projectName?: string;
  /** 카테고리 타입 */
  categoryType?: UpdateExternalQuoteRequestDtoCategoryType;
  /** 담당자 연락처 (필수) */
  managerContact?: string;
  /**
   * 담당자명
   * @maxLength 100
   */
  managerName?: string;
  /** 주소 ID (addresses 테이블 외래키) */
  addressId?: string;
  /**
   * 주소 상세정보 (예: 동 101호, 3층 등의 추가 정보)
   * @nullable
   */
  addressDetail?: string | null;
  /**
   * 견적 요청 설명 및 추가 사항
   * @nullable
   */
  description?: string | null;
  /**
   * 예산 타입
   * @nullable
   */
  budgetType?: UpdateExternalQuoteRequestDtoBudgetType;
  /**
   * 예산 금액 (원화)
   * @nullable
   */
  budgetAmount?: number | null;
  /** 결제 방법 (prepaid: 계약 체결 시 결제, postpaid: 후불) */
  paymentMethod?: UpdateExternalQuoteRequestDtoPaymentMethod;
  /** 공고 결제방법. card/cash/undecided. 미전달 시 미결정으로 취급. paymentMethod(선결제/후불)와 다른 축이다. */
  preferredPaymentChannel?: UpdateExternalQuoteRequestDtoPreferredPaymentChannel;
  /**
   * 동일 지역만 선택 여부
   * @nullable
   */
  sameRegionOnly?: boolean | null;
  /**
   * 공개 여부
   * @nullable
   */
  isPublic?: boolean | null;
  /**
   * 배송일 값 (사용자 입력값)
   * @nullable
   */
  dueDateValue?: UpdateExternalQuoteRequestDtoDueDateValue;
  /**
   * 배송일 (ISO 8601 형식)
   * @nullable
   */
  dueDate?: string | null;
  /**
   * 업로드된 파일들의 메타데이터 배열
   * @nullable
   */
  attachments?: AttachmentMetadataDto[] | null;
  /**
   * 항목 목록 (Product 카테고리에만 필수)
   * @nullable
   */
  items?: CreateQuoteRequestItemDto[] | null;
  /**
   * 추가 조건 (물품 구매 카테고리 전용)
   * @nullable
   */
  additionalConditions?: LabelValuePair[] | null;
  /**
   * 추가 요청사항 (모든 카테고리 선택 가능)
   * @nullable
   */
  additionalRequests?: LabelValuePair[] | null;
  /**
   * 공사 타입 (공사 카테고리 전용)
   * @nullable
   */
  constructionType?: UpdateExternalQuoteRequestDtoConstructionType;
  /**
   * 공간 타입 (공사 카테고리 전용)
   * @nullable
   */
  spaceType?: UpdateExternalQuoteRequestDtoSpaceType;
  /**
   * 공사 면적 (공사 카테고리 전용)
   * @nullable
   */
  constructionArea?: UpdateExternalQuoteRequestDtoConstructionArea;
  /** 결제 방법. true=선결제, false=후불결제. 미전달 시 기존 값 유지(PATCH 시맨틱). */
  isPrepaid?: boolean;
}

export interface ExtendExternalQuoteRequestDeadlineDto {
  /** 새 마감일시 (ISO 8601). 현재 시각과 기존 마감일시보다 뒤여야 하며, 한 번에 30일까지 연장할 수 있습니다. */
  deadline: string;
}

/**
 * 결제 수단
 */
export type SupplierSettlementResponseDtoPaymentMethod =
  (typeof SupplierSettlementResponseDtoPaymentMethod)[keyof typeof SupplierSettlementResponseDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSettlementResponseDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
} as const;

/**
 * 정산 상태
 */
export type SupplierSettlementResponseDtoSettlementStatus =
  (typeof SupplierSettlementResponseDtoSettlementStatus)[keyof typeof SupplierSettlementResponseDtoSettlementStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SupplierSettlementResponseDtoSettlementStatus = {
  WAITING: "WAITING",
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  DEFERRED: "DEFERRED",
} as const;

export interface SupplierSettlementResponseDto {
  /** 계약 ID */
  id: string;
  /** 계약 번호 */
  contractNumber: string;
  /** 계약 생성 일시 */
  contractDate: string;
  /** 총 계약 금액 */
  totalAmount: number;
  /** 플랫폼 수수료 */
  commissionAmount: number;
  /** 정산 금액 (총액 - 수수료) */
  settlementAmount: number;
  /** 결제 수단 */
  paymentMethod: SupplierSettlementResponseDtoPaymentMethod;
  /** 정산 상태 */
  settlementStatus: SupplierSettlementResponseDtoSettlementStatus;
  /** 프로젝트명 */
  projectName?: string;
  /** 구매자명 */
  buyerName?: string;
  /** 구매확정 일시 */
  completedAt?: string;
  /** 정산 예정일 */
  settlementExpectedDate?: string;
}

export interface CmarketCardPaymentConfirmedDto {
  /** 확정된 계약 ID */
  contractId: string;
  /** 세모 결제 거래 ID (MOID) */
  moid: string;
  /** 이미 확정돼 있던 건인지 (웹훅 재전송·복구 스위퍼로 같은 통지가 두 번 온 경우 true) */
  alreadyConfirmed: boolean;
}

export interface CmarketCardPaymentCallbackDto {
  /** 씨마켓 결제창 번호 (b2b_card_payment_request.buy_idx) */
  cardPaymentRequestId: string;
  /** PG 거래번호(TID) */
  tid: string;
  /** 승인 금액 (VAT 포함). 견적 금액과 다르면 계약을 확정하지 않는다. */
  amount: number;
  /** 세모 견적 버전 ID — 대사(對査)용 참고값. 판정은 결제창 번호로 한다. */
  quoteResponseVersionId?: string;
}

export interface UpdateExternalAccountStatusResponseDto {
  /** 실제로 값이 바뀌었는지. 이미 같은 상태였으면 false — 파트너가 재시도해도 안전하다. */
  changed: boolean;
  /** 반영된 활성 여부 */
  isActive: boolean;
}

/**
 * 대상 계정 역할
 */
export type UpdateExternalAccountStatusDtoRole =
  (typeof UpdateExternalAccountStatusDtoRole)[keyof typeof UpdateExternalAccountStatusDtoRole];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateExternalAccountStatusDtoRole = {
  buyer: "buyer",
  supplier: "supplier",
} as const;

export interface UpdateExternalAccountStatusDto {
  /** 대상 계정 역할 */
  role: UpdateExternalAccountStatusDtoRole;
  /** 파트너 시스템의 회원 고유 ID (가입 시 보낸 externalBuyerId / supplierId 와 같은 값) */
  externalId: string;
  /** 활성 여부. false 면 세모 계정을 비활성 처리한다. */
  isActive: boolean;
  /**
   * 변경 사유 (감사 로그용, 선택)
   * @nullable
   */
  reason?: string | null;
}

/**
 * 계약이 들고 있는 계산서 상태. NULL 은 아직 아무 사건도 반영되지 않은 상태다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus =
  | (typeof CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus)[keyof typeof CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

export interface CmarketTaxInvoiceCallbackResultDto {
  /** 상태를 반영한 계약 ID */
  contractId: string;
  /**
   * 계약이 들고 있는 계산서 상태. NULL 은 아직 아무 사건도 반영되지 않은 상태다.
   * @nullable
   */
  taxInvoiceStatus: CmarketTaxInvoiceCallbackResultDtoTaxInvoiceStatus;
  /** 반영하지 않고 넘겼는지 여부. 발행완료 계약에 요청 통지가 재시도로 뒤늦게 닿았거나, 축 id 가 어긋나거나, 모르는 사건 종류가 온 경우 true — 셋 다 오류가 아니므로 씨마켓이 재시도하지 않도록 2xx 로 응답한다. */
  ignoredAsStale: boolean;
}

/**
 * REQUESTED=발주기관이 발행요청, ISSUED=공급기업이 발행, CANCELLED=발행취소. 모르는 값이 오면 반영하지 않고 ignoredAsStale=true 로 응답한다(400 을 내지 않는다).
 */
export type CmarketTaxInvoiceCallbackDtoEvent =
  (typeof CmarketTaxInvoiceCallbackDtoEvent)[keyof typeof CmarketTaxInvoiceCallbackDtoEvent];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CmarketTaxInvoiceCallbackDtoEvent = {
  REQUESTED: "REQUESTED",
  ISSUED: "ISSUED",
  CANCELLED: "CANCELLED",
} as const;

/**
 * 팝빌 관리번호(과세분). 발행 전에는 비어 있다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackDtoMgtKeyTax = {
  [key: string]: unknown;
} | null;

/**
 * 팝빌 관리번호(면세분). 세모 계약은 과세로만 등록되므로 평시엔 비어 있다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackDtoMgtKeyTaxFree = {
  [key: string]: unknown;
} | null;

/**
 * 발주기관이 지정한 작성일자(ISO 8601). 발행 전에는 비어 있다.
 * @nullable
 */
export type CmarketTaxInvoiceCallbackDtoWriteDate = {
  [key: string]: unknown;
} | null;

export interface CmarketTaxInvoiceCallbackDto {
  /** 세모 계약 ID (씨마켓에 등록할 때 보낸 externalContractId) */
  externalContractId: string;
  /** 씨마켓 세금계산서 축 id (`SI{YYMMDD}{NNNNN}`) */
  taxInvoiceTargetId: string;
  /** REQUESTED=발주기관이 발행요청, ISSUED=공급기업이 발행, CANCELLED=발행취소. 모르는 값이 오면 반영하지 않고 ignoredAsStale=true 로 응답한다(400 을 내지 않는다). */
  event: CmarketTaxInvoiceCallbackDtoEvent;
  /**
   * 팝빌 관리번호(과세분). 발행 전에는 비어 있다.
   * @nullable
   */
  mgtKeyTax?: CmarketTaxInvoiceCallbackDtoMgtKeyTax;
  /**
   * 팝빌 관리번호(면세분). 세모 계약은 과세로만 등록되므로 평시엔 비어 있다.
   * @nullable
   */
  mgtKeyTaxFree?: CmarketTaxInvoiceCallbackDtoMgtKeyTaxFree;
  /**
   * 발주기관이 지정한 작성일자(ISO 8601). 발행 전에는 비어 있다.
   * @nullable
   */
  writeDate?: CmarketTaxInvoiceCallbackDtoWriteDate;
}

/**
 * 카테고리
 */
export type AdminQuoteRequestListItemDtoCategoryType =
  (typeof AdminQuoteRequestListItemDtoCategoryType)[keyof typeof AdminQuoteRequestListItemDtoCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteRequestListItemDtoCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

/**
 * 상태. 계약이 걸린 건은 CONTRACT_IN_PROGRESS (상세와 같은 값), 그 외는 DB 원값
 */
export type AdminQuoteRequestListItemDtoStatus =
  (typeof AdminQuoteRequestListItemDtoStatus)[keyof typeof AdminQuoteRequestListItemDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminQuoteRequestListItemDtoStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export interface AdminQuoteRequestListItemDto {
  /** 견적요청 ID (세모 상세로 건너뛰는 키) */
  id: string;
  /** 공고번호 */
  requestNumber: string;
  /** 공고명 */
  projectName: string;
  /**
   * 발주기관명
   * @nullable
   */
  buyerName?: string | null;
  /**
   * 씨마켓 회원 ID. 세모에 직접 가입한 발주기관은 null (씨마켓 회원이 아님)
   * @nullable
   */
  buyerMemberId?: string | null;
  /** 카테고리 */
  categoryType: AdminQuoteRequestListItemDtoCategoryType;
  /** 상태. 계약이 걸린 건은 CONTRACT_IN_PROGRESS (상세와 같은 값), 그 외는 DB 원값 */
  status: AdminQuoteRequestListItemDtoStatus;
  /** 마감일시 (ISO 8601) */
  deadline: string;
  /**
   * 등록일시 (ISO 8601) — 정렬 키
   * @nullable
   */
  publishedAt?: string | null;
  /** 응답(응찰) 수 */
  responseCount: number;
  /**
   * 공개 여부. 표시용이며 이 목록의 필터로는 쓰이지 않는다
   * @nullable
   */
  isPublic?: boolean | null;
  /** 마감 여부 — 수동 마감(status=CLOSED)이거나 마감일이 지났다. `isClosed` 필터와 같은 규칙 */
  isClosed: boolean;
}

/**
 * 참여 노출 상태. visible=정상, hidden=숨김(운영자에게만 보인다, 사용자 화면에서는 빠져 있다)
 */
export type AdminChatRoomListItemDtoParticipationState =
  (typeof AdminChatRoomListItemDtoParticipationState)[keyof typeof AdminChatRoomListItemDtoParticipationState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChatRoomListItemDtoParticipationState = {
  visible: "visible",
  hidden: "hidden",
} as const;

export interface AdminChatRoomListItemDto {
  /** 채팅방 ID */
  id: string;
  /** 견적요청 ID */
  quoteRequestId: string;
  /**
   * 발주기관 표시명
   * @nullable
   */
  buyerName?: string | null;
  /**
   * 공급사 표시명
   * @nullable
   */
  supplierName?: string | null;
  /**
   * 씨마켓 공급사 회원 ID (`suppliers.supplier_id`)
   * @nullable
   */
  externalSupplierId?: string | null;
  /**
   * 마지막 메시지 시각 (ISO 8601)
   * @nullable
   */
  lastMessageAt?: string | null;
  /** 메시지 수 */
  messageCount: number;
  /** 참여 노출 상태. visible=정상, hidden=숨김(운영자에게만 보인다, 사용자 화면에서는 빠져 있다) */
  participationState: AdminChatRoomListItemDtoParticipationState;
  /**
   * 감춘 시각 (ISO 8601). 정상 상태면 null.
   * @nullable
   */
  hiddenAt?: string | null;
  /** 계약이 체결된 참여인지. true 면 숨기기·삭제가 막힌다. */
  hasContracted: boolean;
}

/**
 * 문의 유형
 */
export type CreateContactInquiryDtoInquiryType =
  (typeof CreateContactInquiryDtoInquiryType)[keyof typeof CreateContactInquiryDtoInquiryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateContactInquiryDtoInquiryType = {
  bug: "bug",
  feedback: "feedback",
  supplier: "supplier",
  transaction: "transaction",
  general: "general",
} as const;

export interface CreateContactInquiryDto {
  /**
   * 문의자 이름
   * @minLength 2
   * @maxLength 50
   */
  name: string;
  /** 문의자 이메일 */
  email: string;
  /**
   * 문의자 전화번호
   * @maxLength 20
   */
  phone?: string;
  /**
   * 회사명/사업자명
   * @maxLength 100
   */
  company?: string;
  /** 문의 유형 */
  inquiryType: CreateContactInquiryDtoInquiryType;
  /**
   * 문의 내용
   * @minLength 10
   * @maxLength 2000
   */
  message: string;
}

/**
 * 이 견적의 대금이 흐르는 길. **화면이 어느 버튼·어느 창을 띄울지 이 값 하나로 정한다.**

- `SEMO_ESCROW`: 세모 안심결제. 발주기관이 먼저 결제하고, 승인되면 계약이 선다.
- `CONTRACT_FIRST`: 계약이 먼저 서고, 결제·계산서는 씨마켓에서 한다.

아래 `cardSelectable`·`cardPaymentAvailable` 은 `CONTRACT_FIRST` 일 때만 뜻이 있다 — 씨마켓 결제창에 대한 답이기 때문이다.
 */
export type VendorDirectEligibilityResponseDtoPaymentFlow =
  (typeof VendorDirectEligibilityResponseDtoPaymentFlow)[keyof typeof VendorDirectEligibilityResponseDtoPaymentFlow];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectEligibilityResponseDtoPaymentFlow = {
  SEMO_ESCROW: "SEMO_ESCROW",
  CONTRACT_FIRST: "CONTRACT_FIRST",
} as const;

/**
 * 공고에서 고른 희망 결제수단(card/cash/undecided). 계약의 확정 채널과 비교해 안내를 띄우는 데 쓴다. null 은 기능 신설 이전 공고.
 * @nullable
 */
export type VendorDirectEligibilityResponseDtoRequestedPaymentChannel =
  | (typeof VendorDirectEligibilityResponseDtoRequestedPaymentChannel)[keyof typeof VendorDirectEligibilityResponseDtoRequestedPaymentChannel]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectEligibilityResponseDtoRequestedPaymentChannel = {
  card: "card",
  cash: "cash",
  undecided: "undecided",
} as const;

export interface VendorDirectEligibilityResponseDto {
  /** 이 견적의 대금이 흐르는 길. **화면이 어느 버튼·어느 창을 띄울지 이 값 하나로 정한다.**

- `SEMO_ESCROW`: 세모 안심결제. 발주기관이 먼저 결제하고, 승인되면 계약이 선다.
- `CONTRACT_FIRST`: 계약이 먼저 서고, 결제·계산서는 씨마켓에서 한다.

아래 `cardSelectable`·`cardPaymentAvailable` 은 `CONTRACT_FIRST` 일 때만 뜻이 있다 — 씨마켓 결제창에 대한 답이기 때문이다. */
  paymentFlow: VendorDirectEligibilityResponseDtoPaymentFlow;
  /** **씨마켓 결제창**을 열 수 있는가(공급기업이 카드결제 가맹인가). false 여도 카드를 고를 수는 있다 — 그 경우 발주기관이 공급기업과 직접 카드로 결제한다. 카드 노출 여부는 이 값이 아니라 `cardSelectable` 로 정할 것. */
  cardPaymentAvailable: boolean;
  /** 카드를 결제수단으로 **고를 수 있는가**(발주기관이 씨마켓 회원인가). 씨마켓 회원과 일반 세모 회원은 구매 로직이 갈리므로, 미연동 발주기관에게는 카드 축이 없다. */
  cardSelectable: boolean;
  /**
   * 불가 사유(사용자 안내 문구). 사유를 밝힐 필요가 없는 경우(연동 미설정 등)는 null.
   * @nullable
   */
  reason: string | null;
  /**
   * 공고에서 고른 희망 결제수단(card/cash/undecided). 계약의 확정 채널과 비교해 안내를 띄우는 데 쓴다. null 은 기능 신설 이전 공고.
   * @nullable
   */
  requestedPaymentChannel: VendorDirectEligibilityResponseDtoRequestedPaymentChannel;
}

/**
 * 결제 상태
 */
export type DirectPaymentResponseDtoStatus =
  (typeof DirectPaymentResponseDtoStatus)[keyof typeof DirectPaymentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DirectPaymentResponseDtoStatus = {
  APPROVED: "APPROVED",
  PENDING: "PENDING",
  FAILED: "FAILED",
} as const;

export interface DirectPaymentResponseDto {
  /** 주문번호 (Merchant Order ID) */
  moid: string;
  /** 결제 금액 */
  amount: number;
  /** 결제 상태 */
  status: DirectPaymentResponseDtoStatus;
  /** 생성 시간 */
  createdAt: string;
  /** PG 거래번호 (TID) */
  tid: string;
  /** 생성된 채팅 메시지 ID (채팅방에 즉시 렌더링용, 계약 메시지) */
  chatMessageId?: string;
  /** 생성된 계약 ID (채팅 메시지 렌더링용) */
  contractId?: string;
}

export interface DirectPaymentDto {
  /** 결제에 사용할 카드 ID */
  paymentCardId: string;
  /** 결제할 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /**
   * 할부 개월 수 (0=일시불, 2~12=할부)
   * @minimum 0
   * @maximum 12
   */
  cardQuota?: number;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

export interface CashPaymentResponseDto {
  /** 주문번호 (Merchant Order ID) */
  moid: string;
  /** 결제 금액 */
  amount: number;
  /** 세금 */
  taxAmount: number;
  /** 결제 상태 (현금결제는 항상 PENDING) */
  status: string;
  /** 입금 계좌(은행·계좌번호·예금주 한 줄). 같은 값이 채팅 입금 안내 카드에도 실린다 — 발주기관은 보통 그 카드를 보고 입금한다. */
  bankAccount: string;
  /** 안내 메시지 */
  message: string;
  /** 생성 시간 */
  createdAt: string;
  /** 결제 만료 시간 (3시간 후) */
  expiresAt: string;
  /** 생성된 채팅 메시지 ID (채팅방에 즉시 렌더링용) */
  chatMessageId?: string;
}

export interface CashPaymentDto {
  /** 결제할 견적 응답 버전 ID */
  quoteResponseVersionId: string;
  /** 클라이언트 생성 임시 ID (낙관적 UI 매칭용) */
  tempId?: string;
}

/**
 * 환불 상태
 */
export type RefundResponseDtoStatus =
  (typeof RefundResponseDtoStatus)[keyof typeof RefundResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefundResponseDtoStatus = {
  REQUESTED: "REQUESTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export interface RefundResponseDto {
  /** 환불 ID */
  id: string;
  /** 결제 ID (MOID) */
  paymentTransactionId: string;
  /** 환불 상태 */
  status: RefundResponseDtoStatus;
  /** 환불 금액 (단위: 원) */
  refundAmount: number;
  /** 환불 사유 */
  refundReason: string;
  /** 환불 요청 시간 (ISO 8601) */
  requestedAt: string;
}

export interface RefundRequestDto {
  /**
   * 환불 사유
   * @maxLength 500
   */
  refundReason: string;
  /** 환불 금액 (단위: 원) */
  refundAmount: number;
  /** 환불 받을 은행명 (현금 결제 시 필수) */
  refundBank?: string;
  /** 환불 받을 계좌번호 (현금 결제 시 필수) */
  refundAccountNumber?: string;
  /** 환불 계좌 예금주 (현금 결제 시 필수) */
  refundAccountHolder?: string;
}

export interface VendorDirectPaymentResponseDto {
  /** 생성된 거래 ID (MOID) */
  moid: string;
  /** 결제 금액 */
  amount: number;
  /** 결제 상태. OFFLINE 은 즉시 APPROVED, CMARKET_CARD 는 결제 전이라 PENDING. */
  status: string;
  /** 채팅 메시지 ID */
  chatMessageId: string;
  /** 생성된 계약 ID (채팅 메시지 렌더링용) */
  contractId: string;
  /** PG 거래번호 (TID, 직접결제는 빈 문자열) */
  tid: string;
  /** 생성 시간 */
  createdAt: string;
  /** 씨마켓 결제 화면 링크 (CMARKET_CARD 전용). 발주기관을 이 주소로 보내 결제를 마치게 한다. */
  payUrl?: string;
  /** 씨마켓 결제창 번호 (CMARKET_CARD 전용). */
  cardPaymentRequestId?: string;
}

/**
 * 대금 처리 경로. 미지정 시 OFFLINE(기존 동작) — 구버전 클라이언트 호환.
 */
export type VendorDirectPaymentDtoPaymentRoute =
  (typeof VendorDirectPaymentDtoPaymentRoute)[keyof typeof VendorDirectPaymentDtoPaymentRoute];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectPaymentDtoPaymentRoute = {
  OFFLINE: "OFFLINE",
  CMARKET_CARD: "CMARKET_CARD",
} as const;

/**
 * 업체와 직접 정리하기로 한 방식(cash/card). **기록만 하는 값이다** — 세모가 이 결제를 실행하지 않는다. 실제 결제는 업체 단말기·결제 링크·계좌이체 등 시스템 밖에서 이뤄지고, 여기에 남긴 값은 나중에 「무엇으로 정리했는지」를 아는 근거다.

OFFLINE 경로에서만 뜻이 있다. 미지정 시 cash(기존 동작).
 */
export type VendorDirectPaymentDtoSettlementChannel =
  (typeof VendorDirectPaymentDtoSettlementChannel)[keyof typeof VendorDirectPaymentDtoSettlementChannel];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VendorDirectPaymentDtoSettlementChannel = {
  cash: "cash",
  card: "card",
} as const;

export interface VendorDirectPaymentDto {
  /** 결제를 진행할 견적 응답 버전의 ID */
  quoteResponseVersionId: string;
  /** 낙관적 UI 매칭용 임시 ID */
  tempId?: string;
  /** 대금 처리 경로. 미지정 시 OFFLINE(기존 동작) — 구버전 클라이언트 호환. */
  paymentRoute?: VendorDirectPaymentDtoPaymentRoute;
  /** 업체와 직접 정리하기로 한 방식(cash/card). **기록만 하는 값이다** — 세모가 이 결제를 실행하지 않는다. 실제 결제는 업체 단말기·결제 링크·계좌이체 등 시스템 밖에서 이뤄지고, 여기에 남긴 값은 나중에 「무엇으로 정리했는지」를 아는 근거다.

OFFLINE 경로에서만 뜻이 있다. 미지정 시 cash(기존 동작). */
  settlementChannel?: VendorDirectPaymentDtoSettlementChannel;
}

/**
 * 결제 타입 (CONTRACT | SUBSCRIPTION)
 */
export type PaymentTransactionHistoryDtoType =
  (typeof PaymentTransactionHistoryDtoType)[keyof typeof PaymentTransactionHistoryDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionHistoryDtoType = {
  CONTRACT: "CONTRACT",
  SUBSCRIPTION: "SUBSCRIPTION",
} as const;

/**
 * 결제 수단
 */
export type PaymentTransactionHistoryDtoPaymentMethod =
  (typeof PaymentTransactionHistoryDtoPaymentMethod)[keyof typeof PaymentTransactionHistoryDtoPaymentMethod];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionHistoryDtoPaymentMethod = {
  CARD: "CARD",
  CASH: "CASH",
  DIRECT: "DIRECT",
} as const;

/**
 * 결제 상태
 */
export type PaymentTransactionHistoryDtoStatus =
  (typeof PaymentTransactionHistoryDtoStatus)[keyof typeof PaymentTransactionHistoryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaymentTransactionHistoryDtoStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
} as const;

export interface PaymentTransactionHistoryDto {
  /** 결제 ID (MOID) */
  id: string;
  /** 결제 타입 (CONTRACT | SUBSCRIPTION) */
  type: PaymentTransactionHistoryDtoType;
  /** 결제 수단 */
  paymentMethod: PaymentTransactionHistoryDtoPaymentMethod;
  /**
   * 견적 응답 버전 ID
   * @nullable
   */
  quoteResponseVersionId: string | null;
  /**
   * 구독 ID (구독 결제인 경우)
   * @nullable
   */
  subscriptionId: string | null;
  /**
   * 프로젝트명 (견적 결제인 경우)
   * @nullable
   */
  projectName: string | null;
  /**
   * 공급자명 (업체명 또는 이름)
   * @nullable
   */
  supplierName: string | null;
  /** 결제 금액 */
  amount: number;
  /** 결제 상태 */
  status: PaymentTransactionHistoryDtoStatus;
  /**
   * 결제 승인 시간
   * @nullable
   */
  approvedAt: string | null;
  /** 결제 생성 시간 */
  createdAt: string;
  /**
   * 카드 ID (결제에 사용된 카드) - 현금결제 시 null
   * @nullable
   */
  paymentCardId: string | null;
  /**
   * 마스킹된 카드번호 - 현금결제 시 null
   * @nullable
   */
  maskedCardNumber: string | null;
  /**
   * 거래번호 (Innopay TID)
   * @nullable
   */
  tid: string | null;
  /**
   * 환불 ID (있을 경우)
   * @nullable
   */
  refundId: string | null;
}

/**
 * 환불 상태
 */
export type RefundHistoryDtoStatus =
  (typeof RefundHistoryDtoStatus)[keyof typeof RefundHistoryDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RefundHistoryDtoStatus = {
  REQUESTED: "REQUESTED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PROCESSING: "PROCESSING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
} as const;

export interface RefundHistoryDto {
  /** 환불 ID */
  id: string;
  /** 결제 ID (MOID) */
  paymentTransactionId: string;
  /** 환불 상태 */
  status: RefundHistoryDtoStatus;
  /** 환불 금액 */
  refundAmount: number;
  /** 환불 사유 */
  refundReason: string;
  /** 환불 요청 시간 */
  requestedAt: string;
  /**
   * 환불 완료 시간
   * @nullable
   */
  completedAt: string | null;
  /**
   * 환불 실패 사유
   * @nullable
   */
  errorMessage: string | null;
}

export interface PaymentHistoryResponseDto {
  /** 결제 거래 내역 */
  transactions: PaymentTransactionHistoryDto[];
  /** 환불 내역 */
  refunds: RefundHistoryDto[];
  /** 총 결제 건수 */
  totalTransactions: number;
  /** 총 환불 건수 */
  totalRefunds: number;
  /** 총 결제 금액 */
  totalAmount: number;
  /** 총 환불 금액 */
  totalRefundAmount: number;
}

export interface CompletePaymentDto {
  /** 견적 응답 버전 ID (UUID) */
  quoteResponseVersionId: string;
  /** 구매자 ID (UUID) */
  buyerId: string;
  /** 프로젝트명 (알림 메시지에 포함) */
  projectName: string;
  /** 결제 금액 (KRW, 원) */
  amount: number;
}

export interface RegisterCardDto {
  /** 신용카드/체크카드 카드번호 13~19자리 (공백/하이픈 자동 제거, Luhn 체크섬 검증) */
  cardNum: string;
  /** 카드 유효기간 (YYMM 형식, 예: 2512 = 2025년 12월) */
  cardExpire: string;
  /** 등록자 이름 */
  buyerName: string;
  /** 카드인증 번호 (개인카드: 주민번호 앞 6자리, 법인카드: 사업자번호 10자리) */
  idNum: string;
  /** 카드 비밀번호 앞 2자리 */
  cardPwd: string;
}

/**
 * Subscription plan type
 */
export type CreateSubscriptionDtoPlanType =
  (typeof CreateSubscriptionDtoPlanType)[keyof typeof CreateSubscriptionDtoPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateSubscriptionDtoPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface CreateSubscriptionDto {
  /** Subscription plan type */
  planType: CreateSubscriptionDtoPlanType;
  /** Payment card ID (must be registered in payment module) */
  paymentCardId: string;
}

/**
 * Payment status
 */
export type SubscriptionPaymentResponseDtoStatus =
  (typeof SubscriptionPaymentResponseDtoStatus)[keyof typeof SubscriptionPaymentResponseDtoStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SubscriptionPaymentResponseDtoStatus = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
} as const;

export interface SubscriptionPaymentResponseDto {
  /** Payment record ID */
  id: string;
  /** Subscription ID */
  subscriptionId: string;
  /** Payment amount in KRW */
  amount: number;
  /** Payment status */
  status: SubscriptionPaymentResponseDtoStatus;
  /**
   * Innopay transaction ID (TID)
   * @nullable
   */
  innopayTid: string | null;
  /**
   * Error message if payment failed
   * @nullable
   */
  errorMessage: string | null;
  /**
   * Paid at timestamp
   * @nullable
   */
  paidAt: string | null;
  /** Created at timestamp */
  createdAt: string;
}

/**
 * New subscription plan type
 */
export type ChangeSubscriptionPlanDtoNewPlanType =
  (typeof ChangeSubscriptionPlanDtoNewPlanType)[keyof typeof ChangeSubscriptionPlanDtoNewPlanType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangeSubscriptionPlanDtoNewPlanType = {
  FREE: "FREE",
  PRO: "PRO",
  ENTERPRISE: "ENTERPRISE",
  TEST: "TEST",
} as const;

export interface ChangeSubscriptionPlanDto {
  /** New subscription plan type */
  newPlanType: ChangeSubscriptionPlanDtoNewPlanType;
  /** Payment card ID (required when upgrading from FREE to paid plan) */
  paymentCardId?: string;
}

export interface CancelSubscriptionDto {
  /** 구독 취소 사유 */
  reason?: string;
}

export interface PromotionRedemptionResponseDto {
  /** Success status */
  success: boolean;
  /** Result message */
  message: string;
  /** Extended plan expiration date */
  newExpirationDate?: string;
}

export interface RedeemPromotionDto {
  /** Promotion Code */
  code: string;
}

/**
 * 알람 타입
 */
export type NotificationResponseDtoType =
  (typeof NotificationResponseDtoType)[keyof typeof NotificationResponseDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationResponseDtoType = {
  quote_request_created: "quote_request_created",
  quote_response_received: "quote_response_received",
  quote_deadline_approaching: "quote_deadline_approaching",
  payment_received: "payment_received",
  payment_expired: "payment_expired",
  cancellation_requested: "cancellation_requested",
  contract_cancellation_approved: "contract_cancellation_approved",
  refund_completed: "refund_completed",
  supplier_selected: "supplier_selected",
  contract_completed: "contract_completed",
  purchase_confirmed: "purchase_confirmed",
  contract_documents_ready: "contract_documents_ready",
  contract_restriction_flagged: "contract_restriction_flagged",
  review_requested: "review_requested",
  review_completed: "review_completed",
  new_message_received: "new_message_received",
  chat_message_unanswered: "chat_message_unanswered",
  chat_reply_delayed: "chat_reply_delayed",
  user_signed_up: "user_signed_up",
  subscription_upgraded: "subscription_upgraded",
  subscription_payment_success: "subscription_payment_success",
  subscription_payment_failed: "subscription_payment_failed",
  subscription_expiring_soon: "subscription_expiring_soon",
} as const;

/**
 * 알람 카테고리
 */
export type NotificationResponseDtoCategory =
  (typeof NotificationResponseDtoCategory)[keyof typeof NotificationResponseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationResponseDtoCategory = {
  system: "system",
  project: "project",
  chat: "chat",
  payment: "payment",
  review: "review",
} as const;

/**
 * 내부 메타데이터
 */
export type NotificationResponseDtoMetadata = { [key: string]: unknown };

export interface NotificationResponseDto {
  /** 알람 ID */
  id: string;
  /** 알람 타입 */
  type: NotificationResponseDtoType;
  /** 알람 카테고리 */
  category: NotificationResponseDtoCategory;
  /** 알람 제목 */
  title: string;
  /** 알람 메시지 */
  message: string;
  /** 연결된 리소스 ID */
  resourceId?: string;
  /** Resource type for frontend navigation (quote_request, quote_response, chat_room, etc.) */
  resourceType?: string;
  /** 읽음 여부 */
  isRead: boolean;
  /** 읽음 처리 시각 (ISO 8601) */
  readAt?: string;
  /** 알람 생성 시각 (ISO 8601) */
  createdAt: string;
  /** 내부 메타데이터 */
  metadata?: NotificationResponseDtoMetadata;
}

export interface UnreadCountResponseDto {
  /** 읽지 않은 알람 총 개수 (시스템 + 채팅) */
  count: number;
  /** 읽지 않은 시스템 알림 개수 */
  notificationCount: number;
  /** 읽지 않은 채팅 메시지 개수 */
  chatCount: number;
}

export interface MarkAllReadResponseDto {
  /** 처리 성공 여부 */
  success: boolean;
  /** 처리 메시지 */
  message: string;
}

export interface MarkAllNotificationsReadBodyDto {
  [key: string]: unknown;
}

export interface MarkReadResponseDto {
  /** 처리 성공 여부 */
  success: boolean;
  /** 처리된 알람 ID */
  notificationId: string;
}

export interface SubscriptionUserDto {
  /** 사용자 ID (public.users.id) */
  id: string;
  /** 읽지 않은 알림 개수 */
  unreadCount: number;
}

export interface RealtimeConnectionInfoDto {
  /** 연결 제공자 */
  provider: string;
  /** Supabase 프로젝트 참조 (선택) */
  projectRef?: string;
}

/**
 * 채널 타입
 */
export type RealtimeChannelDtoType =
  (typeof RealtimeChannelDtoType)[keyof typeof RealtimeChannelDtoType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RealtimeChannelDtoType = {
  realtime: "realtime",
} as const;

export interface RealtimeChannelDto {
  /** 채널 타입 */
  type: RealtimeChannelDtoType;
  /** Supabase Realtime 채널명 */
  channelName: string;
  /** 수신 가능한 이벤트 목록 */
  events: string[];
  /** 연결 정보 */
  connectionInfo: RealtimeConnectionInfoDto;
}

export interface SubscriptionSettingsDto {
  /** 시스템 알림 활성화 (공지사항, 점검 등) */
  system: boolean;
  /** 프로젝트 알림 활성화 */
  project: boolean;
  /** 채팅 알림 활성화 */
  chat: boolean;
  /** 결제 알림 활성화 */
  payment: boolean;
  /** 리뷰 알림 활성화 */
  review: boolean;
  /** 설정 마지막 수정일 (ISO 8601) */
  updatedAt: string;
}

export interface SubscriptionMetaDto {
  /** 서버 시간 (ISO 8601) */
  serverTime: string;
  /** 캐시 권장 시간 (초) */
  ttlSeconds: number;
}

export interface NotificationSubscriptionInfoResponseDto {
  /** API 버전 */
  apiVersion: string;
  /** 사용자 정보 */
  user: SubscriptionUserDto;
  /** 구독 채널 목록 (현재 realtime만 지원, 향후 email/kakao/webhook 확장 가능) */
  channels: RealtimeChannelDto[];
  /** 카테고리별 알림 설정 (user_notification_settings 테이블 기반) */
  settings: SubscriptionSettingsDto;
  /** 메타 정보 */
  meta: SubscriptionMetaDto;
}

export interface PushSubscriptionKeysDto {
  p256dh: string;
  auth: string;
}

export interface PushSubscriptionDto {
  endpoint: string;
  keys: PushSubscriptionKeysDto;
  /** @nullable */
  expirationTime?: number | null;
}

export interface PushUnsubscribeDto {
  endpoint: string;
}

/**
 * 카테고리
 */
export type ActivityLogResponseDtoCategory =
  (typeof ActivityLogResponseDtoCategory)[keyof typeof ActivityLogResponseDtoCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogResponseDtoCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

/**
 * 추가 메타데이터
 */
export type ActivityLogResponseDtoMetadata = { [key: string]: unknown };

export interface ActivityLogResponseDto {
  /** 로그 ID */
  id: string;
  /** 카테고리 */
  category: ActivityLogResponseDtoCategory;
  /** 액션 타입 */
  action: string;
  /** 액션 한글 라벨 */
  actionLabel: string;
  /** 리소스 타입 */
  resourceType?: string;
  /** 리소스 ID */
  resourceId?: string;
  /** 추가 메타데이터 */
  metadata?: ActivityLogResponseDtoMetadata;
  /** 생성 시간 */
  createdAt: string;
}

export interface ReviewResponseDto {
  /** 리뷰 ID */
  id: string;
  /** 계약 ID */
  contractId: string;
  /** 리뷰 작성자 ID (구매자) */
  reviewerId: string;
  /** 리뷰 대상 ID (공급업체) */
  revieweeId: string;
  /** 좋은 점 태그 */
  positiveAspects: string[];
  /** 아쉬운 점 태그 */
  negativeAspects: string[];
  /** 상세 후기 */
  detailedReview: string;
  /**
   * 계산된 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  calculatedRating: number;
  /** 작성 일시 */
  createdAt: string;
}

export interface SupplierReviewStatsDto {
  /** 공급업체 ID */
  supplierId: string;
  /**
   * 총 리뷰 수
   * @minimum 0
   */
  totalReviews: number;
  /**
   * 평균 평점 (1-5, 소수점 2자리)
   * @minimum 0
   * @maximum 5
   */
  averageRating: number;
  /**
   * 긍정 리뷰 수 (평점 4-5)
   * @minimum 0
   */
  positiveReviewCount: number;
  /**
   * 부정 리뷰 수 (평점 1-2)
   * @minimum 0
   */
  negativeReviewCount: number;
  /**
   * 최근 리뷰 작성 일시
   * @nullable
   */
  latestReviewDate: string | null;
}

/**
 * 품목ID
 * @nullable
 */
export type SupplierPriceUploadErrorDtoItemId = {
  [key: string]: unknown;
} | null;

export interface SupplierPriceUploadErrorDto {
  /** 엑셀 행 번호(헤더가 1행). 0 이면 행을 특정할 수 없는 오류다. */
  row: number;
  /**
   * 품목ID
   * @nullable
   */
  itemId: SupplierPriceUploadErrorDtoItemId;
  /** 사유 */
  reason: string;
}

export interface SupplierPriceBulkUploadResultDto {
  /** 공급사명 */
  supplierName: string;
  /** 파일의 데이터 행 수 */
  totalRows: number;
  /** 새로 등록된 단가 수 */
  createdCount: number;
  /** 기존 단가를 덮어쓴 수 */
  updatedCount: number;
  /** 신규단가가 비어 있어 손대지 않은 행 수(취급하지 않는 품목) */
  skippedCount: number;
  /** 오류로 빠진 행 수 */
  errorCount: number;
  /** 오류 목록(최대 100건) */
  errors: SupplierPriceUploadErrorDto[];
}

export interface ItemV2SupplierPriceResponseDto {
  /** 품목 ID (items_v2_base.id - UUID) */
  itemId: string;
  /** 공급사 ID */
  supplierId: string;
  /**
   * 공급사별 단가 (최근 거래가)
   * @nullable
   */
  supplierPrice: number | null;
  /**
   * 공급사 최근 거래 일자
   * @nullable
   */
  lastTransactionDate: string | null;
  /** 거래 이력 존재 여부 */
  hasHistory: boolean;
  /**
   * 상품명 (참고용)
   * @nullable
   */
  itemName: string | null;
}

export interface SupplierItemsResponseDto {
  /** 품목 ID (items_v2_base.id - UUID) */
  itemId: string;
  /** 상품명 */
  name: string;
  /** 카테고리 경로 (cat1 > cat2) */
  categoryPath: string;
  /** 최근 거래 일자 (해당 공급사 기준) */
  lastTransactionDate: string;
  /** 최근 거래 단가 (해당 공급사 기준) */
  lastUnitPrice: number;
}

export interface ItemSupplierComparisonDto {
  /** 공급사 ID */
  supplierId: string;
  /**
   * 공급사명
   * @nullable
   */
  supplierName: string | null;
  /**
   * 거래 단가 (원)
   * @nullable
   */
  unitPrice: number | null;
  /**
   * 최근 거래일 (YYYYMMDD)
   * @nullable
   */
  transactionDate: string | null;
}

export interface ExchangeLinkCodeDto {
  /** 세모 웹에서 발급받은 연결코드 */
  code: string;
}

export interface ResolveItemInputDto {
  /** 자연어 품목 문자열 */
  text: string;
  /** 수량 */
  quantity?: number;
  /** 단위 */
  unit?: string;
  /** 규격 (선택). text 에 이미 적혀 있으면 생략한다 — 있으면 후보 재순위에 함께 쓴다. */
  spec?: string;
  /** 제조사·브랜드 (선택). 있으면 후보의 제조사와 대조한다. */
  manufacturer?: string;
}

export interface ResolveItemsRequestDto {
  items: ResolveItemInputDto[];
}

export interface SupplyCheckItemDto {
  /** 카탈로그 물품 ID (resolve_items 결과) */
  itemId: string;
  /** 품명 (표시·매칭 보조) */
  name: string;
  quantity: number;
}

export interface SupplyCheckRequestDto {
  items: SupplyCheckItemDto[];
}

export interface InstantQuoteItemDto {
  /** 카탈로그 물품 ID */
  itemId: string;
  name: string;
  quantity: number;
  unit?: string;
}

export interface CreateInstantQuoteRequestDto {
  items: InstantQuoteItemDto[];
  /** 납품 지역 코드 (법정동 시도 2자리) */
  deliveryRegionCode?: string;
  /** 희망 납기 (YYYY-MM-DD) */
  dueDate?: string;
  vatIncluded?: boolean;
}

export interface AttachGuestRequestDto {
  /** 게스트 토큰 (미리보기 URL 프래그먼트의 t) */
  guestToken: string;
}

export interface ClaimQuoteDocumentRequestDto {
  /** quote_response_versions.id */
  quoteVersionId: string;
}

/**
 * 인증 컨텍스트
 */
export type NiceInitResponseDtoContext =
  (typeof NiceInitResponseDtoContext)[keyof typeof NiceInitResponseDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceInitResponseDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceInitResponseDto {
  /** 토큰 버전 ID */
  tokenVersionId: string;
  /** 암호화된 데이터 */
  encData: string;
  /** 무결성 검증값 */
  integrityValue: string;
  /** 요청 번호 */
  requestNo?: string;
  /** 인증 컨텍스트 */
  context: NiceInitResponseDtoContext;
  /** 본인인증 시험 모드 여부(시험 서버 전용, 운영에서는 오지 않음) */
  testMode?: boolean;
}

/**
 * 인증 컨텍스트
 */
export type NiceInitRequestDtoContext =
  (typeof NiceInitRequestDtoContext)[keyof typeof NiceInitRequestDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceInitRequestDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceInitRequestDto {
  /** 인증 컨텍스트 */
  context: NiceInitRequestDtoContext;
}

/**
 * 성별
 */
export type NicePersonalDataDtoGender =
  (typeof NicePersonalDataDtoGender)[keyof typeof NicePersonalDataDtoGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NicePersonalDataDtoGender = {
  M: "M",
  F: "F",
} as const;

export interface NicePersonalDataDto {
  /** 성명 */
  name: string;
  /** 휴대폰 번호 (하이픈 제거) */
  phone: string;
  /** 생년월일 (YYYYMMDD) */
  birthDate: string;
  /** 성별 */
  gender: NicePersonalDataDtoGender;
}

/**
 * 인증 컨텍스트
 */
export type NiceCallbackResponseDtoContext =
  (typeof NiceCallbackResponseDtoContext)[keyof typeof NiceCallbackResponseDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceCallbackResponseDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceCallbackResponseDto {
  /** 요청 번호 */
  requestNo: string;
  /** CI 해시 */
  ciHash: string;
  /** DI 해시 */
  diHash: string;
  /** 인증 완료 여부 */
  isCompleted: boolean;
  /**
   * 인증 완료 시각
   * @nullable
   */
  verifiedAt: string | null;
  /** 개인정보 */
  personalData?: NicePersonalDataDto;
  /** 메시지 */
  message?: string;
  /** 인증 컨텍스트 */
  context: NiceCallbackResponseDtoContext;
  /** 본인인증 시험 모드로 만든 기록이면 true(시험 서버 전용) */
  testMode?: boolean;
}

/**
 * 인증 컨텍스트
 */
export type NiceCallbackRequestDtoContext =
  (typeof NiceCallbackRequestDtoContext)[keyof typeof NiceCallbackRequestDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceCallbackRequestDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

export interface NiceCallbackRequestDto {
  /** 암호화된 응답 데이터 */
  encData: string;
  /** 무결성 검증값 */
  integrityValue: string;
  /** 인증 컨텍스트 */
  context: NiceCallbackRequestDtoContext;
  /** 토큰 버전 ID */
  tokenVersionId?: string;
}

export interface NiceAuthModeResponseDto {
  /** 본인인증 시험 모드 여부 — true 면 [본인인증] 이 실제 PASS 대신 시험용 창을 연다(시험 서버 전용) */
  testMode: boolean;
}

/**
 * 인증 컨텍스트
 */
export type NiceTestCompleteRequestDtoContext =
  (typeof NiceTestCompleteRequestDtoContext)[keyof typeof NiceTestCompleteRequestDtoContext];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceTestCompleteRequestDtoContext = {
  signup: "signup",
  reauthentication: "reauthentication",
} as const;

/**
 * 성별
 */
export type NiceTestCompleteRequestDtoGender =
  (typeof NiceTestCompleteRequestDtoGender)[keyof typeof NiceTestCompleteRequestDtoGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NiceTestCompleteRequestDtoGender = {
  M: "M",
  F: "F",
} as const;

export interface NiceTestCompleteRequestDto {
  /** 시험 모드 시작 때 받은 1회용 표(tokenVersionId) */
  tokenVersionId: string;
  /** 인증 컨텍스트 */
  context: NiceTestCompleteRequestDtoContext;
  /** 이름 */
  name: string;
  /** 생년월일(YYYYMMDD) */
  birthDate: string;
  /** 성별 */
  gender: NiceTestCompleteRequestDtoGender;
  /** 휴대폰 번호 */
  phone: string;
}

export type ChatControllerGetRoomsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ChatControllerGetRoomsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 읽음 상태 필터
   */
  readStatus?: ChatControllerGetRoomsReadStatus;
};

export type ChatControllerGetRoomsSortOrder =
  (typeof ChatControllerGetRoomsSortOrder)[keyof typeof ChatControllerGetRoomsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatControllerGetRoomsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ChatControllerGetRoomsReadStatus =
  (typeof ChatControllerGetRoomsReadStatus)[keyof typeof ChatControllerGetRoomsReadStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatControllerGetRoomsReadStatus = {
  all: "all",
  read: "read",
  unread: "unread",
} as const;

export type ChatControllerGetRooms200AllOfData = {
  items: ChatRoomResponseDto[];
  meta: PaginationMetaDto;
};

export type ChatControllerGetRooms200AllOf = {
  data?: ChatControllerGetRooms200AllOfData;
};

export type ChatControllerGetRooms200 = BaseResponseDto &
  ChatControllerGetRooms200AllOf;

export type ChatControllerGetRoom200AllOf = {
  data?: ChatRoomResponseDto;
};

export type ChatControllerGetRoom200 = BaseResponseDto &
  ChatControllerGetRoom200AllOf;

export type ChatControllerGetMessagesParams = {
  /**
   * 페이지네이션 커서 (메시지 ID)
   */
  before?: string;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
};

export type ChatControllerGetMessages200AllOf = {
  data?: ChatMessagesResponseDto;
};

export type ChatControllerGetMessages200 = BaseResponseDto &
  ChatControllerGetMessages200AllOf;

export type ChatControllerSendMessage200AllOf = {
  data?: BaseChatMessageResponseDto;
};

export type ChatControllerSendMessage200 = BaseResponseDto &
  ChatControllerSendMessage200AllOf;

export type ChatControllerRequestContractDocuments200AllOf = {
  data?: GeneratedContractDocumentDto[];
};

export type ChatControllerRequestContractDocuments200 = BaseResponseDto &
  ChatControllerRequestContractDocuments200AllOf;

export type ChatControllerSubmitContractDocumentInput200AllOf = {
  data?: ContractDocumentItemDto;
};

export type ChatControllerSubmitContractDocumentInput200 = BaseResponseDto &
  ChatControllerSubmitContractDocumentInput200AllOf;

export type ChatControllerSubmitContractDocumentBuyerConfirmation200AllOf = {
  data?: ContractDocumentItemDto;
};

export type ChatControllerSubmitContractDocumentBuyerConfirmation200 =
  BaseResponseDto &
    ChatControllerSubmitContractDocumentBuyerConfirmation200AllOf;

export type ChatControllerUploadContractDocumentFileBody = {
  file?: Blob;
};

export type ChatControllerUploadContractDocumentFile200AllOf = {
  data?: ContractDocumentItemDto;
};

export type ChatControllerUploadContractDocumentFile200 = BaseResponseDto &
  ChatControllerUploadContractDocumentFile200AllOf;

export type ChatControllerUploadFileBody = {
  file?: Blob;
};

export type ChatControllerUploadFile200AllOf = {
  data?: AttachmentMessageResponseDto;
};

export type ChatControllerUploadFile200 = BaseResponseDto &
  ChatControllerUploadFile200AllOf;

export type ChatControllerSubmitQuoteRevision200AllOf = {
  data?: QuoteMessageResponseDto;
};

export type ChatControllerSubmitQuoteRevision200 = BaseResponseDto &
  ChatControllerSubmitQuoteRevision200AllOf;

export type QuoteResponsesControllerCreate201AllOf = {
  data?: QuoteResponseFlowResultDto;
};

export type QuoteResponsesControllerCreate201 = BaseResponseDto &
  QuoteResponsesControllerCreate201AllOf;

export type QuoteResponsesControllerWithdraw200AllOf = {
  data?: WithdrawQuoteResponseResultDto;
};

export type QuoteResponsesControllerWithdraw200 = BaseResponseDto &
  QuoteResponsesControllerWithdraw200AllOf;

export type QuoteResponsesControllerFindOne200AllOf = {
  data?: QuoteResponseResponseDto;
};

export type QuoteResponsesControllerFindOne200 = BaseResponseDto &
  QuoteResponsesControllerFindOne200AllOf;

export type QuoteResponsesControllerDownloadPdf200AllOf = {
  data?: PdfUrlResponseDto;
};

export type QuoteResponsesControllerDownloadPdf200 = BaseResponseDto &
  QuoteResponsesControllerDownloadPdf200AllOf;

export type QuoteResponsesControllerUploadAttachmentsBody = {
  files?: Blob[];
};

export type QuoteResponsesControllerUploadAttachments201AllOf = {
  data?: AttachmentMetadataDto[];
};

export type QuoteResponsesControllerUploadAttachments201 = BaseResponseDto &
  QuoteResponsesControllerUploadAttachments201AllOf;

export type PdfControllerGenerateQuotePdf201AllOf = {
  data?: PdfGenerationResponseDto;
};

export type PdfControllerGenerateQuotePdf201 = BaseResponseDto &
  PdfControllerGenerateQuotePdf201AllOf;

export type PdfControllerGenerateContractPdf201AllOf = {
  data?: PdfGenerationResponseDto;
};

export type PdfControllerGenerateContractPdf201 = BaseResponseDto &
  PdfControllerGenerateContractPdf201AllOf;

export type AuthSessionControllerGetSystemConfig200AllOf = {
  data?: SystemConfigResponseDto;
};

export type AuthSessionControllerGetSystemConfig200 = BaseResponseDto &
  AuthSessionControllerGetSystemConfig200AllOf;

export type AuthSessionControllerLogin201AllOf = {
  data?: LoginResponseDto;
};

export type AuthSessionControllerLogin201 = BaseResponseDto &
  AuthSessionControllerLogin201AllOf;

export type AuthSessionControllerSignup201AllOf = {
  data?: SignupResponseDto;
};

export type AuthSessionControllerSignup201 = BaseResponseDto &
  AuthSessionControllerSignup201AllOf;

export type AuthSessionControllerRefresh201AllOf = {
  data?: RefreshResponseDto;
};

export type AuthSessionControllerRefresh201 = BaseResponseDto &
  AuthSessionControllerRefresh201AllOf;

export type AuthSessionControllerLogout201AllOf = {
  data?: LogoutResponseDto;
};

export type AuthSessionControllerLogout201 = BaseResponseDto &
  AuthSessionControllerLogout201AllOf;

export type AuthSessionControllerGetCurrentUser200AllOf = {
  data?: UserInfoDto;
};

export type AuthSessionControllerGetCurrentUser200 = BaseResponseDto &
  AuthSessionControllerGetCurrentUser200AllOf;

export type AuthSessionControllerGetLatestTerms200AllOf = {
  data?: TermsDefinitionResponseDto[];
};

export type AuthSessionControllerGetLatestTerms200 = BaseResponseDto &
  AuthSessionControllerGetLatestTerms200AllOf;

export type AuthPasswordControllerChangePassword200AllOfData = {
  [key: string]: unknown;
};

export type AuthPasswordControllerChangePassword200AllOf = {
  data?: AuthPasswordControllerChangePassword200AllOfData;
};

export type AuthPasswordControllerChangePassword200 = BaseResponseDto &
  AuthPasswordControllerChangePassword200AllOf;

export type AuthPasswordControllerVerifyCiHash200AllOf = {
  data?: VerifyCiHashApiResponse;
};

export type AuthPasswordControllerVerifyCiHash200 = BaseResponseDto &
  AuthPasswordControllerVerifyCiHash200AllOf;

export type AuthPasswordControllerConfirmPasswordReset200AllOf = {
  data?: ConfirmPasswordResetApiResponse;
};

export type AuthPasswordControllerConfirmPasswordReset200 = BaseResponseDto &
  AuthPasswordControllerConfirmPasswordReset200AllOf;

export type AuthIdentityControllerFindUserId200AllOf = {
  data?: FindUserIdResponseDto;
};

export type AuthIdentityControllerFindUserId200 = BaseResponseDto &
  AuthIdentityControllerFindUserId200AllOf;

export type AuthIdentityControllerCheckUserIdAvailability200AllOf = {
  data?: CheckUserIdAvailabilityResponseDto;
};

export type AuthIdentityControllerCheckUserIdAvailability200 = BaseResponseDto &
  AuthIdentityControllerCheckUserIdAvailability200AllOf;

export type BuyerProfileControllerUpdateMyProfile200AllOf = {
  data?: UserResponseDto;
};

export type BuyerProfileControllerUpdateMyProfile200 = BaseResponseDto &
  BuyerProfileControllerUpdateMyProfile200AllOf;

export type BuyerProfileControllerUploadProfileImageBody = {
  /** 프로필 이미지 파일 (JPEG, PNG, GIF, WebP - 최대 5MB) */
  file: Blob;
};

export type BuyerProfileControllerUploadProfileImage201AllOf = {
  data?: ProfileImageUploadResponseDto;
};

export type BuyerProfileControllerUploadProfileImage201 = BaseResponseDto &
  BuyerProfileControllerUploadProfileImage201AllOf;

export type BuyerProfileControllerGetVerificationDate200AllOf = {
  data?: VerificationDateResponseDto;
};

export type BuyerProfileControllerGetVerificationDate200 = BaseResponseDto &
  BuyerProfileControllerGetVerificationDate200AllOf;

export type BuyerAddressControllerGetMyAddresses200AllOf = {
  data?: AddressResponseDto[];
};

export type BuyerAddressControllerGetMyAddresses200 = BaseResponseDto &
  BuyerAddressControllerGetMyAddresses200AllOf;

export type BuyerAddressControllerUpsertAddress201AllOf = {
  data?: AddressResponseDto;
};

export type BuyerAddressControllerUpsertAddress201 = BaseResponseDto &
  BuyerAddressControllerUpsertAddress201AllOf;

export type UserSettingsControllerSendEmailVerificationCode200AllOf = {
  data?: SendVerificationCodeResponseDto;
};

export type UserSettingsControllerSendEmailVerificationCode200 =
  BaseResponseDto & UserSettingsControllerSendEmailVerificationCode200AllOf;

export type UserSettingsControllerVerifyEmailCode200AllOf = {
  data?: EmailVerificationResponseDto;
};

export type UserSettingsControllerVerifyEmailCode200 = BaseResponseDto &
  UserSettingsControllerVerifyEmailCode200AllOf;

export type UserSettingsControllerGetNotificationSettings200AllOf = {
  data?: NotificationSettingsResponseDto;
};

export type UserSettingsControllerGetNotificationSettings200 = BaseResponseDto &
  UserSettingsControllerGetNotificationSettings200AllOf;

export type UserSettingsControllerUpdateNotificationSettings200AllOf = {
  data?: NotificationSettingsResponseDto;
};

export type UserSettingsControllerUpdateNotificationSettings200 =
  BaseResponseDto & UserSettingsControllerUpdateNotificationSettings200AllOf;

export type UserSettingsControllerGetMarketingConsent200AllOf = {
  data?: MarketingConsentResponseDto;
};

export type UserSettingsControllerGetMarketingConsent200 = BaseResponseDto &
  UserSettingsControllerGetMarketingConsent200AllOf;

export type UserSettingsControllerUpdateMarketingConsent200AllOf = {
  data?: MarketingConsentResponseDto;
};

export type UserSettingsControllerUpdateMarketingConsent200 = BaseResponseDto &
  UserSettingsControllerUpdateMarketingConsent200AllOf;

export type UserSettingsControllerToggleAutoQuote200AllOf = {
  data?: UserResponseDto;
};

export type UserSettingsControllerToggleAutoQuote200 = BaseResponseDto &
  UserSettingsControllerToggleAutoQuote200AllOf;

export type SupplierProfileControllerGetMyProfile200AllOf = {
  data?: MySupplierProfileDto;
};

export type SupplierProfileControllerGetMyProfile200 = BaseResponseDto &
  SupplierProfileControllerGetMyProfile200AllOf;

export type SupplierProfileControllerUpdateMyProfile200AllOf = {
  data?: MySupplierProfileDto;
};

export type SupplierProfileControllerUpdateMyProfile200 = BaseResponseDto &
  SupplierProfileControllerUpdateMyProfile200AllOf;

export type SupplierProfileControllerUploadLogoBody = {
  /** 로고 이미지 (JPEG, PNG, GIF, WebP — 최대 5MB) */
  file: Blob;
};

export type SupplierProfileControllerUploadLogo200AllOf = {
  data?: SupplierLogoUploadResponseDto;
};

export type SupplierProfileControllerUploadLogo200 = BaseResponseDto &
  SupplierProfileControllerUploadLogo200AllOf;

export type SupplierProfileControllerAddCertificationBody = {
  /** 인증서 명칭 */
  name: string;
  /** 발급 기관 */
  issuer?: string;
  /** 인증 번호 */
  certNumber?: string;
  /** 발급일 (YYYY-MM-DD) */
  issuedAt?: string;
  /** 만료일 (YYYY-MM-DD) */
  expiresAt?: string;
  /** 인증서 파일 (PDF 또는 이미지 — 최대 20MB) */
  file?: Blob;
};

export type SupplierProfileControllerAddCertification200AllOf = {
  data?: SupplierCertificationDto;
};

export type SupplierProfileControllerAddCertification200 = BaseResponseDto &
  SupplierProfileControllerAddCertification200AllOf;

export type SupplierProfileControllerDeleteCertification200AllOfData = {
  [key: string]: unknown;
};

export type SupplierProfileControllerDeleteCertification200AllOf = {
  data?: SupplierProfileControllerDeleteCertification200AllOfData;
};

export type SupplierProfileControllerDeleteCertification200 = BaseResponseDto &
  SupplierProfileControllerDeleteCertification200AllOf;

export type SupplierProfileControllerGetPublicProfileParams = {
  /**
   * 채팅방 문맥 — 있으면 그 방의 계약 여부로 공개를 판정
   */
  chatRoomId?: string;
};

export type SupplierProfileControllerGetPublicProfile200AllOf = {
  data?: SupplierPublicProfileDto;
};

export type SupplierProfileControllerGetPublicProfile200 = BaseResponseDto &
  SupplierProfileControllerGetPublicProfile200AllOf;

export type AdminSupplierCertificationsControllerListCertifications200AllOf = {
  data?: SupplierCertificationDto;
};

export type AdminSupplierCertificationsControllerListCertifications200 =
  BaseResponseDto &
    AdminSupplierCertificationsControllerListCertifications200AllOf;

export type AdminSupplierCertificationsControllerVerifyCertification200AllOf = {
  data?: SupplierCertificationDto;
};

export type AdminSupplierCertificationsControllerVerifyCertification200 =
  BaseResponseDto &
    AdminSupplierCertificationsControllerVerifyCertification200AllOf;

export type ContractsControllerGetMyContractsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ContractsControllerGetMyContractsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  statuses?: ContractsControllerGetMyContractsStatusesItem[];
};

export type ContractsControllerGetMyContractsSortOrder =
  (typeof ContractsControllerGetMyContractsSortOrder)[keyof typeof ContractsControllerGetMyContractsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractsControllerGetMyContractsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ContractsControllerGetMyContractsStatusesItem =
  (typeof ContractsControllerGetMyContractsStatusesItem)[keyof typeof ContractsControllerGetMyContractsStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractsControllerGetMyContractsStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

export type ContractsControllerGetMyContracts200AllOfData = {
  items: ContractListResponseDto[];
  meta: PaginationMetaDto;
};

export type ContractsControllerGetMyContracts200AllOf = {
  data?: ContractsControllerGetMyContracts200AllOfData;
};

export type ContractsControllerGetMyContracts200 = BaseResponseDto &
  ContractsControllerGetMyContracts200AllOf;

export type ContractsControllerDownloadPdf200AllOf = {
  data?: PdfUrlResponseDto;
};

export type ContractsControllerDownloadPdf200 = BaseResponseDto &
  ContractsControllerDownloadPdf200AllOf;

export type ContractsControllerDownloadCancellationPdf200AllOf = {
  data?: PdfUrlResponseDto;
};

export type ContractsControllerDownloadCancellationPdf200 = BaseResponseDto &
  ContractsControllerDownloadCancellationPdf200AllOf;

export type ContractsControllerCreateContract201AllOf = {
  data?: ContractResponseDto;
};

export type ContractsControllerCreateContract201 = BaseResponseDto &
  ContractsControllerCreateContract201AllOf;

export type ContractsControllerGetCardPaymentStatus200AllOf = {
  data?: ContractCardPaymentStatusResponseDto;
};

export type ContractsControllerGetCardPaymentStatus200 = BaseResponseDto &
  ContractsControllerGetCardPaymentStatus200AllOf;

export type ContractsControllerGetContract200AllOf = {
  data?: ContractResponseDto;
};

export type ContractsControllerGetContract200 = BaseResponseDto &
  ContractsControllerGetContract200AllOf;

export type ContractsControllerCancelContract204AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerCancelContract204AllOf = {
  data?: ContractsControllerCancelContract204AllOfData;
};

export type ContractsControllerCancelContract204 = BaseResponseDto &
  ContractsControllerCancelContract204AllOf;

export type ContractsControllerCompleteContract200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerCompleteContract200AllOf = {
  data?: ContractsControllerCompleteContract200AllOfData;
};

export type ContractsControllerCompleteContract200 = BaseResponseDto &
  ContractsControllerCompleteContract200AllOf;

export type ContractsControllerRequestCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerRequestCancellation200AllOf = {
  data?: ContractsControllerRequestCancellation200AllOfData;
};

export type ContractsControllerRequestCancellation200 = BaseResponseDto &
  ContractsControllerRequestCancellation200AllOf;

export type ContractsControllerConfirmCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerConfirmCancellation200AllOf = {
  data?: ContractsControllerConfirmCancellation200AllOfData;
};

export type ContractsControllerConfirmCancellation200 = BaseResponseDto &
  ContractsControllerConfirmCancellation200AllOf;

export type ContractsControllerRejectCancellationBody = {
  rejectionReason: string;
};

export type ContractsControllerRejectCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ContractsControllerRejectCancellation200AllOf = {
  data?: ContractsControllerRejectCancellation200AllOfData;
};

export type ContractsControllerRejectCancellation200 = BaseResponseDto &
  ContractsControllerRejectCancellation200AllOf;

export type QuoteRequestsControllerCreate201AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerCreate201 = BaseResponseDto &
  QuoteRequestsControllerCreate201AllOf;

export type QuoteRequestsControllerFindMyQuotesParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: QuoteRequestsControllerFindMyQuotesSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 상태 필터
   */
  statuses?: QuoteRequestsControllerFindMyQuotesStatusesItem[];
};

export type QuoteRequestsControllerFindMyQuotesSortOrder =
  (typeof QuoteRequestsControllerFindMyQuotesSortOrder)[keyof typeof QuoteRequestsControllerFindMyQuotesSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindMyQuotesSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type QuoteRequestsControllerFindMyQuotesStatusesItem =
  (typeof QuoteRequestsControllerFindMyQuotesStatusesItem)[keyof typeof QuoteRequestsControllerFindMyQuotesStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindMyQuotesStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type QuoteRequestsControllerFindMyQuotes200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type QuoteRequestsControllerFindMyQuotes200AllOf = {
  data?: QuoteRequestsControllerFindMyQuotes200AllOfData;
};

export type QuoteRequestsControllerFindMyQuotes200 = BaseResponseDto &
  QuoteRequestsControllerFindMyQuotes200AllOf;

export type QuoteRequestsControllerCheckAutoQuote200AllOf = {
  data?: CheckAutoQuoteResponseDto;
};

export type QuoteRequestsControllerCheckAutoQuote200 = BaseResponseDto &
  QuoteRequestsControllerCheckAutoQuote200AllOf;

export type QuoteRequestsControllerFindPublicParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: QuoteRequestsControllerFindPublicSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 상태 필터
   */
  statuses?: QuoteRequestsControllerFindPublicStatusesItem[];
};

export type QuoteRequestsControllerFindPublicSortOrder =
  (typeof QuoteRequestsControllerFindPublicSortOrder)[keyof typeof QuoteRequestsControllerFindPublicSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindPublicSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type QuoteRequestsControllerFindPublicStatusesItem =
  (typeof QuoteRequestsControllerFindPublicStatusesItem)[keyof typeof QuoteRequestsControllerFindPublicStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const QuoteRequestsControllerFindPublicStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type QuoteRequestsControllerFindPublic200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type QuoteRequestsControllerFindPublic200AllOf = {
  data?: QuoteRequestsControllerFindPublic200AllOfData;
};

export type QuoteRequestsControllerFindPublic200 = BaseResponseDto &
  QuoteRequestsControllerFindPublic200AllOf;

export type QuoteRequestsControllerFindOne200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerFindOne200 = BaseResponseDto &
  QuoteRequestsControllerFindOne200AllOf;

export type QuoteRequestsControllerUpdate200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerUpdate200 = BaseResponseDto &
  QuoteRequestsControllerUpdate200AllOf;

export type QuoteRequestsControllerExtendDeadline200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerExtendDeadline200 = BaseResponseDto &
  QuoteRequestsControllerExtendDeadline200AllOf;

export type QuoteRequestsControllerCloseQuoteRequest200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type QuoteRequestsControllerCloseQuoteRequest200 = BaseResponseDto &
  QuoteRequestsControllerCloseQuoteRequest200AllOf;

export type PublicQuoteRequestsControllerFindPublicParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: PublicQuoteRequestsControllerFindPublicSortOrder;
  /**
   * 검색어
   */
  search?: string;
};

export type PublicQuoteRequestsControllerFindPublicSortOrder =
  (typeof PublicQuoteRequestsControllerFindPublicSortOrder)[keyof typeof PublicQuoteRequestsControllerFindPublicSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PublicQuoteRequestsControllerFindPublicSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type PublicQuoteRequestsControllerFindPublic200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type PublicQuoteRequestsControllerFindPublic200AllOf = {
  data?: PublicQuoteRequestsControllerFindPublic200AllOfData;
};

export type PublicQuoteRequestsControllerFindPublic200 = BaseResponseDto &
  PublicQuoteRequestsControllerFindPublic200AllOf;

export type AdminStorefrontsControllerListPointBalances200AllOf = {
  data?: AdminPointBalanceListDto;
};

export type AdminStorefrontsControllerListPointBalances200 = BaseResponseDto &
  AdminStorefrontsControllerListPointBalances200AllOf;

export type AdminStorefrontsControllerGetPointLedger200AllOf = {
  data?: AdminPointLedgerDto;
};

export type AdminStorefrontsControllerGetPointLedger200 = BaseResponseDto &
  AdminStorefrontsControllerGetPointLedger200AllOf;

export type AdminStorefrontsControllerChargePoints201AllOf = {
  data?: AdminPointMutationResultDto;
};

export type AdminStorefrontsControllerChargePoints201 = BaseResponseDto &
  AdminStorefrontsControllerChargePoints201AllOf;

export type AdminStorefrontsControllerDeductPoints201AllOf = {
  data?: AdminPointMutationResultDto;
};

export type AdminStorefrontsControllerDeductPoints201 = BaseResponseDto &
  AdminStorefrontsControllerDeductPoints201AllOf;

export type AdminStorefrontsControllerList200AllOf = {
  data?: AdminStorefrontDto[];
};

export type AdminStorefrontsControllerList200 = BaseResponseDto &
  AdminStorefrontsControllerList200AllOf;

export type AdminStorefrontsControllerCreate201AllOf = {
  data?: AdminStorefrontDto;
};

export type AdminStorefrontsControllerCreate201 = BaseResponseDto &
  AdminStorefrontsControllerCreate201AllOf;

export type AdminStorefrontsControllerUpdate200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerUpdate200 = BaseResponseDto &
  AdminStorefrontsControllerUpdate200AllOf;

export type AdminStorefrontsControllerListSuppliers200AllOf = {
  data?: StorefrontSupplierDto[];
};

export type AdminStorefrontsControllerListSuppliers200 = BaseResponseDto &
  AdminStorefrontsControllerListSuppliers200AllOf;

export type AdminStorefrontsControllerLinkSupplier201AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerLinkSupplier201 = BaseResponseDto &
  AdminStorefrontsControllerLinkSupplier201AllOf;

export type AdminStorefrontsControllerUnlinkSupplier200AllOf = {
  data?: UnlinkSupplierResultDto;
};

export type AdminStorefrontsControllerUnlinkSupplier200 = BaseResponseDto &
  AdminStorefrontsControllerUnlinkSupplier200AllOf;

export type AdminStorefrontsControllerListCandidatesParams = {
  supplierId: string;
  q?: string;
  offset?: unknown;
  /**
   * 최대 1000
   */
  limit?: unknown;
};

export type AdminStorefrontsControllerListCandidates200AllOf = {
  data?: CandidateListResponseDto;
};

export type AdminStorefrontsControllerListCandidates200 = BaseResponseDto &
  AdminStorefrontsControllerListCandidates200AllOf;

export type AdminStorefrontsControllerListOfferings200AllOf = {
  data?: AdminOfferingDto[];
};

export type AdminStorefrontsControllerListOfferings200 = BaseResponseDto &
  AdminStorefrontsControllerListOfferings200AllOf;

export type AdminStorefrontsControllerAddOfferings201AllOf = {
  data?: AddOfferingsResultDto;
};

export type AdminStorefrontsControllerAddOfferings201 = BaseResponseDto &
  AdminStorefrontsControllerAddOfferings201AllOf;

export type AdminStorefrontsControllerUpdateOffering200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerUpdateOffering200 = BaseResponseDto &
  AdminStorefrontsControllerUpdateOffering200AllOf;

export type AdminStorefrontsControllerRemoveOffering200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontsControllerRemoveOffering200 = BaseResponseDto &
  AdminStorefrontsControllerRemoveOffering200AllOf;

export type AdminStorefrontsControllerListOrdersParams = {
  status?: string;
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontsControllerListOrders200AllOf = {
  data?: AdminStorefrontOrderListDto;
};

export type AdminStorefrontsControllerListOrders200 = BaseResponseDto &
  AdminStorefrontsControllerListOrders200AllOf;

export type AdminStorefrontsControllerForceReleaseInspection201AllOf = {
  data?: ForceReleaseInspectionResultDto;
};

export type AdminStorefrontsControllerForceReleaseInspection201 =
  BaseResponseDto & AdminStorefrontsControllerForceReleaseInspection201AllOf;

export type AdminStorefrontsControllerForceDeliver201AllOf = {
  data?: ForceOrderActionResultDto;
};

export type AdminStorefrontsControllerForceDeliver201 = BaseResponseDto &
  AdminStorefrontsControllerForceDeliver201AllOf;

export type AdminStorefrontsControllerForceConfirm201AllOf = {
  data?: ForceOrderActionResultDto;
};

export type AdminStorefrontsControllerForceConfirm201 = BaseResponseDto &
  AdminStorefrontsControllerForceConfirm201AllOf;

export type AdminStorefrontBulkControllerBulkOffer200AllOf = {
  data?: BulkOfferResultDto;
};

export type AdminStorefrontBulkControllerBulkOffer200 = BaseResponseDto &
  AdminStorefrontBulkControllerBulkOffer200AllOf;

export type AdminStorefrontBulkControllerBulkActive200AllOf = {
  data?: BulkActiveResultDto;
};

export type AdminStorefrontBulkControllerBulkActive200 = BaseResponseDto &
  AdminStorefrontBulkControllerBulkActive200AllOf;

export type AdminStorefrontBulkControllerBulkPrices200AllOf = {
  data?: BulkPriceResultDto;
};

export type AdminStorefrontBulkControllerBulkPrices200 = BaseResponseDto &
  AdminStorefrontBulkControllerBulkPrices200AllOf;

export type AdminStorefrontBulkControllerListBatchesParams = {
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontBulkControllerListBatches200AllOf = {
  data?: BatchListResponseDto;
};

export type AdminStorefrontBulkControllerListBatches200 = BaseResponseDto &
  AdminStorefrontBulkControllerListBatches200AllOf;

export type AdminStorefrontBulkControllerUndoBatch200AllOf = {
  data?: UndoBatchResultDto;
};

export type AdminStorefrontBulkControllerUndoBatch200 = BaseResponseDto &
  AdminStorefrontBulkControllerUndoBatch200AllOf;

export type AdminStorefrontBulkControllerListRules200AllOf = {
  data?: RuleDto[];
};

export type AdminStorefrontBulkControllerListRules200 = BaseResponseDto &
  AdminStorefrontBulkControllerListRules200AllOf;

export type AdminStorefrontBulkControllerCreateRule201AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerCreateRule201 = BaseResponseDto &
  AdminStorefrontBulkControllerCreateRule201AllOf;

export type AdminStorefrontBulkControllerUpdateRule200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerUpdateRule200 = BaseResponseDto &
  AdminStorefrontBulkControllerUpdateRule200AllOf;

export type AdminStorefrontBulkControllerRemoveRule200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerRemoveRule200 = BaseResponseDto &
  AdminStorefrontBulkControllerRemoveRule200AllOf;

export type AdminStorefrontBulkControllerApplyRules200AllOf = {
  data?: ApplyRulesResultDto;
};

export type AdminStorefrontBulkControllerApplyRules200 = BaseResponseDto &
  AdminStorefrontBulkControllerApplyRules200AllOf;

export type AdminStorefrontBulkControllerListExclusions200AllOf = {
  data?: ExclusionDto[];
};

export type AdminStorefrontBulkControllerListExclusions200 = BaseResponseDto &
  AdminStorefrontBulkControllerListExclusions200AllOf;

export type AdminStorefrontBulkControllerAddExclusion201AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerAddExclusion201 = BaseResponseDto &
  AdminStorefrontBulkControllerAddExclusion201AllOf;

export type AdminStorefrontBulkControllerRemoveExclusion200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerRemoveExclusion200 = BaseResponseDto &
  AdminStorefrontBulkControllerRemoveExclusion200AllOf;

export type AdminStorefrontBulkControllerListRequestsParams = {
  status?: string;
  offset?: unknown;
  limit?: unknown;
};

export type AdminStorefrontBulkControllerListRequests200AllOf = {
  data?: RequestListResponseDto;
};

export type AdminStorefrontBulkControllerListRequests200 = BaseResponseDto &
  AdminStorefrontBulkControllerListRequests200AllOf;

export type AdminStorefrontBulkControllerDecideRequest200AllOf = {
  data?: SuccessResultDto;
};

export type AdminStorefrontBulkControllerDecideRequest200 = BaseResponseDto &
  AdminStorefrontBulkControllerDecideRequest200AllOf;

export type AdminPriceAxisControllerGetStatus200AllOf = {
  data?: SupplierPriceAxisStatusDto;
};

export type AdminPriceAxisControllerGetStatus200 = BaseResponseDto &
  AdminPriceAxisControllerGetStatus200AllOf;

export type AdminPriceAxisControllerSetSupplierAxis200AllOf = {
  data?: SetSupplierPriceAxisResultDto;
};

export type AdminPriceAxisControllerSetSupplierAxis200 = BaseResponseDto &
  AdminPriceAxisControllerSetSupplierAxis200AllOf;

export type AdminPriceAxisControllerSetTaxCategory200AllOf = {
  data?: SetTaxCategoryResultDto;
};

export type AdminPriceAxisControllerSetTaxCategory200 = BaseResponseDto &
  AdminPriceAxisControllerSetTaxCategory200AllOf;

export type AdminPriceAxisControllerListBatchesParams = {
  supplierId?: string;
  limit?: unknown;
};

export type AdminPriceAxisControllerListBatches200AllOf = {
  data?: PriceAxisBatchDto[];
};

export type AdminPriceAxisControllerListBatches200 = BaseResponseDto &
  AdminPriceAxisControllerListBatches200AllOf;

export type AdminPriceAxisControllerUndoBatch200AllOf = {
  data?: UndoPriceAxisResultDto;
};

export type AdminPriceAxisControllerUndoBatch200 = BaseResponseDto &
  AdminPriceAxisControllerUndoBatch200AllOf;

export type AdminTrustScoresControllerRecalculateTrustScores200AllOf = {
  data?: RecalculateTrustScoresResponseDto;
};

export type AdminTrustScoresControllerRecalculateTrustScores200 =
  BaseResponseDto & AdminTrustScoresControllerRecalculateTrustScores200AllOf;

export type AdminSuppliersControllerGetSuppliersParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 기준 컬럼
   */
  sortBy?: AdminSuppliersControllerGetSuppliersSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminSuppliersControllerGetSuppliersSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 최소 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  minTrustScore?: number;
  /**
   * 최대 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  maxTrustScore?: number;
  /**
   * 백분위 구간 (1, 5, 10, 15, 20, 30, null)
   * @nullable
   */
  percentileTier?: AdminSuppliersControllerGetSuppliersPercentileTier;
};

export type AdminSuppliersControllerGetSuppliersSortBy =
  (typeof AdminSuppliersControllerGetSuppliersSortBy)[keyof typeof AdminSuppliersControllerGetSuppliersSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSuppliersControllerGetSuppliersSortBy = {
  trust_score: "trust_score",
  certification_total_score: "certification_total_score",
  total_participation_score: "total_participation_score",
  contract_count_score: "contract_count_score",
  total_amount_score: "total_amount_score",
  total_commission_score: "total_commission_score",
  recent_participation_score: "recent_participation_score",
  trust_percentile: "trust_percentile",
  created_at: "created_at",
} as const;

export type AdminSuppliersControllerGetSuppliersSortOrder =
  (typeof AdminSuppliersControllerGetSuppliersSortOrder)[keyof typeof AdminSuppliersControllerGetSuppliersSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSuppliersControllerGetSuppliersSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminSuppliersControllerGetSuppliersPercentileTier =
  | (typeof AdminSuppliersControllerGetSuppliersPercentileTier)[keyof typeof AdminSuppliersControllerGetSuppliersPercentileTier]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminSuppliersControllerGetSuppliersPercentileTier = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

export type AdminSuppliersControllerGetSuppliers200AllOfData = {
  items: SupplierWithTrustScoreDto[];
  meta: PaginationMetaDto;
};

export type AdminSuppliersControllerGetSuppliers200AllOf = {
  data?: AdminSuppliersControllerGetSuppliers200AllOfData;
};

export type AdminSuppliersControllerGetSuppliers200 = BaseResponseDto &
  AdminSuppliersControllerGetSuppliers200AllOf;

export type AdminSuppliersControllerGetSupplier200AllOf = {
  data?: SupplierWithTrustScoreDto;
};

export type AdminSuppliersControllerGetSupplier200 = BaseResponseDto &
  AdminSuppliersControllerGetSupplier200AllOf;

export type AdminSuppliersControllerGetSupplierEmbedUrl201AllOf = {
  data?: EmbedJoinResponseDto;
};

export type AdminSuppliersControllerGetSupplierEmbedUrl201 = BaseResponseDto &
  AdminSuppliersControllerGetSupplierEmbedUrl201AllOf;

export type AdminBuyersControllerGetBuyersParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 기준 컬럼 (구매자는 3개만 지원)
   */
  sortBy?: AdminBuyersControllerGetBuyersSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminBuyersControllerGetBuyersSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 최소 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  minTrustScore?: number;
  /**
   * 최대 신뢰 점수 (0-100)
   * @minimum 0
   * @maximum 100
   */
  maxTrustScore?: number;
  /**
   * 백분위 구간 (1, 5, 10, 15, 20, 30, null = 하위 70%)
   * @nullable
   */
  percentileTier?: AdminBuyersControllerGetBuyersPercentileTier;
};

export type AdminBuyersControllerGetBuyersSortBy =
  (typeof AdminBuyersControllerGetBuyersSortBy)[keyof typeof AdminBuyersControllerGetBuyersSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBuyersControllerGetBuyersSortBy = {
  trust_score: "trust_score",
  trust_percentile: "trust_percentile",
  created_at: "created_at",
} as const;

export type AdminBuyersControllerGetBuyersSortOrder =
  (typeof AdminBuyersControllerGetBuyersSortOrder)[keyof typeof AdminBuyersControllerGetBuyersSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBuyersControllerGetBuyersSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminBuyersControllerGetBuyersPercentileTier =
  | (typeof AdminBuyersControllerGetBuyersPercentileTier)[keyof typeof AdminBuyersControllerGetBuyersPercentileTier]
  | null;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminBuyersControllerGetBuyersPercentileTier = {
  NUMBER_1: 1,
  NUMBER_5: 5,
  NUMBER_10: 10,
  NUMBER_15: 15,
  NUMBER_20: 20,
  NUMBER_30: 30,
} as const;

export type AdminBuyersControllerGetBuyers200AllOfData = {
  items: BuyerWithTrustScoreDto[];
  meta: PaginationMetaDto;
};

export type AdminBuyersControllerGetBuyers200AllOf = {
  data?: AdminBuyersControllerGetBuyers200AllOfData;
};

export type AdminBuyersControllerGetBuyers200 = BaseResponseDto &
  AdminBuyersControllerGetBuyers200AllOf;

export type AdminBuyersControllerGetBuyerById200AllOf = {
  data?: BuyerDetailDto;
};

export type AdminBuyersControllerGetBuyerById200 = BaseResponseDto &
  AdminBuyersControllerGetBuyerById200AllOf;

export type AdminBuyersControllerGetBuyerLoginLock200AllOf = {
  data?: BuyerLoginLockStatusDto;
};

export type AdminBuyersControllerGetBuyerLoginLock200 = BaseResponseDto &
  AdminBuyersControllerGetBuyerLoginLock200AllOf;

export type AdminPaymentControllerGetRefundsParams = {
  /**
   * Offset for pagination
   */
  offset?: unknown;
  /**
   * Limit for pagination
   */
  limit?: unknown;
  /**
   * Refund Status Filter
   */
  status?: string;
  /**
   * Search term (Reason, ID)
   */
  search?: string;
};

export type AdminPaymentControllerGetRefunds200AllOfData = {
  items: RefundDetailedResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetRefunds200AllOf = {
  data?: AdminPaymentControllerGetRefunds200AllOfData;
};

export type AdminPaymentControllerGetRefunds200 = BaseResponseDto &
  AdminPaymentControllerGetRefunds200AllOf;

export type AdminPaymentControllerGetUserPayments200AllOf = {
  data?: PaymentTransactionResponseDto[];
};

export type AdminPaymentControllerGetUserPayments200 = BaseResponseDto &
  AdminPaymentControllerGetUserPayments200AllOf;

export type AdminPaymentControllerGetStuckPayments200AllOfData = {
  items: PendingCashPaymentDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetStuckPayments200AllOf = {
  data?: AdminPaymentControllerGetStuckPayments200AllOfData;
};

export type AdminPaymentControllerGetStuckPayments200 = BaseResponseDto &
  AdminPaymentControllerGetStuckPayments200AllOf;

export type AdminPaymentControllerGetCashPaymentsParams = {
  /**
   * Offset for pagination
   */
  offset?: unknown;
  /**
   * Limit for pagination
   */
  limit?: unknown;
  /**
   * Payment Status Filter
   */
  status?: AdminPaymentControllerGetCashPaymentsStatus;
  /**
   * Search term (MOID, Buyer Name, Project Name)
   */
  search?: string;
};

export type AdminPaymentControllerGetCashPaymentsStatus =
  (typeof AdminPaymentControllerGetCashPaymentsStatus)[keyof typeof AdminPaymentControllerGetCashPaymentsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPaymentControllerGetCashPaymentsStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  FAILED: "FAILED",
  CANCELED: "CANCELED",
  EXPIRED: "EXPIRED",
} as const;

export type AdminPaymentControllerGetCashPayments200AllOfData = {
  items: AdminCashPaymentDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetCashPayments200AllOf = {
  data?: AdminPaymentControllerGetCashPayments200AllOfData;
};

export type AdminPaymentControllerGetCashPayments200 = BaseResponseDto &
  AdminPaymentControllerGetCashPayments200AllOf;

export type AdminPaymentControllerGetPendingCashPayments200AllOfData = {
  items: PendingCashPaymentDto[];
  meta: PaginationMetaDto;
};

export type AdminPaymentControllerGetPendingCashPayments200AllOf = {
  data?: AdminPaymentControllerGetPendingCashPayments200AllOfData;
};

export type AdminPaymentControllerGetPendingCashPayments200 = BaseResponseDto &
  AdminPaymentControllerGetPendingCashPayments200AllOf;

export type AdminCategoriesControllerBulkUploadCategoriesBody = {
  /** 카테고리 일괄 등록 엑셀 파일 (.xlsx) */
  file?: Blob;
};

export type AdminCategoriesControllerBulkUploadCategories200AllOf = {
  data?: AdminBulkUploadResultDto;
};

export type AdminCategoriesControllerBulkUploadCategories200 = BaseResponseDto &
  AdminCategoriesControllerBulkUploadCategories200AllOf;

export type AdminCategoriesControllerGetCategoryTree200AllOf = {
  data?: CategoryTreeNodeDto[];
};

export type AdminCategoriesControllerGetCategoryTree200 = BaseResponseDto &
  AdminCategoriesControllerGetCategoryTree200AllOf;

export type AdminCategoriesControllerGetItemsByCategoryParams = {
  categoryId: string;
  includeDescendants: boolean;
  limit: number;
  offset: number;
};

export type AdminCategoriesControllerGetItemsByCategory200AllOfData = {
  items: AdminCategoryItemDto[];
  meta: PaginationMetaDto;
};

export type AdminCategoriesControllerGetItemsByCategory200AllOf = {
  data?: AdminCategoriesControllerGetItemsByCategory200AllOfData;
};

export type AdminCategoriesControllerGetItemsByCategory200 = BaseResponseDto &
  AdminCategoriesControllerGetItemsByCategory200AllOf;

export type AdminCategoriesControllerGetCategoryById200AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerGetCategoryById200 = BaseResponseDto &
  AdminCategoriesControllerGetCategoryById200AllOf;

export type AdminCategoriesControllerUpdateCategory200AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerUpdateCategory200 = BaseResponseDto &
  AdminCategoriesControllerUpdateCategory200AllOf;

export type AdminCategoriesControllerCreateCategory201AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerCreateCategory201 = BaseResponseDto &
  AdminCategoriesControllerCreateCategory201AllOf;

export type AdminCategoriesControllerReorderCategory200AllOf = {
  data?: CategoryResponseDto;
};

export type AdminCategoriesControllerReorderCategory200 = BaseResponseDto &
  AdminCategoriesControllerReorderCategory200AllOf;

export type AdminItemsControllerFindDuplicateCandidatesParams = {
  /**
   * 유사도 임계값 (0.0 ~ 1.0, 기본값: 0.8)
   */
  threshold?: number;
  /**
   * 카테고리 ID (해당 카테고리가 포함된 중복 그룹 조회)
   */
  categoryId?: string;
  /**
   * 검색어 (상품명/브랜드 등에 포함된 중복 그룹 조회)
   */
  search?: string;
  /**
   * 가져올 그룹 수 (기본값: 20)
   */
  limit?: number;
  /**
   * 건너뛸 그룹 수 (기본값: 0)
   */
  offset?: number;
  /**
   * 구간 하한(포함) — 그룹 최고 유사도 기준. 임계값(threshold)과는 별개다: 임계값을 올리면 약한 구성원이 잘려 그룹이 통째로 사라지므로, 구간 선택에는 이 값을 쓴다.
   */
  minScore?: number;
  /**
   * 구간 상한(미포함) — 그룹 최고 유사도 기준. 비우면 상한 없음.
   */
  maxScore?: number;
};

export type AdminItemsControllerFindDuplicateCandidates200AllOfData = {
  items: DuplicateItemCandidateDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerFindDuplicateCandidates200AllOf = {
  data?: AdminItemsControllerFindDuplicateCandidates200AllOfData;
};

export type AdminItemsControllerFindDuplicateCandidates200 = BaseResponseDto &
  AdminItemsControllerFindDuplicateCandidates200AllOf;

export type AdminItemsControllerGetDuplicateCandidateBandsParams = {
  threshold?: number;
  categoryId?: string;
  search?: string;
};

export type AdminItemsControllerGetDuplicateCandidateBands200AllOf = {
  data?: DuplicateCandidateBandDto[];
};

export type AdminItemsControllerGetDuplicateCandidateBands200 =
  BaseResponseDto & AdminItemsControllerGetDuplicateCandidateBands200AllOf;

export type AdminItemsControllerTriggerDuplicateRecalculation202AllOf = {
  data?: BaseResponseDto;
};

export type AdminItemsControllerTriggerDuplicateRecalculation202 =
  BaseResponseDto & AdminItemsControllerTriggerDuplicateRecalculation202AllOf;

export type AdminItemsControllerCancelDuplicateRecalculation200AllOf = {
  data?: BaseResponseDto;
};

export type AdminItemsControllerCancelDuplicateRecalculation200 =
  BaseResponseDto & AdminItemsControllerCancelDuplicateRecalculation200AllOf;

export type AdminItemsControllerGetDuplicateRecalculationStatus200AllOf = {
  data?: DuplicateRecalculationStatusDto;
};

export type AdminItemsControllerGetDuplicateRecalculationStatus200 =
  BaseResponseDto & AdminItemsControllerGetDuplicateRecalculationStatus200AllOf;

export type AdminItemsControllerPreviewMerge200AllOf = {
  data?: MergePreviewResponseDto;
};

export type AdminItemsControllerPreviewMerge200 = BaseResponseDto &
  AdminItemsControllerPreviewMerge200AllOf;

export type AdminItemsControllerMergeItems200AllOf = {
  data?: MergeItemsResponseDto;
};

export type AdminItemsControllerMergeItems200 = BaseResponseDto &
  AdminItemsControllerMergeItems200AllOf;

export type AdminItemsControllerExportItemsParams = {
  /**
   * 선택된 카테고리 ID 목록 (콤마 구분). 지정하지 않으면 전체 다운로드
   */
  categoryIds?: string;
  /**
   * 하위 카테고리 포함 여부 (기본값: true)
   */
  includeDescendants?: string;
};

export type AdminItemsControllerBulkUploadProductsBody = {
  /** 상품 일괄 등록 엑셀 파일 (.xlsx) */
  file?: Blob;
};

export type AdminItemsControllerBulkUploadProducts200AllOf = {
  data?: AdminBulkUploadResultDto;
};

export type AdminItemsControllerBulkUploadProducts200 = BaseResponseDto &
  AdminItemsControllerBulkUploadProducts200AllOf;

export type AdminItemsControllerUploadProductImageBody = {
  /** 상품 이미지 (JPG, PNG, GIF, WEBP, BMP / 최대 5MB) */
  file: Blob;
};

export type AdminItemsControllerUploadProductImage201AllOf = {
  data?: AdminProductImageUploadResponseDto;
};

export type AdminItemsControllerUploadProductImage201 = BaseResponseDto &
  AdminItemsControllerUploadProductImage201AllOf;

export type AdminItemsControllerCreateProduct201AllOf = {
  data?: CreateProductResponseDto;
};

export type AdminItemsControllerCreateProduct201 = BaseResponseDto &
  AdminItemsControllerCreateProduct201AllOf;

export type AdminItemsControllerGetItemsParams = {
  /**
   * 조회 개수 (기본 50)
   */
  limit?: number;
  /**
   * 페이지네이션 오프셋 (기본 0)
   */
  offset?: number;
  /**
   * 커서 (다음 페이지 조회를 위한 Base64 인코딩 값)
   */
  cursor?: string;
  /**
   * 카테고리 ID (선택 시 해당 카테고리 내 물품 조회)
   */
  categoryId?: string;
  /**
   * 하위 카테고리 포함 여부 (기본 true)
   */
  includeDescendants?: boolean;
  /**
   * 검색어 (상품명 등)
   */
  search?: string;
  /**
   * 정렬 기준 컬럼
   */
  sortBy?: AdminItemsControllerGetItemsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminItemsControllerGetItemsSortOrder;
};

export type AdminItemsControllerGetItemsSortBy =
  (typeof AdminItemsControllerGetItemsSortBy)[keyof typeof AdminItemsControllerGetItemsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerGetItemsSortBy = {
  name: "name",
  price: "price",
  updated_at: "updated_at",
  supplier_count: "supplier_count",
  code: "code",
} as const;

export type AdminItemsControllerGetItemsSortOrder =
  (typeof AdminItemsControllerGetItemsSortOrder)[keyof typeof AdminItemsControllerGetItemsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerGetItemsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminItemsControllerGetItems200AllOfData = {
  items: AdminCategoryItemDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerGetItems200AllOf = {
  data?: AdminItemsControllerGetItems200AllOfData;
};

export type AdminItemsControllerGetItems200 = BaseResponseDto &
  AdminItemsControllerGetItems200AllOf;

export type AdminItemsControllerFindRequestsParams = {
  limit?: number;
  offset?: number;
  status?: AdminItemsControllerFindRequestsStatus;
};

export type AdminItemsControllerFindRequestsStatus =
  (typeof AdminItemsControllerFindRequestsStatus)[keyof typeof AdminItemsControllerFindRequestsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminItemsControllerFindRequestsStatus = {
  pending: "pending",
  approved: "approved",
  rejected: "rejected",
} as const;

export type AdminItemsControllerFindRequests200AllOfData = {
  items: SupplierItemRequestSummaryDto[];
  meta: PaginationMetaDto;
};

export type AdminItemsControllerFindRequests200AllOf = {
  data?: AdminItemsControllerFindRequests200AllOfData;
};

export type AdminItemsControllerFindRequests200 = BaseResponseDto &
  AdminItemsControllerFindRequests200AllOf;

export type AdminItemsControllerFindRequestById200AllOf = {
  data?: SupplierItemRequestDetailResponseDto;
};

export type AdminItemsControllerFindRequestById200 = BaseResponseDto &
  AdminItemsControllerFindRequestById200AllOf;

export type AdminItemsControllerApproveRequest200AllOf = {
  data?: ApprovalResultResponseDto;
};

export type AdminItemsControllerApproveRequest200 = BaseResponseDto &
  AdminItemsControllerApproveRequest200AllOf;

export type AdminItemsControllerRejectRequest200AllOf = {
  data?: RejectionResultResponseDto;
};

export type AdminItemsControllerRejectRequest200 = BaseResponseDto &
  AdminItemsControllerRejectRequest200AllOf;

export type AdminItemsControllerUpdateProduct200AllOf = {
  data?: UpdateProductResponseDto;
};

export type AdminItemsControllerUpdateProduct200 = BaseResponseDto &
  AdminItemsControllerUpdateProduct200AllOf;

export type AdminItemsControllerFindProductById200AllOf = {
  data?: GetProductResponseDto;
};

export type AdminItemsControllerFindProductById200 = BaseResponseDto &
  AdminItemsControllerFindProductById200AllOf;

export type AdminItemsControllerDeleteProduct200AllOf = {
  data?: DeleteProductResponseDto;
};

export type AdminItemsControllerDeleteProduct200 = BaseResponseDto &
  AdminItemsControllerDeleteProduct200AllOf;

export type AdminItemsControllerGetVendorStats200AllOf = {
  data?: VendorStatsResponseDto[];
};

export type AdminItemsControllerGetVendorStats200 = BaseResponseDto &
  AdminItemsControllerGetVendorStats200AllOf;

export type AdminItemsControllerSyncSupplierCounts200AllOf = {
  data?: DeleteProductResponseDto;
};

export type AdminItemsControllerSyncSupplierCounts200 = BaseResponseDto &
  AdminItemsControllerSyncSupplierCounts200AllOf;

export type AdminItemsControllerGetSyncSupplierCountsStatus200AllOf = {
  data?: DuplicateRecalculationStatusDto;
};

export type AdminItemsControllerGetSyncSupplierCountsStatus200 =
  BaseResponseDto & AdminItemsControllerGetSyncSupplierCountsStatus200AllOf;

export type AdminItemsControllerSyncMsdsCatalog202AllOf = {
  data?: MsdsCatalogSyncStartedDto;
};

export type AdminItemsControllerSyncMsdsCatalog202 = BaseResponseDto &
  AdminItemsControllerSyncMsdsCatalog202AllOf;

export type AdminItemsControllerGetMsdsCatalogStatus200AllOf = {
  data?: MsdsCatalogStatusDto;
};

export type AdminItemsControllerGetMsdsCatalogStatus200 = BaseResponseDto &
  AdminItemsControllerGetMsdsCatalogStatus200AllOf;

export type AdminAuthControllerAdminSignup201AllOf = {
  data?: AdminSignupResponseDto;
};

export type AdminAuthControllerAdminSignup201 = BaseResponseDto &
  AdminAuthControllerAdminSignup201AllOf;

export type AdminAuthControllerAdminLogin200AllOf = {
  data?: AdminLoginResponseDto;
};

export type AdminAuthControllerAdminLogin200 = BaseResponseDto &
  AdminAuthControllerAdminLogin200AllOf;

export type AdminPriceBandControllerGetPriceBandsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminPriceBandControllerGetPriceBandsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 신뢰등급 필터 (미지정 시 A/B/C 전체)
   */
  grade?: AdminPriceBandControllerGetPriceBandsGrade;
};

export type AdminPriceBandControllerGetPriceBandsSortOrder =
  (typeof AdminPriceBandControllerGetPriceBandsSortOrder)[keyof typeof AdminPriceBandControllerGetPriceBandsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPriceBandControllerGetPriceBandsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminPriceBandControllerGetPriceBandsGrade =
  (typeof AdminPriceBandControllerGetPriceBandsGrade)[keyof typeof AdminPriceBandControllerGetPriceBandsGrade];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminPriceBandControllerGetPriceBandsGrade = {
  A: "A",
  B: "B",
  C: "C",
} as const;

export type AdminPriceBandControllerGetPriceBands200AllOfData = {
  items: PriceBandListItemDto[];
  meta: PaginationMetaDto;
};

export type AdminPriceBandControllerGetPriceBands200AllOf = {
  data?: AdminPriceBandControllerGetPriceBands200AllOfData;
};

export type AdminPriceBandControllerGetPriceBands200 = BaseResponseDto &
  AdminPriceBandControllerGetPriceBands200AllOf;

export type AdminPriceBandControllerGetPriceBandDetail200AllOf = {
  data?: PriceBandDetailDto;
};

export type AdminPriceBandControllerGetPriceBandDetail200 = BaseResponseDto &
  AdminPriceBandControllerGetPriceBandDetail200AllOf;

export type AdminProjectsControllerGetProjectsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminProjectsControllerGetProjectsSortOrder;
  /**
   * 검색어. 공고명·설명뿐 아니라 목록에 보이는 값으로도 찾을 수 있어야 한다 — 견적번호(`request_number`), 발주기관명(`buyers.organization_name`·`users.name`), 공급기업명(`suppliers.company_name`, 채팅방으로 이어진 공고)을 함께 훑는다. 회사 이름은 다른 표에 있어 먼저 id 를 모아 온 뒤 거르며, 한 번에 모으는 양에 상한이 있다(초과 시 서버 로그에 경고).
   */
  search?: string;
  /**
 * 상태 필터.

- `IN_PROGRESS` — 진행중
- `CLOSED` — 마감 전부. DB 의 `ON_HOLD`(마감일 경과로 스케줄러가 내린 값)와 `CLOSED`(사람이 누른 값)를 함께 뜻한다.
- `DEADLINE_PASSED` — 마감 «안쪽» 중 아무도 누르지 않은 것만(`ON_HOLD`)
- `CLOSED_BY_BUYER` — 발주기관이 직접 [마감하기] 를 누른 것만
- `CLOSED_BY_ADMIN` — 관리자가 대신 마감한 것만

뒤 세 값은 마감 한 칸을 **주체**로 다시 가른다 — 시간이 지나 저절로 내려간 건, 발주기관이 스스로 끝낸 건, 관리자가 대신 끝낸 건은 이후에 할 일이 서로 다르다. 계약까지 갔는지는 이 필터가 아니라 응답의 `status`(계약 파생값)로 가른다 — 마감 목록을 열어 그 안에서 계약 여부를 훑는 게 이 화면을 쓰는 방식이라, 계약 건을 필터에서 빼면 찾던 것이 목록에서 사라진다. (`ON_HOLD` 로 들어와도 마감 전부로 받아준다)
 */
  status?: AdminProjectsControllerGetProjectsStatus;
  /**
   * "삭제됨" 탭. true 면 삭제된 프로젝트만, 기본값(false)이면 살아있는 것만 조회한다.
   */
  deleted?: boolean;
  /**
   * 자동견적 진행 상태 필터(`quote_requests.auto_quote_status`). 쉼표로 여러 값을 줄 수 있다. `none,failed` 가 실제로 쓰이는 조합이다 — 발송이 안 나갔거나 실패한 공고는 사람이 보지 않으면 드러나지 않는다.
   */
  autoQuote?: string;
  /**
   * 매칭이 남은 공고만. 파생 컬럼 `unmatched_item_count > 0` 으로 거른다 — 페이지를 받아 온 뒤 거르면 총 건수와 페이지 수가 어긋난다.
   */
  unmatched?: boolean;
  /**
   * 마감 48시간 이내인데 견적이 0건인 진행중 공고만. 자동견적이 닿지 않았거나 매칭이 비어 있는 건이 대부분 여기 걸린다.
   */
  stalled?: boolean;
  /**
   * 가입 경로 필터(`users.source`). 씨마켓 연동 건과 세모 직가입 건을 가른다.
   */
  source?: AdminProjectsControllerGetProjectsSource;
};

export type AdminProjectsControllerGetProjectsSortOrder =
  (typeof AdminProjectsControllerGetProjectsSortOrder)[keyof typeof AdminProjectsControllerGetProjectsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectsControllerGetProjectsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminProjectsControllerGetProjectsStatus =
  (typeof AdminProjectsControllerGetProjectsStatus)[keyof typeof AdminProjectsControllerGetProjectsStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectsControllerGetProjectsStatus = {
  IN_PROGRESS: "IN_PROGRESS",
  CLOSED: "CLOSED",
  DEADLINE_PASSED: "DEADLINE_PASSED",
  CLOSED_BY_BUYER: "CLOSED_BY_BUYER",
  CLOSED_BY_ADMIN: "CLOSED_BY_ADMIN",
} as const;

export type AdminProjectsControllerGetProjectsSource =
  (typeof AdminProjectsControllerGetProjectsSource)[keyof typeof AdminProjectsControllerGetProjectsSource];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminProjectsControllerGetProjectsSource = {
  direct: "direct",
  cmarket: "cmarket",
} as const;

export type AdminProjectsControllerGetProjects200AllOfData = {
  items: AdminProjectDto[];
  meta: PaginationMetaDto;
};

export type AdminProjectsControllerGetProjects200AllOf = {
  data?: AdminProjectsControllerGetProjects200AllOfData;
};

export type AdminProjectsControllerGetProjects200 = BaseResponseDto &
  AdminProjectsControllerGetProjects200AllOf;

export type AdminProjectsControllerGetProjectDetail200AllOf = {
  data?: AdminProjectDetailResponseDto;
};

export type AdminProjectsControllerGetProjectDetail200 = BaseResponseDto &
  AdminProjectsControllerGetProjectDetail200AllOf;

export type AdminProjectsControllerDeleteProject200AllOfData = {
  [key: string]: unknown;
};

export type AdminProjectsControllerDeleteProject200AllOf = {
  data?: AdminProjectsControllerDeleteProject200AllOfData;
};

export type AdminProjectsControllerDeleteProject200 = BaseResponseDto &
  AdminProjectsControllerDeleteProject200AllOf;

export type AdminProjectsControllerMatchItem200AllOf = {
  data?: AdminMatchItemResponseDto;
};

export type AdminProjectsControllerMatchItem200 = BaseResponseDto &
  AdminProjectsControllerMatchItem200AllOf;

export type AdminProjectsControllerRegisterAndMatchItem200AllOf = {
  data?: AdminRegisterAndMatchItemResponseDto;
};

export type AdminProjectsControllerRegisterAndMatchItem200 = BaseResponseDto &
  AdminProjectsControllerRegisterAndMatchItem200AllOf;

export type AdminProjectsControllerGetQuotedPrices200AllOf = {
  data?: AdminQuotedPriceLineDto[];
};

export type AdminProjectsControllerGetQuotedPrices200 = BaseResponseDto &
  AdminProjectsControllerGetQuotedPrices200AllOf;

export type AdminProjectsControllerLinkQuotedPrice200AllOf = {
  data?: AdminLinkQuotedPriceResponseDto;
};

export type AdminProjectsControllerLinkQuotedPrice200 = BaseResponseDto &
  AdminProjectsControllerLinkQuotedPrice200AllOf;

export type AdminProjectsControllerExtendDeadline200AllOf = {
  data?: AdminExtendDeadlineResponseDto;
};

export type AdminProjectsControllerExtendDeadline200 = BaseResponseDto &
  AdminProjectsControllerExtendDeadline200AllOf;

export type AdminProjectsControllerCloseProject200AllOf = {
  data?: AdminCloseProjectResponseDto;
};

export type AdminProjectsControllerCloseProject200 = BaseResponseDto &
  AdminProjectsControllerCloseProject200AllOf;

export type AdminProjectsControllerSubmitAgencyQuote201AllOf = {
  data?: AdminAgencyQuoteSubmissionResponseDto;
};

export type AdminProjectsControllerSubmitAgencyQuote201 = BaseResponseDto &
  AdminProjectsControllerSubmitAgencyQuote201AllOf;

export type AdminProjectsControllerSetTransactionModel200AllOf = {
  data?: AdminTransactionModelResponseDto;
};

export type AdminProjectsControllerSetTransactionModel200 = BaseResponseDto &
  AdminProjectsControllerSetTransactionModel200AllOf;

export type AdminProjectsControllerTriggerAutoQuotes200AllOf = {
  data?: AdminTriggerAutoQuotesResponseDto;
};

export type AdminProjectsControllerTriggerAutoQuotes200 = BaseResponseDto &
  AdminProjectsControllerTriggerAutoQuotes200AllOf;

export type AdminProjectsControllerGetSimilarSuppliers200AllOf = {
  data?: AdminSimilarSuppliersResponseDto;
};

export type AdminProjectsControllerGetSimilarSuppliers200 = BaseResponseDto &
  AdminProjectsControllerGetSimilarSuppliers200AllOf;

export type AdminProjectsControllerNotifySimilarSuppliers200AllOf = {
  data?: AdminNotifySimilarSuppliersResultDto;
};

export type AdminProjectsControllerNotifySimilarSuppliers200 = BaseResponseDto &
  AdminProjectsControllerNotifySimilarSuppliers200AllOf;

export type AdminProjectsControllerGetProjectNotes200AllOf = {
  data?: AdminProjectNoteListResponseDto;
};

export type AdminProjectsControllerGetProjectNotes200 = BaseResponseDto &
  AdminProjectsControllerGetProjectNotes200AllOf;

export type AdminProjectsControllerCreateProjectNote200AllOf = {
  data?: AdminProjectNoteResponseDto;
};

export type AdminProjectsControllerCreateProjectNote200 = BaseResponseDto &
  AdminProjectsControllerCreateProjectNote200AllOf;

export type AdminProjectsControllerDeleteProjectNote200AllOfData = {
  [key: string]: unknown;
};

export type AdminProjectsControllerDeleteProjectNote200AllOf = {
  data?: AdminProjectsControllerDeleteProjectNote200AllOfData;
};

export type AdminProjectsControllerDeleteProjectNote200 = BaseResponseDto &
  AdminProjectsControllerDeleteProjectNote200AllOf;

export type AdminProjectsControllerHideParticipation200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type AdminProjectsControllerHideParticipation200 = BaseResponseDto &
  AdminProjectsControllerHideParticipation200AllOf;

export type AdminProjectsControllerUnhideParticipation200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type AdminProjectsControllerUnhideParticipation200 = BaseResponseDto &
  AdminProjectsControllerUnhideParticipation200AllOf;

export type AdminProjectsControllerDeleteParticipation200AllOf = {
  data?: AdminParticipationDeletionResponseDto;
};

export type AdminProjectsControllerDeleteParticipation200 = BaseResponseDto &
  AdminProjectsControllerDeleteParticipation200AllOf;

export type AdminProjectsControllerRestoreProject200AllOfData = {
  [key: string]: unknown;
};

export type AdminProjectsControllerRestoreProject200AllOf = {
  data?: AdminProjectsControllerRestoreProject200AllOfData;
};

export type AdminProjectsControllerRestoreProject200 = BaseResponseDto &
  AdminProjectsControllerRestoreProject200AllOf;

export type AdminSettlementControllerExportHometaxParams = {
  status?: string;
  paymentMethod?: string;
  startDate?: string;
  endDate?: string;
  searchTerm?: string;
};

export type AdminSettlementControllerGetSettlementsParams = {
  status?: string;
  paymentMethod?: string;
  searchTerm?: string;
  limit?: number;
  page?: number;
};

export type AdminSettlementControllerGetSettlements200AllOfData = {
  items: AdminSettlementResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminSettlementControllerGetSettlements200AllOf = {
  data?: AdminSettlementControllerGetSettlements200AllOfData;
};

export type AdminSettlementControllerGetSettlements200 = BaseResponseDto &
  AdminSettlementControllerGetSettlements200AllOf;

export type AdminSettlementControllerGetStatsParams = {
  status?: string;
  searchTerm?: string;
  startDate?: string;
  endDate?: string;
};

export type AdminSettlementControllerGetStats200AllOf = {
  data?: SettlementStatsResponseDto;
};

export type AdminSettlementControllerGetStats200 = BaseResponseDto &
  AdminSettlementControllerGetStats200AllOf;

export type AdminSettlementControllerGetMonthlyBillingParams = {
  month: string;
  includeIssued?: boolean;
  searchTerm?: string;
  supplierId?: string;
};

export type AdminSettlementControllerGetMonthlyBilling200AllOf = {
  data?: MonthlyBillingResponseDto;
};

export type AdminSettlementControllerGetMonthlyBilling200 = BaseResponseDto &
  AdminSettlementControllerGetMonthlyBilling200AllOf;

export type AdminSettlementControllerExportMonthlyTaxInvoicesParams = {
  month: string;
  includeIssued?: boolean;
  searchTerm?: string;
  /**
   * 쉼표로 구분한 공급기업 ID. 비우면 조회된 전체.
   */
  supplierIds?: string;
};

export type AdminSettlementControllerGetSettlement200AllOf = {
  data?: AdminSettlementResponseDto;
};

export type AdminSettlementControllerGetSettlement200 = BaseResponseDto &
  AdminSettlementControllerGetSettlement200AllOf;

export type AdminContractControllerRecreateDocumentRequestMessage200AllOfData =
  { [key: string]: unknown };

export type AdminContractControllerRecreateDocumentRequestMessage200AllOf = {
  data?: AdminContractControllerRecreateDocumentRequestMessage200AllOfData;
};

export type AdminContractControllerRecreateDocumentRequestMessage200 =
  BaseResponseDto &
    AdminContractControllerRecreateDocumentRequestMessage200AllOf;

export type AdminContractControllerGetContractsParams = {
  /**
   * 계약 상태 (IN_PROGRESS, COMPLETED, CANCELED 등)
   */
  status?: string;
  /**
   * 계약번호 검색
   */
  searchTerm?: string;
  limit?: number;
  offset?: number;
};

export type AdminContractControllerGetContracts200AllOfData = {
  items: AdminContractResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminContractControllerGetContracts200AllOf = {
  data?: AdminContractControllerGetContracts200AllOfData;
};

export type AdminContractControllerGetContracts200 = BaseResponseDto &
  AdminContractControllerGetContracts200AllOf;

export type AdminContractControllerGetContract200AllOf = {
  data?: AdminContractResponseDto;
};

export type AdminContractControllerGetContract200 = BaseResponseDto &
  AdminContractControllerGetContract200AllOf;

export type AdminContractControllerRegeneratePdf200AllOf = {
  data?: RegenerateContractPdfResponseDto;
};

export type AdminContractControllerRegeneratePdf200 = BaseResponseDto &
  AdminContractControllerRegeneratePdf200AllOf;

export type AdminFeePolicyControllerGetPolicy200AllOf = {
  data?: PlatformFeePolicyResponseDto;
};

export type AdminFeePolicyControllerGetPolicy200 = BaseResponseDto &
  AdminFeePolicyControllerGetPolicy200AllOf;

export type AdminFeePolicyControllerUpdatePolicy200AllOf = {
  data?: PlatformFeePolicyResponseDto;
};

export type AdminFeePolicyControllerUpdatePolicy200 = BaseResponseDto &
  AdminFeePolicyControllerUpdatePolicy200AllOf;

export type AdminTermsControllerCreateTerms201AllOf = {
  data?: AdminTermsResponseDto;
};

export type AdminTermsControllerCreateTerms201 = BaseResponseDto &
  AdminTermsControllerCreateTerms201AllOf;

export type AdminTermsControllerGetAllTerms200AllOf = {
  data?: AdminTermsResponseDto[];
};

export type AdminTermsControllerGetAllTerms200 = BaseResponseDto &
  AdminTermsControllerGetAllTerms200AllOf;

export type AdminTermsControllerGetTermsById200AllOf = {
  data?: AdminTermsResponseDto;
};

export type AdminTermsControllerGetTermsById200 = BaseResponseDto &
  AdminTermsControllerGetTermsById200AllOf;

export type AdminTermsControllerUpdateTerms200AllOf = {
  data?: AdminTermsResponseDto;
};

export type AdminTermsControllerUpdateTerms200 = BaseResponseDto &
  AdminTermsControllerUpdateTerms200AllOf;

export type AdminPromotionControllerCreate201AllOf = {
  data?: PromotionCodeDto;
};

export type AdminPromotionControllerCreate201 = BaseResponseDto &
  AdminPromotionControllerCreate201AllOf;

export type AdminPromotionControllerFindAllParams = {
  offset?: number;
  limit?: number;
};

export type AdminPromotionControllerFindAll200AllOfData = {
  items: PromotionCodeDto[];
  meta: PaginationMetaDto;
};

export type AdminPromotionControllerFindAll200AllOf = {
  data?: AdminPromotionControllerFindAll200AllOfData;
};

export type AdminPromotionControllerFindAll200 = BaseResponseDto &
  AdminPromotionControllerFindAll200AllOf;

export type AdminPromotionControllerFindOne200AllOf = {
  data?: PromotionCodeDto;
};

export type AdminPromotionControllerFindOne200 = BaseResponseDto &
  AdminPromotionControllerFindOne200AllOf;

export type AdminPromotionControllerUpdate200AllOf = {
  data?: PromotionCodeDto;
};

export type AdminPromotionControllerUpdate200 = BaseResponseDto &
  AdminPromotionControllerUpdate200AllOf;

export type AdminPromotionControllerGetRedemptionHistoryParams = {
  offset?: number;
  limit?: number;
};

export type AdminPromotionControllerGetRedemptionHistory200AllOfData = {
  items: PromotionRedemptionDto[];
  meta: PaginationMetaDto;
};

export type AdminPromotionControllerGetRedemptionHistory200AllOf = {
  data?: AdminPromotionControllerGetRedemptionHistory200AllOfData;
};

export type AdminPromotionControllerGetRedemptionHistory200 = BaseResponseDto &
  AdminPromotionControllerGetRedemptionHistory200AllOf;

export type AdminAgencyPartyControllerGet200AllOf = {
  data?: AdminAgencyPartyDto;
};

export type AdminAgencyPartyControllerGet200 = BaseResponseDto &
  AdminAgencyPartyControllerGet200AllOf;

export type AdminAgencyPartyControllerSet200AllOf = {
  data?: AdminAgencyPartyDto;
};

export type AdminAgencyPartyControllerSet200 = BaseResponseDto &
  AdminAgencyPartyControllerSet200AllOf;

export type AdminAgencyPartyControllerClear200AllOf = {
  data?: AdminAgencyPartyDto;
};

export type AdminAgencyPartyControllerClear200 = BaseResponseDto &
  AdminAgencyPartyControllerClear200AllOf;

export type AdminAgencyPayoutsControllerListParams = {
  /**
   * 지급 상태
   */
  status?: AdminAgencyPayoutsControllerListStatus;
  /**
   * 공급기업 id (users.id)
   */
  supplierId?: string;
  page?: number;
  limit?: number;
};

export type AdminAgencyPayoutsControllerListStatus =
  (typeof AdminAgencyPayoutsControllerListStatus)[keyof typeof AdminAgencyPayoutsControllerListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminAgencyPayoutsControllerListStatus = {
  scheduled: "scheduled",
  on_hold: "on_hold",
  paid: "paid",
  failed: "failed",
  canceled: "canceled",
} as const;

export type AdminAgencyPayoutsControllerList200AllOfData = {
  items: AdminPayoutDto[];
  meta: PaginationMetaDto;
};

export type AdminAgencyPayoutsControllerList200AllOf = {
  data?: AdminAgencyPayoutsControllerList200AllOfData;
};

export type AdminAgencyPayoutsControllerList200 = BaseResponseDto &
  AdminAgencyPayoutsControllerList200AllOf;

export type AdminAgencyPayoutsControllerBalance200AllOf = {
  data?: AdminPayoutBalanceDto;
};

export type AdminAgencyPayoutsControllerBalance200 = BaseResponseDto &
  AdminAgencyPayoutsControllerBalance200AllOf;

export type AdminAgencyPayoutsControllerMarkPaid200AllOf = {
  data?: AdminPayoutDto;
};

export type AdminAgencyPayoutsControllerMarkPaid200 = BaseResponseDto &
  AdminAgencyPayoutsControllerMarkPaid200AllOf;

export type AdminAgencyPayoutsControllerHold200AllOf = {
  data?: AdminPayoutDto;
};

export type AdminAgencyPayoutsControllerHold200 = BaseResponseDto &
  AdminAgencyPayoutsControllerHold200AllOf;

export type StorageControllerUploadTemporaryFilesBody = {
  /**
   * 업로드할 파일 (최대 10개, 각 파일 최대 20MB)
   * @maxItems 10
   */
  files: Blob[];
};

export type StorageControllerUploadTemporaryFiles201AllOf = {
  data?: TemporaryFileUploadResponseDto;
};

export type StorageControllerUploadTemporaryFiles201 = BaseResponseDto &
  StorageControllerUploadTemporaryFiles201AllOf;

export type ExternalSuppliersControllerAuthenticateSupplier201AllOf = {
  data?: AuthSupplierResponseDto;
};

export type ExternalSuppliersControllerAuthenticateSupplier201 =
  BaseResponseDto & ExternalSuppliersControllerAuthenticateSupplier201AllOf;

export type ExternalSuppliersControllerGetSupplierMe200AllOf = {
  data?: SupplierInfoDto;
};

export type ExternalSuppliersControllerGetSupplierMe200 = BaseResponseDto &
  ExternalSuppliersControllerGetSupplierMe200AllOf;

export type ExternalBuyersControllerAuthenticateBuyer201AllOf = {
  data?: AuthBuyerResponseDto;
};

export type ExternalBuyersControllerAuthenticateBuyer201 = BaseResponseDto &
  ExternalBuyersControllerAuthenticateBuyer201AllOf;

export type ExternalEmbedControllerVerifyEmbedToken200AllOf = {
  data?: EmbedTokenVerifyResponseDto;
};

export type ExternalEmbedControllerVerifyEmbedToken200 = BaseResponseDto &
  ExternalEmbedControllerVerifyEmbedToken200AllOf;

export type ExternalEmbedControllerGenerateAlimTalkLinks201AllOf = {
  data?: GenerateAlimTalkLinksResponseDto;
};

export type ExternalEmbedControllerGenerateAlimTalkLinks201 = BaseResponseDto &
  ExternalEmbedControllerGenerateAlimTalkLinks201AllOf;

export type ExternalEmbedControllerGetEmbedUrl201AllOf = {
  data?: EmbedJoinResponseDto;
};

export type ExternalEmbedControllerGetEmbedUrl201 = BaseResponseDto &
  ExternalEmbedControllerGetEmbedUrl201AllOf;

export type ExternalCategoriesControllerGetCategoryTreeParams = {
  /**
   * 조회 모드
   */
  mode?: ExternalCategoriesControllerGetCategoryTreeMode;
};

export type ExternalCategoriesControllerGetCategoryTreeMode =
  (typeof ExternalCategoriesControllerGetCategoryTreeMode)[keyof typeof ExternalCategoriesControllerGetCategoryTreeMode];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalCategoriesControllerGetCategoryTreeMode = {
  all: "all",
  dealing: "dealing",
} as const;

export type ExternalCategoriesControllerGetCategoryTree200AllOf = {
  data?: CategoryTreeNodeDto[];
};

export type ExternalCategoriesControllerGetCategoryTree200 = BaseResponseDto &
  ExternalCategoriesControllerGetCategoryTree200AllOf;

export type ExternalItemsControllerGetItemsParams = {
  /**
   * 조회 개수 (기본 20)
   */
  limit?: number;
  /**
   * 페이지네이션 오프셋 (기본 0)
   */
  offset?: number;
  /**
   * 카테고리 ID
   */
  categoryId?: string;
  /**
   * 하위 카테고리 포함 여부 (기본 true)
   */
  includeDescendants?: boolean;
  /**
   * 내 상품만 보기 여부
   */
  onlyMyProducts?: boolean;
  /**
   * 내 상품의 판매 상태 필터 — onlyMyProducts=true 일 때만 적용. active=판매중(생략 시 기본, 종전 동작), inactive=판매중지, all=둘 다
   */
  sellingStatus?: ExternalItemsControllerGetItemsSellingStatus;
  /**
   * 내 취급 카테고리 상품만 보기 여부
   */
  onlyMyCategories?: boolean;
  /**
   * 검색어 (상품명, 브랜드, 코드 등)
   */
  search?: string;
  /**
   * 정렬 기준
   */
  sortBy?: ExternalItemsControllerGetItemsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalItemsControllerGetItemsSortOrder;
};

export type ExternalItemsControllerGetItemsSellingStatus =
  (typeof ExternalItemsControllerGetItemsSellingStatus)[keyof typeof ExternalItemsControllerGetItemsSellingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetItemsSellingStatus = {
  active: "active",
  inactive: "inactive",
  all: "all",
} as const;

export type ExternalItemsControllerGetItemsSortBy =
  (typeof ExternalItemsControllerGetItemsSortBy)[keyof typeof ExternalItemsControllerGetItemsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetItemsSortBy = {
  name: "name",
  price: "price",
  updated_at: "updated_at",
  supplier_count: "supplier_count",
} as const;

export type ExternalItemsControllerGetItemsSortOrder =
  (typeof ExternalItemsControllerGetItemsSortOrder)[keyof typeof ExternalItemsControllerGetItemsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetItemsSortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type ExternalItemsControllerGetItems200AllOfData = {
  items: SupplierCategoryItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalItemsControllerGetItems200AllOf = {
  data?: ExternalItemsControllerGetItems200AllOfData;
};

export type ExternalItemsControllerGetItems200 = BaseResponseDto &
  ExternalItemsControllerGetItems200AllOf;

export type ExternalItemsControllerUpdateSettings200AllOf = {
  data?: SupplierPriceResponseDto;
};

export type ExternalItemsControllerUpdateSettings200 = BaseResponseDto &
  ExternalItemsControllerUpdateSettings200AllOf;

export type ExternalItemsControllerCreateRequest201AllOf = {
  data?: SupplierItemRequestResponseDto;
};

export type ExternalItemsControllerCreateRequest201 = BaseResponseDto &
  ExternalItemsControllerCreateRequest201AllOf;

export type ExternalItemsControllerGetMyRequestsParams = {
  /**
   * 조회 개수 (기본 20)
   */
  limit?: number;
  /**
   * 페이지네이션 오프셋 (기본 0)
   */
  offset?: number;
  /**
   * 카테고리 ID
   */
  categoryId?: string;
  /**
   * 하위 카테고리 포함 여부 (기본 true)
   */
  includeDescendants?: boolean;
  /**
   * 내 상품만 보기 여부
   */
  onlyMyProducts?: boolean;
  /**
   * 내 상품의 판매 상태 필터 — onlyMyProducts=true 일 때만 적용. active=판매중(생략 시 기본, 종전 동작), inactive=판매중지, all=둘 다
   */
  sellingStatus?: ExternalItemsControllerGetMyRequestsSellingStatus;
  /**
   * 내 취급 카테고리 상품만 보기 여부
   */
  onlyMyCategories?: boolean;
  /**
   * 검색어 (상품명, 브랜드, 코드 등)
   */
  search?: string;
  /**
   * 정렬 기준
   */
  sortBy?: ExternalItemsControllerGetMyRequestsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalItemsControllerGetMyRequestsSortOrder;
};

export type ExternalItemsControllerGetMyRequestsSellingStatus =
  (typeof ExternalItemsControllerGetMyRequestsSellingStatus)[keyof typeof ExternalItemsControllerGetMyRequestsSellingStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyRequestsSellingStatus = {
  active: "active",
  inactive: "inactive",
  all: "all",
} as const;

export type ExternalItemsControllerGetMyRequestsSortBy =
  (typeof ExternalItemsControllerGetMyRequestsSortBy)[keyof typeof ExternalItemsControllerGetMyRequestsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyRequestsSortBy = {
  name: "name",
  price: "price",
  updated_at: "updated_at",
  supplier_count: "supplier_count",
} as const;

export type ExternalItemsControllerGetMyRequestsSortOrder =
  (typeof ExternalItemsControllerGetMyRequestsSortOrder)[keyof typeof ExternalItemsControllerGetMyRequestsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemsControllerGetMyRequestsSortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type ExternalItemsControllerGetMyRequests200AllOfData = {
  items: SupplierItemRequestResponseDto[];
  meta: PaginationMetaDto;
};

export type ExternalItemsControllerGetMyRequests200AllOf = {
  data?: ExternalItemsControllerGetMyRequests200AllOfData;
};

export type ExternalItemsControllerGetMyRequests200 = BaseResponseDto &
  ExternalItemsControllerGetMyRequests200AllOf;

export type ExternalItemSearchControllerSearchParams = {
  /**
   * 검색어 (최소 2글자)
   * @minLength 2
   */
  q: string;
  /**
   * 결과 개수 (기본: 10, 최대: 50)
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
  /**
   * 결과 오프셋 (기본: 0). limit 상한(50) 너머로 페이징할 때 사용 — offset=50 이면 51번째부터 반환한다. 응답은 그대로 배열이며, 반환 건수가 limit 과 같으면 다음 페이지가 있을 수 있다.
   * @minimum 0
   */
  offset?: number;
  /**
   * 공급사 ID (선택사항 - 공급사별 단가 조회 시 필요)
   */
  supplierId?: string;
  /**
   * 카테고리 ID 필터 (선택사항). 지정 시 해당 카테고리 품목만 검색한다. 쉼표 구분 또는 반복 쿼리 파라미터(categoryIds=a&categoryIds=b) 모두 허용.
   */
  categoryIds?: string[];
  /**
   * 정렬 기준
   */
  sortBy?: ItemV2SortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalItemSearchControllerSearchSortOrder;
  /**
   * 카탈로그 epoch 필터. legacy=2026-05-19 이전 등록 품목, v2=이후 등록 품목. 미지정 시 전체.
   */
  catalogEpoch?: ItemV2CatalogEpoch;
};

export type ExternalItemSearchControllerSearchSortOrder =
  (typeof ExternalItemSearchControllerSearchSortOrder)[keyof typeof ExternalItemSearchControllerSearchSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalItemSearchControllerSearchSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalItemSearchControllerSearch200AllOf = {
  data?: ItemV2AutocompleteResponseDto[];
};

export type ExternalItemSearchControllerSearch200 = BaseResponseDto &
  ExternalItemSearchControllerSearch200AllOf;

export type ExternalStorefrontControllerGetItemsParams = {
  /**
   * 상품명·제조사 검색
   */
  q?: string;
  /**
   * 소분류(말단) 한정
   */
  categoryId?: string;
  /**
   * 대분류 한정. 쇼핑몰의 대분류 탭이 이 값으로 서버 조회를 한 번 한다
   */
  rootCategoryId?: string;
  /**
   * 기본은 카테고리→품명. 목록을 잘라 받을 때 정렬은 서버 몫이다
   */
  sort?: ExternalStorefrontControllerGetItemsSort;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalStorefrontControllerGetItemsSort =
  (typeof ExternalStorefrontControllerGetItemsSort)[keyof typeof ExternalStorefrontControllerGetItemsSort];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalStorefrontControllerGetItemsSort = {
  recommended: "recommended",
  price_asc: "price_asc",
  price_desc: "price_desc",
  name: "name",
} as const;

export type ExternalStorefrontControllerGetItems200AllOf = {
  data?: StorefrontItemListResponseDto;
};

export type ExternalStorefrontControllerGetItems200 = BaseResponseDto &
  ExternalStorefrontControllerGetItems200AllOf;

export type ExternalStorefrontControllerGetCategories200AllOf = {
  data?: StorefrontCategoryListResponseDto;
};

export type ExternalStorefrontControllerGetCategories200 = BaseResponseDto &
  ExternalStorefrontControllerGetCategories200AllOf;

export type ExternalStorefrontControllerGetItem200AllOf = {
  data?: StorefrontItemResponseDto;
};

export type ExternalStorefrontControllerGetItem200 = BaseResponseDto &
  ExternalStorefrontControllerGetItem200AllOf;

export type ExternalStorefrontControllerGetItemOffers200AllOf = {
  data?: StorefrontOfferListResponseDto;
};

export type ExternalStorefrontControllerGetItemOffers200 = BaseResponseDto &
  ExternalStorefrontControllerGetItemOffers200AllOf;

export type ExternalStorefrontOrdersControllerGetPointBalance200AllOf = {
  data?: StorefrontPointBalanceDto;
};

export type ExternalStorefrontOrdersControllerGetPointBalance200 =
  BaseResponseDto & ExternalStorefrontOrdersControllerGetPointBalance200AllOf;

export type ExternalStorefrontOrdersControllerCreateOrder201AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerCreateOrder201 = BaseResponseDto &
  ExternalStorefrontOrdersControllerCreateOrder201AllOf;

export type ExternalStorefrontOrdersControllerListOrdersParams = {
  employeeNo?: string;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalStorefrontOrdersControllerListOrders200AllOf = {
  data?: StorefrontOrderListDto;
};

export type ExternalStorefrontOrdersControllerListOrders200 = BaseResponseDto &
  ExternalStorefrontOrdersControllerListOrders200AllOf;

export type ExternalStorefrontOrdersControllerGetOrder200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerGetOrder200 = BaseResponseDto &
  ExternalStorefrontOrdersControllerGetOrder200AllOf;

export type ExternalStorefrontOrdersControllerApplyRequisition200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerApplyRequisition200 =
  BaseResponseDto & ExternalStorefrontOrdersControllerApplyRequisition200AllOf;

export type ExternalStorefrontOrdersControllerGetInspection200AllOf = {
  data?: InspectionDto;
};

export type ExternalStorefrontOrdersControllerGetInspection200 =
  BaseResponseDto & ExternalStorefrontOrdersControllerGetInspection200AllOf;

export type ExternalStorefrontOrdersControllerCompleteInspection200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerCompleteInspection200 =
  BaseResponseDto &
    ExternalStorefrontOrdersControllerCompleteInspection200AllOf;

export type ExternalStorefrontOrdersControllerCancelOrder200AllOf = {
  data?: StorefrontOrderDto;
};

export type ExternalStorefrontOrdersControllerCancelOrder200 = BaseResponseDto &
  ExternalStorefrontOrdersControllerCancelOrder200AllOf;

export type ExternalSupplierShipmentsControllerListCouriers200AllOf = {
  data?: CourierDto[];
};

export type ExternalSupplierShipmentsControllerListCouriers200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerListCouriers200AllOf;

export type ExternalSupplierShipmentsControllerListMyTargets200AllOf = {
  data?: SupplierShipmentTargetDto[];
};

export type ExternalSupplierShipmentsControllerListMyTargets200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerListMyTargets200AllOf;

export type ExternalSupplierShipmentsControllerList200AllOf = {
  data?: ShipmentDto[];
};

export type ExternalSupplierShipmentsControllerList200 = BaseResponseDto &
  ExternalSupplierShipmentsControllerList200AllOf;

export type ExternalSupplierShipmentsControllerRegister201AllOf = {
  data?: ShipmentDto;
};

export type ExternalSupplierShipmentsControllerRegister201 = BaseResponseDto &
  ExternalSupplierShipmentsControllerRegister201AllOf;

export type ExternalSupplierShipmentsControllerFindMallOrder200AllOf = {
  data?: QuoteRequestMallOrderDto;
};

export type ExternalSupplierShipmentsControllerFindMallOrder200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerFindMallOrder200AllOf;

export type ExternalSupplierShipmentsControllerUpdateStatus200AllOf = {
  data?: ShipmentDto;
};

export type ExternalSupplierShipmentsControllerUpdateStatus200 =
  BaseResponseDto & ExternalSupplierShipmentsControllerUpdateStatus200AllOf;

export type ExternalSupplierStorefrontsControllerListMine200AllOf = {
  data?: MyStorefrontDto[];
};

export type ExternalSupplierStorefrontsControllerListMine200 = BaseResponseDto &
  ExternalSupplierStorefrontsControllerListMine200AllOf;

export type ExternalSupplierStorefrontsControllerListMyPricesParams = {
  /**
   * 쉼표로 구분한 품목 UUID 목록
   */
  itemIds: string;
};

export type ExternalSupplierStorefrontsControllerListMyPrices200AllOf = {
  data?: MyStorefrontPriceDto[];
};

export type ExternalSupplierStorefrontsControllerListMyPrices200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerListMyPrices200AllOf;

export type ExternalSupplierStorefrontsControllerSetPrice200AllOf = {
  data?: SetStorefrontPriceResultDto;
};

export type ExternalSupplierStorefrontsControllerSetPrice200 = BaseResponseDto &
  ExternalSupplierStorefrontsControllerSetPrice200AllOf;

export type ExternalSupplierStorefrontsControllerListMyOfferingsParams = {
  state?: ExternalSupplierStorefrontsControllerListMyOfferingsState;
  q?: string;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalSupplierStorefrontsControllerListMyOfferingsState =
  (typeof ExternalSupplierStorefrontsControllerListMyOfferingsState)[keyof typeof ExternalSupplierStorefrontsControllerListMyOfferingsState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalSupplierStorefrontsControllerListMyOfferingsState = {
  all: "all",
  listed: "listed",
  unpriced: "unpriced",
  inactive: "inactive",
} as const;

export type ExternalSupplierStorefrontsControllerListMyOfferings200AllOf = {
  data?: MyStorefrontOfferingListDto;
};

export type ExternalSupplierStorefrontsControllerListMyOfferings200 =
  BaseResponseDto &
    ExternalSupplierStorefrontsControllerListMyOfferings200AllOf;

export type ExternalSupplierStorefrontsControllerBulkSetPrices200AllOf = {
  data?: BulkPriceResultDto;
};

export type ExternalSupplierStorefrontsControllerBulkSetPrices200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerBulkSetPrices200AllOf;

export type ExternalSupplierStorefrontsControllerBulkSetActive200AllOf = {
  data?: BulkActiveResultDto;
};

export type ExternalSupplierStorefrontsControllerBulkSetActive200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerBulkSetActive200AllOf;

export type ExternalSupplierStorefrontsControllerRequestOffering201AllOf = {
  data?: CreateOfferingRequestResultDto;
};

export type ExternalSupplierStorefrontsControllerRequestOffering201 =
  BaseResponseDto &
    ExternalSupplierStorefrontsControllerRequestOffering201AllOf;

export type ExternalSupplierStorefrontsControllerListMyRequestsParams = {
  status?: string;
  offset?: unknown;
  limit?: unknown;
};

export type ExternalSupplierStorefrontsControllerListMyRequests200AllOf = {
  data?: RequestListResponseDto;
};

export type ExternalSupplierStorefrontsControllerListMyRequests200 =
  BaseResponseDto & ExternalSupplierStorefrontsControllerListMyRequests200AllOf;

export type ExternalFilesControllerUploadTemporaryFilesBody = {
  /**
   * 업로드할 파일 (최대 10개, 각 파일 최대 20MB)
   * @maxItems 10
   */
  files: Blob[];
};

export type ExternalFilesControllerUploadTemporaryFiles201AllOf = {
  data?: TemporaryFileUploadResponseDto;
};

export type ExternalFilesControllerUploadTemporaryFiles201 = BaseResponseDto &
  ExternalFilesControllerUploadTemporaryFiles201AllOf;

export type ExternalQuoteRequestsControllerCreateWithAddress201AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerCreateWithAddress201 =
  BaseResponseDto & ExternalQuoteRequestsControllerCreateWithAddress201AllOf;

export type ExternalQuoteRequestsControllerFindAllParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalQuoteRequestsControllerFindAllSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 견적 요청 상태 필터
   */
  status?: ExternalQuoteRequestsControllerFindAllStatusItem[];
  /**
   * 마감 여부 필터 (서버 시각 기준)
   */
  isClosed?: boolean;
};

export type ExternalQuoteRequestsControllerFindAllSortOrder =
  (typeof ExternalQuoteRequestsControllerFindAllSortOrder)[keyof typeof ExternalQuoteRequestsControllerFindAllSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindAllSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalQuoteRequestsControllerFindAllStatusItem =
  (typeof ExternalQuoteRequestsControllerFindAllStatusItem)[keyof typeof ExternalQuoteRequestsControllerFindAllStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindAllStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalQuoteRequestsControllerFindAll200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalQuoteRequestsControllerFindAll200AllOf = {
  data?: ExternalQuoteRequestsControllerFindAll200AllOfData;
};

export type ExternalQuoteRequestsControllerFindAll200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindAll200AllOf;

export type ExternalQuoteRequestsControllerFindMineParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalQuoteRequestsControllerFindMineSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 견적 요청 상태 필터
   */
  status?: ExternalQuoteRequestsControllerFindMineStatusItem[];
  /**
   * 마감 여부 필터 (서버 시각 기준)
   */
  isClosed?: boolean;
};

export type ExternalQuoteRequestsControllerFindMineSortOrder =
  (typeof ExternalQuoteRequestsControllerFindMineSortOrder)[keyof typeof ExternalQuoteRequestsControllerFindMineSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindMineSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalQuoteRequestsControllerFindMineStatusItem =
  (typeof ExternalQuoteRequestsControllerFindMineStatusItem)[keyof typeof ExternalQuoteRequestsControllerFindMineStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindMineStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalQuoteRequestsControllerFindMine200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalQuoteRequestsControllerFindMine200AllOf = {
  data?: ExternalQuoteRequestsControllerFindMine200AllOfData;
};

export type ExternalQuoteRequestsControllerFindMine200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindMine200AllOf;

export type ExternalQuoteRequestsControllerFindRespondedParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalQuoteRequestsControllerFindRespondedSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 견적 요청 상태 필터
   */
  status?: ExternalQuoteRequestsControllerFindRespondedStatusItem[];
  /**
   * 마감 여부 필터 (서버 시각 기준)
   */
  isClosed?: boolean;
};

export type ExternalQuoteRequestsControllerFindRespondedSortOrder =
  (typeof ExternalQuoteRequestsControllerFindRespondedSortOrder)[keyof typeof ExternalQuoteRequestsControllerFindRespondedSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindRespondedSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalQuoteRequestsControllerFindRespondedStatusItem =
  (typeof ExternalQuoteRequestsControllerFindRespondedStatusItem)[keyof typeof ExternalQuoteRequestsControllerFindRespondedStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalQuoteRequestsControllerFindRespondedStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalQuoteRequestsControllerFindResponded200AllOfData = {
  items: QuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalQuoteRequestsControllerFindResponded200AllOf = {
  data?: ExternalQuoteRequestsControllerFindResponded200AllOfData;
};

export type ExternalQuoteRequestsControllerFindResponded200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindResponded200AllOf;

export type ExternalQuoteRequestsControllerFindOne200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerFindOne200 = BaseResponseDto &
  ExternalQuoteRequestsControllerFindOne200AllOf;

export type ExternalQuoteRequestsControllerUpdateOne200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerUpdateOne200 = BaseResponseDto &
  ExternalQuoteRequestsControllerUpdateOne200AllOf;

export type ExternalQuoteRequestsControllerFindModifications200AllOf = {
  data?: QuoteRequestModificationDto[];
};

export type ExternalQuoteRequestsControllerFindModifications200 =
  BaseResponseDto & ExternalQuoteRequestsControllerFindModifications200AllOf;

export type ExternalQuoteRequestsControllerFindContractDocuments200AllOf = {
  data?: QuoteRequestContractDocumentGroupDto[];
};

export type ExternalQuoteRequestsControllerFindContractDocuments200 =
  BaseResponseDto &
    ExternalQuoteRequestsControllerFindContractDocuments200AllOf;

export type ExternalQuoteRequestsControllerExtendDeadline200AllOf = {
  data?: ProductQuoteRequestDetailDto;
};

export type ExternalQuoteRequestsControllerExtendDeadline200 = BaseResponseDto &
  ExternalQuoteRequestsControllerExtendDeadline200AllOf;

export type ExternalContractsControllerGetContracts200AllOf = {
  data?: ContractListResponseDto[];
};

export type ExternalContractsControllerGetContracts200 = BaseResponseDto &
  ExternalContractsControllerGetContracts200AllOf;

export type ExternalContractsControllerGetMyContractsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ExternalContractsControllerGetMyContractsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  statuses?: ExternalContractsControllerGetMyContractsStatusesItem[];
};

export type ExternalContractsControllerGetMyContractsSortOrder =
  (typeof ExternalContractsControllerGetMyContractsSortOrder)[keyof typeof ExternalContractsControllerGetMyContractsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalContractsControllerGetMyContractsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ExternalContractsControllerGetMyContractsStatusesItem =
  (typeof ExternalContractsControllerGetMyContractsStatusesItem)[keyof typeof ExternalContractsControllerGetMyContractsStatusesItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalContractsControllerGetMyContractsStatusesItem = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETED: "COMPLETED",
  CANCELED: "CANCELED",
} as const;

export type ExternalContractsControllerGetMyContracts200AllOfData = {
  items: ContractListResponseDto[];
  meta: PaginationMetaDto;
};

export type ExternalContractsControllerGetMyContracts200AllOf = {
  data?: ExternalContractsControllerGetMyContracts200AllOfData;
};

export type ExternalContractsControllerGetMyContracts200 = BaseResponseDto &
  ExternalContractsControllerGetMyContracts200AllOf;

export type ExternalContractsControllerGetSettlements200AllOf = {
  data?: SupplierSettlementResponseDto[];
};

export type ExternalContractsControllerGetSettlements200 = BaseResponseDto &
  ExternalContractsControllerGetSettlements200AllOf;

export type ExternalContractsControllerGetContract200AllOf = {
  data?: ContractResponseDto;
};

export type ExternalContractsControllerGetContract200 = BaseResponseDto &
  ExternalContractsControllerGetContract200AllOf;

export type ExternalContractsControllerRequestCancellation200AllOfData = {
  [key: string]: unknown;
};

export type ExternalContractsControllerRequestCancellation200AllOf = {
  data?: ExternalContractsControllerRequestCancellation200AllOfData;
};

export type ExternalContractsControllerRequestCancellation200 =
  BaseResponseDto & ExternalContractsControllerRequestCancellation200AllOf;

export type ExternalPaymentsControllerConfirmCardPayment201AllOf = {
  data?: CmarketCardPaymentConfirmedDto;
};

export type ExternalPaymentsControllerConfirmCardPayment201 = BaseResponseDto &
  ExternalPaymentsControllerConfirmCardPayment201AllOf;

export type ExternalAccountStatusControllerUpdateStatus200AllOf = {
  data?: UpdateExternalAccountStatusResponseDto;
};

export type ExternalAccountStatusControllerUpdateStatus200 = BaseResponseDto &
  ExternalAccountStatusControllerUpdateStatus200AllOf;

export type ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200AllOf = {
  data?: CmarketTaxInvoiceCallbackResultDto;
};

export type ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200 =
  BaseResponseDto & ExternalTaxInvoicesControllerApplyTaxInvoiceEvent200AllOf;

export type ExternalAdminQuoteRequestsControllerFindAllParams = {
  /**
   * 페이지 (1부터)
   */
  page?: number;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
  /**
   * 통합 검색 — 공고번호 · 공고명 · 발주기관명
   */
  search?: string;
  /**
   * 상태 (다중). 쉼표 구분 또는 반복 파라미터. `CONTRACT_IN_PROGRESS` 는 계약이 걸린 건을 고른다
   */
  status?: ExternalAdminQuoteRequestsControllerFindAllStatusItem[];
  /**
   * 카테고리 (단일). 미지정이면 전체
   */
  categoryType?: ExternalAdminQuoteRequestsControllerFindAllCategoryType;
  /**
   * 등록일 시작 (ISO 8601, 포함)
   */
  publishedFrom?: string;
  /**
   * 등록일 끝 (ISO 8601, 포함)
   */
  publishedTo?: string;
  /**
   * 마감일 시작 (ISO 8601, 포함) — `publishedFrom` 과 다른 축이다
   */
  deadlineFrom?: string;
  /**
   * 마감일 끝 (ISO 8601, 포함)
   */
  deadlineTo?: string;
  /**
   * 마감 여부 (서버 시각 기준). `true` = 수동 마감(status=CLOSED) **또는** 마감일 경과, `false` = 그 반대. 진행중·마감 탭은 이 값 하나로 거세요
   */
  isClosed?: boolean;
};

export type ExternalAdminQuoteRequestsControllerFindAllStatusItem =
  (typeof ExternalAdminQuoteRequestsControllerFindAllStatusItem)[keyof typeof ExternalAdminQuoteRequestsControllerFindAllStatusItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAdminQuoteRequestsControllerFindAllStatusItem = {
  IN_PROGRESS: "IN_PROGRESS",
  ON_HOLD: "ON_HOLD",
  CLOSED: "CLOSED",
  CONTRACT_IN_PROGRESS: "CONTRACT_IN_PROGRESS",
} as const;

export type ExternalAdminQuoteRequestsControllerFindAllCategoryType =
  (typeof ExternalAdminQuoteRequestsControllerFindAllCategoryType)[keyof typeof ExternalAdminQuoteRequestsControllerFindAllCategoryType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAdminQuoteRequestsControllerFindAllCategoryType = {
  product: "product",
  construction: "construction",
  manufacturing: "manufacturing",
  used: "used",
} as const;

export type ExternalAdminQuoteRequestsControllerFindAll200AllOfData = {
  items: AdminQuoteRequestListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalAdminQuoteRequestsControllerFindAll200AllOf = {
  data?: ExternalAdminQuoteRequestsControllerFindAll200AllOfData;
};

export type ExternalAdminQuoteRequestsControllerFindAll200 = BaseResponseDto &
  ExternalAdminQuoteRequestsControllerFindAll200AllOf;

export type ExternalAdminQuoteRequestsControllerDeleteOne200AllOfData = {
  [key: string]: unknown;
};

export type ExternalAdminQuoteRequestsControllerDeleteOne200AllOf = {
  data?: ExternalAdminQuoteRequestsControllerDeleteOne200AllOfData;
};

export type ExternalAdminQuoteRequestsControllerDeleteOne200 = BaseResponseDto &
  ExternalAdminQuoteRequestsControllerDeleteOne200AllOf;

export type ExternalAdminQuoteRequestsControllerRestoreOne200AllOfData = {
  [key: string]: unknown;
};

export type ExternalAdminQuoteRequestsControllerRestoreOne200AllOf = {
  data?: ExternalAdminQuoteRequestsControllerRestoreOne200AllOfData;
};

export type ExternalAdminQuoteRequestsControllerRestoreOne200 =
  BaseResponseDto & ExternalAdminQuoteRequestsControllerRestoreOne200AllOf;

export type ExternalAdminChatControllerFindRoomsParams = {
  /**
   * 견적요청 UUID
   */
  quoteRequestId?: string;
  /**
   * 공고번호. 씨마켓 bid id('AA0014_2') 형태도 받는다 — '_' 뒤를 떼고 SE 접두사를 붙여 해석한다.
   */
  requestNumber?: string;
  /**
   * 씨마켓 공급사 회원 ID (SEMO `suppliers.supplier_id`)
   */
  externalSupplierId?: string;
  /**
   * 페이지 (1부터)
   */
  page?: number;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
};

export type ExternalAdminChatControllerFindRooms200AllOfData = {
  items: AdminChatRoomListItemDto[];
  meta: PaginationMetaDto;
};

export type ExternalAdminChatControllerFindRooms200AllOf = {
  data?: ExternalAdminChatControllerFindRooms200AllOfData;
};

export type ExternalAdminChatControllerFindRooms200 = BaseResponseDto &
  ExternalAdminChatControllerFindRooms200AllOf;

export type ExternalAdminChatControllerFindMessagesParams = {
  /**
   * 커서. 이 메시지보다 이전 것을 가져온다(기존 `before` 와 같다)
   */
  cursor?: string;
  /**
   * 페이지 크기
   * @maximum 100
   */
  limit?: number;
};

export type ExternalAdminChatControllerFindMessages200AllOf = {
  data?: ChatMessagesResponseDto;
};

export type ExternalAdminChatControllerFindMessages200 = BaseResponseDto &
  ExternalAdminChatControllerFindMessages200AllOf;

export type ExternalAdminParticipationsControllerHide200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type ExternalAdminParticipationsControllerHide200 = BaseResponseDto &
  ExternalAdminParticipationsControllerHide200AllOf;

export type ExternalAdminParticipationsControllerUnhide200AllOf = {
  data?: AdminParticipationVisibilityResponseDto;
};

export type ExternalAdminParticipationsControllerUnhide200 = BaseResponseDto &
  ExternalAdminParticipationsControllerUnhide200AllOf;

export type ExternalAdminParticipationsControllerRemove200AllOf = {
  data?: AdminParticipationDeletionResponseDto;
};

export type ExternalAdminParticipationsControllerRemove200 = BaseResponseDto &
  ExternalAdminParticipationsControllerRemove200AllOf;

export type ContactControllerCreateInquiry200AllOfData = {
  [key: string]: unknown;
};

export type ContactControllerCreateInquiry200AllOf = {
  data?: ContactControllerCreateInquiry200AllOfData;
};

export type ContactControllerCreateInquiry200 = BaseResponseDto &
  ContactControllerCreateInquiry200AllOf;

export type PaymentControllerGetVendorDirectEligibilityParams = {
  quoteResponseVersionId: string;
};

export type PaymentControllerGetVendorDirectEligibility200AllOf = {
  data?: VendorDirectEligibilityResponseDto;
};

export type PaymentControllerGetVendorDirectEligibility200 = BaseResponseDto &
  PaymentControllerGetVendorDirectEligibility200AllOf;

export type PaymentControllerPayWithCard201AllOf = {
  data?: DirectPaymentResponseDto;
};

export type PaymentControllerPayWithCard201 = BaseResponseDto &
  PaymentControllerPayWithCard201AllOf;

export type PaymentControllerPayWithCash201AllOf = {
  data?: CashPaymentResponseDto;
};

export type PaymentControllerPayWithCash201 = BaseResponseDto &
  PaymentControllerPayWithCash201AllOf;

export type PaymentControllerRequestRefund201AllOf = {
  data?: RefundResponseDto;
};

export type PaymentControllerRequestRefund201 = BaseResponseDto &
  PaymentControllerRequestRefund201AllOf;

export type PaymentControllerVendorDirectPay201AllOf = {
  data?: VendorDirectPaymentResponseDto;
};

export type PaymentControllerVendorDirectPay201 = BaseResponseDto &
  PaymentControllerVendorDirectPay201AllOf;

export type PaymentControllerGetPaymentHistory200AllOf = {
  data?: PaymentHistoryResponseDto;
};

export type PaymentControllerGetPaymentHistory200 = BaseResponseDto &
  PaymentControllerGetPaymentHistory200AllOf;

export type PaymentNotificationControllerGetTransaction200AllOf = {
  data?: PaymentTransactionResponseDto;
};

export type PaymentNotificationControllerGetTransaction200 = BaseResponseDto &
  PaymentNotificationControllerGetTransaction200AllOf;

export type PaymentCardControllerRegisterCard201AllOf = {
  data?: PaymentCardDto;
};

export type PaymentCardControllerRegisterCard201 = BaseResponseDto &
  PaymentCardControllerRegisterCard201AllOf;

export type PaymentCardControllerGetUserCards200AllOf = {
  data?: PaymentCardDto[];
};

export type PaymentCardControllerGetUserCards200 = BaseResponseDto &
  PaymentCardControllerGetUserCards200AllOf;

export type SubscriptionControllerCreateSubscription201AllOf = {
  data?: SubscriptionResponseDto;
};

export type SubscriptionControllerCreateSubscription201 = BaseResponseDto &
  SubscriptionControllerCreateSubscription201AllOf;

export type SubscriptionControllerGetCurrentUserSubscription200AllOf = {
  data?: SubscriptionResponseDto;
};

export type SubscriptionControllerGetCurrentUserSubscription200 =
  BaseResponseDto & SubscriptionControllerGetCurrentUserSubscription200AllOf;

export type SubscriptionControllerGetPaymentHistory200AllOf = {
  data?: SubscriptionPaymentResponseDto[];
};

export type SubscriptionControllerGetPaymentHistory200 = BaseResponseDto &
  SubscriptionControllerGetPaymentHistory200AllOf;

export type PromotionControllerValidateCode200AllOf = {
  data?: PromotionCodeDto;
};

export type PromotionControllerValidateCode200 = BaseResponseDto &
  PromotionControllerValidateCode200AllOf;

export type PromotionControllerRedeem201AllOf = {
  data?: PromotionRedemptionResponseDto;
};

export type PromotionControllerRedeem201 = BaseResponseDto &
  PromotionControllerRedeem201AllOf;

export type NotificationsControllerGetNotificationsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: NotificationsControllerGetNotificationsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 알람 카테고리 필터
   */
  category?: NotificationsControllerGetNotificationsCategory;
  /**
   * 읽음 상태 필터
   */
  isRead?: boolean;
};

export type NotificationsControllerGetNotificationsSortOrder =
  (typeof NotificationsControllerGetNotificationsSortOrder)[keyof typeof NotificationsControllerGetNotificationsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationsControllerGetNotificationsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type NotificationsControllerGetNotificationsCategory =
  (typeof NotificationsControllerGetNotificationsCategory)[keyof typeof NotificationsControllerGetNotificationsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationsControllerGetNotificationsCategory = {
  system: "system",
  project: "project",
  chat: "chat",
  payment: "payment",
  review: "review",
} as const;

export type NotificationsControllerGetNotifications200AllOfData = {
  items: NotificationResponseDto[];
  meta: PaginationMetaDto;
};

export type NotificationsControllerGetNotifications200AllOf = {
  data?: NotificationsControllerGetNotifications200AllOfData;
};

export type NotificationsControllerGetNotifications200 = BaseResponseDto &
  NotificationsControllerGetNotifications200AllOf;

export type NotificationsControllerGetUnreadCount200AllOf = {
  data?: UnreadCountResponseDto;
};

export type NotificationsControllerGetUnreadCount200 = BaseResponseDto &
  NotificationsControllerGetUnreadCount200AllOf;

export type NotificationsControllerMarkAllAsRead200AllOf = {
  data?: MarkAllReadResponseDto;
};

export type NotificationsControllerMarkAllAsRead200 = BaseResponseDto &
  NotificationsControllerMarkAllAsRead200AllOf;

export type NotificationsControllerMarkAsRead200AllOf = {
  data?: MarkReadResponseDto;
};

export type NotificationsControllerMarkAsRead200 = BaseResponseDto &
  NotificationsControllerMarkAsRead200AllOf;

export type NotificationsControllerGetSubscriptionInfo200AllOf = {
  data?: NotificationSubscriptionInfoResponseDto;
};

export type NotificationsControllerGetSubscriptionInfo200 = BaseResponseDto &
  NotificationsControllerGetSubscriptionInfo200AllOf;

export type ActivityLogsControllerGetMyActivityLogsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: ActivityLogsControllerGetMyActivityLogsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 활동 카테고리 필터
   */
  category?: ActivityLogsControllerGetMyActivityLogsCategory;
  /**
   * 조회 시작 날짜 (ISO8601)
   */
  from?: string;
  /**
   * 조회 종료 날짜 (ISO8601)
   */
  to?: string;
};

export type ActivityLogsControllerGetMyActivityLogsSortOrder =
  (typeof ActivityLogsControllerGetMyActivityLogsSortOrder)[keyof typeof ActivityLogsControllerGetMyActivityLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogsControllerGetMyActivityLogsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ActivityLogsControllerGetMyActivityLogsCategory =
  (typeof ActivityLogsControllerGetMyActivityLogsCategory)[keyof typeof ActivityLogsControllerGetMyActivityLogsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivityLogsControllerGetMyActivityLogsCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

export type ActivityLogsControllerGetMyActivityLogs200AllOfData = {
  items: ActivityLogResponseDto[];
  meta: PaginationMetaDto;
};

export type ActivityLogsControllerGetMyActivityLogs200AllOf = {
  data?: ActivityLogsControllerGetMyActivityLogs200AllOfData;
};

export type ActivityLogsControllerGetMyActivityLogs200 = BaseResponseDto &
  ActivityLogsControllerGetMyActivityLogs200AllOf;

export type AdminActivityLogsControllerGetAllActivityLogsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminActivityLogsControllerGetAllActivityLogsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 활동 카테고리 필터
   */
  category?: AdminActivityLogsControllerGetAllActivityLogsCategory;
  /**
   * 조회 시작 날짜 (ISO8601)
   */
  from?: string;
  /**
   * 조회 종료 날짜 (ISO8601)
   */
  to?: string;
  /**
   * 특정 사용자 ID로 필터
   */
  userId?: string;
};

export type AdminActivityLogsControllerGetAllActivityLogsSortOrder =
  (typeof AdminActivityLogsControllerGetAllActivityLogsSortOrder)[keyof typeof AdminActivityLogsControllerGetAllActivityLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetAllActivityLogsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminActivityLogsControllerGetAllActivityLogsCategory =
  (typeof AdminActivityLogsControllerGetAllActivityLogsCategory)[keyof typeof AdminActivityLogsControllerGetAllActivityLogsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetAllActivityLogsCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

export type AdminActivityLogsControllerGetAllActivityLogs200AllOfData = {
  items: ActivityLogResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminActivityLogsControllerGetAllActivityLogs200AllOf = {
  data?: AdminActivityLogsControllerGetAllActivityLogs200AllOfData;
};

export type AdminActivityLogsControllerGetAllActivityLogs200 = BaseResponseDto &
  AdminActivityLogsControllerGetAllActivityLogs200AllOf;

export type AdminActivityLogsControllerGetStatsParams = {
  from: string;
  to: string;
};

export type AdminActivityLogsControllerGetResourceLogsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 필드
   */
  sortBy?: string;
  /**
   * 정렬 순서
   */
  sortOrder?: AdminActivityLogsControllerGetResourceLogsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 활동 카테고리 필터
   */
  category?: AdminActivityLogsControllerGetResourceLogsCategory;
  /**
   * 조회 시작 날짜 (ISO8601)
   */
  from?: string;
  /**
   * 조회 종료 날짜 (ISO8601)
   */
  to?: string;
  /**
   * 특정 사용자 ID로 필터
   */
  userId?: string;
};

export type AdminActivityLogsControllerGetResourceLogsSortOrder =
  (typeof AdminActivityLogsControllerGetResourceLogsSortOrder)[keyof typeof AdminActivityLogsControllerGetResourceLogsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetResourceLogsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type AdminActivityLogsControllerGetResourceLogsCategory =
  (typeof AdminActivityLogsControllerGetResourceLogsCategory)[keyof typeof AdminActivityLogsControllerGetResourceLogsCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminActivityLogsControllerGetResourceLogsCategory = {
  auth: "auth",
  quote: "quote",
  chat: "chat",
  profile: "profile",
  payment: "payment",
  contract: "contract",
  security: "security",
  promotion: "promotion",
} as const;

export type AdminActivityLogsControllerGetResourceLogs200AllOfData = {
  items: ActivityLogResponseDto[];
  meta: PaginationMetaDto;
};

export type AdminActivityLogsControllerGetResourceLogs200AllOf = {
  data?: AdminActivityLogsControllerGetResourceLogs200AllOfData;
};

export type AdminActivityLogsControllerGetResourceLogs200 = BaseResponseDto &
  AdminActivityLogsControllerGetResourceLogs200AllOf;

export type ReviewsControllerGetReviewsParams = {
  /**
   * 페이지 번호
   * @minimum 1
   */
  page?: number;
  /**
   * 페이지당 항목 수
   * @minimum 1
   * @maximum 100
   */
  limit?: number;
  /**
   * 정렬 기준
   */
  sortBy?: ReviewsControllerGetReviewsSortBy;
  /**
   * 정렬 순서
   */
  sortOrder?: ReviewsControllerGetReviewsSortOrder;
  /**
   * 검색어
   */
  search?: string;
  /**
   * 리뷰 작성자 ID로 필터링
   */
  reviewerId?: string;
  /**
   * 리뷰 대상 ID (공급업체)로 필터링
   */
  revieweeId?: string;
  /**
   * 계약 ID로 필터링
   */
  contractId?: string;
  /**
   * 최소 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  minRating?: number;
  /**
   * 최대 평점 (1-5)
   * @minimum 1
   * @maximum 5
   */
  maxRating?: number;
  /**
   * 삭제된 리뷰 포함 여부
   */
  includeDeleted?: boolean;
};

export type ReviewsControllerGetReviewsSortBy =
  (typeof ReviewsControllerGetReviewsSortBy)[keyof typeof ReviewsControllerGetReviewsSortBy];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewsControllerGetReviewsSortBy = {
  created_at: "created_at",
  calculated_rating: "calculated_rating",
} as const;

export type ReviewsControllerGetReviewsSortOrder =
  (typeof ReviewsControllerGetReviewsSortOrder)[keyof typeof ReviewsControllerGetReviewsSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReviewsControllerGetReviewsSortOrder = {
  asc: "asc",
  desc: "desc",
} as const;

export type ReviewsControllerGetReviews200AllOfData = {
  items: ReviewResponseDto[];
  meta: PaginationMetaDto;
};

export type ReviewsControllerGetReviews200AllOf = {
  data?: ReviewsControllerGetReviews200AllOfData;
};

export type ReviewsControllerGetReviews200 = BaseResponseDto &
  ReviewsControllerGetReviews200AllOf;

export type ReviewsControllerGetReview200AllOf = {
  data?: ReviewResponseDto;
};

export type ReviewsControllerGetReview200 = BaseResponseDto &
  ReviewsControllerGetReview200AllOf;

export type ReviewsControllerDeleteReview200AllOfData = {
  [key: string]: unknown;
};

export type ReviewsControllerDeleteReview200AllOf = {
  data?: ReviewsControllerDeleteReview200AllOfData;
};

export type ReviewsControllerDeleteReview200 = BaseResponseDto &
  ReviewsControllerDeleteReview200AllOf;

export type ReviewsControllerGetSupplierStats200AllOf = {
  data?: SupplierReviewStatsDto;
};

export type ReviewsControllerGetSupplierStats200 = BaseResponseDto &
  ReviewsControllerGetSupplierStats200AllOf;

export type ItemsV2ControllerBulkUploadSupplierPricesBody = {
  /** 단가 엑셀(.xlsx) */
  file?: Blob;
};

export type ItemsV2ControllerBulkUploadSupplierPrices200AllOf = {
  data?: SupplierPriceBulkUploadResultDto;
};

export type ItemsV2ControllerBulkUploadSupplierPrices200 = BaseResponseDto &
  ItemsV2ControllerBulkUploadSupplierPrices200AllOf;

export type ItemsV2ControllerAutocompleteParams = {
  /**
   * 검색 키워드 (최소 2자)
   * @minLength 2
   * @maxLength 100
   */
  q: string;
  /**
   * 결과 개수 (기본값: 10, 최대: 50)
   * @minimum 1
   * @maximum 50
   */
  limit?: number;
  /**
   * 결과 오프셋 (기본: 0). limit 상한(50) 너머로 페이징할 때 사용 — offset=50 이면 51번째부터 반환한다. 응답은 그대로 배열이며, 반환 건수가 limit 과 같으면 다음 페이지가 있을 수 있다.
   * @minimum 0
   */
  offset?: number;
  /**
   * 공급사 ID (선택사항 - 공급사별 단가 조회 시 필요)
   */
  supplierId?: string;
  /**
   * 카테고리 ID 필터 (선택사항). 지정 시 해당 카테고리 품목만 검색한다. 쉼표 구분 또는 반복 쿼리 파라미터(categoryIds=a&categoryIds=b) 모두 허용.
   */
  categoryIds?: string[];
  /**
   * 정렬 기준 (기본값: name)
   */
  sortBy?: ItemV2SortBy;
  /**
   * 정렬 순서 (기본값: ASC)
   */
  sortOrder?: ItemsV2ControllerAutocompleteSortOrder;
  /**
   * 카탈로그 epoch 필터. legacy=2026-05-19 이전 등록 품목, v2=이후 등록 품목. 미지정 시 전체.
   */
  catalogEpoch?: ItemV2CatalogEpoch;
};

export type ItemsV2ControllerAutocompleteSortOrder =
  (typeof ItemsV2ControllerAutocompleteSortOrder)[keyof typeof ItemsV2ControllerAutocompleteSortOrder];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ItemsV2ControllerAutocompleteSortOrder = {
  ASC: "ASC",
  DESC: "DESC",
} as const;

export type ItemsV2ControllerAutocomplete200AllOf = {
  data?: ItemV2AutocompleteResponseDto[];
};

export type ItemsV2ControllerAutocomplete200 = BaseResponseDto &
  ItemsV2ControllerAutocomplete200AllOf;

export type ItemsV2ControllerGetPopularParams = {
  limit?: string;
};

export type ItemsV2ControllerGetPopular200AllOf = {
  data?: ItemV2AutocompleteResponseDto[];
};

export type ItemsV2ControllerGetPopular200 = BaseResponseDto &
  ItemsV2ControllerGetPopular200AllOf;

export type ItemsV2ControllerGetSupplierPriceParams = {
  /**
   * 품목 ID (items_v2_base.id - UUID)
   */
  itemId: string;
  /**
   * 공급사 ID
   */
  supplierId: string;
};

export type ItemsV2ControllerGetSupplierPrice200AllOf = {
  data?: ItemV2SupplierPriceResponseDto;
};

export type ItemsV2ControllerGetSupplierPrice200 = BaseResponseDto &
  ItemsV2ControllerGetSupplierPrice200AllOf;

export type ItemsV2ControllerGetSupplierItems200AllOf = {
  data?: SupplierItemsResponseDto[];
};

export type ItemsV2ControllerGetSupplierItems200 = BaseResponseDto &
  ItemsV2ControllerGetSupplierItems200AllOf;

export type ItemsV2ControllerGetItemSupplierComparison200AllOf = {
  data?: ItemSupplierComparisonDto[];
};

export type ItemsV2ControllerGetItemSupplierComparison200 = BaseResponseDto &
  ItemsV2ControllerGetItemSupplierComparison200AllOf;

export type ItemsV2ControllerFindById200AllOf = {
  data?: ItemV2AutocompleteResponseDto;
};

export type ItemsV2ControllerFindById200 = BaseResponseDto &
  ItemsV2ControllerFindById200AllOf;

export type NiceAuthControllerInitializeAuth200AllOf = {
  data?: NiceInitResponseDto;
};

export type NiceAuthControllerInitializeAuth200 = BaseResponseDto &
  NiceAuthControllerInitializeAuth200AllOf;

export type NiceAuthControllerProcessCallback200AllOf = {
  data?: NiceCallbackResponseDto;
};

export type NiceAuthControllerProcessCallback200 = BaseResponseDto &
  NiceAuthControllerProcessCallback200AllOf;

export type NiceAuthControllerGetAuthMode200AllOf = {
  data?: NiceAuthModeResponseDto;
};

export type NiceAuthControllerGetAuthMode200 = BaseResponseDto &
  NiceAuthControllerGetAuthMode200AllOf;

export type NiceAuthControllerCompleteTestVerification200AllOf = {
  data?: NiceCallbackResponseDto;
};

export type NiceAuthControllerCompleteTestVerification200 = BaseResponseDto &
  NiceAuthControllerCompleteTestVerification200AllOf;

export type NiceAuthControllerBridgeNiceCallbackParams = {
  context: string;
};

export type NiceAuthControllerBridgeNiceCallbackGetParams = {
  context: string;
};
